import { PragmaticplayGames } from "./PragmaticplayGames.data";

export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const SlotGames = {
  slotsgames: {
    slide1: {
      // twinspin: {
      //   redirectUrl: "/casino/ezugi/twinspin",
      //   code: "1100039",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/twin-and-spin.jpg", alt: "" },
      // },
      // gonzoquest: {
      //   redirectUrl: "/casino/ezugi/gonzoquest",
      //   code: "1100018",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/gonzo-treasure-hunt.jpg", alt: "" },
      // },

      // asgardianstones: {
      //   redirectUrl: "/casino/ezugi/asgardianstones",
      //   code: "1100096",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/asgardianstones1.jpg", alt: "" },
      // },
      // secrets: {
      //   href: "/casino/ezugi/secrets",
      //   code: "1100106",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/secrets.jpg", alt: "" },
      // },
      // grandwheel: {
      //   href: "/casino/ezugi/grandwheel",
      //   code: "1100150",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/Grand-wheel.jpg", alt: "" },
      // },
      // Strike777: {
      //   href: "/casino/ezugi/Strike777",
      //   code: "1100031",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Nights1000: {
      //   href: "/casino/ezugi/Nights1000",
      //   code: "1100003",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // CashUltimate: {
      //   href: "/casino/ezugi/CashUltimate",
      //   code: "1100070",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // CashVolt: {
      //   href: "/casino/ezugi/CashVolt",
      //   code: "1100071",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DazzleMegaways: {
      //   href: "/casino/ezugi/DazzleMegaways",
      //   code: "1100083",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DivinieFortuneMegaways: {
      //   href: "/casino/ezugi/DivinieFortuneMegaways",
      //   code: "1100089",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Dynamiteriches: {
      //   href: "/casino/ezugi/Dynamiteriches",
      //   code: "1100073",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FortuneHouse: {
      //   href: "/casino/ezugi/FortuneHouse",
      //   code: "1100007",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FruitShopMegaways: {
      //   href: "/casino/ezugi/FruitShopMegaways",
      //   code: "1100094",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GoldenCryptex: {
      //   href: "/casino/ezugi/GoldenCryptex",
      //   code: "1100147",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GoldenTsar: {
      //   href: "/casino/ezugi/GoldenTsar",
      //   code: "1100149",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GorillaKingdom: {
      //   href: "/casino/ezugi/GorillaKingdom",
      //   code: "1100088",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // MystryReels: {
      //   href: "/casino/ezugi/MystryReels",
      //   code: "1100061",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RageoftheSea: {
      //   href: "/casino/ezugi/RageoftheSea",
      //   code: "1100116",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ReelKingMegaways: {
      //   href: "/casino/ezugi/ReelKingMegaways",
      //   code: "1100052",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // TurnFortune: {
      //   href: "/casino/ezugi/TurnFortune",
      //   code: "1100041",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // TwinSpinMegaways: {
      //   href: "/casino/ezugi/TwinSpinMegaways",
      //   code: "1100039",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // WillysChills: {
      //   href: "/casino/ezugi/WillysChills",
      //   code: "1100128",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // VikingsSlots: {
      //   href: "/casino/ezugi/VikingsSlots",
      //   code: "1100124",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },

      // ChineseTreasures: {
      //   href: "/casino/ezugi/ChineseTreasures",
      //   code: "1100006",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DragonLuck: {
      //   href: "/casino/ezugi/DragonLuck",
      //   code: "1100001",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DragonFire: {
      //   href: "/casino/ezugi/DragonFire",
      //   code: "1100008",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DragonLuckDeluxe: {
      //   href: "/casino/ezugi/DragonLuckDeluxe",
      //   code: "1100011",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DragonLuckReel: {
      //   href: "/casino/ezugi/DragonLuckReel",
      //   code: "1100002",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // EpicJourney: {
      //   href: "/casino/ezugi/EpicJourney",
      //   code: "1100012",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GodWealth: {
      //   href: "/casino/ezugi/GodWealth",
      //   code: "1100005",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // LuckyFortune: {
      //   href: "/casino/ezugi/LuckyFortune",
      //   code: "1100010",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // MagicGate: {
      //   href: "/casino/ezugi/MagicGate",
      //   code: "1100009",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GoldenTemple: {
      //   href: "/casino/ezugi/GoldenTemple",
      //   code: "1100013",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // PhoenixPower: {
      //   href: "/casino/ezugi/PhoenixPower",
      //   code: "1100014",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // PiratesPlenty: {
      //   href: "/casino/ezugi/PiratesPlenty",
      //   code: "1100015",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GoldenOffer: {
      //   href: "/casino/ezugi/GoldenOffer",
      //   code: "1100016",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RAsLegend: {
      //   href: "/casino/ezugi/RAsLegend",
      //   code: "1100017",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GonzoMegawaya: {
      //   href: "/casino/ezugi/GonzoMegawaya",
      //   code: "1100018                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RainbowJAcket: {
      //   href: "/casino/ezugi/RainbowJAcket",
      //   code: "1100019                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // MegaPyramid: {
      //   href: "/casino/ezugi/MegaPyramid",
      //   code: "1100020                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Ozzy_Osbourne: {
      //   href: "/casino/ezugi/Ozzy_Osbourne",
      //   code: "1100024                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Jimi_Hendrix: {
      //   href: "/casino/ezugi/Jimi_Hendrix",
      //   code: "1100026                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Jimi_Hendrix: {
      //   href: "/casino/ezugi/Jimi_Hendrix",
      //   code: "1100026                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Jumanji: {
      //   href: "/casino/ezugi/Jumanji",
      //   code: "1100027                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // MotorheadVideoSlot: {
      //   href: "/casino/ezugi/MotorheadVideoSlot",
      //   code: "1100028                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Starburst: {
      //   href: "/casino/ezugi/Starburst",
      //   code: "1100029                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // WarofGod: {
      //   href: "/casino/ezugi/WarofGod",
      //   code: "1100030                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Christmas: {
      //   href: "/casino/ezugi/Christmas",
      //   code: "1100032                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ClusterPays: {
      //   href: "/casino/ezugi/ClusterPays",
      //   code: "1100033                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // AncientsBlessing: {
      //   href: "/casino/ezugi/AncientsBlessing",
      //   code: "1100034                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // AurumCodex: {
      //   href: "/casino/ezugi/AurumCodex",
      //   code: "1100035                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GunsNRoses: {
      //   href: "/casino/ezugi/GunsNRoses",
      //   code: "1100036                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // BorisandBoo: {
      //   href: "/casino/ezugi/BorisandBoo",
      //   code: "1100037                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // WildWest: {
      //   href: "/casino/ezugi/WildWest",
      //   code: "1100038                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // SteamTower: {
      //   href: "/casino/ezugi/SteamTower",
      //   code: "1100043                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ZeusLightning: {
      //   href: "/casino/ezugi/ZeusLightning",
      //   code: "1100044                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // WingsofRa: {
      //   href: "/casino/ezugi/WingsofRa",
      //   code: "1100045                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Trillionaire: {
      //   href: "/casino/ezugi/Trillionaire",
      //   code: "1100047                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // TreasureMine: {
      //   href: "/casino/ezugi/TreasureMine",
      //   code: "1100048                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ThorVengeance: {
      //   href: "/casino/ezugi/ThorVengeance",
      //   code: "1100049                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RegalStreak: {
      //   href: "/casino/ezugi/RegalStreak",
      //   code: "1100050                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RegalBeasts: {
      //   href: "/casino/ezugi/RegalBeasts",
      //   code: "1100051                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ReelKeeper: {
      //   href: "/casino/ezugi/ReelKeeper",
      //   code: "1100053                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RainbowJackpotsPowerLines: {
      //   href: "/casino/ezugi/RainbowJackpotsPowerLines",
      //   code: "1100055                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // PiggyRichesMegaways: {
      //   href: "/casino/ezugi/PiggyRichesMegaways",
      //   code: "1100059                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JingleBells: {
      //   href: "/casino/ezugi/JingleBells",
      //   code: "1100065                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JackinaPot: {
      //   href: "/casino/ezugi/JackinaPot",
      //   code: "1100066                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FiveStar: {
      //   href: "/casino/ezugi/FiveStar",
      //   code: "1100068                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // BountyRaid: {
      //   href: "/casino/ezugi/BountyRaid",
      //   code: "1100069                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // MysteryReels2: {
      //   href: "/casino/ezugi/MysteryReels2",
      //   code: "1100061                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DiamondBlitz: {
      //   href: "/casino/ezugi/DiamondBlitz",
      //   code: "1100072                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DragonFireMegaways: {
      //   href: "/casino/ezugi/DragonFireMegaways",
      //   code: "1100074                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Rome: {
      //   href: "/casino/ezugi/Rome",
      //   code: "1100075                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ReelRush: {
      //   href: "/casino/ezugi/ReelRush",
      //   code: "1100076                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // BloodSuckers: {
      //   href: "/casino/ezugi/BloodSuckers",
      //   code: "1100077                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Pyramid: {
      //   href: "/casino/ezugi/Pyramid",
      //   code: "1100078                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ButterflyStaxx: {
      //   href: "/casino/ezugi/ButterflyStaxx",
      //   code: "1100079                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // PiggyRiches: {
      //   href: "/casino/ezugi/PiggyRiches",
      //   code: "1100080                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DarkKing: {
      //   href: "/casino/ezugi/DarkKing",
      //   code: "1100081                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JingleSpin: {
      //   href: "/casino/ezugi/JingleSpin",
      //   code: "1100082                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Dazzle: {
      //   href: "/casino/ezugi/Dazzle",
      //   code: "1100083                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JackHammer: {
      //   href: "/casino/ezugi/JackHammer",
      //   code: "1100084                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DeadorAlive: {
      //   href: "/casino/ezugi/DeadorAlive",
      //   code: "1100085                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JackandtheBeanstalk: {
      //   href: "/casino/ezugi/JackandtheBeanstalk",
      //   code: "1100086                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DeadorAlive2: {
      //   href: "/casino/ezugi/DeadorAlive2",
      //   code: "1100087                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DivineFortuneMegaways: {
      //   href: "/casino/ezugi/DivineFortuneMegaways",
      //   code: "1100089                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GordonRamsayHellsKitchen: {
      //   href: "/casino/ezugi/GordonRamsayHellsKitchen",
      //   code: "1100090                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Elements: {
      //   href: "/casino/ezugi/Elements",
      //   code: "1100091                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GonzosQuest: {
      //   href: "/casino/ezugi/GonzosQuest",
      //   code: "1100092                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FinnandtheSwirlySpin: {
      //   href: "/casino/ezugi/FinnandtheSwirlySpin",
      //   code: "1100093                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FruitShop: {
      //   href: "/casino/ezugi/FruitShop",
      //   code: "1100095                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // BloodSuckers2: {
      //   href: "/casino/ezugi/BloodSuckers2",
      //   code: "1100097                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ButterflyStaxx2: {
      //   href: "/casino/ezugi/ButterflyStaxx2",
      //   code: "1100098                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DazzleMeMegaways: {
      //   href: "/casino/ezugi/DazzleMeMegaways",
      //   code: "1100099                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DeadorAlive2FeatureBuy: {
      //   href: "/casino/ezugi/DeadorAlive2FeatureBuy",
      //   code: "1100100                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DoubleStacks: {
      //   href: "/casino/ezugi/DoubleStacks",
      //   code: "1100101                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FairytaleLegends: {
      //   href: "/casino/ezugi/FairytaleLegends",
      //   code: "1100102                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Flowers: {
      //   href: "/casino/ezugi/Flowers",
      //   code: "1100103                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FruitShopChristmasEdition: {
      //   href: "/casino/ezugi/FruitShopChristmasEdition",
      //   code: "1100104                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Hotline: {
      //   href: "/casino/ezugi/Hotline",
      //   code: "1100107                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Hotline2: {
      //   href: "/casino/ezugi/Hotline2",
      //   code: "1100108                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // TheInvisibleMan: {
      //   href: "/casino/ezugi/TheInvisibleMan",
      //   code: "1100109                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // IrishPotLuck: {
      //   href: "/casino/ezugi/IrishPotLuck",
      //   code: "1100110                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JackHammer2: {
      //   href: "/casino/ezugi/JackHammer2",
      //   code: "1100111                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FruitSpin: {
      //   href: "/casino/ezugi/FruitSpin",
      //   code: "1100112                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JungleSpirit: {
      //   href: "/casino/ezugi/JungleSpirit",
      //   code: "1100113                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // KoiPrincess: {
      //   href: "/casino/ezugi/KoiPrincess",
      //   code: "1100114                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DriveMultiplierMayhem: {
      //   href: "/casino/ezugi/DriveMultiplierMayhem",
      //   code: "1100115                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RageoftheSeas: {
      //   href: "/casino/ezugi/RageoftheSeas",
      //   code: "1100116                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RichesofMidgard: {
      //   href: "/casino/ezugi/RichesofMidgard",
      //   code: "1100117                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ScruffyDuck: {
      //   href: "/casino/ezugi/ScruffyDuck",
      //   code: "1100118                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // SecretoftheStones: {
      //   href: "/casino/ezugi/SecretoftheStones",
      //   code: "1100119                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // SecretsofChristmas: {
      //   href: "/casino/ezugi/SecretsofChristmas",
      //   code: "1100120                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      SerengetiKings: {
        redirectUrl: "/casino/ezugi/SerengetiKings",
        code: "1100121                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Serengeti-Kings.jpg",
        alt: "",
        name: "Serengeti Kings",
        providerName: "NetEnt",
      },
      SpaceWars: {
        redirectUrl: "/casino/ezugi/SpaceWars",
        code: "1100122                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Space-Wars.jpg",
        alt: "",
        name: "Space Wars",
        providerName: "NetEnt",
      },
      Victorious: {
        redirectUrl: "/casino/ezugi/Victorious",
        code: "1100123                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Victorious.jpg",
        alt: "",
        name: "Victorious",
        providerName: "NetEnt",
      },
      Warlords: {
        redirectUrl: "/casino/ezugi/Warlords",
        code: "1100125                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Warlords-Crystal-of-Power.jpg",
        alt: "",
        name: "Warlords: Crystal of Power",
        providerName: "NetEnt",
      },
      WildWater: {
        redirectUrl: "/casino/ezugi/WildWater",
        code: "1100126                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Wild-Water.jpg",
        alt: "",
        name: "Wild Water",
        providerName: "NetEnt",
      },
      WildWorlds: {
        redirectUrl: "/casino/ezugi/WildWorlds",
        code: "1100127                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Wild-Worlds.jpg",
        alt: "",
        name: "Wild Worlds",
        providerName: "NetEnt",
      },
      Squad4: {
        redirectUrl: "/casino/ezugi/Squad4",
        code: "1100129                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/4-Squad.jpg",
        alt: "",
        name: "4 Squad",
        providerName: "Red Tiger",
      },
      Families5: {
        redirectUrl: "/casino/ezugi/Families5",
        code: "1100130                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/5-Families.jpg",
        alt: "",
        name: "5 Families",
        providerName: "Red Tiger",
      },
      AgentRoyale: {
        redirectUrl: "/casino/ezugi/AgentRoyale",
        code: "1100131                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Agent-Royale.jpg",
        alt: "",
        name: "Agent Royale",
        providerName: "Red Tiger",
      },
      ArcadeBomb: {
        redirectUrl: "/casino/ezugi/ArcadeBomb",
        code: "1100132                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Arcade-Bomb.jpg",
        alt: "",
        name: "Arcade Bomb",
        providerName: "Red Tiger",
      },
      Atlantis: {
        redirectUrl: "/casino/ezugi/Atlantis",
        code: "1100133                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Atlantis.jpg",
        alt: "",
        name: "Atlantis",
        providerName: "Red Tiger",
      },
      AztecSpins: {
        redirectUrl: "/casino/ezugi/AztecSpins",
        code: "1100134                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Aztec-Spins.jpg",
        alt: "",
        name: "Aztec Spins",
        providerName: "Red Tiger",
      },
      CinderellaBall: {
        redirectUrl: "/casino/ezugi/CinderellaBall",
        code: "1100135                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Cinderella`s-Ball.jpg",
        alt: "",
        name: "Cinderella`s Ball",
        providerName: "Red Tiger",
      },
      CirquedelaFortune: {
        redirectUrl: "/casino/ezugi/CirquedelaFortune",
        code: "1100136                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Cirque-de-la-Fortune.jpg",
        alt: "",
        name: "Cirque de la Fortune",
        providerName: "Red Tiger",
      },
      ClashoftheBeasts: {
        redirectUrl: "/casino/ezugi/ClashoftheBeasts",
        code: "1100137                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Clash-of-the-Beasts.jpg",
        alt: "",
        name: "Clash of the Beasts",
        providerName: "Red Tiger",
      },
      CrazyGenie: {
        redirectUrl: "/casino/ezugi/CrazyGenie",
        code: "1100138                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Crazy-Genie.jpg",
        alt: "",
        name: "Crazy Genie",
        providerName: "Red Tiger",
      },
      CrystalMirror: {
        redirectUrl: "/casino/ezugi/CrystalMirror",
        code: "1100139                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Crystal-Mirror.jpg",
        alt: "",
        name: "Crystal Mirror",
        providerName: "Red Tiger",
      },
      DaVinciMystery: {
        redirectUrl: "/casino/ezugi/DaVinciMystery",
        code: "1100140                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Da-Vinci`s-Mystery.jpg",
        alt: "",
        name: "Da Vinci`s Mystery",
        providerName: "Red Tiger",
      },
      DevilNumber: {
        redirectUrl: "/casino/ezugi/DevilNumber",
        code: "1100141                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Devil`s-Number.jpg",
        alt: "",
        name: "Devil`s Number",
        providerName: "Red Tiger",
      },
      DiceDice: {
        redirectUrl: "/casino/ezugi/DiceDice",
        code: "1100142                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Dice-Dice-Dice.jpg",
        alt: "",
        name: "Dice Dice Dice",
        providerName: "Red Tiger",
      },
      FiveStarsPowerReels: {
        redirectUrl: "/casino/ezugi/FiveStarsPowerReels",
        code: "1100144                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Five-Stars-Power-Reels.jpg",
        alt: "",
        name: "Five Stars Power Reels",
        providerName: "Red Tiger",
      },
      GemsGoneWild: {
        redirectUrl: "/casino/ezugi/GemsGoneWild",
        code: "1100145                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Gems-Gone-Wild.jpg",
        alt: "",
        name: "Gems Gone Wild",
        providerName: "Red Tiger",
      },
      GemsGoneWildPowerReels: {
        redirectUrl: "/casino/ezugi/GemsGoneWildPowerReels",
        code: "1100146                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Gems-Gone-Wild-Power-Reels.jpg",
        alt: "",

        name: "Gems Gone Wild Power Reels",
        providerName: "Red Tiger",
      },
      GoldenLeprechaunMegaways: {
        redirectUrl: "/casino/ezugi/GoldenLeprechaunMegaways",
        code: "1100148                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Golden-Leprechaun-Megaways.jpg",
        alt: "",

        name: "Golden Leprechaun Megaways",
        providerName: "Red Tiger",
      },
      HoardofPoseidon: {
        redirectUrl: "/casino/ezugi/HoardofPoseidon",
        code: "1100151                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Hoard-of-Poseidon.jpg",
        alt: "",
        name: "Hoard of Poseidon",
        providerName: "Red Tiger",
      },
      JewelScarabs: {
        redirectUrl: "/casino/ezugi/JewelScarabs",
        code: "1100152                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Jewel-Scarabs.jpg",
        alt: "",
        name: "Jewel Scarabs",
        providerName: "Red Tiger",
      },
      JingleBellsPowerReels: {
        redirectUrl: "/casino/ezugi/JingleBellsPowerReels",
        code: "1100153                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Jingle-Bells-Power-Reels.jpg",
        alt: "",
        name: "Jingle Bells Power Reels",
        providerName: "Red Tiger",
      },
      LegendofAthena: {
        redirectUrl: "/casino/ezugi/LegendofAthena",
        code: "1100154                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Legend-of-Athena.jpg",
        alt: "",
        name: "Legend of Athena",
        providerName: "Red Tiger",
      },
      LuckyHalloween: {
        redirectUrl: "/casino/ezugi/LuckyHalloween",
        code: "1100155                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Lucky-Halloween.jpg",
        alt: "",
        name: "Lucky Halloween",
        providerName: "Red Tiger",
      },
      LuckyLittleDevil: {
        redirectUrl: "/casino/ezugi/LuckyLittleDevil",
        code: "1100156                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Lucky-Little-Devil.jpg",
        alt: "",
        name: "Lucky Little Devil",
        providerName: "Red Tiger",
      },
      LuckyValentine: {
        redirectUrl: "/casino/ezugi/LuckyValentine",
        code: "1100157                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Lucky-Valentine.jpg",
        alt: "",
        name: "Lucky Valentine",
        providerName: "Red Tiger",
      },
      LuckyWizard: {
        redirectUrl: "/casino/ezugi/LuckyWizard",
        code: "1100158                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Lucky-Wizard.jpg",
        alt: "",
        name: "Lucky Wizard",
        providerName: "Red Tiger",
      },
      Masquerade: {
        redirectUrl: "/casino/ezugi/Masquerade",
        code: "1100159                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Masquerade.jpg",
        alt: "",
        name: "Masquerade",
        providerName: "Red Tiger",
      },
      MayanGods: {
        redirectUrl: "/casino/ezugi/MayanGods",
        code: "1100160                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Mayan-Gods.jpg",
        alt: "",
        name: "Mayan Gods",
        providerName: "Red Tiger",
      },
      MegaDragon: {
        redirectUrl: "/casino/ezugi/MegaDragon",
        code: "1100161                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Mega-Dragon.jpg",
        alt: "",
        name: "Mega Dragon",
        providerName: "Red Tiger",
      },
      MegaJade: {
        redirectUrl: "/casino/ezugi/MegaJade",
        code: "1100162                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Mega-Jade.jpg",
        alt: "",
        name: "Mega Jade",
        providerName: "Red Tiger",
      },
      MegaRise: {
        redirectUrl: "/casino/ezugi/MegaRise",
        code: "1100163                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Mega-Rise.jpg",
        alt: "",
        name: "Mega Rise",
        providerName: "Red Tiger",
      },
      MultiplierRiches: {
        redirectUrl: "/casino/ezugi/MultiplierRiches",
        code: "1100164                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Multiplier-Riches.jpg",
        alt: "",
        name: "Mystery Reels Megaways",
        providerName: "Red Tiger",
      },
      MysteryReelsMegaways: {
        redirectUrl: "/casino/ezugi/MysteryReelsMegaways",
        code: "1100165                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Mystery_Reels_Megaways.jpg",
        alt: "",
        name: "Mystery Reels Megaways",
        providerName: "Red Tiger",
      },
      NinjaWays: {
        redirectUrl: "/casino/ezugi/NinjaWays",
        code: "1100166                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Ninja-Ways.jpg",
        alt: "",
        name: "Ninja Ways",
        providerName: "Red Tiger",
      },
      PathofDestiny: {
        redirectUrl: "/casino/ezugi/PathofDestiny",
        code: "1100167                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Path-of-Destiny.jpg",
        alt: "",
        name: "Path of Destiny",
        providerName: "Red Tiger",
      },
      PersianFortune: {
        redirectUrl: "/casino/ezugi/PersianFortune",
        code: "1100168                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Persian-Fortune.jpg",
        alt: "",
        name: "Persian Fortune",
        providerName: "Red Tiger",
      },
      ReelHeist: {
        redirectUrl: "/casino/ezugi/ReelHeist",
        code: "1100169                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Reel-Heist.jpg",
        alt: "",
        name: "Reel Heist",
        providerName: "Red Tiger",
      },
      RobinHoodWildForest: {
        redirectUrl: "/casino/ezugi/RobinHoodWildForest",
        code: "1100170                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Robin-Hood`s-Wild-Forest.jpg",
        alt: "",
        name: "Robin Hood`s Wild Forest",
        providerName: "Red Tiger",
      },
      SnowWild: {
        redirectUrl: "/casino/ezugi/SnowWild",
        code: "1100171                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Snow-Wild-And-The-7-Features.jpg",
        alt: "",

        name: "Snow Wild And The 7 Features",
        providerName: "Red Tiger",
      },
      SylvanSpirits: {
        redirectUrl: "/casino/ezugi/SylvanSpirits",
        code: "1100172                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Sylvan-Spirits.jpg",
        alt: "",
        name: "Sylvan Spirits",
        providerName: "Red Tiger",
      },
      TheGreatestTrainRobbery: {
        redirectUrl: "/casino/ezugi/TheGreatestTrainRobbery",
        code: "1100173                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/The-Greatest-Train-Robbery.jpg",
        alt: "",

        name: "The Greatest Train Robbery",
        providerName: "Red Tiger",
      },
      TheWildHatter: {
        redirectUrl: "/casino/ezugi/TheWildHatter",
        code: "1100174                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/The-Wild-Hatter.jpg",
        alt: "",
        name: "The Wild Hatter",
        providerName: "Red Tiger",
      },
      ThorLightning: {
        redirectUrl: "/casino/ezugi/ThorLightning",
        code: "1100175                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Thor`s-Lightning.jpg",
        alt: "",
        name: "Thor`s Lightning",
        providerName: "Red Tiger",
      },
      TikiFruits: {
        redirectUrl: "/casino/ezugi/TikiFruits",
        code: "1100176                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Tiki-Fruits.jpg",
        alt: "",
        name: "Tiki Fruits",
        providerName: "Red Tiger",
      },
      TotemLightning: {
        redirectUrl: "/casino/ezugi/TotemLightning",
        code: "1100177                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Totem-Lightning.jpg",
        alt: "",
        name: "Totem Lightning",
        providerName: "Red Tiger",
      },
      VaultCracker: {
        redirectUrl: "/casino/ezugi/VaultCracker",
        code: "1100178                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Vault-Cracker.jpg",
        alt: "",
        name: "Vault Cracker",
        providerName: "Red Tiger",
      },
      VaultofAnubis: {
        redirectUrl: "/casino/ezugi/VaultofAnubis",
        code: "1100179                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Vault-of-Anubis.jpg",
        alt: "",
        name: "Vault of Anubis",
        providerName: "Red Tiger",
      },
      WellofWishes: {
        redirectUrl: "/casino/ezugi/WellofWishes",
        code: "1100180                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Well-of-Wishes.jpg",
        alt: "",
        name: "Well of Wishes",
        providerName: "Red Tiger",
      },
      WildCatsMultiline: {
        redirectUrl: "/casino/ezugi/WildCatsMultiline",
        code: "1100181                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Wild-Cats-Multiline.jpg",
        alt: "",
        name: "Wild Cats Multiline",
        providerName: "Red Tiger",
      },
      WildOClock: {
        redirectUrl: "/casino/ezugi/WildOClock",
        code: "1100182                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Wild-O`Clock.jpg",
        alt: "",
        name: "Wild O`Clock",
        providerName: "Red Tiger",
      },
      WildChest: {
        redirectUrl: "/casino/ezugi/WildChest",
        code: "1100183                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Wild-Wild-Chest.jpg",
        alt: "",
        name: "Wild Wild Chest",
        providerName: "Red Tiger",
      },
      WinEscalator: {
        redirectUrl: "/casino/ezugi/WinEscalator",
        code: "1100184                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Win-Escalator.jpg",
        alt: "",
        name: "Win Escalator",
        providerName: "Red Tiger",
      },
      YucatanMystery: {
        redirectUrl: "/casino/ezugi/YucatanMystery",
        code: "1100185                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Yucatan`s-Mystery.jpg",
        alt: "",
        name: "Yucatan Mystery",
        providerName: "Red Tiger",
      },
    },
    name: "Slots",
  },

  netent: {
    slide1: {
      asgardianstones: {
        redirectUrl: "/casino/ezgne-asgardian-stones",
        code: "1100096",
        casino: "ezugi",
        imgUrl: "./images/slots/asgardianstones.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Asgardian Stones",
        providerName: "NetEnt",
      },
      secrets: {
        redirectUrl: "/casino/ezgne-secrets-of-atlantis",
        code: "1100106",
        casino: "ezugi",
        imgUrl: "./images/slots/secrets-of-atlantis.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Secrets of Atlantis",
        providerName: "NetEnt",
      },
      SteamTower: {
        redirectUrl: "/casino/ezgne-steam-tower",
        code: "1100043",
        casino: "ezugi",
        imgUrl: "./images/slots/Steam-Tower.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Steam Tower",
        providerName: "NetEnt",
      },
      DivinieFortuneMegaways: {
        redirectUrl: "/casino/ezgne-divine-fortune-megaways",
        code: "1100089",
        casino: "ezugi",
        imgUrl: "./images/slots/divine_fortune_megaways.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Divine Fortune Megaways",
        providerName: "NetEnt",
      },
      FruitShopMegaways: {
        redirectUrl: "/casino/ezgne-fruit-shop-megaways",
        code: "1100094",
        casino: "ezugi",
        imgUrl: "./images/slots/Fruit_Shop_Megaways.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Fruit Shop Megaways",
        providerName: "NetEnt",
      },
      GorillaKingdom: {
        redirectUrl: "/casino/ezgne-gorilla-kingdom",
        code: "1100088",
        casino: "ezugi",
        imgUrl: "./images/slots/Gorilla_Kingdom.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Gorilla Kingdom",
        providerName: "NetEnt",
      },

      Christmas: {
        redirectUrl: "/casino/ezgne-aloha-christmas",
        code: "1100032",
        casino: "ezugi",
        imgUrl: "./images/slots/Aloha-Christmas.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Aloha! Christmas",
        providerName: "NetEnt",
      },
      ClusterPays: {
        redirectUrl: "/casino/ezgne-aloha-cluster-pays",
        code: "1100033",
        casino: "ezugi",
        imgUrl: "./images/slots/Aloha-Cluster-Pays.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Aloha! Cluster Pays",
        providerName: "NetEnt",
      },
      WildWest: {
        redirectUrl: "/casino/ezgne-wild-wild-west-the-great-train-heist",
        code: "1100038",
        casino: "ezugi",
        imgUrl: "./images/slots/Wild-Wild-West-The-Great-Train-Heist.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Wild Wild West: The Great Train Heist",
        providerName: "NetEnt",
      },
      TwinSpinMegaways: {
        redirectUrl: "/casino/ezgne-twin-spin-megaways",
        code: "1100039",
        casino: "ezugi",
        imgUrl: "./images/slots/Twin_Spin_Megaways.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Twin Spin Megaways",
        providerName: "NetEnt",
      },
      TurnFortune: {
        redirectUrl: "/casino/ezgne-turn-your-fortune",
        code: "1100041",
        casino: "ezugi",
        imgUrl: "./images/slots/Turn_Your_Fortune.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Turn Your Fortune",
        providerName: "NetEnt",
      },
    },
    slide2: {
      Pyramid: {
        redirectUrl: "/casino/ezgne-pyramid-quest-for-immortality",
        code: "1100078",
        casino: "ezugi",
        imgUrl: "./images/slots/Pyramid-Quest-for-Immortality.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Pyramid: Quest for Immortality",
        providerName: "NetEnt",
      },
      PiggyRiches: {
        redirectUrl: "/casino/ezgne-piggy-riches",
        code: "1100080",
        casino: "ezugi",
        imgUrl: "./images/slots/Piggy-Riches.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Piggy Riches",
      },
      DarkKing: {
        redirectUrl: "/casino/ezgne-dark-king-forbidden-riches",
        code: "1100081",
        casino: "ezugi",
        imgUrl: "./images/slots/Dark-King-Forbidden-Riches.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Dark King: Forbidden Riches",
        providerName: "NetEnt",
      },
      JingleSpin: {
        redirectUrl: "/casino/ezgne-jingle-spin",
        code: "1100082",
        casino: "ezugi",
        imgUrl: "./images/slots/Jingle-Spin.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Jingle Spin",
        providerName: "NetEnt",
      },
      JackHammer: {
        redirectUrl: "/casino/ezgne-jack-hammer",
        code: "1100084",
        casino: "ezugi",
        imgUrl: "./images/slots/Jack-Hammer.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Jack Hammer",
        providerName: "NetEnt",
      },
      DeadorAlive: {
        redirectUrl: "/casino/ezgne-dead-or-alive",
        code: "1100085",
        casino: "ezugi",
        imgUrl: "./images/slots/Dead-or-Alive.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Dead or Alive",
        providerName: "NetEnt",
      },
      DeadorAlive2: {
        redirectUrl: "/casino/ezgne-dead-or-alive-2",
        code: "1100087",
        casino: "ezugi",
        imgUrl: "./images/slots/Dead-or-Alive-2.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Dead or Alive 2",
        providerName: "NetEnt",
      },
      JackandtheBeanstalk: {
        redirectUrl: "/casino/ezgne-jack-and-the-beanstalk",
        code: "1100086",
        casino: "ezugi",
        imgUrl: "./images/slots/Jack-and-the-Beanstalk.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Jack and the Beanstalk",
        providerName: "NetEnt",
      },
      Elements: {
        redirectUrl: "/casino/ezgne-elements-the-awakening",
        code: "1100091",
        casino: "ezugi",
        imgUrl: "./images/slots/Elements-The-Awakening.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Elements: The Awakening",
        providerName: "NetEnt",
      },
      FinnandtheSwirlySpin: {
        redirectUrl: "/casino/ezgne-finn-and-the-swirly-spin",
        code: "1100093",
        casino: "ezugi",
        imgUrl: "./images/slots/Finn-and-the-Swirly-Spin.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Finn and the Swirly Spin",
        providerName: "NetEnt",
      },
      FruitShop: {
        redirectUrl: "/casino/ezgne-fruit-shop",
        code: "1100095",
        casino: "ezugi",
        imgUrl: "./images/slots/Fruit-Shop.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Fruit Shop",
        providerName: "NetEnt",
      },
      DeadorAlive2FeatureBuy: {
        redirectUrl: "/casino/ezgne-dead-or-alive-2-feature-buy",
        code: "1100100",
        casino: "ezugi",
        imgUrl: "./images/slots/Dead-or-Alive-2-Feature-Buy.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Dead or Alive 2 Feature Buy",
        providerName: "NetEnt",
      },
    },
    name: "Netent",
    key: "netent",
  },

  redtigertab: {
    slide1: {
      DragonsLuck: {
      redirectUrl: "/casino/ezgrt-dragons-luck",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuck.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck",
      providerName: "slots",
    },
    DragonsLuckPowerReels: {
      redirectUrl: "/casino/ezgrt-dragons-luck-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuckPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck Power Reels",
      providerName: "slots",
    },
    Nights10001: {
      redirectUrl: "/casino/ezgrt-10001-nights",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/10001Nights.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "10,001 Nights",
      providerName: "slots",
    },
    GodOfWealth: {
      redirectUrl: "/casino/ezgrt-god-of-wealth",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GodOfWealth.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "God Of Wealth",
      providerName: "slots",
    },
    PiratesPlentyBattleforGold: {
      redirectUrl: "/casino/ezgrt-pirates-plenty-battle-for-gold",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiratesPlentyBattleforGold.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pirates' Plenty Battle for Gold",
      providerName: "slots",
    },
    ChineseTreasures: {
      redirectUrl: "/casino/ezgrt-chinese-treasures",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ChineseTreasures.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Chinese Treasures",
      providerName: "slots",
    },
    FortuneHouse: {
      redirectUrl: "/casino/ezgrt-fortune-house",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FortuneHouse.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fortune House",
      providerName: "slots",
    },
    DragonsFire: {
      redirectUrl: "/casino/ezgrt-dragons-fire",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsFire.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Fire",
      providerName: "slots",
    },
    MagicGate: {
      redirectUrl: "/casino/ezgrt-magic-gate",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MagicGate.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Magic Gate",
      providerName: "slots",
    },
    LuckyFortuneCat: {
      redirectUrl: "/casino/ezgrt-lucky-fortune-cat",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyFortuneCat.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Fortune Cat",
      providerName: "slots",
    },
    DragonsLuckDeluxe: {
      redirectUrl: "/casino/ezgrt-dragons-luck-deluxe",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuckDeluxe.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck Deluxe",
      providerName: "slots",
    },
    EpicJourney: {
      redirectUrl: "/casino/ezgrt-epic-journey",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/EpicJourney.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Epic Journey",
      providerName: "slots",
    },
    PhoenixFirePowerReels: {
      redirectUrl: "/casino/ezgrt-phoenix-fire-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PhoenixFirePowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Phoenix Fire Power Reels",
      providerName: "slots",
    },
    GoldenTemple: {
      redirectUrl: "/casino/ezgrt-golden-temple",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenTemple.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Temple",
      providerName: "slots",
    },
    PiratesPlenty: {
      redirectUrl: "/casino/ezgrt-pirates-plenty",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiratesPlenty.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pirates' Plenty",
      providerName: "slots",
    },
    GoldenOffer: {
      redirectUrl: "/casino/ezgrt-golden-offer",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenOffer.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Offer",
      providerName: "slots",
    },
    RAsLegend: {
      redirectUrl: "/casino/ezgrt-ras-legend",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RAsLegend.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "RA's Legend",
      providerName: "slots",
    },
    GonzosQuestMegaways: {
      redirectUrl: "/casino/ezgrt-gonzos-quest-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GonzosQuestMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gonzo's Quest Megaways",
      providerName: "slots",
    },
    RainbowJackpots: {
      redirectUrl: "/casino/ezgrt-rainbow-jackpots",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RainbowJackpots.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Rainbow Jackpots",
      providerName: "slots",
    },
    MegaPyramid: {
      redirectUrl: "/casino/ezgrt-mega-pyramid",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaPyramid.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Pyramid",
      providerName: "slots",
    },
    WarOfGods: {
      redirectUrl: "/casino/ezgrt-war-of-gods",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WarOfGods.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "War Of Gods",
      providerName: "slots",
    },
    Strike777: {
      redirectUrl: "/casino/ezgrt-777-strike",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/777Strike.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "777 Strike",
      providerName: "slots",
    },
    AncientsBlessing: {
      redirectUrl: "/casino/ezgrt-ancients-blessing",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AncientsBlessing.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Ancients Blessing",
      providerName: "slots",
    },
    AurumCodex: {
      redirectUrl: "/casino/ezgrt-aurum-codex",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AurumCodex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aurum Codex",
      providerName: "slots",
    },
    BettyBorisandBoo: {
      redirectUrl: "/casino/ezgrt-betty-boris-and-boo",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/BettyBorisandBoo.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Betty, Boris and Boo",
      providerName: "slots",
    },
    // ZeusLightningPowerReels: {
    //   redirectUrl: "/casino/ezgrt-zeus-lightning-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   imgUrl: "./images/slots/new/redtiger/ZeusLightningPower-Reels.webp",
    //   homeUrl: pageUrlGenerator("/Slots"),
    //   name: "Zeus Lightning Power Reels",
    //   providerName: "slots",
    // },
    WingsofRa: {
      redirectUrl: "/casino/ezgrt-wings-of-ra",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WingsofRa.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wings of Ra",
      providerName: "slots",
    },
    TreasureMine: {
      redirectUrl: "/casino/ezgrt-treasure-mine",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TreasureMine.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Treasure Mine",
      providerName: "slots",
    },
    ThorsVengeance: {
      redirectUrl: "/casino/ezgrt-thors-vengeance",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ThorsVengeance.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor's Vengeance",
      providerName: "slots",
    },
    RegalStreak: {
      redirectUrl: "/casino/ezgrt-regal-streak",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RegalStreak.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Regal Streak",
      providerName: "slots",
    },
    RegalBeasts: {
      redirectUrl: "/casino/ezgrt-regal-beasts",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RegalBeasts.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Regal Beasts",
      providerName: "slots",
    },
    ReelKingMega: {
      redirectUrl: "/casino/ezgrt-reel-king-mega",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelKingMega.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel King Mega",
      providerName: "slots",
    },
    ReelKeeper: {
      redirectUrl: "/casino/ezgrt-reel-keeper",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelKeeper.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Keeper",
      providerName: "slots",
    },
    RainbowJackpotsPowerLines: {
      redirectUrl: "/casino/ezgrt-rainbow-jackpots-power-lines",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RainbowJackpotsPowerLines.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Rainbow Jackpots Power Lines",
      providerName: "slots",
    },
    MysteryReels: {
      redirectUrl: "/casino/ezgrt-mystery-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MysteryReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mystery Reels",
      providerName: "slots",
    },
    PiggyRichesMegaways: {
      redirectUrl: "/casino/ezgrt-piggy-riches-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiggyRichesMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Piggy Riches Megaways",
      providerName: "slots",
    },
    JingleBells: {
      redirectUrl: "/casino/ezgrt-jingle-bells",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JingleBells.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Bells",
      providerName: "slots",
    },
    JackinaPot: {
      redirectUrl: "/casino/ezgrt-jack-in-a-pot",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JackinaPot.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack in a Pot",
      providerName: "slots",
    },
    FiveStar: {
      redirectUrl: "/casino/ezgrt-five-star",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FiveStar.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Five Star",
      providerName: "slots",
    },
    BountyRaid: {
      redirectUrl: "/casino/ezgrt-bounty-raid",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/BountyRaid.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Bounty Raid",
      providerName: "slots",
    },
    CashUltimate: {
      redirectUrl: "/casino/ezgrt-cash-ultimate",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CashUltimate.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cash Ultimate",
      providerName: "slots",
    },
    CashVolt: {
      redirectUrl: "/casino/ezgrt-cash-volt",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CashVolt.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cash Volt",
      providerName: "slots",
    },
    DynamiteRiches: {
      redirectUrl: "/casino/ezgrt-dynamite-riches",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DynamiteRiches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dynamite Riches",
      providerName: "slots",
    },
    DiamondBlitz: {
      redirectUrl: "/casino/ezgrt-diamond-blitz",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DiamondBlitz.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Diamond Blitz",
      providerName: "slots",
    },
    DragonsFireMegaways: {
      redirectUrl: "/casino/ezgrt-dragons-fire-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsFireMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Fire Megaways",
      providerName: "slots",
    },
    Squad4: {
      redirectUrl: "/casino/ezgrt-4-squad",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/4Squad.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "4 Squad",
      providerName: "slots",
    },
    AgentRoyale: {
      redirectUrl: "/casino/ezgrt-agent-royale",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AgentRoyale.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Agent Royale",
      providerName: "slots",
    },
    Families5: {
      redirectUrl: "/casino/ezgrt-5-families",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/5Families.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "5 Families",
      providerName: "slots",
    },
    ArcadeBomb: {
      redirectUrl: "/casino/ezgrt-arcade-bomb",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ArcadeBomb.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Arcade Bomb",
      providerName: "slots",
    },
    CinderellasBall: {
      redirectUrl: "/casino/ezgrt-cinderellas-ball",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CinderellasBall.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cinderella`s Ball",
      providerName: "slots",
    },
    Atlantis: {
      redirectUrl: "/casino/ezgrt-atlantis",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/Atlantis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Atlantis",
      providerName: "slots",
    },
    AztecSpins: {
      redirectUrl: "/casino/ezgrt-aztec-spins",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AztecSpins.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aztec Spins",
      providerName: "slots",
    },
    ClashoftheBeasts: {
      redirectUrl: "/casino/ezgrt-clash-of-the-beasts",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ClashoftheBeasts.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Clash of the Beasts",
      providerName: "slots",
    },
    CirquedelaFortune: {
      redirectUrl: "/casino/ezgrt-cirque-de-la-fortune",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CirquedelaFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cirque de la Fortune",
      providerName: "slots",
    },
    CrazyGenie: {
      redirectUrl: "/casino/ezgrt-crazy-genie",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CrazyGenie.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Crazy Genie",
      providerName: "slots",
    },
    CrystalMirror: {
      redirectUrl: "/casino/ezgrt-crystal-mirror",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CrystalMirror.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Crystal Mirror",
      providerName: "slots",
    },
    DevilsNumber: {
      redirectUrl: "/casino/ezgrt-devils-number",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DevilsNumber.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Devil`s Number",
      providerName: "slots",
    },
    DaVincisMystery: {
      redirectUrl: "/casino/ezgrt-da-vincis-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DaVincisMystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Da Vinci`s Mystery",
      providerName: "slots",
    },
    DiceDiceDice: {
      redirectUrl: "/casino/ezgrt-dice-dice-dice",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DiceDiceDice.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dice Dice Dice",
      providerName: "slots",
    },
    FiveStarsPowerReels: {
      redirectUrl: "/casino/ezgrt-five-stars-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FiveStarsPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Five Stars Power Reels",
      providerName: "slots",
    },
    GemsGoneWild: {
      redirectUrl: "/casino/ezgrt-gems-gone-wild",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GemsGoneWild.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gems Gone Wild",
      providerName: "slots",
    },
    GemsGoneWildPowerReels: {
      redirectUrl: "/casino/ezgrt-gems-gone-wild-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GemsGoneWildPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gems Gone Wild Power Reels",
      providerName: "slots",
    },
    GoldenCryptex: {
      redirectUrl: "/casino/ezgrt-golden-cryptex",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenCryptex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Cryptex",
      providerName: "slots",
    },
    GoldenLeprechaunMegaways: {
      redirectUrl: "/casino/ezgrt-golden-leprechaun-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenLeprechaunMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Leprechaun Megaways",
      providerName: "slots",
    },
    GrandWheel: {
      redirectUrl: "/casino/ezgrt-grand-wheel",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GrandWheel.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Grand Wheel",
      providerName: "slots",
    },
    GoldenTsar: {
      redirectUrl: "/casino/ezgrt-golden-tsar",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenTsar.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Tsar",
      providerName: "slots",
    },
    HoardofPoseidon: {
      redirectUrl: "/casino/ezgrt-hoard-of-poseidon",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/HoardofPoseidon.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Hoard of Poseidon",
      providerName: "slots",
    },
    JewelScarabs: {
      redirectUrl: "/casino/ezgrt-jewel-scarabs",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JewelScarabs.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jewel Scarabs",
      providerName: "slots",
    },
    LegendofAthena: {
      redirectUrl: "/casino/ezgrt-legend-of-athena",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LegendofAthena.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Legend of Athena",
      providerName: "slots",
    },
    JingleBellsPowerReels: {
      redirectUrl: "/casino/ezgrt-jingle-bells-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JingleBellsPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Bells Power Reels",
      providerName: "slots",
    },
    LuckyHalloween: {
      redirectUrl: "/casino/ezgrt-lucky-halloween",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyHalloween.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Halloween",
      providerName: "slots",
    },
    LuckyLittleDevil: {
      redirectUrl: "/casino/ezgrt-lucky-little-devil",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyLittleDevil.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Little Devil",
      providerName: "slots",
    },
    LuckyValentine: {
      redirectUrl: "/casino/ezgrt-lucky-valentine",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyValentine.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Valentine",
      providerName: "slots",
    },
    LuckyWizard: {
      redirectUrl: "/casino/ezgrt-lucky-wizard",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyWizard.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Wizard",
      providerName: "slots",
    },
    Masquerade: {
      redirectUrl: "/casino/ezgrt-masquerade",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/Masquerade.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Masquerade",
      providerName: "slots",
    },
    MayanGods: {
      redirectUrl: "/casino/ezgrt-mayan-gods",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MayanGods.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mayan Gods",
      providerName: "slots",
    },
    MegaDragon: {
      redirectUrl: "/casino/ezgrt-mega-dragon",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaDragon.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Dragon",
      providerName: "slots",
    },
    MegaJade: {
      redirectUrl: "/casino/ezgrt-mega-jade",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaJade.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Jade",
      providerName: "slots",
    },
    MegaRise: {
      redirectUrl: "/casino/ezgrt-mega-rise",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaRise.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Rise",
      providerName: "slots",
    },
    MultiplierRiches: {
      redirectUrl: "/casino/ezgrt-multiplier-riches",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MultiplierRiches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Multiplier Riches",
      providerName: "slots",
    },
    MysteryReelsMegaways: {
      redirectUrl: "/casino/ezgrt-mystery-reels-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MysteryReelsMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mystery Reels Megaways",
      providerName: "slots",
    },
    NinjaWays: {
      redirectUrl: "/casino/ezgrt-ninja-ways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Ninja Ways",
      providerName: "slots",
    },
    PathofDestiny: {
      redirectUrl: "/casino/ezgrt-path-of-destiny",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PathofDestiny.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Path of Destiny",
      providerName: "slots",
    },
    PersianFortune: {
      redirectUrl: "/casino/ezgrt-persian-fortune",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PersianFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Persian Fortune",
      providerName: "slots",
    },
    ReelHeist: {
      redirectUrl: "/casino/ezgrt-reel-heist",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelHeist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Heist",
      providerName: "slots",
    },
    RobinHoodsWildForest: {
      redirectUrl: "/casino/ezgrt-robin-hoods-wild-forest",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RobinHoodsWildForest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Robin Hood`s Wild Forest",
      providerName: "slots",
    },
    SnowWildAndThe7Features: {
      redirectUrl: "/casino/ezgrt-snow-wild-and-the-7-features",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/SnowWildAndThe7Features.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Snow Wild And The 7 Features",
      providerName: "slots",
    },
    SylvanSpirits: {
      redirectUrl: "/casino/ezgrt-sylvan-spirits",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/SylvanSpirits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Sylvan Spirits",
      providerName: "slots",
    },
    TheGreatestTrainRobbery: {
      redirectUrl: "/casino/ezgrt-the-greatest-train-robbery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TheGreatestTrainRobbery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Greatest Train Robbery",
      providerName: "slots",
    },
    TheWildHatter: {
      redirectUrl: "/casino/ezgrt-the-wild-hatter",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TheWildHatter.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Wild Hatter",
      providerName: "slots",
    },
    ThorsLightning: {
      redirectUrl: "/casino/ezgrt-thors-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ThorsLightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor`s Lightning",
      providerName: "slots",
    },
    TikiFruits: {
      redirectUrl: "/casino/ezgrt-tiki-fruits",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TikiFruits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Tiki Fruits",
      providerName: "slots",
    },
    VaultCracker: {
      redirectUrl: "/casino/ezgrt-vault-cracker",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/VaultCracker.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault Cracker",
      providerName: "slots",
    },
    TotemLightning: {
      redirectUrl: "/casino/ezgrt-totem-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TotemLightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Totem Lightning",
      providerName: "slots",
    },
    WellofWishes: {
      redirectUrl: "/casino/ezgrt-well-of-wishes",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WellofWishes.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Well of Wishes",
      providerName: "slots",
    },
    VaultofAnubis: {
      redirectUrl: "/casino/ezgrt-vault-of-anubis",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/VaultofAnubis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault of Anubis",
      providerName: "slots",
    },
    WildOClock: {
      redirectUrl: "/casino/ezgrt-wild-oclock",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildOClock.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild O`Clock",
      providerName: "slots",
    },
    WildCatsMultiline: {
      redirectUrl: "/casino/ezgrt-wild-cats-multiline",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildCatsMultiline.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Cats Multiline",
      providerName: "slots",
    },
    YucatansMystery: {
      redirectUrl: "/casino/ezgrt-yucatans-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/YucatansMystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Yucatan`s Mystery",
      providerName: "slots",
    },
    WildWildChest: {
      redirectUrl: "/casino/ezgrt-wild-wild-chest",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildWildChest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild Chest",
      providerName: "slots",
    },
    WinEscalator: {
      redirectUrl: "/casino/ezgrt-win-escalator",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WinEscalator.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Win Escalator",
      providerName: "slots",
    },
    },
    name: "Red Tiger",
    key: "redTiger",
  },

  jili: {
    slide1: {
      Poolrummy: {
        code: "98567",
        casino: "aura",
        provider: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Pool Rummy",
        name: "Pool Rummy",
        providerName: "Jili Gaming",
        imgUrl: "./images/casino/jili-games/PoolRummy.webp",
        redirectUrl: "/casino/aggapjiligaming-pool-rummy",
      },
      rummy7364: {
        code: "98567",
        casino: "aura",
        provider: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Rummy",
        name: "Rummy",
        providerName: "Jili Gaming",
        imgUrl: "./images/casino/jili-games/rummy-u7364.webp",
        redirectUrl: "/casino/aggapjiligaming-rummy-u7364",
      },
      //   rummy: {
      //   code: "98567",
      //   casino: "aura",
      //   provider: "Jili",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Rummy",
      //   name: "Rummy",
      //   providerName: "Jili Gaming",
      //   imgUrl: "./images/casino/jili-games/rummy.webp",
      //   redirectUrl: "/casino/aggapjiligaming-rummy",
      // },
      Threecardrummy: {
        redirectUrl: "/casino/aggapbetsoft-three-card-rummy",
        code: "98567",
        casino: "aura",
        provider: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        alt: "three card rummy",
        name: "Three card ummy",
        providerName: "Jili Gaming",
        imgUrl: "./images/casino/jili-games/threecardrummy.webp",
      },
      Coin3Treasures: {
        redirectUrl: "/casino/aggapjiligaming-3-coin-treasures",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/3-coin-treasures.webp",
        alt: "3 coin treasures",
        name: "3 coin treasures",
      },
      Lucky3Piggy: {
        redirectUrl: "/casino/aggapjiligaming-3-lucky-piggy",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/3-lucky-piggy.webp",
        alt: "3 lucky piggy",
        name: "3 lucky piggy",
      },
      Pot3Dragons: {
        redirectUrl: "/casino/aggapjiligaming-3-pot-dragons",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/3-pot-dragons.webp",
        alt: "3 pot dragons",
        name: "3 pot dragons",
      },
      AgentAce: {
        redirectUrl: "/casino/aggapjiligaming-agent-ace",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/agent-ace.webp",
        alt: "agent ace",
        name: "agent ace",
      },
      AliBaba: {
        redirectUrl: "/casino/aggapjiligaming-ali-baba",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/ali-baba.webp",
        alt: "ali baba",
        name: "ali baba",
      },
      ArenaFighter: {
        redirectUrl: "/casino/aggapjiligaming-arena-fighter",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/arena-fighter.webp",
        alt: "arena fighter",
        name: "arena fighter",
      },
      AztecPriestess: {
        redirectUrl: "/casino/aggapjiligaming-aztec-priestess",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/aztec-priestess.webp",
        alt: "aztec priestess",
        name: "aztec priestess",
      },
      BanglaBeauty: {
        redirectUrl: "/casino/aggapjiligaming-bangla-beauty",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/bangla-beauty.webp",
        alt: "bangla beauty",
        name: "bangla beauty",
      },
      BaoBoonChin: {
        redirectUrl: "/casino/aggapjiligaming-bao-boon-chin-u8868",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/bao-boon-chin.webp",
        alt: "bao boon chin",
        name: "bao boon chin",
      },
      BoneFortune: {
        redirectUrl: "/casino/aggapjiligaming-bone-fortune",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/bone-fortune.webp",
        alt: "bone fortune",
        name: "bone fortune",
      },
      BonusHunter: {
        redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/bonus-hunter.webp",
        alt: "bonus h1unter",
        name: "bonus hunter",
      },
      BookOfGold: {
        redirectUrl: "/casino/aggapjiligaming-book-of-gold",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/book-of-gold.webp",
        alt: "book of gold",
        name: "book of gold",
      },
      BoxingKing: {
        redirectUrl: "/casino/aggapjiligaming-boxing-king-u2533",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/boxing-king.webp",
        alt: "boxing king",
        name: "boxing king",
      },
      BubbleBeauty: {
        redirectUrl: "/casino/aggapjiligaming-bubble-beauty-u9301",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/bubble-beauty.webp",
        alt: "bubble beauty",
        name: "bubble beauty",
      },
      CargeBuffalo: {
        redirectUrl: "/casino/aggapjiligaming-charge-buffalo-u3171",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/charge-buffalo.webp",
        alt: "charge buffalo",
        name: "charge buffalo",
      },
      ChargeBuffaloAscent: {
        redirectUrl: "/casino/aggapjiligaming-charge-buffalo-ascent",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/charge-buffalo-ascent.webp",
        alt: "charge buffalo ascent",
        name: "charge buffalo ascent",
      },
      Chinshihuang: {
        redirectUrl: "/casino/aggapjiligaming-chin-shi-huang-u9500",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/chin-shi-huang.webp",
        alt: "",
        name: "Chin Shi Huang",
      },
      CrazyFafafa: {
        redirectUrl: "/casino/aggapjiligaming-crazy-fafafa-u4810",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/crazy-fafafa.webp",
        alt: "crazy fafafa",
        name: "crazy fafafa",
      },
      CrazyHunter: {
        redirectUrl: "/casino/aggapjiligaming-crazy-hunter",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/crazy-hunter.webp",
        alt: "crazy hunter",
        name: "crazy hunter",
      },
      Crazy777: {
        redirectUrl: "/casino/aggapjiligaming-crazy777-u3020",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/crazy777.webp",
        alt: "",
        name: "Crazy777",
      },
      CricketKing18: {
        redirectUrl: "/casino/aggapjiligaming-cricket-king-18",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/cricket-king-18.webp",
        alt: "cricket king 18",
        name: "cricket king 18",
      },
      CricketSah75: {
        redirectUrl: "/casino/aggapjiligaming-cricket-sah-75",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/cricket-sah-75.webp",
        alt: "cricket sah 75",
        name: "cricket sah 75",
      },
      Dabanggg: {
        redirectUrl: "/casino/aggapjiligaming-dabanggg",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/dabanggg.webp",
        alt: "dabanggg",
        name: "dabanggg",
      },
      DevilFire2: {
        redirectUrl: "/casino/aggapjiligaming-devil-fire-2",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/devil-fire-2.webp",
        alt: "devil fire 2",
        name: "devil fire 2",
      },
      DiamondParty: {
        redirectUrl: "/casino/aggapjiligaming-diamondparty",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/diamond-party.webp",
        alt: "diamond party",
        name: "diamond party",
      },
      DragonTreasure: {
        redirectUrl: "/casino/aggapjiligaming-dragon-treasure-u4739",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/dragon-treasure.webp",
        alt: "dragon treasure",
        name: "dragon treasure",
      },
      EgyptsGlow: {
        redirectUrl: "/casino/aggapjiligaming-egypts-glow",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/egypts-glow.webp",
        alt: "egypt's glow",
        name: "egypt's glow",
      },
      FaFaFa: {
        redirectUrl: "/casino/aggapjiligaming-fa-fa-fa-u6906",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/fa-fa-fa.webp",
        alt: "fa fa fa",
        name: "fa fa fa",
      },
      Fengshen: {
        redirectUrl: "/casino/aggapjiligaming-fengshen-u7470",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/fengshen.webp",
        alt: "fengshen",
        name: "fengshen",
      },
      FortuneGems: {
        redirectUrl: "/casino/aggapjiligaming-fortune-gems-u4245",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/fortune-gems.webp",
        alt: "fortune gems",
        name: "fortune gems",
      },
      FortuneGems2: {
        redirectUrl: "/casino/aggapjiligaming-fortune-gems-2",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/fortune-gems-2.webp",
        alt: "fortune gems 2",
        name: "fortune gems 2",
      },
      FortuneGems3: {
        redirectUrl: "/casino/aggapjiligaming-fortune-gems-3",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/fortune-gems-3.webp",
        alt: "fortune gems 3",
        name: "fortune gems 3",
      },
      FortuneMonkey: {
        redirectUrl: "/casino/aggapjiligaming-fortune-monkey",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/fortune-monkey.webp",
        alt: "fortune monkey",
        name: "fortune monkey",
      },
      FortuneTree: {
        redirectUrl: "/casino/aggapjiligaming-fortune-tree-u8538",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/fortune-tree.webp",
        alt: "",
        name: "Fortune Tree",
      },
      GemParty: {
        redirectUrl: "/casino/aggapjiligaming-gem-party-u2387",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/gem-party.webp",
        alt: "",
        name: "Gem Party",
      },
      GodOfMartial: {
        redirectUrl: "/casino/aggapjiligaming-god-of-martial-u5992",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/god-of-martial.webp",
        alt: "",
        name: "God Of Martial",
      },
      GoldRush: {
        redirectUrl: "/casino/aggapjiligaming-gold-rush",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/gold-rush.webp",
        alt: "gold rush",
        name: "gold rush",
      },
      GoldenBank: {
        redirectUrl: "/casino/aggapjiligaming-crazy-golden-bank-u4164",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/golden-bank.webp",
        alt: "golden bank",
        name: "golden bank",
      },
      GoldenEmpire: {
        redirectUrl: "/casino/aggapjiligaming-golden-empire-u7108",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/golden-empire.webp",
        alt: "golden empire",
        name: "golden empire",
      },
      GoldenJoker: {
        redirectUrl: "/casino/aggapjiligaming-golden-joker",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/golden-joker.webp",
        alt: "golden joker",
        name: "golden joker",
      },
      GoldenQueen: {
        redirectUrl: "/casino/aggapjiligaming-golden-queen-u4063",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/golden-queen.webp",
        alt: "golden queen",
        name: "golden queen",
      },
      GoldenTemple: {
        redirectUrl: "/casino/aggapjiligaming-golden-temple",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/golden-temple.webp",
        alt: "golden temple",
        name: "golden temple",
      },
      HappyTaxi: {
        redirectUrl: "/casino/aggapjiligaming-happy-taxi",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/happy-taxi.webp",
        alt: "happy taxi",
        name: "happy taxi",
      },
      HawaiiBeauty: {
        redirectUrl: "/casino/aggapjiligaming-hawaii-beauty",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/hawaii-beauty.webp",
        alt: "hawaii beauty",
        name: "hawaii beauty",
      },
      HotChili: {
        redirectUrl: "/casino/aggapjiligaming-hot-chilli-u9609",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/hot-chilli.webp",
        alt: "Hot Chilli",
        name: "Hot Chilli",
      },
      HyperBrust: {
        redirectUrl: "/casino/aggapjiligaming-hyper-burst-u8874",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/hyper-burst.webp",
        alt: "Hyper Burst",
        name: "Hyper Burst",
      },
      JiliCaishen: {
        redirectUrl: "/casino/aggapjiligaming-jili-caishen",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/jili-caishen.webp",
        alt: "jili caishen",
        name: "jili caishen",
      },
      JungleKing: {
        redirectUrl: "/casino/aggapjiligaming-jungle-king-u3906",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/jungle-king.webp",
        alt: "jungle king",
        name: "jungle king",
      },
      KingArthur: {
        redirectUrl: "/casino/aggapjiligaming-king-arthur",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/king-arthur.webp",
        alt: "king arthur",
        name: "king arthur",
      },
      LegacyOfEgypt: {
        redirectUrl: "/casino/aggapjiligaming-legacy-of-egypt",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/legacy-of-egypt.webp",
        alt: "legacy of egypt",
        name: "legacy of egypt",
      },
      LuckyBall: {
        redirectUrl: "/casino/aggapjiligaming-lucky-ball-u9225",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/lucky-ball.webp",
        alt: "lucky ball",
        name: "lucky ball",
      },
      LuckyComing: {
        redirectUrl: "/casino/aggapjiligaming-lucky-coming-u1332",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/lucky-coming.webp",
        alt: "lucky coming",
        name: "lucky coming",
      },
      MagicLamp: {
        redirectUrl: "/casino/aggapjiligaming-magic-lamp",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/magic-lamp.webp",
        alt: "magic lamp",
        name: "magic lamp",
      },
      MasterTiger: {
        redirectUrl: "/casino/aggapjiligaming-master-tiger",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/master-tiger.webp",
        alt: "master tiger",
        name: "master tiger",
      },
      MayanEmpire: {
        redirectUrl: "/casino/aggapjiligaming-mayan-empire",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/mayan-empire.webp",
        alt: "mayan empire",
        name: "mayan empire",
      },
      Medusa: {
        redirectUrl: "/casino/aggapjiligaming-medusa",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/medusa.webp",
        alt: "medusa",
        name: "medusa",
      },
      MegaAce: {
        redirectUrl: "/casino/aggapjiligaming-mega-ace",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/mega-ace.webp",
        alt: "mega ace",
        name: "mega ace",
      },
      MoneyComing: {
        redirectUrl: "/casino/aggapjiligaming-money-coming-u6162",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/money-coming.webp",
        alt: "money coming",
        name: "money coming",
      },
      MoneyComingExpandedBets: {
        redirectUrl: "/casino/aggapjiligaming-money-coming-expand-bets",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/money-coming-expanded-bets.webp",
        alt: "money coming expanded bets",
        name: "money coming expanded bets",
      },
      MonkeyParty: {
        redirectUrl: "/casino/aggapjiligaming-monkey-party-u2044",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/monkey-party.webp",
        alt: "monkey party",
        name: "monkey party",
      },
      NekoFortune: {
        redirectUrl: "/casino/aggapjiligaming-neko-fortune",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/neko-fortune.webp",
        alt: "neko fortune",
        name: "neko fortune",
      },
      NightCity: {
        redirectUrl: "/casino/aggapjiligaming-night-city",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/night-city.webp",
        alt: "night city",
        name: "night city",
      },
      PartyNight: {
        redirectUrl: "/casino/aggapjiligaming-party-night",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/party-night.webp",
        alt: "party night",
        name: "party night",
      },
      PartyStar: {
        redirectUrl: "/casino/aggapjiligaming-party-star",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/party-star.webp",
        alt: "party star",
        name: "party star",
      },
      PharaohTreasure: {
        redirectUrl: "/casino/aggapjiligaming-pharaoh-treasure-u8071",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/pharaoh-treasure.webp",
        alt: "pharaoh treasure",
        name: "pharaoh treasure",
      },
      PirateQueen: {
        redirectUrl: "/casino/aggapjiligaming-pirate-queen",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/pirate-queen.webp",
        alt: "pirate queen",
        name: "pirate queen",
      },
      Poseidon: {
        redirectUrl: "/casino/aggapjiligaming-poseidon",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/poseidon.webp",
        alt: "poseidon",
        name: "poseidon",
      },
      PotionWizard: {
        redirectUrl: "/casino/aggapjiligaming-potion-wizard",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/potion-wizard.webp",
        alt: "potion wizard",
        name: "potion wizard",
      },
      RomaX: {
        redirectUrl: "/casino/aggapjiligaming-romax-u7927",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/roma-x.webp",
        alt: "romax",
        name: "romax",
      },
      Samba: {
        redirectUrl: "/casino/aggapjiligaming-samba",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/samba.webp",
        alt: "samba",
        name: "samba",
      },
      SecretTreasure: {
        redirectUrl: "/casino/aggapjiligaming-secret-treasure-u2925",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/secret-treasure.webp",
        alt: "secret treasure",
        name: "secret treasure",
      },
      ShanghaiBeauty: {
        redirectUrl: "/casino/aggapjiligaming-shanghai-beauty-u4231",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/shanghai-beauty.webp",
        alt: "Shanghai Beauty",
        name: "Shanghai Beauty",
      },
      SinCity: {
        redirectUrl: "/casino/aggapjiligaming-sin-city",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/sin-city.webp",
        alt: "sin city",
        name: "sin city",
      },
      SuperAce: {
        redirectUrl: "/casino/aggapjiligaming-super-ace-u9419",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/super-ace.webp",
        alt: "super ace",
        name: "super ace",
      },
      SuperAceDeluxe: {
        redirectUrl: "/casino/aggapjiligaming-super-ace-deluxe",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/super-ace-deluxe.webp",
        alt: "super ace deluxe",
        name: "super ace deluxe",
      },
      SuperRich: {
        redirectUrl: "/casino/aggapjiligaming-super-rich-u8310",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/super-rich.webp",
        alt: "super rich",
        name: "super rich",
      },
      SweetLand: {
        redirectUrl: "/casino/aggapjiligaming-sweet-land",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/sweet-land.webp",
        alt: "sweet land",
        name: "sweet land",
      },
      ThorX: {
        redirectUrl: "/casino/aggapjiligaming-thor-x",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/thor-x.webp",
        alt: "thor x",
        name: "thor x",
      },
      TrialOfPhoenix: {
        redirectUrl: "/casino/aggapjiligaming-trial-of-phoenix",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/trial-of-phoenix.webp",
        alt: "trial of phoenix",
        name: "trial of phoenix",
      },
      TwinWins: {
        redirectUrl: "/casino/aggapjiligaming-twin-wins",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/twin-wins.webp",
        alt: "twin wins",
        name: "twin wins",
      },
      WarOfDragons: {
        redirectUrl: "/casino/aggapjiligaming-war-of-dragons-u8775",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/war-of-dragons.webp",
        alt: "war of dragons",
        name: "war of dragons",
      },
      WildAce: {
        redirectUrl: "/casino/aggapjiligaming-wild-ace",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/wild-ace.webp",
        alt: "wild ace",
        name: "wild ace",
      },
      WildRacer: {
        redirectUrl: "/casino/aggapjiligaming-wild-racer",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/wild-racer.webp",
        alt: "wild racer",
        name: "wild racer",
      },
      WitchesNight: {
        redirectUrl: "/casino/aggapjiligaming-witches-night",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/witches-night.webp",
        alt: "witches night",
        name: "witches night",
      },
      WorldCup: {
        redirectUrl: "/casino/aggapjiligaming-world-cup",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/world-cup.webp",
        alt: "world cup",
        name: "world cup",
      },
      Xiyangyang: {
        redirectUrl: "/casino/aggapjiligaming-xiyangyang-u3491",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/xiyangyang.webp",
        alt: "xiyangyang",
        name: "xiyangyang",
      },
      Zeus: {
        redirectUrl: "/casino/aggapjiligaming-zeus",
        code: "",
        casino: "Slots",
        provider: "Jili",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/jili-games/zeus.webp",
        alt: "zeus",
        name: "zeus",
      },
    },
    name: "Jili",
    key: "jiliGames",
  },

  popokgaming: {
    slide1: {
      CrashoSaurus: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggappopok-crashosaurus",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/crashosaurus.jpg",
        alt: "CrashoSaurus",
        name: "CrashoSaurus",
        provider: "Popok",
      },
      CrazyPokiBoo: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggappopok-crazy-poki-boo-u6978",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/crazypokiboo.jpg",
        alt: "Crazy Poki Boo",
        name: "Crazy Poki Boo",
        provider: "Popok",
      },
      dice: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggappopok-dice",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/dice.jpg",
        alt: "Dice",
        name: "Dice",
        provider: "Popok",
      },
      fastfruits: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggappopok-fast-fruits-u3499",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/fastfruits.jpg",
        alt: "Fast Fruits",
        name: "Fast Fruits",
        provider: "Popok",
      },
      fastmaster: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggappopok-fast-fruits-u3499",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/fastmaster.jpg",
        alt: "Fast Masters",
        name: "Fast Masters",
        provider: "Popok",
      },
      firstballon: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggappopok-first-balloon",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/firstballon.jpg",
        alt: "First Ballon",
        name: "First Ballon",
        provider: "Popok",
      },
      fortunepanda: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggappopok-fortune-panda",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/fortunepanda.jpg",
        alt: "Fortune Panda",
        name: "Fortune Panda",
        provider: "Popok",
      },
      halloweencrash: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggappopok-halloween-crash-u1317",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/halloweencrash.jpg",
        alt: "Halloween Crash",
        name: "Halloween Crash",
        provider: "Popok",
      },
      hohoho: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggappopok-ho-ho-ho-u1958",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/hohoho.jpg",
        alt: "Ho Ho Ho",
        name: "Ho Ho Ho",
        provider: "Popok",
      },
      hotangels: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggappopok-hot-angels-u6917",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/hotangels.jpg",
        alt: "Hot Angels",
        name: "Hot Angels",
        provider: "Popok",
      },
    },
    name: "Popok Gaming",
    key: "popokGaming",
  },
  playaceGaming: {
    slide1: {
      RouletteP62: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapplayace-roulette-p62",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/RouletteP62.jpg",
        alt: "Roulette P62",
        name: "Roulette P62",
        provider: "PlayAce",
      },
      SpeedRouletteP72: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapplayace-speed-roulette-p72",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/SpeedRouletteP72.jpg",
        alt: "Speed Roulette P72",
        name: "Speed Roulette P72",
        provider: "PlayAce",
      },
      SpeedSicboD10: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapplayace-speed-sicbo-d10",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/SpeedSicboD10.jpg",
        alt: "Speed Sicbo D10",
        name: "Speed Sicbo D10",
        provider: "PlayAce",
      },
      SqueezebaccaratP17: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapplayace-squeeze-baccarat-p17",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/SqueezebaccaratP17.jpg",
        alt: "Squeeze Baccarat P17",
        name: "Squeeze Baccarat P17",
        provider: "PlayAce",
      },
      SuperSpeedBaccaratP01: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapplayace-super-speed-baccarat-p01",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/SuperSpeedBaccaratP01.jpg",
        alt: "Super Speed Baccarat P01",
        name: "Super Speed Baccarat P01",
        provider: "PlayAce",
      },
      SuperSpeedBaccaratP02: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapplayace-super-speed-baccarat-p02",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/SuperSpeedBaccaratP02.jpg",
        alt: "Super Speed Baccarat P02",
        name: "Super Speed Baccarat P02",
        provider: "PlayAce",
      },
      SuperSpeedBaccaratP04: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapplayace-super-speed-baccarat-p04",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/SuperSpeedBaccaratP04.jpg",
        alt: "Super Speed Baccarat P04",
        name: "Super Speed Baccarat P04",
        provider: "PlayAce",
      },
      SuperSpeedBaccaratP05: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapplayace-super-speed-baccarat-p05",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/SuperSpeedBaccaratP05.jpg",
        alt: "Super Speed Baccarat P05",
        name: "Super Speed Baccarat P05",
        provider: "PlayAce",
      },
      SuperSpeedBaccaratP06: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapplayace-super-speed-baccarat-p06",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/SuperSpeedBaccaratP06.jpg",
        alt: "Super Speed Baccarat P06",
        name: "Super Speed Baccarat P06",
        provider: "PlayAce",
      },
    },
    name: "PlayAce Gaming",
    key: "playaceGaming",
  },
  tvbetGames: {
    slide1: {
      betOne: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggaptvbet-1bet",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/1bet.jpg",
        alt: "1 Bet",
        name: "1 Bet",
        provider: "TV Bet",
      },
      betFive: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggaptvbet-5bet",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/5bet.jpg",
        alt: "5 Bet",
        name: "5 Bet",
        provider: "TV Bet",
      },
      betSeven: {
        code: "",
        casino: "Ezugi",       
        redirectUrl: "/casino/aggaptvbet-7bet-u8340",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/7bet.jpg",
        alt: "7 Bet",
        name: "7 Bet",
        provider: "TV Bet",
      },
      Aerobet: {
        code: "",
        casino: "Ezugi",    
        redirectUrl: "/casino/aggaptvbet-aerobet",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/Aerobet.jpg",
        alt: "Aerobet",
        name: "Aerobet",
        provider: "TV Bet",
      },
      Blackjack: {
        code: "",
        casino: "Ezugi",    
        redirectUrl: "/casino/aggaptvbet-blackjack-u2779",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/blackjack.jpg",
        alt: "Blackjack",
        name: "Blackjack",
        provider: "TV Bet",
      },
      fastkeno: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggaptvbet-fast-keno-u1028",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/fastkeno.jpg",
        alt: "Fast Keno",
        name: "Fast Keno",
        provider: "TV Bet",
      },
      lucky6: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggaptvbet-lucky6-u5101",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/lucky6.jpg",
        alt: "Lucky6",
        name: "Lucky6",
        provider: "TV Bet",
      },
      poker: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggaptvbet-poker-u6785",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/poker.jpg",
        alt: "Poker",
        name: "Poker",
        provider: "TV Bet",
      },
      war: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggaptvbet-war",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/war.jpg",
        alt: "War",
        name: "War",
        provider: "TV Bet",
      },
      wheelbet: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggaptvbet-wheelbet-u4797",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/wheelbet.jpg",
        alt: "Wheelbet",
        name: "Wheelbet",
        provider: "TV Bet",
      },
      WheelBonus: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggaptvbet-wheelbet-bonus",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/WheelBonus.jpg",
        alt: "WheelBonus",
        name: "WheelBonus",
        provider: "TV Bet",
      },
    },
    name: "TV Bet",
    key: "tvbetGames",
  },
  vivoGaming: {
    slide1: {
      legendofheroes: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/pragmaticplay-legend-of-heroes",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/legendofheroes.jpg",
        alt: "Legend of Heroes",
        name: "Legend of Heroes",
        provider: "Vivo Gaming",
      },
      leprechauncarol: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/pragmaticplay-leprechaun-carol",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/leprechauncarol.jpg",
        alt: "Leprechaun Carol",
        name: "Leprechaun Carol",
        provider: "Vivo Gaming",
      },
      leprechaunsong: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/pragmaticplay-leprechaun-song",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/leprechaunsong.jpg",
        alt: "Leprechaun Song",
        name: "Leprechaun Song",
        provider: "Vivo Gaming",
      },
      lokisriches: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/pragmaticplay-lokis-riches",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/lokisriches.jpg",
        alt: "Loki's Riches",
        name: "Loki's Riches",
        provider: "Vivo Gaming",
      },
      Lucknewyear: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/pragmaticplay-lucky-new-year",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/Lucknewyear.jpg",
        alt: "Lucky New Year",
        name: "Lucky New Year",
        provider: "Vivo Gaming",
      },
      luckydragons: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/pragmaticplay-lucky-dragons",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/luckydragons.jpg",
        alt: "Lucky Dragons",
        name: "Lucky Dragons",
        provider: "Vivo Gaming",
      },
      luckyfishingmegaways: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/pragmaticplay-lucky-fishing-megaways",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/luckyfishingmegaways.jpg",
        alt: "Lucky Fishing Megaways",
        name: "Lucky Fishing Megaways",
        provider: "Vivo Gaming",
      },
      luckygarceandcharm: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/pragmaticplay-lucky-grace-and-charm",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/luckygarceandcharm.jpg",
        alt: "Lucky Grace And Charm",
        name: "Lucky Grace And Charm",
        provider: "Vivo Gaming",
      },
      luckylightning: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/pragmaticplay-lucky-lightning",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/luckylightning.jpg",
        alt: "Lucky Lightning",
        name: "Lucky Lightning",
        provider: "Vivo Gaming",
      },
      luckyswildPub: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/pragmaticplay-luckys-wild-pub",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/popular/slots/luckyswildPub.jpg",
        alt: "Lucky’s Wild Pub",
        name: "Lucky’s Wild Pub",
        provider: "Vivo Gaming",
      },
    },
    name: "Vivo Gaming",
    key: "vivoGaming",
  },
  crashGames: {
    slide1: {
      Sugarfrenzy1000: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapcrashlive-sugarfrenzy1000",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/crashgames/Sugarfrenzy1000-new.webp",
        alt: "Sugarfrenzy1000",
        name: "Sugarfrenzy1000",
        provider: "Crash Games",
      },
      Olympusscatterrealms: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapcrashlive-olympusscatterrealms",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/crashgames/gatessofolympus.webp",
        alt: "Olympusscatterrealms",
        name: "Olympusscatterrealms",
        provider: "Crash Games",
      },
      Olympusrealms1000: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapcrashlive-olympusrealms1000",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/crashgames/gatessofolympus1000.webp",
        alt: "Olympusrealms1000",
        name: "Olympusrealms1000",
        provider: "Crash Games",
      },
      MegaAce: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapcrashlive-megaace",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/crashgames/megaace-new.webp",
        alt: "MegaAce",
        name: "MegaAce",
        provider: "Crash Games",
      },
      MahjongMastery2: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapcrashlive-mahjong-mastery2",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/crashgames/mahjongmystery2.webp",
        alt: "Mahjong Mastery2",
        name: "Mahjong Mastery2",
        provider: "Crash Games",
      },
      CandyBonanza1000: {
        code: "",
        casino: "Ezugi",
        redirectUrl: "/casino/aggapcrashlive-candy-bonanza1000",
        homeUrl: "/sports",
        imgUrl: "./images/casino-games/crashgames/sweetbonanza1000.webp",
        alt: "Candy Bonanza1000",
        name: "Candy Bonanza1000",
        provider: "Crash Games",
      },
      AviatorX2: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-aviatorx2",
        code: "",
        casino: "Mac88 Gaming Virtual",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/AviatorX2.webp",
        alt: "AviatorX2",
        name: "AviatorX2",
      },
      Baloon: {
        redirectUrl: "/casino/aggapsmartsoftgaming-baloon",
        code: "",
        casino: "Smartsoft Gaming",
        provider: "ALT_GAMING_GAP",
        gameType: "crash",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/Baloon.webp",
        alt: "Baloon",
        name: "Baloon",
      },
      Cappadocia: {
        redirectUrl: "/casino/aggapsmartsoftgaming-cappadocia",
        code: "",
        gameType: "crash",
        casino: "Smartsoft Gaming",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/Cappadocia.webp",
        alt: "Cappadocia",
        name: "Cappadocia",
      },
      CoinWinHoldTheSpin: {
        redirectUrl: "/casino/aggapgamzix-coin-win-hold-the-spin",
        code: "",
        gameType: "crash",
        casino: "Gamzix",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/CoinWinHoldTheSpin.webp",
        alt: "Coin Win: Hold The Spin",
        name: "Coin Win: Hold The Spin",
      },
      CrashX: {
        redirectUrl: "/casino/aggapturbogames-crash-x",
        code: "",
        gameType: "crash",
        casino: "Turbo Games",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/CrashX.webp",
        alt: "CrashX",
        name: "CrashX",
      },
      CricketX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-cricketx",
        code: "",
        gameType: "crash",
        casino: "Smartsoft Gaming",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/CricketX.webp",
        alt: "CricketX",
        name: "CricketX",
      },
      FirstPersonSuperSicBo: {
        redirectUrl: "/casino/aggapevolutiongaming-first-person-super-sic-bo",
        code: "",
        gameType: "crash",
        casino: "Evolution Gaming",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/FirstPersonSuperSicBo.webp",
        alt: "First Person Super Sic Bo",
        name: "First Person Super Sic Bo",
      },
      FootballX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-footballx",
        code: "",
        gameType: "crash",
        casino: "Smartsoft Gaming",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/FootballX.webp",
        alt: "FootballX",
        name: "FootballX",
      },
      JetX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-jetx",
        code: "",
        gameType: "crash",
        casino: "Smartsoft Gaming",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/JetX.webp",
        alt: "JetX",
        name: "JetX",
      },
      JetX3: {
        redirectUrl: "/casino/aggapsmartsoftgaming-jetx3",
        code: "",
        gameType: "crash",
        casino: "Smartsoft Gaming",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/JetX3.webp",
        alt: "JetX3",
        name: "JetX3",
      },
      JetXt: {
        redirectUrl: "/casino/aggapcrash88gaming-jetxt",
        code: "",
        gameType: "crash",
        casino: "CRASH88 Gaming",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/jetxt.webp",
        alt: "JetXt",
        name: "JetXt",
      },
      Kitex: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-kitex",
        code: "",
        gameType: "crash",
        casino: "Mac88 Gaming Virtual",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/Kitex.webp",
        alt: "Kitex",
        name: "Kitex",
      },
      OlympusofLuckHoldTheSpin: {
        redirectUrl: "/casino/aggapgamzix-olympus-of-luck-hold-the-spin",
        code: "",
        gameType: "crash",
        casino: "Gamzix",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/OlympusofLuckHoldTheSpin.webp",
        alt: "Olympus of Luck: Hold The Spin",
        name: "Olympus of Luck: Hold The Spin",
      },
      PushpaRani: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-pushpa-rani",
        code: "",
        gameType: "crash",
        casino: "Mac88 Gaming Virtual",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/PushpaRani.webp",
        alt: "Pushpa Rani",
        name: "Pushpa Rani",
      },
      SlicerX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-slicerx",
        code: "",
        gameType: "crash",
        casino: "Mac88 Gaming Virtual",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/SlicerX.webp",
        alt: "SlicerX",
        name: "SlicerX",
      },
      TowerX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-towerx",
        code: "",
        gameType: "crash",
        casino: "Smartsoft Gaming",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/crash-games/TowerX.webp",
        alt: "TowerX",
        name: "TowerX",
      },
    },
    name: "Crash Games",
    key: "crashGames",
  },
  hacksaw: {
    slide1: {
      SCRATCHPlatinum: {
        redirectUrl: "/casino/qt-scratch-platinum",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/SCRATCHPlatinum.webp",
        alt: "SCRATCH! Platinum",
        name: "SCRATCH! Platinum",
      },
      SCRATCHGold: {
        redirectUrl: "/casino/qt-scratch-gold",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/SCRATCHGold.webp",
        alt: "SCRATCH! Gold",
        name: "SCRATCH! Gold",
      },
      SCRATCHSilver: {
        redirectUrl: "/casino/qt-scratch-silver",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/SCRATCHSilver.webp",
        alt: "SCRATCH! Silver",
        name: "SCRATCH! Silver",
      },
      SCRATCHBronze: {
        redirectUrl: "/casino/qt-scratch-bronze",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/SCRATCHBronze.webp",
        alt: "SCRATCH! Bronze",
        name: "SCRATCH! Bronze",
      },
      SnowScratcher: {
        redirectUrl: "/casino/aggaphacksawgaming-snow-scratcher",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/SnowScratcher.webp",
        alt: "Snow Scratcher",
        name: "Snow Scratcher",
      },
      SummerScratch: {
        redirectUrl: "/casino/aggaphacksawgaming-summer-scratch",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/SummerScratch.webp",
        alt: "Summer Scratch",
        name: "Summer Scratch",
      },
      Express200Scratch: {
        redirectUrl: "/casino/qt-express-200-scratch",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Express200Scratch.webp",
        alt: "Express 200 Scratch",
        name: "Express 200 Scratch",
      },
      ScratchyMini: {
        redirectUrl: "/casino/aggaphacksawgaming-scratchy-mini",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ScratchyMini.webp",
        alt: "Scratchy Mini",
        name: "Scratchy Mini",
      },
      Scratchy: {
        redirectUrl: "/casino/aggaphacksawgaming-scratchy",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Scratchy.webp",
        alt: "Scratchy",
        name: "Scratchy",
      },
      // ScratchyBig: {
      //   redirectUrl: "/casino/aggaphacksawgaming-scratchy-big",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/hacksaw/ScratchyBig.webp",
      //   alt: "Scratchy Big",
      //   name: "Scratchy Big",
      // },
      MinesHS: {
        redirectUrl: "/casino/aggaphacksawgaming-mines-dare2win",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "mines",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Mines.webp",
        alt: "Mines",
        name: "Mines",
      },
      KingTreasure: {
        redirectUrl: "/casino/aggaphacksawgaming-king-treasure",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/KingTreasure.webp",
        alt: "King Treasure",
        name: "King Treasure",
      },
      QueenTreasure: {
        redirectUrl: "/casino/aggaphacksawgaming-queen-treasure",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/QueenTreasure.webp",
        alt: "Queen Treasure",
        name: "Queen Treasure",
      },
      PrinceTreasure: {
        redirectUrl: "/casino/aggaphacksawgaming-prince-treasure",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/PrinceTreasure.webp",
        alt: "Prince Treasure",
        name: "Prince Treasure",
      },
      HappyScratch: {
        redirectUrl: "/casino/aggaphacksawgaming-happy-scratch",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Happyscratch.webp",
        alt: "Happy Scratch",
        name: "Happy Scratch",
      },
      LOVEIsAllYouNeed: {
        redirectUrl: "/casino/aggaphacksawgaming-love-is-all-you-need",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/LoveIsAllYouNeed.webp",
        alt: "LOVE is all you need",
        name: "LOVE is all you need",
      },
      LuckyScratch: {
        redirectUrl: "/casino/aggaphacksawgaming-lucky-scratch",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Luckyscratch.webp",
        alt: "Lucky Scratch",
        name: "Lucky Scratch",
      },
      CashPool: {
        redirectUrl: "/casino/aggaphacksawgaming-cash-pool",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Cashpool.webp",
        alt: "Cash Pool",
        name: "Cash Pool",
      },
      CashScratch: {
        redirectUrl: "/casino/aggaphacksawgaming-cash-scratch",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/CashScratch.webp",
        alt: "Cash Scratch",
        name: "Cash Scratch",
      },
      ChaosCrewScratch: {
        redirectUrl: "/casino/aggaphacksawgaming-chaos-crew-scratch",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ChaosCrewScratch.webp",
        alt: "Chaos Crew Scratch",
        name: "Chaos Crew Scratch",
      },
      DreamCarUrban: {
        redirectUrl: "/casino/aggaphacksawgaming-dream-car-urban",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DreamCarUrban.webp",
        alt: "Dream Car Urban",
        name: "Dream Car Urban",
      },
      DreamCarSUV: {
        redirectUrl: "/casino/aggaphacksawgaming-dream-car-suv",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DreamCarSUV.webp",
        alt: "Dream Car SUV",
        name: "Dream Car SUV",
      },
      DreamCarSpeed: {
        redirectUrl: "/casino/aggaphacksawgaming-dream-car-speed",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DreamCarSpeed.webp",
        alt: "Dream Car Speed",
        name: "Dream Car Speed",
      },
      // EggstraCash: {
      //   redirectUrl: "/casino/aggaphacksawgaming-eggstra-cash",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/hacksaw/EggstraCash.webp",
      //   alt: "Eggstra Cash",
      //   name: "Eggstra Cash",
      // },
      FootballScratch: {
        redirectUrl: "/casino/aggaphacksawgaming-football-scratch",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/FootballScratch.webp",
        alt: "Football Scratch",
        name: "Football Scratch",
      },
      GoldRush: {
        redirectUrl: "/casino/aggaphacksawgaming-gold-rush",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/GoldRush.webp",
        alt: "Gold Rush",
        name: "Gold Rush",
      },
      RubyRush: {
        redirectUrl: "/casino/aggaphacksawgaming-ruby-rush",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/RubyRush.webp",
        alt: "Ruby Rush",
        name: "Ruby Rush",
      },
      DiamondRush: {
        redirectUrl: "/casino/aggaphacksawgaming-diamond-rush",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DiamondRush.webp",
        alt: "Diamond Rush",
        name: "Diamond Rush",
      },
      // LuckyShot: {
      //   redirectUrl: "/casino/aggaphacksawgaming-lucky-shot",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/hacksaw/LuckyShot.webp",
      //   alt: "Lucky Shot",
      //   name: "Lucky Shot",
      // },
      CashVaultI: {
        redirectUrl: "/casino/aggaphacksawgaming-cash-vault-i",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/CashVaultI.webp",
        alt: "Cash Vault I",
        name: "Cash Vault I",
      },
      CashVaultII: {
        redirectUrl: "/casino/aggaphacksawgaming-cash-vault-ii",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/CashVaultII.webp",
        alt: "Cash Vault II",
        name: "Cash Vault II",
      },
      CrazyDonuts: {
        redirectUrl: "/casino/aggaphacksawgaming-crazy-donuts",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/CrazyDonuts.webp",
        alt: "Crazy Donuts",
        name: "Crazy Donuts",
      },
      LuckyNumbersX8: {
        redirectUrl: "/casino/aggaphacksawgaming-lucky-numbers-x8",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/LuckyNumbersX8.webp",
        alt: "Lucky Numbers x8",
        name: "Lucky Numbers x8",
      },
      LuckyNumbersX12: {
        redirectUrl: "/casino/aggaphacksawgaming-lucky-numbers-x12",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/LuckyNumbersX12.webp",
        alt: "Lucky Numbers x12",
        name: "Lucky Numbers x12",
      },
      LuckyNumbersX16: {
        redirectUrl: "/casino/aggaphacksawgaming-lucky-numbers-x16",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/LuckyNumbersX16.webp",
        alt: "Lucky Numbers x16",
        name: "Lucky Numbers x16",
      },
      LuckyNumbersX20: {
        redirectUrl: "/casino/aggaphacksawgaming-lucky-numbers-x20",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/LuckyNumbersx20.webp",
        alt: "Lucky Numbers x20",
        name: "Lucky Numbers x20",
      },
      ItsBananas: {
        redirectUrl: "/casino/aggaphacksawgaming-its-bananas",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Itsbananas.webp",
        alt: "It's bananas",
        name: "It's bananas",
      },
      DoubleSalary1Year: {
        redirectUrl: "/casino/qt-double-salary-1-year",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DoubleSalary1Year.webp",
        alt: "Double Salary - 1 Year",
        name: "Double Salary - 1 Year",
      },
      ShaveTheBeard: {
        redirectUrl: "/casino/aggaphacksawgaming-shave-the-beard",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ShaveTheBeard.webp",
        alt: "Shave the Beard",
        name: "Shave the Beard",
      },
      CutTheGrass: {
        redirectUrl: "/casino/aggaphacksawgaming-cut-the-grass",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/CutTheGrass.webp",
        alt: "Cut the Grass",
        name: "Cut the Grass",
      },
      Scratchem: {
        redirectUrl: "/casino/qt-scratchem",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Scratchem.webp",
        alt: "Scratch’em",
        name: "Scratch’em",
      },
      KoiCash: {
        redirectUrl: "/casino/aggaphacksawgaming-koi-cash",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/KoiCash.webp",
        alt: "Koi Cash",
        name: "Koi Cash",
      },
      BreakTheIce: {
        redirectUrl: "/casino/aggaphacksawgaming-break-the-ice",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/BreakTheIce.webp",
        alt: "Break the Ice",
        name: "Break the Ice",
      },
      GoldCoins: {
        redirectUrl: "/casino/aggaphacksawgaming-gold-coins",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/GoldCoins.webp",
        alt: "Gold Coins",
        name: "Gold Coins",
      },
      FrogsScratch: {
        redirectUrl: "/casino/aggaphacksawgaming-frogs-scratch",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/FrogsScratch.webp",
        alt: "Frogs Scratch",
        name: "Frogs Scratch",
      },
      ShaveTheSheep: {
        redirectUrl: "/casino/aggaphacksawgaming-shave-the-sheep",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ShaveTheSheep.webp",
        alt: "Shave the Sheep",
        name: "Shave the Sheep",
      },
      SpookyScaryScratchy: {
        redirectUrl: "/casino/aggaphacksawgaming-spooky-scary-scratchy",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/SpookyScaryScratchy.webp",
        alt: "Spooky Scary Scratchy",
        name: "Spooky Scary Scratchy",
      },
      ThePerfectScratch: {
        redirectUrl: "/casino/aggaphacksawgaming-the-perfect-scratch",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ThePerfectScratch.webp",
        alt: "The perfect Scratch",
        name: "The perfect Scratch",
      },
      TigerScratch: {
        redirectUrl: "/casino/aggaphacksawgaming-tiger-scratch",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/TigerScratch.webp",
        alt: "Tiger Scratch",
        name: "Tiger Scratch",
      },
      RatRiches: {
        redirectUrl: "/casino/aggaphacksawgaming-rat-riches",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/RatRiches.webp",
        alt: "Rat Riches",
        name: "Rat Riches",
      },
      StackEmScratch: {
        redirectUrl: "/casino/aggaphacksawgaming-stackem-scratch",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/StackEmScratch.webp",
        alt: "Stack'Em Scratch",
        name: "Stack'Em Scratch",
      },
      GoPanda: {
        redirectUrl: "/casino/aggaphacksawgaming-go-panda",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/GoPanda.webp",
        alt: "Go Panda",
        name: "Go Panda",
      },
      WantedDeadOrAWild: {
        redirectUrl: "/casino/aggaphacksawgaming-wanted-dead-or-a-wild",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/WantedDeadOrAWild.webp",
        alt: "Wanted Dead or a Wild",
        name: "Wanted Dead or a Wild",
      },
      Wild2Die2: {
        redirectUrl: "/casino/aggaphacksawgaming-2-wild-2-die",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/2Wild2Die.webp",
        alt: "2 Wild 2 Die",
        name: "2 Wild 2 Die",
      },
      Coins: {
        redirectUrl: "/casino/qt-coins",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Coins.webp",
        alt: "Coins",
        name: "Coins",
      },
      Colors: {
        redirectUrl: "/casino/aggaphacksawgaming-colors",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Colors.webp",
        alt: "Colors",
        name: "Colors",
      },
      Blocks: {
        redirectUrl: "/casino/aggaphacksawgaming-blocks",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Blocks.webp",
        alt: "Blocks",
        name: "Blocks",
      },
      Boxes: {
        redirectUrl: "/casino/qt-boxes",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Boxes.webp",
        alt: "Boxes",
        name: "Boxes",
      },
      HiLo: {
        redirectUrl: "/casino/aggaphacksawgaming-hi-lo",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/HiLo.webp",
        alt: "Hi-Lo",
        name: "Hi-Lo",
      },
      Lines: {
        redirectUrl: "/casino/aggaphacksawgaming-lines",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Lines.webp",
        alt: "Lines",
        name: "Lines",
      },
      Plinko: {
        redirectUrl: "/casino/qt-plinko",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Plinko.webp",
        alt: "Plinko",
        name: "Plinko",
      },
      TwentyOne: {
        redirectUrl: "/casino/aggaphacksawgaming-twenty-one",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/TwentyOne.webp",
        alt: "Twenty-One",
        name: "Twenty-One",
      },
      Wheel: {
        redirectUrl: "/casino/aggaphacksawgaming-wheel",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Wheel.webp",
        alt: "Wheel",
        name: "Wheel",
      },
      XmasDrop: {
        redirectUrl: "/casino/aggaphacksawgaming-xmas-drop",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/XmasDrop.webp",
        alt: "Xmas Drop",
        name: "Xmas Drop",
      },
      DarkSummoning: {
        redirectUrl: "/casino/aggaphacksawgaming-dark-summoning",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DarkSummoning.webp",
        alt: "Dark Summoning",
        name: "Dark Summoning",
      },
      ImmortalDesire: {
        redirectUrl: "/casino/aggaphacksawgaming-immortal-desire",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ImmortalDesire.webp",
        alt: "Immortal Desire",
        name: "Immortal Desire",
      },
      EyeOfThePanda: {
        redirectUrl: "/casino/aggaphacksawgaming-eye-of-the-panda",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/EyeOfThePanda.webp",
        alt: "Eye of the Panda",
        name: "Eye of the Panda",
      },
      ChaosCrewII: {
        redirectUrl: "/casino/aggaphacksawgaming-chaos-crew-ii",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ChaosCrewII.webp",
        alt: "Chaos Crew II",
        name: "Chaos Crew II",
      },
      BennyTheBeer: {
        redirectUrl: "/casino/aggaphacksawgaming-benny-the-beer",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/BennyTheBeer.webp",
        alt: "Benny the Beer",
        name: "Benny the Beer",
      },
      Densho: {
        redirectUrl: "/casino/aggaphacksawgaming-densho",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Densho.webp",
        alt: "Densho",
        name: "Densho",
      },
      LeBandit: {
        redirectUrl: "/casino/aggaphacksawgaming-le-bandit",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/LeBandit.webp",
        alt: "Le Bandit",
        name: "Le Bandit",
      },
      RoninStackways: {
        redirectUrl: "/casino/aggaphacksawgaming-ronin-stackways",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/RoninStackways.webp",
        alt: "Ronin Stackways",
        name: "Ronin Stackways",
      },
      Dropem: {
        redirectUrl: "/casino/aggaphacksawgaming-dropem",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Dropem.webp",
        alt: "Drop'EM",
        name: "Drop'EM",
      },
      VendingMachine: {
        redirectUrl: "/casino/aggaphacksawgaming-vending-machine",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/VendingMachine.webp",
        alt: "Vending Machine",
        name: "Vending Machine",
      },
      BeastBelow: {
        redirectUrl: "/casino/aggaphacksawgaming-beast-below",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/BeastBelow.webp",
        alt: "Beast Below",
        name: "Beast Below",
      },
      MightyMasks: {
        redirectUrl: "/casino/aggaphacksawgaming-mighty-masks",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/MightyMasks.webp",
        alt: "Mighty Masks",
        name: "Mighty Masks",
      },
      AlphaEagle: {
        redirectUrl: "/casino/aggaphacksawgaming-alpha-eagle",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/AlphaEagle.webp",
        alt: "Alpha Eagle",
        name: "Alpha Eagle",
      },
      AztecTwist: {
        redirectUrl: "/casino/aggaphacksawgaming-aztec-twist",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/AztecTwist.webp",
        alt: "Aztec Twist",
        name: "Aztec Twist",
      },
      Bloodthirst: {
        redirectUrl: "/casino/aggaphacksawgaming-bloodthirst",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Bloodthirst.webp",
        alt: "Bloodthirst",
        name: "Bloodthirst",
      },
      BookOfTime: {
        redirectUrl: "/casino/aggaphacksawgaming-book-of-time",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/BookOfTime.webp",
        alt: "Book of Time",
        name: "Book of Time",
      },
      BornWild: {
        redirectUrl: "/casino/aggaphacksawgaming-born-wild",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/BornWild.webp",
        alt: "Born Wild",
        name: "Born Wild",
      },
      BreakBones: {
        redirectUrl: "/casino/aggaphacksawgaming-break-bones",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/BreakBones.webp",
        alt: "Break Bones",
        name: "Break Bones",
      },
      BuffaloStackNSync: {
        redirectUrl: "/casino/aggaphacksawgaming-buffalo-stacknsync",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/BuffaloStackNSync.webp",
        alt: "Buffalo Stack'n'Sync",
        name: "Buffalo Stack'n'Sync",
      },
      Cubes: {
        redirectUrl: "/casino/aggaphacksawgaming-cubes",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Cubes.webp",
        alt: "Cubes",
        name: "Cubes",
      },
      Cubes2: {
        redirectUrl: "/casino/aggaphacksawgaming-cubes-2",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Cubes2.webp",
        alt: "Cubes 2",
        name: "Cubes 2",
      },
      CursedSeas: {
        redirectUrl: "/casino/aggaphacksawgaming-cursed-seas",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/CursedSeas.webp",
        alt: "Cursed Seas",
        name: "Cursed Seas",
      },
      CashCompass: {
        redirectUrl: "/casino/aggaphacksawgaming-cash-compass",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/CashCompass.webp",
        alt: "Cash Compass",
        name: "Cash Compass",
      },
      CashQuest: {
        redirectUrl: "/casino/aggaphacksawgaming-cash-quest",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/CashQuest.webp",
        alt: "Cash Quest",
        name: "Cash Quest",
      },
      ChaosCrew: {
        redirectUrl: "/casino/aggaphacksawgaming-chaos-crew",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ChaosCrew.webp",
        alt: "Chaos Crew",
        name: "Chaos Crew",
      },
      DorkUnit: {
        redirectUrl: "/casino/aggaphacksawgaming-dork-unit",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DorkUnit.webp",
        alt: "Dork Unit",
        name: "Dork Unit",
      },
      DoubleRainbow: {
        redirectUrl: "/casino/aggaphacksawgaming-double-rainbow",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DoubleRainbow.webp",
        alt: "Double Rainbow",
        name: "Double Rainbow",
      },
      FearTheDark: {
        redirectUrl: "/casino/aggaphacksawgaming-fear-the-dark",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/FearTheDark.webp",
        alt: "Fear the Dark",
        name: "Fear the Dark",
      },
      ForestFortune: {
        redirectUrl: "/casino/aggaphacksawgaming-forest-fortune",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ForestFortune.webp",
        alt: "Forest Fortune",
        name: "Forest Fortune",
      },
      FranksFarm: {
        redirectUrl: "/casino/aggaphacksawgaming-franks-farm",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/FranksFarm.webp",
        alt: "Frank's Farm",
        name: "Frank's Farm",
      },
      FruitDuel: {
        redirectUrl: "/casino/aggaphacksawgaming-fruit-duel",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/FruitDuel.webp",
        alt: "Fruit Duel",
        name: "Fruit Duel",
      },
      Frutz: {
        redirectUrl: "/casino/aggaphacksawgaming-frutz",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Frutz.webp",
        alt: "Frutz",
        name: "Frutz",
      },
      GladiatorLegends: {
        redirectUrl: "/casino/aggaphacksawgaming-gladiator-legends",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/GladiatorLegends.webp",
        alt: "Gladiator Legends",
        name: "Gladiator Legends",
      },
      GronksGems: {
        redirectUrl: "/casino/aggaphacksawgaming-gronks-gems",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/GronksGems.webp",
        alt: "Gronk's Gems",
        name: "Gronk's Gems",
      },
      HandOfAnubis: {
        redirectUrl: "/casino/aggaphacksawgaming-hand-of-anubis",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/HandOfAnubis.webp",
        alt: "Hand Of Anubis",
        name: "Hand Of Anubis",
      },
      HarvestWilds: {
        redirectUrl: "/casino/aggaphacksawgaming-harvest-wilds",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/HarvestWilds.webp",
        alt: "Harvest Wilds",
        name: "Harvest Wilds",
      },
      HopNpop: {
        redirectUrl: "/casino/aggaphacksawgaming-hopnpop",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/HopNpop.webp",
        alt: "Hop'n'pop",
        name: "Hop'n'pop",
      },
      Itero: {
        redirectUrl: "/casino/aggaphacksawgaming-itero",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Itero.webp",
        alt: "Itero",
        name: "Itero",
      },
      JokerBombs: {
        redirectUrl: "/casino/aggaphacksawgaming-joker-bombs",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/JokerBombs.webp",
        alt: "Joker Bombs",
        name: "Joker Bombs",
      },
      KeepemCool: {
        redirectUrl: "/casino/aggaphacksawgaming-keepem-cool",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/KeepemCool.webp",
        alt: "Keep'em Cool",
        name: "Keep'em Cool",
      },
      KingCarrot: {
        redirectUrl: "/casino/aggaphacksawgaming-king-carrot",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/KingCarrot.webp",
        alt: "King Carrot",
        name: "King Carrot",
      },
      LetItSnow: {
        redirectUrl: "/casino/aggaphacksawgaming-let-it-snow",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/LetItSnow.webp",
        alt: "Let it Snow",
        name: "Let it Snow",
      },
      MagicPiggy: {
        redirectUrl: "/casino/aggaphacksawgaming-magic-piggy",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/MagicPiggy.webp",
        alt: "Magic Piggy",
        name: "Magic Piggy",
      },
      MayanStackways: {
        redirectUrl: "/casino/aggaphacksawgaming-mayan-stackways",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/MayanStackways.webp",
        alt: "Mayan Stackways",
        name: "Mayan Stackways",
      },
      MiamiMultiplier: {
        redirectUrl: "/casino/qt-miami-multiplier",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/MiamiMultiplier.webp",
        alt: "Miami Multiplier",
        name: "Miami Multiplier",
      },
      MysteryMotel: {
        redirectUrl: "/casino/aggaphacksawgaming-mystery-motel",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/MysteryMotel.webp",
        alt: "Mystery Motel",
        name: "Mystery Motel",
      },
      OmNom: {
        redirectUrl: "/casino/aggaphacksawgaming-omnom",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/OmNom.webp",
        alt: "OmNom",
        name: "OmNom",
      },
      OutlawsInc: {
        redirectUrl: "/casino/aggaphacksawgaming-outlaws-inc",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/OutlawsInc.webp",
        alt: "Outlaws Inc",
        name: "Outlaws Inc",
      },
      PugLife: {
        redirectUrl: "/casino/aggaphacksawgaming-pug-life",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/PugLife.webp",
        alt: "Pug Life",
        name: "Pug Life",
      },
      RIPCity: {
        redirectUrl: "/casino/aggaphacksawgaming-rip-city",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/RIPCity.webp",
        alt: "RIP City",
        name: "RIP City",
      },
      RocketReels: {
        redirectUrl: "/casino/aggaphacksawgaming-rocket-reels",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/RocketReels.webp",
        alt: "Rocket Reels",
        name: "Rocket Reels",
      },
      Rotten: {
        redirectUrl: "/casino/aggaphacksawgaming-rotten",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Rotten.webp",
        alt: "Rotten",
        name: "Rotten",
      },
      StackEM: {
        redirectUrl: "/casino/aggaphacksawgaming-stackem",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/StackEM.webp",
        alt: "Stack'EM",
        name: "Stack'EM",
      },
      Stickem: {
        redirectUrl: "/casino/qt-stick-em",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Stickem.webp",
        alt: "Stick ‘em",
        name: "Stick ‘em",
      },
      Stormforged: {
        redirectUrl: "/casino/aggaphacksawgaming-stormforged",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Stormforged.webp",
        alt: "Stormforged",
        name: "Stormforged",
      },
      TastyTreats: {
        redirectUrl: "/casino/aggaphacksawgaming-tasty-treats",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/TastyTreats.webp",
        alt: "Tasty Treats",
        name: "Tasty Treats",
      },
      TempleOfTorment: {
        redirectUrl: "/casino/aggaphacksawgaming-temple-of-torment",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/TempleOfTorment.webp",
        alt: "Temple of Torment",
        name: "Temple of Torment",
      },
      TheBoweryBoys: {
        redirectUrl: "/casino/aggaphacksawgaming-the-bowery-boys",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/TheBoweryBoys.webp",
        alt: "The Bowery Boys",
        name: "The Bowery Boys",
      },
      TheRespinners: {
        redirectUrl: "/casino/aggaphacksawgaming-the-respinners",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/TheRespinners.webp",
        alt: "The Respinners",
        name: "The Respinners",
      },
      TimeSpinners: {
        redirectUrl: "/casino/aggaphacksawgaming-time-spinners",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/TimeSpinners.webp",
        alt: "Time Spinners",
        name: "Time Spinners",
      },
      ToshiVideoClub: {
        redirectUrl: "/casino/aggaphacksawgaming-toshi-video-club",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ToshiVideoClub.webp",
        alt: "Toshi Video Club",
        name: "Toshi Video Club",
      },
      UndeadFortune: {
        redirectUrl: "/casino/aggaphacksawgaming-undead-fortune",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/UndeadFortune.webp",
        alt: "Undead Fortune",
        name: "Undead Fortune",
      },
      WarriorWays: {
        redirectUrl: "/casino/aggaphacksawgaming-warrior-ways",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/WarriorWays.webp",
        alt: "Warrior Ways",
        name: "Warrior Ways",
      },
      Xpander: {
        redirectUrl: "/casino/aggaphacksawgaming-xpander",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Xpander.webp",
        alt: "Xpander",
        name: "Xpander",
      },
      FeelTheBeat: {
        redirectUrl: "/casino/aggaphacksawgaming-feel-the-beat",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/FeelTheBeat.webp",
        alt: "Feel the Beat",
        name: "Feel the Beat",
      },
      BeamBoys: {
        redirectUrl: "/casino/aggaphacksawgaming-beam-boys",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/BeamBoys.webp",
        alt: "Beam Boys",
        name: "Beam Boys",
      },
      Baccarat: {
        redirectUrl: "/casino/aggaphacksawgaming-baccarat",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Baccarat.webp",
        alt: "Baccarat",
        name: "Baccarat",
      },
      FistOfDestruction: {
        redirectUrl: "/casino/aggaphacksawgaming-fist-of-destruction",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/FistOfDestruction.webp",
        alt: "Fist of Destruction",
        name: "Fist of Destruction",
      },
      DawnOfKings: {
        redirectUrl: "/casino/aggaphacksawgaming-dawn-of-kings",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DawnOfKings.webp",
        alt: "Dawn of Kings",
        name: "Dawn of Kings",
      },
      BouncyBombs: {
        redirectUrl: "/casino/aggaphacksawgaming-bouncy-bombs",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/BouncyBombs.webp",
        alt: "Bouncy Bombs",
        name: "Bouncy Bombs",
      },
      RustyAndCurly: {
        redirectUrl: "/casino/aggaphacksawgaming-rusty-and-curly",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/RustyAndCurly.webp",
        alt: "Rusty and Curly",
        name: "Rusty and Curly",
      },
      // ScratchAMillion: {
      //   redirectUrl: "/casino/qtechhacksawgaming-scratch-a-million-u8239",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/hacksaw/ScratchAMillion.webp",
      //   alt: "Scratch a Million",
      //   name: "Scratch a Million",
      // },
      // InstaCubes: {
      //   redirectUrl: "/casino/qtechhacksawgaming-insta-cubes-u4725",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/hacksaw/InstaCubes.webp",
      //   alt: "Insta Cubes",
      //   name: "Insta Cubes",
      // },
      LePharaoh: {
        redirectUrl: "/casino/aggaphacksawgaming-le-pharaoh",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/LePharaoh.webp",
        alt: "Le Pharaoh",
        name: "Le Pharaoh",
      },
      OctoAttack: {
        redirectUrl: "/casino/aggaphacksawgaming-octo-attack",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/OctoAttack.webp",
        alt: "Octo Attack",
        name: "Octo Attack",
      },
      EvilEyes: {
        redirectUrl: "/casino/aggaphacksawgaming-evil-eyes",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/EvilEyes.webp",
        alt: "Evil Eyes",
        name: "Evil Eyes",
      },
      SpeedCrash: {
        redirectUrl: "/casino/aggaphacksawgaming-speed-crash",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/SpeedCrash.webp",
        alt: "Speed Crash",
        name: "Speed Crash",
      },
      Limbo: {
        redirectUrl: "/casino/aggaphacksawgaming-limbo",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Limbo.webp",
        alt: "Limbo",
        name: "Limbo",
      },
      DonnyDough: {
        redirectUrl: "/casino/aggaphacksawgaming-donny-dough",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DonnyDough.webp",
        alt: "Donny Dough",
        name: "Donny Dough",
      },
      DragonsDomain: {
        redirectUrl: "/casino/aggaphacksawgaming-dragons-domain",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DragonsDomain.webp",
        alt: "Dragon's Domain",
        name: "Dragon's Domain",
      },
      SixSixSix: {
        redirectUrl: "/casino/aggaphacksawgaming-sixsixsix",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/SixSixSix.webp",
        alt: "SixSixSix",
        name: "SixSixSix",
      },
      Dice: {
        redirectUrl: "/casino/aggaphacksawgaming-dice",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Dice.webp",
        alt: "Dice",
        name: "Dice",
      },
      TaiTheToad: {
        redirectUrl: "/casino/aggaphacksawgaming-tai-the-toad",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/TaiTheToad.webp",
        alt: "Tai the Toad",
        name: "Tai the Toad",
      },
      TwistedLab: {
        redirectUrl: "/casino/aggaphacksawgaming-twisted-lab",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/TwistedLabs.webp",
        alt: "Twisted Lab",
        name: "Twisted Lab",
      },
      ZeZeus: {
        redirectUrl: "/casino/aggaphacksawgaming-ze-zeus",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ZeZeus.webp",
        alt: "Ze Zeus",
        name: "Ze Zeus",
      },
      CursedCrypt: {
        redirectUrl: "/casino/aggaphacksawgaming-cursed-crypt",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/CursedCrypt.webp",
        alt: "Cursed Crypt",
        name: "Cursed Crypt",
      },
      SlayersInc: {
        redirectUrl: "/casino/aggaphacksawgaming-slayers-inc",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/SlayersInc.webp",
        alt: "Slayers Inc",
        name: "Slayers Inc",
      },
      JellySlice: {
        redirectUrl: "/casino/aggaphacksawgaming-jelly-slice",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/JellySlice.webp",
        alt: "Jelly Slice",
        name: "Jelly Slice",
      },
      KeepEm: {
        redirectUrl: "/casino/aggaphacksawgaming-keepem",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/KeepEm.webp",
        alt: "Keep'Em",
        name: "Keep'Em",
      },
      DivineDrop: {
        redirectUrl: "/casino/aggaphacksawgaming-divine-drop",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DivineDrop.webp",
        alt: "Divine Drop",
        name: "Divine Drop",
      },
      OrbOfDestiny: {
        redirectUrl: "/casino/aggaphacksawgaming-orb-of-destiny",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/OrbOfDestiny.webp",
        alt: "Orb of Destiny",
        name: "Orb of Destiny",
      },
      CashCrew: {
        redirectUrl: "/casino/aggaphacksawgaming-cash-crew",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/CashCrew.webp",
        alt: "Cash Crew",
        name: "Cash Crew",
      },
      CloudPrincess: {
        redirectUrl: "/casino/aggaphacksawgaming-cloud-princess",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/CloudPrincess.webp",
        alt: "Cloud Princess",
        name: "Cloud Princess",
      },
      GetTheCheese: {
        redirectUrl: "/casino/aggaphacksawgaming-get-the-cheese",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/GetTheCheese.webp",
        alt: "Get The Cheese",
        name: "Get The Cheese",
      },
      RiseOfYmir: {
        redirectUrl: "/casino/aggaphacksawgaming-rise-of-ymir",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/RiseOfYmir.webp",
        alt: "Rise of Ymir",
        name: "Rise of Ymir",
      },
      WingsOfHorus: {
        redirectUrl: "/casino/aggaphacksawgaming-wings-of-horus",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/WingsOfHorus.webp",
        alt: "Wings of Horus",
        name: "Wings of Horus",
      },
      DuelAtDawn: {
        redirectUrl: "/casino/aggaphacksawgaming-duel-at-dawn",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DuelAtDawn.webp",
        alt: "Duel at Dawn",
        name: "Duel at Dawn",
      },
      SnowSlingers: {
        redirectUrl: "/casino/aggaphacksawgaming-snow-slingers",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/SnowSlingers.webp",
        alt: "Snow Slingers",
        name: "Snow Slingers",
      },
      ShaolinMaster: {
        redirectUrl: "/casino/aggaphacksawgaming-shaolin-master",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/ShaolinMaster.webp",
        alt: "Shaolin Master",
        name: "Shaolin Master",
      },
      DonutDivision: {
        redirectUrl: "/casino/aggaphacksawgaming-donut-division",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/DonutDivision.webp",
        alt: "Donut Division",
        name: "Donut Division",
      },
      FireMyLaser: {
        redirectUrl: "/casino/aggaphacksawgaming-fire-my-laser",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/FireMyLaser.webp",
        alt: "Fire My Laser",
        name: "Fire My Laser",
      },
      Klowns: {
        redirectUrl: "/casino/aggaphacksawgaming-klowns",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/Klowns.webp",
        alt: "Klowns",
        name: "Klowns",
      },
      LeViking: {
        redirectUrl: "/casino/aggaphacksawgaming-le-viking",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/LeViking.webp",
        alt: "Le Viking",
        name: "Le Viking",
      },
      PhoenixDuelReels: {
        redirectUrl: "/casino/aggaphacksawgaming-phoenix-duelreels",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/PhoenixDuelReels.webp",
        alt: "Phoenix DuelReels",
        name: "Phoenix DuelReels",
      },
      MarlinMasters: {
        redirectUrl: "/casino/aggaphacksawgaming-marlin-masters",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/MarlinMasters.webp",
        alt: "Marlin Masters",
        name: "Marlin Masters",
      },
      FRKNBananas: {
        redirectUrl: "/casino/aggaphacksawgaming-frkn-bananas",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/FRKNBananas.webp",
        alt: "FRKN Bananas",
        name: "FRKN Bananas",
      },
      HoundsOfHell: {
        redirectUrl: "/casino/aggaphacksawgaming-hounds-of-hell",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/hacksaw/HoundsOfHell.webp",
        alt: "Hounds of Hell",
        name: "Hounds of Hell",
      },
    },
    name: "Hacksaw",
    key: "hacksawGames",
  },
  turbo: {
    slide1: {
      BallAndBall: {
        redirectUrl: "/casino/aggapturbogames-ball-and-ball",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/Ball&Ball.webp",
        alt: "Ball & Ball",
        name: "Ball & Ball",
      },
      Bayraktar: {
        redirectUrl: "/casino/aggapturbogames-bayraktar",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/Bayraktar.webp",
        alt: "Bayraktar",
        name: "Bayraktar",
      },
      Bubbles: {
        redirectUrl: "/casino/aggapturbogames-bubbles",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/Bubbles.webp",
        alt: "Bubbles",
        name: "Bubbles",
      },
      DiceTwice: {
        redirectUrl: "/casino/aggapturbogames-dice-twice",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/DiceTwice.webp",
        alt: "Dice Twice",
        name: "Dice Twice",
      },
      DogsStreet: {
        redirectUrl: "/casino/aggapturbogames-dogs-street",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/DogsStreet.webp",
        alt: "Dogs' Street",
        name: "Dogs' Street",
      },
      DoubleRoll: {
        redirectUrl: "/casino/aggapturbogames-double-roll",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/DoubleRoll.webp",
        alt: "Double Roll",
        name: "Double Roll",
      },
      FastFielder: {
        redirectUrl: "/casino/aggapturbogames-fast-fielder",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/FastFielder.webp",
        alt: "Fast Fielder",
        name: "Fast Fielder",
      },
      FruitTowers: {
        redirectUrl: "/casino/aggapturbogames-fruit-towers",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/FruitTowers.webp",
        alt: "Fruit Towers",
        name: "Fruit Towers",
      },
      Hamsta: {
        redirectUrl: "/casino/aggapturbogames-hamsta",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/Hamsta.webp",
        alt: "Hamsta",
        name: "Hamsta",
      },
      JavelinX: {
        redirectUrl: "/casino/aggapturbogames-javelinx",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/JavelinX.webp",
        alt: "JavelinX",
        name: "JavelinX",
      },
      LimboRider: {
        redirectUrl: "/casino/aggapturbogames-limbo-rider",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/LimboRider.webp",
        alt: "Limbo Rider",
        name: "Limbo Rider",
      },
      Neko: {
        redirectUrl: "/casino/aggapturbogames-neko",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/Neko.webp",
        alt: "Neko",
        name: "Neko",
      },
      SaveThePrincess: {
        redirectUrl: "/casino/aggapturbogames-save-the-princess",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/SaveThePrincess.webp",
        alt: "Save the Princess",
        name: "Save the Princess",
      },
      SpinStrike: {
        redirectUrl: "/casino/aggapturbogames-spin-strike",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/SpinStrike.webp",
        alt: "Spin Strike",
        name: "Spin Strike",
      },
      Stairs: {
        redirectUrl: "/casino/aggapturbogames-fury-stairs",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/Stairs.webp",
        alt: "Stairs",
        name: "Stairs",
      },
      TradingDice: {
        redirectUrl: "/casino/aggapturbogames-trading-dice",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/TradingDice.webp",
        alt: "Trading Dice",
        name: "Trading Dice",
      },
      Towers: {
        redirectUrl: "/casino/aggapturbogames-towers",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/Towers.webp",
        alt: "Towers",
        name: "Towers",
      },
      TurboPlinko: {
        redirectUrl: "/casino/aggapturbogames-turbo-plinko",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/TurboPlinko.webp",
        alt: "Turbo Plinko",
        name: "Turbo Plinko",
      },
      WicketBlast: {
        redirectUrl: "/casino/aggapturbogames-wicket-blast",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/WicketBlast.webp",
        alt: "Wicket Blast",
        name: "Wicket Blast",
      },
      MagicKeno: {
        redirectUrl: "/casino/aggapturbogames-magic-keno",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/MagicKeno.webp",
        alt: "Magic Keno",
        name: "Magic Keno",
      },
      Vortex: {
        redirectUrl: "/casino/aggapturbogames-vortex",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/Vortex.webp",
        alt: "Vortex",
        name: "Vortex",
      },
      TakeMyPlinko: {
        redirectUrl: "/casino/aggapturbogames-take-my-plinko",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/TakeMyPlinko.webp",
        alt: "Take My Plinko",
        name: "Take My Plinko",
      },
      DiceThrice: {
        redirectUrl: "/casino/aggapturbogames-dice-thrice",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/DiceThrice.webp",
        alt: "Dice Thrice",
        name: "Dice Thrice",
      },
      PumpedX: {
        redirectUrl: "/casino/aggapturbogames-pumpedx",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/PumpedX.webp",
        alt: "PumpedX",
        name: "PumpedX",
      },
      DonnyKing: {
        redirectUrl: "/casino/aggapturbogames-donny-king",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/DonnyKing.webp",
        alt: "Donny King",
        name: "Donny King",
      },
      CrystalPoker: {
        redirectUrl: "/casino/aggapturbogames-crystal-poker",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/CrystalPoker.webp",
        alt: "Crystal Poker",
        name: "Crystal Poker",
      },
      JewelClicker: {
        redirectUrl: "/casino/aggapturbogames-jewel-clicker",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "turbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/JewelClicker.webp",
        alt: "Jewel Clicker",
        name: "Jewel Clicker",
      },
      aero: {
        redirectUrl: "/casino/aggapturbogames-aero",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "crash",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/Aero.webp",
        alt: "Aero",
        name: "Aero",
      },
      MinesTurbo: {
        redirectUrl: "/casino/aggapturbogames-mines",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "mines",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/Mines.webp",
        alt: "Mines",
        name: "Mines",
      },
      TurboMines: {
        redirectUrl: "/casino/aggapturbogames-turbo-mines",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "mines",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/TurboMines.webp",
        alt: "Turbo Mines",
        name: "Turbo Mines",
      },
      Tap1Mines: {
        redirectUrl: "/casino/aggapturbogames-1tap-mines",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "mines",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/1TapMines(InstantWin).webp",
        alt: "1Tap Mines",
        name: "1Tap Mines",
      },
      Tap1MinesIW: {
        redirectUrl: "/casino/qt-1tap-mines",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "mines",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/1TapMines.webp",
        alt: "1Tap Mines (Instant Win)",
        name: "1Tap Mines (Instant Win)",
      },
      MultiplayerMines: {
        redirectUrl: "/casino/aggapturbogames-multiplayer-mines",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "mines",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/MultiplayerMines.webp",
        alt: "Multiplayer Mines",
        name: "Multiplayer Mines",
      },
      BookOfMines: {
        redirectUrl: "/casino/aggapturbogames-book-of-mines",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "mines",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/BookOfMines.webp",
        alt: "Book of Mines",
        name: "Book of Mines",
      },
      HiLo: {
        redirectUrl: "/casino/aggapturbogames-hi-lo",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "hiLo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/Hi-Lo.webp",
        alt: "Hi-Lo",
        name: "Hi-Lo",
      },
      crashX: {
        redirectUrl: "/casino/aggapturbogames-crash-x",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "crashX",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/CrashX.webp",
        alt: "Crash X",
        name: "Crash X",
      },
      CrashXFootballEdition: {
        redirectUrl: "/casino/aggapturbogames-crash-x-football-edition",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "crashX",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/turbo/CrashXFootballEdition.webp",
        alt: "Crash X Football Edition",
        name: "Crash X Football Edition",
      },
    },
    name: "Turbo",
    key: "turboGames",
  },
  playNGo: {
    slide1: {
      SuperWheel: {
        redirectUrl: "/casino/aggapplayngo-super-wheel",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SuperWheel.webp",
        alt: "super wheel",
        name: "Super Wheel",
      },
      MoneyWheel: {
        redirectUrl: "/casino/aggapplayngo-money-wheel",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MoneyWheel.webp",
        alt: "money wheel",
        name: "Money Wheel",
      },
      RainforestMagicBingo: {
        redirectUrl: "/casino/aggapplayngo-rainforest-magic-bingo",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RainforestMagicBingo.webp",
        alt: "rainforest magic bingo",
        name: "Rainforest Magic Bingo",
      },
      SweetAlchemyBingo: {
        redirectUrl: "/casino/aggapplayngo-sweet-alchemy-bingo",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SweetAlchemyBingo.webp",
        alt: "sweet alchemy bingo",
        name: "Sweet Alchemy Bingo",
      },
      VikingRunecraftBingo: {
        redirectUrl: "/casino/aggapplayngo-viking-runecraft-bingo",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/VikingRunecraftBingo.webp",
        alt: "viking runecraft bingo",
        name: "Viking Runecraft Bingo",
      },
      Clown3MontyII: {
        redirectUrl: "/casino/aggapplayngo-3-clown-monty-ii",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/3ClownMontyII.webp",
        alt: "3 clown monty ii",
        name: "3 Clown Monty II",
      },
      PandasticAdventure: {
        redirectUrl: "/casino/aggapplayngo-pandastic-adventure",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PandasticAdventure.webp",
        alt: "pandastic adventure",
        name: "Pandastic Adventure",
      },
      TalesOfMithruneSynsFortune: {
        redirectUrl: "/casino/aggapplayngo-tales-of-mithrune-syns-fortune",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TalesofMithruneSynsFortune.webp",
        alt: "tales of mithrune syn's fortune",
        name: "Tales of Mithrune Syn's Fortune",
      },
      VikingRunecraft100: {
        redirectUrl: "/casino/aggapplayngo-viking-runecraft-100",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/VikingRunecraft100.webp",
        alt: "viking runecraft 100",
        name: "Viking Runecraft 100",
      },
      Gargantoonz: {
        redirectUrl: "/casino/aggapplayngo-gargantoonz",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Gargantoonz.webp",
        alt: "gargantoonz",
        name: "Gargantoonz",
      },
      MegaDonFeedingFrenzy: {
        redirectUrl: "/casino/aggapplayngo-mega-don-feeding-frenzy",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MegaDonFeedingFrenzy.webp",
        alt: "mega don feeding frenzy",
        name: "Mega Don: Feeding Frenzy",
      },
      InvadingVegasLasChristmas: {
        redirectUrl: "/casino/aggapplayngo-invading-vegas-las-christmas",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/InvadingVegasLasChristmas.webp",
        alt: "invading vegas las christmas",
        name: "Invading Vegas: Las Christmas",
      },
      LegacyOfDynasties: {
        redirectUrl: "/casino/aggapplayngo-legacy-of-dynasties",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LegacyofDynasties.webp",
        alt: "legacy of dynasties",
        name: "Legacy of Dynasties",
      },
      MonkeyBattlefortheScrolls: {
        redirectUrl: "/casino/aggapplayngo-monkey-battle-for-the-scrolls",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MonkeyBattlefortheScrolls.webp",
        alt: "monkey battle for the scrolls",
        name: "Monkey: Battle for the Scrolls",
      },
      SherwoodGold: {
        redirectUrl: "/casino/aggapplayngo-sherwood-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SherwoodGold.webp",
        alt: "sherwood gold",
        name: "Sherwood Gold",
      },
      RagingRex3: {
        redirectUrl: "/casino/aggapplayngo-raging-rex-3",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RagingRex3.webp",
        alt: "raging rex 3",
        name: "Raging Rex 3",
      },
      RuffHeist: {
        redirectUrl: "/casino/aggapplayngo-ruff-heist",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RuffHeist.webp",
        alt: "ruff heist",
        name: "Ruff Heist",
      },
      PiggyBlitz: {
        redirectUrl: "/casino/aggapplayngo-piggy-blitz",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PiggyBlitz.webp",
        alt: "piggy blitz",
        name: "Piggy Blitz",
      },
      ReturnoftheGreenKnight: {
        redirectUrl: "/casino/aggapplayngo-return-of-the-green-knight",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ReturnoftheGreenKnight.webp",
        alt: "return of the green knight",
        name: "Return of the Green Knight",
      },
      TempleOfProsperity: {
        redirectUrl: "/casino/aggapplayngo-temple-of-prosperity",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TempleofProsperity.webp",
        alt: "temple of prosperity",
        name: "Temple of Prosperity",
      },
      ScalesOfDead: {
        redirectUrl: "/casino/aggapplayngo-scales-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ScalesofDead.webp",
        alt: "scales of dead",
        name: "Scales of Dead",
      },
      BoatBonanzaColossalCatch: {
        redirectUrl: "/casino/aggapplayngo-boat-bonanza-colossal-catch",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BoatBonanzaColossalCatch.webp",
        alt: "boat bonanza colossal catch",
        name: "Boat Bonanza Colossal Catch",
      },
      HoneyRush100: {
        redirectUrl: "/casino/aggapplayngo-honey-rush-100",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HoneyRush100.webp",
        alt: "honey rush 100",
        name: "Honey Rush 100",
      },
      HugoLegacy: {
        redirectUrl: "/casino/aggapplayngo-hugo-legacy",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HugoLegacy.webp",
        alt: "hugo legacy",
        name: "Hugo Legacy",
      },
      SweetAlchemy100: {
        redirectUrl: "/casino/aggapplayngo-sweet-alchemy-100",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SweetAlchemy100.webp",
        alt: "sweet alchemy 100",
        name: "Sweet Alchemy 100",
      },
      ScrollOfSeth: {
        redirectUrl: "/casino/aggapplayngo-scroll-of-seth",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ScrollofSeth.webp",
        alt: "scroll of seth",
        name: "Scroll of Seth",
      },
      MerlinJourneyOfFlame: {
        redirectUrl: "/casino/aggapplayngo-merlin-journey-of-flame",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MerlinJourneyofFlame.webp",
        alt: "merlin journey of flame",
        name: "Merlin: Journey of Flame",
      },
      SparkyAndShortsHiddenJoules: {
        redirectUrl: "/casino/aggapplayngo-sparky-and-shorts-hidden-joules",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SparkyAndShortzHiddenJoules.webp",
        alt: "sparky & shorts hidden joules",
        name: "Sparky & Shorts Hidden Joules",
      },
      FoxMayhem: {
        redirectUrl: "/casino/aggapplayngo-fox-mayhem",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FoxMayhem.webp",
        alt: "fox mayhem",
        name: "Fox Mayhem",
      },
      RichWildeAndTheAmuletOfDead: {
        redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-amulet-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RichWildeandtheAmuletofDead.webp",
        alt: "rich wilde and the amulet of dead",
        name: "Rich Wilde and the Amulet of Dead",
      },
      SweetAlchemy2: {
        redirectUrl: "/casino/aggapplayngo-sweet-alchemy-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SweetAlchemy2.webp",
        alt: "sweet alchemy 2",
        name: "Sweet Alchemy 2",
      },
      RascalRiches: {
        redirectUrl: "/casino/aggapplayngo-rascal-riches",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RascalRiches.webp",
        alt: "rascal riches",
        name: "Rascal Riches",
      },
      Ternion: {
        redirectUrl: "/casino/aggapplayngo-ternion",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Ternion.webp",
        alt: "ternion",
        name: "Ternion",
      },
      VikingRunecraftApocalypse: {
        redirectUrl: "/casino/aggapplayngo-viking-runecraft-apocalypse",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/VikingRunecraftApocalypse.webp",
        alt: "viking runecraft apocalypse",
        name: "Viking Runecraft: Apocalypse",
      },
      Crystal15RosesATaleOfLove: {
        redirectUrl: "/casino/aggapplayngo-15-crystal-roses-a-tale-of-love",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/15CrystalRosesATaleOfLove.webp",
        alt: "15 crystal roses a tale of love",
        name: "15 Crystal Roses A Tale Of Love",
      },
      Dragon24k: {
        redirectUrl: "/casino/aggapplayngo-24k-dragon",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/24kDragon.webp",
        alt: "24k dragon",
        name: "24k Dragon",
      },
      Clown3Monty: {
        redirectUrl: "/casino/aggapplayngo-3-clown-monty",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/3ClownMonty.webp",
        alt: "3 clown monty",
        name: "3 Clown Monty",
      },
      Magic5x: {
        redirectUrl: "/casino/aggapplayngo-5x-magic",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/5xMagic.webp",
        alt: "5x magic",
        name: "5x Magic",
      },
      Sins7: {
        redirectUrl: "/casino/aggapplayngo-7-sins",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/7Sins.webp",
        alt: "7 sins",
        name: "7 Sins",
      },
      AceOfSpades: {
        redirectUrl: "/casino/aggapplayngo-ace-of-spades",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/AceofSpades.webp",
        alt: "ace of spades",
        name: "Ace of Spades",
      },
      AgentDestiny: {
        redirectUrl: "/casino/aggapplayngo-agent-destiny",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/AgentDestiny.webp",
        alt: "agent destiny",
        name: "Agent Destiny",
      },
      AgentOfHearts: {
        redirectUrl: "/casino/aggapplayngo-agent-of-hearts",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/AgentofHearts.webp",
        alt: "agent of hearts",
        name: "Agent of Hearts",
      },
      AnimalMadness: {
        redirectUrl: "/casino/aggapplayngo-animal-madness",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/AnimalMadness.webp",
        alt: "animal madness",
        name: "Animal Madness",
      },
      AnkhOfAnubis: {
        redirectUrl: "/casino/aggapplayngo-ankh-of-anubis",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/AnkhofAnubis.webp",
        alt: "ankh of anubis",
        name: "Ankh of Anubis",
      },
      Annihilator: {
        redirectUrl: "/casino/aggapplayngo-annihilator",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Annihilator.webp",
        alt: "annihilator",
        name: "Annihilator",
      },
      AthenaAscending: {
        redirectUrl: "/casino/aggapplayngo-athena-ascending",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/AthenaAscending.webp",
        alt: "athena ascending",
        name: "Athena Ascending",
      },
      AztecIdols: {
        redirectUrl: "/casino/aggapplayngo-aztec-idols",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/AztecIdols.webp",
        alt: "aztec idols",
        name: "Aztec Idols",
      },
      AztecWarriorPrincess: {
        redirectUrl: "/casino/aggapplayngo-aztec-warrior-princess",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/AztecWarriorPrincess.webp",
        alt: "aztec warrior princess",
        name: "Aztec Warrior Princess",
      },
      BakersTreat: {
        redirectUrl: "/casino/aggapplayngo-bakers-treat",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BakersTreat.webp",
        alt: "bakers treat",
        name: "Baker's Treat",
      },
      BananaRock: {
        redirectUrl: "/casino/aggapplayngo-banana-rock",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BananaRock.webp",
        alt: "banana rock",
        name: "Banana Rock",
      },
      BattleRoyal: {
        redirectUrl: "/casino/aggapplayngo-battle-royal",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BattleRoyal.webp",
        alt: "battle royal",
        name: "Battle Royal",
      },
      BeastsOfFire: {
        redirectUrl: "/casino/aggapplayngo-beasts-of-fire",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BeastsOfFire.webp",
        alt: "beasts of fire",
        name: "Beasts Of Fire",
      },
      BigWin777: {
        redirectUrl: "/casino/aggapplayngo-big-win-777",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BigWin777.webp",
        alt: "big win 777",
        name: "Big Win 777",
      },
      BigWinCat: {
        redirectUrl: "/casino/aggapplayngo-big-win-cat",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BigWinCat.webp",
        alt: "big win cat",
        name: "Big Win Cat",
      },
      BlackMamba: {
        redirectUrl: "/casino/aggapplayngo-black-mamba",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BlackMamba.webp",
        alt: "black mamba",
        name: "Black Mamba",
      },
      BlazinBullfrog: {
        redirectUrl: "/casino/aggapplayngo-blazin-bullfrog",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BlazinBullfrog.webp",
        alt: "blazin bullfrog",
        name: "Blazin' Bullfrog",
      },
      Blinged: {
        redirectUrl: "/casino/aggapplayngo-blinged",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Blinged.webp",
        alt: "blinged",
        name: "Blinged",
      },
      BoatBonanza: {
        redirectUrl: "/casino/aggapplayngo-boat-bonanza",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BoatBonanza.webp",
        alt: "boat bonanza",
        name: "Boat Bonanza",
      },
      BookOfDead: {
        redirectUrl: "/casino/aggapplayngo-book-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BookofDead.webp",
        alt: "book of dead",
        name: "Book of Dead",
      },
      BullInAChinaShop: {
        redirectUrl: "/casino/aggapplayngo-bull-in-a-china-shop",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BullinaChinaShop.webp",
        alt: "bull in a china shop",
        name: "Bull in a China Shop",
      },
      BullInARodeo: {
        redirectUrl: "/casino/aggapplayngo-bull-in-a-rodeo",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BullinaRodeo.webp",
        alt: "bull in a rodeo",
        name: "Bull in a Rodeo",
      },
      CandyIslandPrincess: {
        redirectUrl: "/casino/aggapplayngo-candy-island-princess",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CandyIslandPrincess.webp",
        alt: "candy island princess",
        name: "Candy Island Princess",
      },
      CanineCarnage: {
        redirectUrl: "/casino/aggapplayngo-canine-carnage",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CanineCarnage.webp",
        alt: "canine carnage",
        name: "Canine Carnage",
      },
      CaptainGlumPirateHunter: {
        redirectUrl: "/casino/aggapplayngo-captain-glum-pirate-hunter",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CaptainGlumPirateHunter.webp",
        alt: "captain glum pirate hunter",
        name: "Captain Glum: Pirate Hunter",
      },
      CaptainXenosEarthAdventure: {
        redirectUrl: "/casino/aggapplayngo-captain-xenos-earth-adventure",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CaptainXenosEarthAdventure.webp",
        alt: "captain xenos earth adventure",
        name: "Captain Xeno's Earth Adventure",
      },
      CashACabana: {
        redirectUrl: "/casino/aggapplayngo-cash-a-cabana",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CashaCabana.webp",
        alt: "cash a cabana",
        name: "Cash-a-Cabana",
      },
      CashOfCommand: {
        redirectUrl: "/casino/aggapplayngo-cash-of-command",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CashofCommand.webp",
        alt: "cash of command",
        name: "Cash of Command",
      },
      CashPump: {
        redirectUrl: "/casino/aggapplayngo-cash-pump",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CashPump.webp",
        alt: "cash pump",
        name: "Cash Pump",
      },
      CashVandal: {
        redirectUrl: "/casino/aggapplayngo-cash-vandal",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CashVandal.webp",
        alt: "cash vandal",
        name: "Cash Vandal",
      },
      CatWildeAndTheDoomOfDead: {
        redirectUrl: "/casino/aggapplayngo-cat-wilde-and-the-doom-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CatWildeandtheDoomofDead.webp",
        alt: "cat wilde and the doom of dead",
        name: "Cat Wilde and the Doom of Dead",
      },
      CatWildeAndTheLostChapter: {
        redirectUrl: "/casino/aggapplayngo-cat-wilde-and-the-lost-chapter",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CatWildeandtheLostChapter.webp",
        alt: "cat wilde and the lost chapter",
        name: "Cat Wilde and the Lost Chapter",
      },
      CatWildeAndThePyramidsOfDead: {
        redirectUrl: "/casino/aggapplayngo-cat-wilde-and-the-pyramids-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CatWildeandthePyramidsofDead.webp",
        alt: "cat wilde and the pyramids of dead",
        name: "Cat Wilde and the Pyramids of Dead",
      },
      CatWildeInTheEclipseOfTheSunGod: {
        redirectUrl:
          "/casino/aggapplayngo-cat-wilde-in-the-eclipse-of-the-sun-god",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "./images/casino/play-n-go/CatWildeintheEclipseoftheSunGod.webp",
        alt: "cat wilde in the eclipse of the sun god",
        name: "Cat Wilde in the Eclipse of the Sun God",
      },
      CatsAndCash: {
        redirectUrl: "/casino/aggapplayngo-cats-and-cash",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CatsandCash.webp",
        alt: "cats and cash",
        name: "Cats and Cash",
      },
      ChampionsOfMithrune: {
        redirectUrl: "/casino/aggapplayngo-champions-of-mithrune",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ChampionsofMithrune.webp",
        alt: "champions of mithrune",
        name: "Champions of Mithrune",
      },
      CharlieChance: {
        redirectUrl: "/casino/aggapplayngo-charlie-chance",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CharlieChance.webp",
        alt: "charlie chance",
        name: "Charlie Chance",
      },
      CharlieChanceAndTheCurseOfCleopatra: {
        redirectUrl:
          "/casino/aggapplayngo-charlie-chance-and-the-curse-of-cleopatra",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "./images/casino/play-n-go/CharlieChanceandTheCurseofCleopatra.webp",
        alt: "charlie chance and the curse of cleopatra",
        name: "Charlie Chance and The Curse of Cleopatra",
      },
      // CharlieChanceInHellToPay: {
      //   redirectUrl: "/casino/qtechplayngo-charlie-chance-in-hell-to-pay",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/play-n-go/CharlieChanceinHelltoPay.webp",
      //   alt: "charlie chance in hell to pay",
      //   name: "Charlie Chance in Hell to Pay",
      // },
      ChineseNewYear: {
        redirectUrl: "/casino/aggapplayngo-chinese-new-year",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ChineseNewYear.webp",
        alt: "chinese new year",
        name: "Chinese New Year",
      },
      ChronosJoker: {
        redirectUrl: "/casino/aggapplayngo-chronos-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ChronosJoker.webp",
        alt: "chronos joker",
        name: "Chronos Joker",
      },
      ClashOfCamelot: {
        redirectUrl: "/casino/aggapplayngo-clash-of-camelot",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ClashofCamelot.webp",
        alt: "clash of camelot",
        name: "Clash of Camelot",
      },
      CloudQuest: {
        redirectUrl: "/casino/aggapplayngo-cloud-quest",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CloudQuest.webp",
        alt: "cloud quest",
        name: "Cloud Quest",
      },
      CoilsOfCash: {
        redirectUrl: "/casino/aggapplayngo-coils-of-cash",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CoilsofCash.webp",
        alt: "coils of cash",
        name: "Coils of Cash",
      },
      ColtLightning: {
        redirectUrl: "/casino/aggapplayngo-colt-lightning",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ColtLightning.webp",
        alt: "colt lightning",
        name: "Colt Lightning",
      },
      Contact: {
        redirectUrl: "/casino/aggapplayngo-contact",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Contact.webp",
        alt: "contact",
        name: "Contact",
      },
      CopsNRobbers: {
        redirectUrl: "/casino/aggapplayngo-copsnrobbers",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CopsnRobbers.webp",
        alt: "copsnrobbers",
        name: "Cops'n'Robbers",
      },
      CountJokula: {
        redirectUrl: "/casino/aggapplayngo-count-jokula",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CountJokula.webp",
        alt: "count jokula",
        name: "Count Jokula",
      },
      CourtOfHearts: {
        redirectUrl: "/casino/aggapplayngo-court-of-hearts",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CourtofHearts.webp",
        alt: "court of hearts",
        name: "Court of Hearts",
      },
      CoywolfCash: {
        redirectUrl: "/casino/aggapplayngo-coywolf-cash",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CoywolfCash.webp",
        alt: "coywolf cash",
        name: "Coywolf Cash",
      },
      CrazyCows: {
        redirectUrl: "/casino/aggapplayngo-crazy-cows",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CrazyCows.webp",
        alt: "crazy cows",
        name: "Crazy Cows",
      },
      CrystalSun: {
        redirectUrl: "/casino/aggapplayngo-crystal-sun",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CrystalSun.webp",
        alt: "crystal sun",
        name: "Crystal Sun",
      },
      DawnOfEgypt: {
        redirectUrl: "/casino/aggapplayngo-dawn-of-egypt",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DawnofEgypt.webp",
        alt: "dawn of egypt",
        name: "Dawn of Egypt",
      },
      Demon: {
        redirectUrl: "/casino/aggapplayngo-demon",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Demon.webp",
        alt: "demon",
        name: "Demon",
      },
      DerbyWheel: {
        redirectUrl: "/casino/aggapplayngo-derby-wheel",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DerbyWheel.webp",
        alt: "derby wheel",
        name: "Derby Wheel",
      },
      DiamondsOfTheRealm: {
        redirectUrl: "/casino/aggapplayngo-diamonds-of-the-realm",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DiamondsoftheRealm.webp",
        alt: "diamonds of the realm",
        name: "Diamonds of the Realm",
      },
      DiamondVortex: {
        redirectUrl: "/casino/aggapplayngo-diamond-vortex",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DiamondVortex.webp",
        alt: "diamond-vortex",
        name: "Diamond Vortex",
      },
      DiscoDiamonds: {
        redirectUrl: "/casino/aggapplayngo-disco-diamonds",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DiscoDiamonds.webp",
        alt: "disco diamonds",
        name: "Disco Diamonds",
      },
      DivineShowdown: {
        redirectUrl: "/casino/aggapplayngo-divine-showdown",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DivineShowdown.webp",
        alt: "divine showdown",
        name: "Divine Showdown",
      },
      DrToonz: {
        redirectUrl: "/casino/aggapplayngo-dr-toonz",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DrToonz.webp",
        alt: "dr toonz",
        name: "Dr Toonz",
      },
      DoomOfEgypt: {
        redirectUrl: "/casino/aggapplayngo-doom-of-egypt",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DoomofEgypt.webp",
        alt: "doom of egypt",
        name: "Doom of Egypt",
      },
      DragonMaiden: {
        redirectUrl: "/casino/aggapplayngo-dragon-maiden",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DragonMaiden.webp",
        alt: "Dragon Maiden",
        name: "Dragon Maiden",
      },
      DragonShip: {
        redirectUrl: "/casino/aggapplayngo-dragon-ship",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DragonShip.webp",
        alt: "Dragon Ship",
        name: "Dragon Ship",
      },
      EasterEggs: {
        redirectUrl: "/casino/aggapplayngo-easter-eggs",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/EasterEggs.webp",
        alt: "Easter Eggs",
        name: "Easter Eggs",
      },
      EnchantedCrystals: {
        redirectUrl: "/casino/aggapplayngo-enchanted-crystals",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/EnchantedCrystals.webp",
        alt: "Enchanted Crystals",
        name: "Enchanted Crystals",
      },
      EnchantedMeadow: {
        redirectUrl: "/casino/aggapplayngo-enchanted-meadow",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/EnchantedMeadow.webp",
        alt: "Enchanted Meadow",
        name: "Enchanted Meadow",
      },
      Energoonz: {
        redirectUrl: "/casino/aggapplayngo-energoonz",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Energoonz.webp",
        alt: "Energoonz",
        name: "Energoonz",
      },
      EyeOfAtum: {
        redirectUrl: "/casino/aggapplayngo-eye-of-atum",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/EyeOfAtum.webp",
        alt: "Eye Of Atum",
        name: "Eye Of Atum",
      },
      EyeOfTheKraken: {
        redirectUrl: "/casino/aggapplayngo-eye-of-the-kraken",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/EyeOfTheKraken.webp",
        alt: "Eye of the Kraken",
        name: "Eye of the Kraken",
      },
      FatFrankies: {
        redirectUrl: "/casino/aggapplayngo-fat-frankies",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FatFrankies.webp",
        alt: "Fat Frankies",
        name: "Fat Frankies",
      },
      FelineFury: {
        redirectUrl: "/casino/aggapplayngo-feline-fury",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FelineFury.webp",
        alt: "Feline Fury",
        name: "Feline Fury",
      },
      FireJoker: {
        redirectUrl: "/casino/aggapplayngo-fire-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FireJoker.webp",
        alt: "Fire Joker",
        name: "Fire Joker",
      },
      FireJokerFreeze: {
        redirectUrl: "/casino/aggapplayngo-fire-joker-freeze",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FireJokerFreeze.webp",
        alt: "Fire Joker Freeze",
        name: "Fire Joker Freeze",
      },
      FireflyFrenzy: {
        redirectUrl: "/casino/aggapplayngo-firefly-frenzy",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FireflyFrenzy.webp",
        alt: "Firefly Frenzy",
        name: "Firefly Frenzy",
      },

      ForgeOfFortunes: {
        redirectUrl: "/casino/aggapplayngo-forge-of-fortunes",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ForgeOfFortunes.webp",
        alt: "Forge of Fortunes",
        name: "Forge of Fortunes",
      },
      ForgeOfGems: {
        redirectUrl: "/casino/aggapplayngo-forge-of-gems",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ForgeOfGems.webp",
        alt: "Forge Of Gems",
        name: "Forge Of Gems",
      },
      FortuneRewind: {
        redirectUrl: "/casino/aggapplayngo-fortune-rewind",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FortuneRewind.webp",
        alt: "Fortune Rewind",
        name: "Fortune Rewind",
      },
      FortunesOfAliBaba: {
        redirectUrl: "/casino/aggapplayngo-fortunes-of-ali-baba",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FortunesOfAliBaba.webp",
        alt: "Fortunes of Ali Baba",
        name: "Fortunes of Ali Baba",
      },
      FreeReelinJoker1000: {
        redirectUrl: "/casino/aggapplayngo-free-reelin-joker-1000",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FreeReelinJoker1000.webp",
        alt: "Free Reelin' Joker 1000",
        name: "Free Reelin' Joker 1000",
      },
      FreeReelinJoker: {
        redirectUrl: "/casino/aggapplayngo-free-reelin-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FreeReelinJoker.webp",
        alt: "Free Reelin' Joker",
        name: "Free Reelin' Joker",
      },
      FrozenGems: {
        redirectUrl: "/casino/aggapplayngo-frozen-gems",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FrozenGems.webp",
        alt: "Frozen Gems",
        name: "Frozen Gems",
      },
      FUERDAI: {
        redirectUrl: "/casino/aggapplayngo-fu-er-dai",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/FUERDAI.webp",
        alt: "FU ER DAI",
        name: "FU ER DAI",
      },
      GameOfGladiators: {
        redirectUrl: "/casino/aggapplayngo-game-of-gladiators",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GameOfGladiators.webp",
        alt: "Game of Gladiators",
        name: "Game of Gladiators",
      },
      GameOfGladiatorsUprising: {
        redirectUrl: "/casino/aggapplayngo-game-of-gladiators",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GameOfGladiatorsUprising.webp",
        alt: "Game of Gladiators: Uprising",
        name: "Game of Gladiators: Uprising",
      },
      GatesOfTroy: {
        redirectUrl: "/casino/aggapplayngo-gates-of-troy",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GatesOfTroy.webp",
        alt: "Gates of Troy",
        name: "Gates of Troy",
      },
      Gemix: {
        redirectUrl: "/casino/aggapplayngo-gemix",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Gemix.webp",
        alt: "Gemix",
        name: "Gemix",
      },
      Gemix2: {
        redirectUrl: "/casino/aggapplayngo-gemix-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Gemix2.webp",
        alt: "Gemix 2",
        name: "Gemix 2",
      },
      GerardsGambit: {
        redirectUrl: "/casino/aggapplayngo-gerards-gambit",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GerardsGambit.webp",
        alt: "Gerard's Gambit",
        name: "Gerard's Gambit",
      },
      GhostOfDead: {
        redirectUrl: "/casino/aggapplayngo-ghost-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GhostOfDead.webp",
        alt: "Ghost of Dead",
        name: "Ghost of Dead",
      },
      Gigantoonz: {
        redirectUrl: "/casino/aggapplayngo-gigantoonz",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Gigantoonz.webp",
        alt: "Gigantoonz",
        name: "Gigantoonz",
      },
      GoldKing: {
        redirectUrl: "/casino/aggapplayngo-gold-king",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GoldKing.webp",
        alt: "Gold King",
        name: "Gold King",
      },
      GoldTrophy2: {
        redirectUrl: "/casino/aggapplayngo-gold-trophy-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GoldTrophy2.webp",
        alt: "Gold Trophy 2",
        name: "Gold Trophy 2",
      },
      GoldVolcano: {
        redirectUrl: "/casino/aggapplayngo-gold-volcano",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GoldVolcano.webp",
        alt: "Gold Volcano",
        name: "Gold Volcano",
      },
      GoldenCaravan: {
        redirectUrl: "/casino/aggapplayngo-golden-caravan",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GoldenCaravan.webp",
        alt: "Golden Caravan",
        name: "Golden Caravan",
      },
      GoldenColts: {
        redirectUrl: "/casino/aggapplayngo-golden-colts",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GoldenColts.webp",
        alt: "Golden Colts",
        name: "Golden Colts",
      },
      GoldenLegend: {
        redirectUrl: "/casino/aggapplayngo-golden-legend",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GoldenLegend.webp",
        alt: "Golden Legend",
        name: "Golden Legend",
      },
      GoldenOsiris: {
        redirectUrl: "/casino/aggapplayngo-golden-osiris",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GoldenOsiris.webp",
        alt: "Golden Osiris",
        name: "Golden Osiris",
      },
      GoldenTicket: {
        redirectUrl: "/casino/aggapplayngo-golden-ticket",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GoldenTicket.webp",
        alt: "Golden Ticket",
        name: "Golden Ticket",
      },
      GoldenTicket2: {
        redirectUrl: "/casino/aggapplayngo-golden-ticket-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GoldenTicket2.webp",
        alt: "Golden Ticket 2",
        name: "Golden Ticket 2",
      },
      GrimMuerto: {
        redirectUrl: "/casino/aggapplayngo-grim-muerto",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GrimMuerto.webp",
        alt: "Grim Muerto",
        name: "Grim Muerto",
      },
      HappyHalloween: {
        redirectUrl: "/casino/aggapplayngo-happy-halloween",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HappyHalloween.webp",
        alt: "Happy Halloween",
        name: "Happy Halloween",
      },
      HighwayLegends: {
        redirectUrl: "/casino/aggapplayngo-highway-legends",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HighwayLegends.webp",
        alt: "Highway Legends",
        name: "Highway Legends",
      },
      HolidaySeason: {
        redirectUrl: "/casino/aggapplayngo-holiday-season",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HolidaySeason.webp",
        alt: "Holiday Season",
        name: "Holiday Season",
      },
      HolidaySpirits: {
        redirectUrl: "/casino/aggapplayngo-holiday-spirits",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HolidaySpirits.webp",
        alt: "Holiday Spirits",
        name: "Holiday Spirits",
      },
      HoneyRush: {
        redirectUrl: "/casino/aggapplayngo-honey-rush",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HoneyRush.webp",
        alt: "Honey Rush",
        name: "Honey Rush",
      },
      HooliganHustle: {
        redirectUrl: "/casino/aggapplayngo-hooligan-hustle",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HooliganHustle.webp",
        alt: "Hooligan Hustle",
        name: "Hooligan Hustle",
      },
      HotelYetiWay: {
        redirectUrl: "/casino/aggapplayngo-hotel-yeti-way",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HotelYetiWay.webp",
        alt: "Hotel Yeti-Way",
        name: "Hotel Yeti-Way",
      },
      HouseOfDoom: {
        redirectUrl: "/casino/aggapplayngo-house-of-doom",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HouseofDoom.webp",
        alt: "House of Doom",
        name: "House of Doom",
      },
      HouseOfDoom2TheCrypt: {
        redirectUrl: "/casino/aggapplayngo-house-of-doom-2-the-crypt",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HouseofDoom2TheCrypt.webp",
        alt: "House of Doom 2 The Crypt",
        name: "House of Doom 2 The Crypt",
      },
      IceJoker: {
        redirectUrl: "/casino/aggapplayngo-ice-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/IceJoker.webp",
        alt: "Ice Joker",
        name: "Ice Joker",
      },
      IdolOfFortune: {
        redirectUrl: "/casino/aggapplayngo-idol-of-fortune",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/IdolofFortune.webp",
        alt: "Idol of Fortune",
        name: "Idol of Fortune",
      },
      ImmorTailsOfEgypt: {
        redirectUrl: "/casino/aggapplayngo-immortails-of-egypt",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ImmorTailsOfEgypt.webp",
        alt: "ImmorTails of Egypt",
        name: "ImmorTails of Egypt",
      },
      // ImperialOpera: {
      //   redirectUrl: "/casino/qtechplayngo-imperial-opera",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/play-n-go/ImperialOpera.webp",
      //   alt: "Imperial Opera",
      //   name: "Imperial Opera",
      // },
      InfernoJoker: {
        redirectUrl: "/casino/aggapplayngo-inferno-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/InfernoJoker.webp",
        alt: "Inferno Joker",
        name: "Inferno Joker",
      },
      InvadingVegas: {
        redirectUrl: "/casino/aggapplayngo-invading-vegas",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/InvadingVegas.webp",
        alt: "Invading Vegas",
        name: "Invading Vegas",
      },
      InfernoStar: {
        redirectUrl: "/casino/aggapplayngo-inferno-star",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/InfernoStar.webp",
        alt: "Inferno Star",
        name: "Inferno Star",
      },
      IrishGold: {
        redirectUrl: "/casino/aggapplayngo-irish-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/IrishGold.webp",
        alt: "Irish Gold",
        name: "Irish Gold",
      },
      IronGirl: {
        redirectUrl: "/casino/aggapplayngo-iron-girl",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/IronGirl.webp",
        alt: "Iron Girl",
        name: "Iron Girl",
      },
      JadeMagician: {
        redirectUrl: "/casino/aggapplayngo-jade-magician",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/JadeMagician.webp",
        alt: "Jade Magician",
        name: "Jade Magician",
      },
      JewelBox: {
        redirectUrl: "/casino/aggapplayngo-jewel-box",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/JewelBox.webp",
        alt: "Jewel Box",
        name: "Jewel Box",
      },
      // JollyRoger: {
      //   redirectUrl: "/casino/qtechplayngo-jolly-roger",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/play-n-go/JollyRoger.webp",
      //   alt: "Jolly Roger",
      //   name: "Jolly Roger",
      // },
      JollyRoger2: {
        redirectUrl: "/casino/aggapplayngo-jolly-roger-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/JollyRoger2.webp",
        alt: "Jolly Roger 2",
        name: "Jolly Roger 2",
      },
      KingsMask: {
        redirectUrl: "/casino/aggapplayngo-kings-mask",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/KingsMask.webp",
        alt: "King's Mask",
        name: "King's Mask",
      },
      LadyOfFortune: {
        redirectUrl: "/casino/aggapplayngo-lady-of-fortune",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LadyOfFortune.webp",
        alt: "Lady of Fortune",
        name: "Lady of Fortune",
      },
      LegacyOfDead: {
        redirectUrl: "/casino/aggapplayngo-legacy-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LegacyOfDead.webp",
        alt: "Legacy of Dead",
        name: "Legacy of Dead",
      },
      LegacyOfEgypt: {
        redirectUrl: "/casino/aggapplayngo-legacy-of-egypt",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LegacyOfEgypt.webp",
        alt: "Legacy of Egypt",
        name: "Legacy of Egypt",
      },
      LegacyOfInca: {
        redirectUrl: "/casino/aggapplayngo-legacy-of-inca",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LegacyOfInca.webp",
        alt: "Legacy of Inca",
        name: "Legacy of Inca",
      },
      LegendOfTheIceDragon: {
        redirectUrl: "/casino/aggapplayngo-legend-of-the-ice-dragon",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LegendOfTheIceDragon.webp",
        alt: "Legend Of The Ice Dragon",
        name: "Legend Of The Ice Dragon",
      },
      LegionGold: {
        redirectUrl: "/casino/aggapplayngo-legion-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LegionGold.webp",
        alt: "Legion Gold",
        name: "Legion Gold",
      },
      LeprechaunGoesEgypt: {
        redirectUrl: "/casino/aggapplayngo-leprechaun-goes-egypt",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LeprechaunGoesEgypt.webp",
        alt: "Leprechaun goes Egypt",
        name: "Leprechaun goes Egypt",
      },
      LeprechaunGoesWild: {
        redirectUrl: "/casino/aggapplayngo-leprechaun-goes-wild",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LeprechaunGoesWild.webp",
        alt: "Leprechaun Goes Wild",
        name: "Leprechaun Goes Wild",
      },
      LeprechaunsVault: {
        redirectUrl: "/casino/aggapplayngo-leprechauns-vault",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LeprechaunsVault.webp",
        alt: "Leprechaun's Vault",
        name: "Leprechaun's Vault",
      },
      LordMerlinAndTheLadyOfTheLake: {
        redirectUrl:
          "/casino/aggapplayngo-lord-merlin-and-the-lady-of-the-lake",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LordMerlinAndTheLadyOfTheLake.webp",
        alt: "Lord Merlin and The Lady of The Lake",
        name: "Lord Merlin and The Lady of The Lake",
      },
      LoveJoker: {
        redirectUrl: "/casino/aggapplayngo-love-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LoveJoker.webp",
        alt: "Love Joker",
        name: "Love Joker",
      },
      Luchamigos: {
        redirectUrl: "/casino/aggapplayngo-luchamigos",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Luchamigos.webp",
        alt: "Luchamigos",
        name: "Luchamigos",
      },
      LuckyDiamonds: {
        redirectUrl: "/casino/aggapplayngo-lucky-diamonds",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LuckyDiamonds.webp",
        alt: "Lucky Diamonds",
        name: "Lucky Diamonds",
      },
      MadameInk: {
        redirectUrl: "/casino/aggapplayngo-madame-ink",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MadameInk.webp",
        alt: "Madame Ink",
        name: "Madame Ink",
      },
      MegaDon: {
        redirectUrl: "/casino/aggapplayngo-mega-don",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MegaDon.webp",
        alt: "Mega Don",
        name: "Mega Don",
      },
      Mahjong88: {
        redirectUrl: "/casino/aggapplayngo-mahjong-88",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Mahjong88.webp",
        alt: "Mahjong 88",
        name: "Mahjong 88",
      },
      Matsuri: {
        redirectUrl: "/casino/aggapplayngo-matsuri",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Matsuri.webp",
        alt: "Matsuri",
        name: "Matsuri",
      },
      MerlinAndIceQueenMorgana: {
        redirectUrl: "/casino/aggapplayngo-merlin-and-ice-queen-morgana",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MerlinAndTheIceQueenMorgana.webp",
        alt: "Merlin and Ice Queen Morgana",
        name: "Merlin and Ice Queen Morgana",
      },
      MerlinsGrimoire: {
        redirectUrl: "/casino/aggapplayngo-merlins-grimoire",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MerlinsGrimoire.webp",
        alt: "Merlin's Grimoire",
        name: "Merlin's Grimoire",
      },
      MermaidsDiamond: {
        redirectUrl: "/casino/aggapplayngo-mermaids-diamond",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MermaidsDiamond.webp",
        alt: "Mermaid's Diamond",
        name: "Mermaid's Diamond",
      },
      MerryXmas: {
        redirectUrl: "/casino/aggapplayngo-merry-xmas",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MerryXmas.webp",
        alt: "Merry Xmas",
        name: "Merry Xmas",
      },
      MinerDonkeyTrouble: {
        redirectUrl: "/casino/aggapplayngo-miner-donkey-trouble",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MinerDonkeyTrouble.webp",
        alt: "Miner Donkey Trouble",
        name: "Miner Donkey Trouble",
      },
      MissionCash: {
        redirectUrl: "/casino/aggapplayngo-mission-cash",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MissionCash.webp",
        alt: "Mission Cash",
        name: "Mission Cash",
      },
      MoonPrincess100: {
        redirectUrl: "/casino/aggapplayngo-moon-princess-100",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MoonPrincess100.webp",
        alt: "Moon Princess 100",
        name: "Moon Princess 100",
      },
      MoonPrincess: {
        redirectUrl: "/casino/aggapplayngo-moon-princess",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MoonPrincess.webp",
        alt: "Moon Princess",
        name: "Moon Princess",
      },
      MoonPrincessChristmasKingdom: {
        redirectUrl: "/casino/aggapplayngo-moon-princess-christmas-kingdom",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MoonPrincessChristmasKingdom.webp",
        alt: "Moon Princess Christmas Kingdom",
        name: "Moon Princess Christmas Kingdom",
      },
      MoonPrincessTrinity: {
        redirectUrl: "/casino/aggapplayngo-moon-princess-trinity",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MoonPrincessTrinity.webp",
        alt: "Moon Princess Trinity",
        name: "Moon Princess Trinity",
      },
      MountM: {
        redirectUrl: "/casino/aggapplayngo-mount-m",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MountM.webp",
        alt: "Mount M",
        name: "Mount M",
      },
      MuertoEnMictlán: {
        redirectUrl: "/casino/aggapplayngo-muerto-en-mictlan",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MuertoEnMictlán.webp",
        alt: "Muerto en Mictlán",
        name: "Muerto en Mictlán",
      },
      // MultiFruit81: {
      //   redirectUrl: "/casino/qtechplayngo-multifruit-81",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/play-n-go/MultiFruit81.webp",
      //   alt: "MultiFruit 81",
      //   name: "MultiFruit 81",
      // },
      MysteryJoker: {
        redirectUrl: "/casino/aggapplayngo-mystery-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MysteryJoker.webp",
        alt: "Mystery Joker",
        name: "Mystery Joker",
      },
      MysteryJoker6000: {
        redirectUrl: "/casino/aggapplayngo-mystery-joker-6000",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MysteryJoker6000.webp",
        alt: "Mystery Joker 6000",
        name: "Mystery Joker 6000",
      },
      Myth: {
        redirectUrl: "/casino/aggapplayngo-myth",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Myth.webp",
        alt: "Myth",
        name: "Myth",
      },
      NaughtyNicksBook: {
        redirectUrl: "/casino/aggapplayngo-naughty-nicks-book",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/NaughtyNicksBook.webp",
        alt: "Naughty Nick's Book",
        name: "Naughty Nick's Book",
      },
      NewYearRiches: {
        redirectUrl: "/casino/aggapplayngo-new-year-riches",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/NewYearRiches.webp",
        alt: "New Year Riches",
        name: "New Year Riches",
      },
      NinjaFruits: {
        redirectUrl: "/casino/aggapplayngo-ninja-fruits",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/NinjaFruits.webp",
        alt: "Ninja Fruits",
        name: "Ninja Fruits",
      },
      OctopusTreasure: {
        redirectUrl: "/casino/aggapplayngo-octopus-treasure",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/OctopusTreasure.webp",
        alt: "Octopus Treasure",
        name: "Octopus Treasure",
      },
      OdinProtectorOfRealms: {
        redirectUrl: "/casino/aggapplayngo-odin-protector-of-realms",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/OdinProtectorOfRealms.webp",
        alt: "Odin: Protector of Realms",
        name: "Odin: Protector of Realms",
      },
      PackAndCash: {
        redirectUrl: "/casino/aggapplayngo-pack-and-cash",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PackAndCash.webp",
        alt: "Pack & Cash",
        name: "Pack & Cash",
      },
      PandorasBoxOfEvil: {
        redirectUrl: "/casino/aggapplayngo-pandoras-box-of-evil",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PandorasBoxOfEvil.webp",
        alt: "Pandora's Box of Evil",
        name: "Pandora's Box of Evil",
      },
      PearlLagoon: {
        redirectUrl: "/casino/aggapplayngo-pearl-lagoon",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PearlLagoon.webp",
        alt: "Pearl Lagoon",
        name: "Pearl Lagoon",
      },
      PearlsOfIndia: {
        redirectUrl: "/casino/aggapplayngo-pearls-of-india",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PearlsOfIndia.webp",
        alt: "Pearls of India",
        name: "Pearls of India",
      },
      PerfectGems: {
        redirectUrl: "/casino/aggapplayngo-perfect-gems",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PerfectGems.webp",
        alt: "Perfect Gems",
        name: "Perfect Gems",
      },
      PhoenixReborn: {
        redirectUrl: "/casino/aggapplayngo-phoenix-reborn",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PhoenixReborn.webp",
        alt: "Phoenix Reborn",
        name: "Phoenix Reborn",
      },
      PhotoSafari: {
        redirectUrl: "/casino/aggapplayngo-photo-safari",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PhotoSafari.webp",
        alt: "Photo Safari",
        name: "Photo Safari",
      },
      PiggyBankFarm: {
        redirectUrl: "/casino/aggapplayngo-piggy-bank-farm",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PiggyBankFarm.webp",
        alt: "Piggy Bank Farm",
        name: "Piggy Bank Farm",
      },
      PilgrimOfDead: {
        redirectUrl: "/casino/aggapplayngo-pilgrim-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PilgrimOfDead.webp",
        alt: "Pilgrim of Dead",
        name: "Pilgrim of Dead",
      },
      Pimped: {
        redirectUrl: "/casino/aggapplayngo-pimped",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Pimped.webp",
        alt: "Pimped",
        name: "Pimped",
      },
      PlanetFortune: {
        redirectUrl: "/casino/aggapplayngo-planet-fortune",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PlanetFortune.webp",
        alt: "Planet Fortune",
        name: "Planet Fortune",
      },
      PrismOfGems: {
        redirectUrl: "/casino/aggapplayngo-prism-of-gems",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PrismOfGems.webp",
        alt: "Prism of Gems",
        name: "Prism of Gems",
      },
      PrissyPrincess: {
        redirectUrl: "/casino/aggapplayngo-prissy-princess",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PrissyPrincess.webp",
        alt: "Prissy Princess",
        name: "Prissy Princess",
      },
      ProsperityPalace: {
        redirectUrl: "/casino/aggapplayngo-prosperity-palace",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ProsperityPalace.webp",
        alt: "Prosperity Palace",
        name: "Prosperity Palace",
      },
      PueblaParade: {
        redirectUrl: "/casino/aggapplayngo-puebla-parade",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PueblaParade.webp",
        alt: "Puebla Parade",
        name: "Puebla Parade",
      },
      QueensDayTilt: {
        redirectUrl: "/casino/aggapplayngo-queens-day-tilt",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/QueensDayTilt.webp",
        alt: "Queens Day Tilt",
        name: "Queens Day Tilt",
      },
      RabbitHoleRiches: {
        redirectUrl: "/casino/aggapplayngo-rabbit-hole-riches",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RabbitHoleRiches.webp",
        alt: "Rabbit Hole Riches",
        name: "Rabbit Hole Riches",
      },
      RageToRiches: {
        redirectUrl: "/casino/aggapplayngo-rage-to-riches",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RageToRiches.webp",
        alt: "Rage to Riches",
        name: "Rage to Riches",
      },
      RagingRex: {
        redirectUrl: "/casino/aggapplayngo-raging-rex",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RagingRex.webp",
        alt: "Raging Rex",
        name: "Raging Rex",
      },
      RagingRex2: {
        redirectUrl: "/casino/aggapplayngo-raging-rex-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RagingRex2.webp",
        alt: "Raging Rex 2",
        name: "Raging Rex 2",
      },
      RainforestMagic: {
        redirectUrl: "/casino/aggapplayngo-rainforest-magic",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RainforestMagic.webp",
        alt: "Rainforest Magic",
        name: "Rainforest Magic",
      },
      Rally4Riches: {
        redirectUrl: "/casino/aggapplayngo-rally-4-riches",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Rally4Riches.webp",
        alt: "Rally 4 Riches",
        name: "Rally 4 Riches",
      },
      Reactoonz: {
        redirectUrl: "/casino/aggapplayngo-reactoonz",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Reactoonz.webp",
        alt: "Reactoonz",
        name: "Reactoonz",
      },
      Reactoonz2: {
        redirectUrl: "/casino/aggapplayngo-reactoonz-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Reactoonz2.webp",
        alt: "Reactoonz 2",
        name: "Reactoonz 2",
      },
      RichWildeAndTheWanderingCity: {
        redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-wandering-city",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RichWildeAndTheWanderingCity.webp",
        alt: "Rich Wilde And The Wandering City",
        name: "Rich Wilde And The Wandering City",
      },
      RichWildeAndTheShieldOfAthena: {
        redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-shield-of-athena",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RichWildeAndTheShieldOfAthena.webp",
        alt: "Rich Wilde and the Shield of Athena",
        name: "Rich Wilde and the Shield of Athena",
      },
      RichesOfRA: {
        redirectUrl: "/casino/aggapplayngo-riches-of-ra",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RichesOfRA.webp",
        alt: "Riches of RA",
        name: "Riches of RA",
      },
      RichesOfRobin: {
        redirectUrl: "/casino/aggapplayngo-riches-of-robin",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RichesOfRobin.webp",
        alt: "Riches of Robin",
        name: "Riches of Robin",
      },
      RiddleReelsACaseOfRiches: {
        redirectUrl: "/casino/aggapplayngo-riddle-reels-a-case-of-riches",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RiddleReelsACaseOfRiches.webp",
        alt: "Riddle Reels a case of riches",
        name: "Riddle Reels a case of riches",
      },
      RingOfOdin: {
        redirectUrl: "/casino/aggapplayngo-ring-of-odin",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RingOfOdin.webp",
        alt: "Ring of Odin",
        name: "Ring of Odin",
      },
      RiseOfAthena: {
        redirectUrl: "/casino/aggapplayngo-rise-of-athena",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RiseOfAthena.webp",
        alt: "Rise of Athena",
        name: "Rise of Athena",
      },
      RiseOfDead: {
        redirectUrl: "/casino/aggapplayngo-rise-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RiseOfDead.webp",
        alt: "Rise of Dead",
        name: "Rise of Dead",
      },
      RiseOfGodsReckoning: {
        redirectUrl: "/casino/aggapplayngo-rise-of-gods-reckoning",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RiseOfGodsReckoning.webp",
        alt: "Rise of Gods Reckoning",
        name: "Rise of Gods Reckoning",
      },
      RiseOfMerlin: {
        redirectUrl: "/casino/aggapplayngo-rise-of-merlin",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RiseOfMerlin.webp",
        alt: "Rise of Merlin",
        name: "Rise of Merlin",
      },
      // RiseOfOlympus: {
      //   redirectUrl: "/casino/aggapplayngo-rise-of-olympus",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/play-n-go/RiseOfOlympus.webp",
      //   alt: "Rise of Olympus",
      //   name: "Rise of Olympus",
      // },
      RiseOfOlympus100: {
        redirectUrl: "/casino/aggapplayngo-rise-of-olympus-100",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RiseOfOlympus100.webp",
        alt: "Rise of Olympus 100",
        name: "Rise of Olympus 100",
      },
      RoccoGallo: {
        redirectUrl: "/casino/aggapplayngo-rocco-gallo",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RoccoGallo.webp",
        alt: "Rocco Gallo",
        name: "Rocco Gallo",
      },
      RoninsHonour: {
        redirectUrl: "/casino/aggapplayngo-ronins-honour",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RoninsHonour.webp",
        alt: "Ronin's Honour",
        name: "Ronin's Honour",
      },
      Rotiki: {
        redirectUrl: "/casino/aggapplayngo-rotiki",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Rotiki.webp",
        alt: "Rotiki",
        name: "Rotiki",
      },
      RoyalMasquerade: {
        redirectUrl: "/casino/aggapplayngo-royal-masquerade",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RoyalMasquerade.webp",
        alt: "Royal Masquerade",
        name: "Royal Masquerade",
      },
      Sabaton: {
        redirectUrl: "/casino/aggapplayngo-sabaton",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Sabaton.webp",
        alt: "Sabaton",
        name: "Sabaton",
      },
      SafariOfWealth: {
        redirectUrl: "/casino/aggapplayngo-safari-of-wealth",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SafariOfWealth.webp",
        alt: "Safari Of Wealth",
        name: "Safari Of Wealth",
      },
      SailsOfGold: {
        redirectUrl: "/casino/aggapplayngo-sails-of-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SailsOfGold.webp",
        alt: "Sails of Gold",
        name: "Sails of Gold",
      },
      SambaCarnival: {
        redirectUrl: "/casino/aggapplayngo-samba-carnival",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SambaCarnival.webp",
        alt: "Samba Carnival",
        name: "Samba Carnival",
      },
      ScrollOfDead: {
        redirectUrl: "/casino/aggapplayngo-scroll-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ScrollOfDead.webp",
        alt: "Scroll of Dead",
        name: "Scroll of Dead",
      },
      SeaHunter: {
        redirectUrl: "/casino/aggapplayngo-sea-hunter",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SeaHunter.webp",
        alt: "Sea Hunter",
        name: "Sea Hunter",
      },
      SecretOfDead: {
        redirectUrl: "/casino/aggapplayngo-secret-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SecretOfDead.webp",
        alt: "Secret Of Dead",
        name: "Secret Of Dead",
      },
      ShamrockMiner: {
        redirectUrl: "/casino/aggapplayngo-shamrock-miner",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ShamrockMiner.webp",
        alt: "Shamrock Miner",
        name: "Shamrock Miner",
      },
      SistersOfTheSun: {
        redirectUrl: "/casino/aggapplayngo-sisters-of-the-sun",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SistersOfTheSun.webp",
        alt: "Sisters of The Sun",
        name: "Sisters of The Sun",
      },
      SizzlingSpins: {
        redirectUrl: "/casino/aggapplayngo-sizzling-spins",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SizzlingSpins.webp",
        alt: "Sizzling Spins",
        name: "Sizzling Spins",
      },
      Slashimi: {
        redirectUrl: "/casino/aggapplayngo-slashimi",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Slashimi.webp",
        alt: "Slashimi",
        name: "Slashimi",
      },
      SpaceRace: {
        redirectUrl: "/casino/aggapplayngo-space-race",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SpaceRace.webp",
        alt: "Space Race",
        name: "Space Race",
      },
      SparkyAndShortz: {
        redirectUrl: "/casino/aggapplayngo-sparky-and-shortz",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SparkyAndShortz.webp",
        alt: "Sparky & Shortz",
        name: "Sparky & Shortz",
      },
      SpinParty: {
        redirectUrl: "/casino/aggapplayngo-spin-party",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SpinParty.webp",
        alt: "Spin Party",
        name: "Spin Party",
      },
      StarJoker: {
        redirectUrl: "/casino/aggapplayngo-star-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/StarJoker.webp",
        alt: "Star Joker",
        name: "Star Joker",
      },
      StickyJoker: {
        redirectUrl: "/casino/aggapplayngo-sticky-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/StickyJoker.webp",
        alt: "Sticky Joker",
        name: "Sticky Joker",
      },
      StreetMagic: {
        redirectUrl: "/casino/aggapplayngo-street-magic",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/StreetMagic.webp",
        alt: "Street Magic",
        name: "Street Magic",
      },
      SuperFlip: {
        redirectUrl: "/casino/aggapplayngo-super-flip",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SuperFlip.webp",
        alt: "Super Flip",
        name: "Super Flip",
      },
      Sweet27: {
        redirectUrl: "/casino/aggapplayngo-sweet-27",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Sweet27.webp",
        alt: "Sweet 27",
        name: "Sweet 27",
      },
      SweetAlchemy: {
        redirectUrl: "/casino/aggapplayngo-sweet-alchemy",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SweetAlchemy.webp",
        alt: "Sweet Alchemy",
        name: "Sweet Alchemy",
      },
      TaleOfKyubiko: {
        redirectUrl: "/casino/aggapplayngo-tale-of-kyubiko",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TaleOfKyubiko.webp",
        alt: "Tale Of Kyubiko",
        name: "Tale Of Kyubiko",
      },
      TalesOfAsgardFreyasWedding: {
        redirectUrl: "/casino/aggapplayngo-tales-of-asgard-freyas-wedding",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TalesOfAsgardFreyasWedding.webp",
        alt: "Tales of Asgard Freya's Wedding",
        name: "Tales of Asgard Freya's Wedding",
      },
      TalesOfAsgardLokisFortune: {
        redirectUrl: "/casino/aggapplayngo-tales-of-asgard-lokis-fortune",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TalesOfAsgardLokisFortune.webp",
        alt: "Tales Of Asgard Loki's Fortune",
        name: "Tales Of Asgard Loki's Fortune",
      },
      Testament: {
        redirectUrl: "/casino/aggapplayngo-testament",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Testament.webp",
        alt: "Testament",
        name: "Testament",
      },
      ThatsRich: {
        redirectUrl: "/casino/aggapplayngo-thats-rich",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ThatsRich.webp",
        alt: "That's Rich",
        name: "That's Rich",
      },
      TheFacesOfFreya: {
        redirectUrl: "/casino/aggapplayngo-the-faces-of-freya",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TheFacesOfFreya.webp",
        alt: "The Faces of Freya",
        name: "The Faces of Freya",
      },
      TheGreenKnight: {
        redirectUrl: "/casino/aggapplayngo-the-green-knight",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TheGreenKnight.webp",
        alt: "The Green Knight",
        name: "The Green Knight",
      },
      TheLastSundown: {
        redirectUrl: "/casino/aggapplayngo-the-last-sundown",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TheLastSundown.webp",
        alt: "The Last Sundown",
        name: "The Last Sundown",
      },
      ThePayingPianoClub: {
        redirectUrl: "/casino/aggapplayngo-the-paying-piano-club",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ThePayingPianoClub.webp",
        alt: "The Paying Piano Club",
        name: "The Paying Piano Club",
      },
      ShimmeringWoods: {
        redirectUrl: "/casino/aggapplayngo-shimmering-woods",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TheShimmeringWoods.webp",
        alt: "Shimmering Woods",
        name: "Shimmering Woods",
      },
      TheSwordAndTheGrail: {
        redirectUrl: "/casino/aggapplayngo-the-sword-and-the-grail",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TheSwordAndTheGrail.webp",
        alt: "The Sword and The Grail",
        name: "The Sword and The Grail",
      },
      TheWildClass: {
        redirectUrl: "/casino/aggapplayngo-the-wild-class",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TheWildClass.webp",
        alt: "The Wild Class",
        name: "The Wild Class",
      },
      ThunderScreech: {
        redirectUrl: "/casino/aggapplayngo-thunder-screech",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ThunderScreech.webp",
        alt: "Thunder Screech",
        name: "Thunder Screech",
      },
      // TomeOfMadness: {
      //   redirectUrl: "/casino/qtechplayngo-tome-of-madness",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/play-n-go/TomeOfMadness.webp",
      //   alt: "Tome of Madness",
      //   name: "Tome of Madness",
      // },
      TrollHunters: {
        redirectUrl: "/casino/aggapplayngo-troll-hunters",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TrollHunters.webp",
        alt: "Troll Hunters",
        name: "Troll Hunters",
      },
      TrollHunters2: {
        redirectUrl: "/casino/aggapplayngo-troll-hunters-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TrollHunters2.webp",
        alt: "Troll Hunters 2",
        name: "Troll Hunters 2",
      },
      USAFlip: {
        redirectUrl: "/casino/aggapplayngo-usa-flip",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/USAFlip.webp",
        alt: "USA Flip",
        name: "USA Flip",
      },
      VikingRunecraft: {
        redirectUrl: "/casino/aggapplayngo-viking-runecraft",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/VikingRunecraft.webp",
        alt: "Viking Runecraft",
        name: "Viking Runecraft",
      },
      WildBandolier: {
        redirectUrl: "/casino/aggapplayngo-wild-bandolier",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildBandolier.webp",
        alt: "Wild Bandolier",
        name: "Wild Bandolier",
      },
      WildBlood: {
        redirectUrl: "/casino/aggapplayngo-wild-blood",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildBlood.webp",
        alt: "Wild Blood",
        name: "Wild Blood",
      },
      WildBlood2: {
        redirectUrl: "/casino/aggapplayngo-wild-blood-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildBlood2.webp",
        alt: "Wild Blood 2",
        name: "Wild Blood 2",
      },
      WildFalls: {
        redirectUrl: "/casino/aggapplayngo-wild-falls",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildFalls.webp",
        alt: "Wild Falls",
        name: "Wild Falls",
      },
      WildFalls2: {
        redirectUrl: "/casino/aggapplayngo-wild-falls-2",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildFalls2.webp",
        alt: "Wild Falls 2",
        name: "Wild Falls 2",
      },
      WildFrames: {
        redirectUrl: "/casino/aggapplayngo-wild-frames",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildFrames.webp",
        alt: "Wild Frames",
        name: "Wild Frames",
      },
      WildMelon: {
        redirectUrl: "/casino/aggapplayngo-wild-melon",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildMelon.webp",
        alt: "Wild Melon",
        name: "Wild Melon",
      },
      WildNorth: {
        redirectUrl: "/casino/aggapplayngo-wild-north",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildNorth.webp",
        alt: "Wild North",
        name: "Wild North",
      },
      WildRails: {
        redirectUrl: "/casino/aggapplayngo-wild-rails",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildRails.webp",
        alt: "Wild Rails",
        name: "Wild Rails",
      },
      WildTrigger: {
        redirectUrl: "/casino/aggapplayngo-wild-trigger",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildTrigger.webp",
        alt: "Wild Trigger",
        name: "Wild Trigger",
      },
      WildhoundDerby: {
        redirectUrl: "/casino/aggapplayngo-wildhound-derby",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildhoundDerby.webp",
        alt: "Wildhound Derby",
        name: "Wildhound Derby",
      },
      WinABeest: {
        redirectUrl: "/casino/aggapplayngo-win-a-beest",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WinABeest.webp",
        alt: "Win-A-Beest",
        name: "Win-A-Beest",
      },
      WizardOfGems: {
        redirectUrl: "/casino/aggapplayngo-wizard-of-gems",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WizardOfGems.webp",
        alt: "Wizard of Gems",
        name: "Wizard of Gems",
      },
      XmasJoker: {
        redirectUrl: "/casino/aggapplayngo-xmas-joker-3-reel",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/XmasJoker.webp",
        alt: "Xmas Joker",
        name: "Xmas Joker",
      },
      XmasMagic: {
        redirectUrl: "/casino/aggapplayngo-xmas-magic",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/XmasMagic.webp",
        alt: "Xmas Magic",
        name: "Xmas Magic",
      },
      Hand3CasinoHoldem: {
        redirectUrl: "/casino/aggapplayngo-3-hand-casino-holdem",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/3HandCasinoHoldem.webp",
        alt: "3-Hand Casino Hold'em",
        name: "3-Hand Casino Hold'em",
      },
      BlackJackMH: {
        redirectUrl: "/casino/aggapplayngo-blackjack-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BlackJackMH.webp",
        alt: "BlackJack MH",
        name: "BlackJack MH",
      },
      DeucesWild: {
        redirectUrl: "/casino/aggapplayngo-deuces-wild-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DeucesWild.webp",
        alt: "Deuces Wild",
        name: "Deuces Wild",
      },
      DoubleExposureBlackJackMH: {
        redirectUrl: "/casino/aggapplayngo-double-exposure-blackjack-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DoubleExposureBlackJackMH.webp",
        alt: "Double Exposure BlackJack MH",
        name: "Double Exposure BlackJack MH",
      },
      EuropeanBlackJackMH: {
        redirectUrl: "/casino/aggapplayngo-european-blackjack-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/EuropeanBlackJackMH.webp",
        alt: "European BlackJack MH",
        name: "European BlackJack MH",
      },
      EuropeanRoulette: {
        redirectUrl: "/casino/aggapplayngo-european-roulette",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/EuropeanRoulettePro.webp",
        alt: "European Roulette",
        name: "European Roulette",
      },
      JacksOrBetterMH: {
        redirectUrl: "/casino/aggapplayngo-jacks-or-better-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/JacksOrBetterMH.webp",
        alt: "Jacks or Better MH",
        name: "Jacks or Better MH",
      },
      JokerPokerMH: {
        redirectUrl: "/casino/aggapplayngo-joker-poker-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/JokerPokerMH.webp",
        alt: "Joker Poker MH",
        name: "Joker Poker MH",
      },
      // Keno: {
      //   redirectUrl: "/casino/qtechplayngo-keno",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/play-n-go/Keno.webp",
      //   alt: "Keno",
      //   name: "Keno",
      // },
      // MiniBaccarat: {
      //   redirectUrl: "/casino/qtechplayngo-mini-baccarat",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/play-n-go/MiniBaccarat.webp",
      //   alt: "Mini Baccarat",
      //   name: "Mini Baccarat",
      // },
      SingleDeckBlackJackMH: {
        redirectUrl: "/casino/aggapplayngo-single-deck-blackjack-mh",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SingleDeckBlackJackMH.webp",
        alt: "Single Deck BlackJack MH",
        name: "Single Deck BlackJack MH",
      },
      MoonPrincessPowerOfLove: {
        redirectUrl: "/casino/aggapplayngo-moon-princess-power-of-love",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MoonPrincessPowerOfLove.webp",
        alt: "Moon Princess - Power of Love",
        name: "Moon Princess - Power of Love",
      },
      LoveIsInTheFair: {
        redirectUrl: "/casino/aggapplayngo-love-is-in-the-fair",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LoveIsInTheFair.webp",
        alt: "Love is in the Fair",
        name: "Love is in the Fair",
      },
      CatWildeAndTheIncanQuest: {
        redirectUrl: "/casino/aggapplayngo-cat-wilde-and-the-incan-quest",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CatWildeAndTheIncanQuest.webp",
        alt: "Cat Wilde and the Incan Quest",
        name: "Cat Wilde and the Incan Quest",
      },
      BoatBonanzaDownUnder: {
        redirectUrl: "/casino/aggapplayngo-boat-bonanza-down-under",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BoatBonanzaDownUnder.webp",
        alt: "Boat Bonanza Down Under",
        name: "Boat Bonanza Down Under",
      },
      HugoCarts: {
        redirectUrl: "/casino/aggapplayngo-hugo-carts",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HugoCarts.webp",
        alt: "Hugo Carts",
        name: "Hugo Carts",
      },
      AliceCooperAndTheTomeOfMadness: {
        redirectUrl:
          "/casino/aggapplayngo-alice-cooper-and-the-tome-of-madness",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/AliceCooperAndTheTomeOfMadness.webp",
        alt: "Alice Cooper And The Tome Of Madness",
        name: "Alice Cooper And The Tome Of Madness",
      },
      Snakebite: {
        redirectUrl: "/casino/qt-snakebite",
        code: "",
        casino: "Play'n GO",
        provider: "WorldCasino",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Snakebite.webp",
        alt: "Snakebite",
        name: "Snakebite",
      },
      kissReelsOfRock: {
        redirectUrl: "/casino/aggapplayngo-kiss-reels-of-rock",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/kissReelsOfRock.webp",
        alt: "kiss Reels Of Rock",
        name: "kiss Reels Of Rock",
      },
      DefLeppardHysteria: {
        redirectUrl: "/casino/aggapplayngo-def-leppard-hysteria",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DefleppardHysteria.webp",
        alt: "Def Leppard Hysteria",
        name: "Def Leppard Hysteria",
      },
      DioKillingTheDragon: {
        redirectUrl: "/casino/aggapplayngo-dio-killing-the-dragon",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DioKillingTheDragon.webp",
        alt: "DIO Killing the Dragon",
        name: "DIO Killing the Dragon",
      },
      DivineDivas: {
        redirectUrl: "/casino/aggapplayngo-divine-divas",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DivineDivas.webp",
        alt: "Divine Divas",
        name: "Divine Divas",
      },
      Gemix100: {
        redirectUrl: "/casino/aggapplayngo-gemix-100",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Gemix100.webp",
        alt: "Gemix 100",
        name: "Gemix 100",
      },
      KingdomBelow: {
        redirectUrl: "/casino/aggapplayngo-kingdom-below",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/KingdomBelow.webp",
        alt: "Kingdom Below",
        name: "Kingdom Below",
      },
      MirrorJoker: {
        redirectUrl: "/casino/aggapplayngo-mirror-joker",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MirrorJoker.webp",
        alt: "Mirror Joker",
        name: "Mirror Joker",
      },
      BuildinBucks: {
        redirectUrl: "/casino/aggapplayngo-buildin-bucks",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BuildinBucks.webp",
        alt: "Buildin' Bucks",
        name: "Buildin' Bucks",
      },
      AnkhOfAnubisAwakening: {
        redirectUrl: "/casino/aggapplayngo-ankh-of-anubis-awakening",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/AnkhOfAnubisAwakening.webp",
        alt: "Ankh of Anubis Awakening",
        name: "Ankh of Anubis Awakening",
      },
      ScourgeOfRome: {
        redirectUrl: "/casino/aggapplayngo-scourge-of-rome",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ScourgeOfRome.webp",
        alt: "Scourge of Rome",
        name: "Scourge of Rome",
      },
      MafiaGold: {
        redirectUrl: "/casino/aggapplayngo-mafia-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MafiaGold.webp",
        alt: "Mafia Gold",
        name: "Mafia Gold",
      },
      RiseOfOlympusOrigin: {
        redirectUrl: "/casino/aggapplayngo-rise-of-olympus-origin",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RiseOfOlympusOrigins.webp",
        alt: "Rise of Olympus Origin",
        name: "Rise of Olympus Origin",
      },
      KingsMaskEclipseOfGods: {
        redirectUrl: "/casino/aggapplayngo-kings-mask-eclipse-of-gods",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/KingsMaskEclipseOfGods.webp",
        alt: "King’s Mask Eclipse of Gods",
        name: "King’s Mask Eclipse of Gods",
      },
      WhisperingWinds: {
        redirectUrl: "/casino/aggapplayngo-whispering-winds",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WhisperingWinds.webp",
        alt: "Whispering Winds",
        name: "Whispering Winds",
      },
      DansbandPaTurne: {
        redirectUrl: "/casino/aggapplayngo-dansband-pa-turne",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/DansbandPaTurne.webp",
        alt: "Dansband Pa Turne",
        name: "Dansband Pa Turne",
      },
      OasisOfDead: {
        redirectUrl: "/casino/aggapplayngo-oasis-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/OasisOfDead.webp",
        alt: "Oasis of Dead",
        name: "Oasis of Dead",
      },
      JourneyToParis: {
        redirectUrl: "/casino/aggapplayngo-journey-to-paris",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/JourneyToParis.webp",
        alt: "Journey to Paris",
        name: "Journey to Paris",
      },
      TempleOfTollan: {
        redirectUrl: "/casino/aggapplayngo-temple-of-tollan",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TempleOfTollan.webp",
        alt: "Temple of Tollan",
        name: "Temple of Tollan",
      },
      MerlinRealmOfCharm: {
        redirectUrl: "/casino/aggapplayngo-merlin-realm-of-charm",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MerlinRealmOfCharm.webp",
        alt: "Merlin Realm of Charm",
        name: "Merlin Realm of Charm",
      },
      GoldOfFortuneGod: {
        redirectUrl: "/casino/aggapplayngo-gold-of-fortune-god",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/GoldOfFortuneGod.webp",
        alt: "Gold of Fortune God",
        name: "Gold of Fortune God",
      },
      RichWildeAndTheTomeOfInsanity: {
        redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-tome-of-insanity",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RichWildeAndTheTomeOfInsanity.webp",
        alt: "Rich Wilde and the Tome of Insanity",
        name: "Rich Wilde and the Tome of Insanity",
      },
      ColtLightningFirestorm: {
        redirectUrl: "/casino/aggapplayngo-colt-lightning-firestorm",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ColtLightningFirestorm.webp",
        alt: "Colt Lightning Firestorm",
        name: "Colt Lightning Firestorm",
      },
      SparkOfGenius: {
        redirectUrl: "/casino/aggapplayngo-spark-of-genius",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SparkOfGenius.webp",
        alt: "Spark of Genius",
        name: "Spark of Genius",
      },
      WildSurvivor: {
        redirectUrl: "/casino/aggapplayngo-wild-survivor",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildSurvivor.webp",
        alt: "Wild Survivor",
        name: "Wild Survivor",
      },
      Fulong88: {
        redirectUrl: "/casino/aggapplayngo-fulong-88",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/Fulong88.webp",
        alt: "Fulong 88",
        name: "Fulong 88",
      },
      TheSwordAndTheGrailExcalibur: {
        redirectUrl: "/casino/aggapplayngo-the-sword-and-the-grail-excalibur",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TheSwordAndTheGrailExcalibur.webp",
        alt: "The Sword and the Grail Excalibur",
        name: "The Sword and the Grail Excalibur",
      },
      BoatBonanzaDownUnder: {
        redirectUrl: "/casino/aggapplayngo-boat-bonanza-down-under",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BoatBonanzaDownUnder.webp",
        alt: "Boat Bonanza Down Under",
        name: "Boat Bonanza Down Under",
      },
      TombOfGold: {
        redirectUrl: "/casino/aggapplayngo-tomb-of-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TombOfGold.webp",
        alt: "Tomb of Gold",
        name: "Tomb of Gold",
      },
      MysteryGenieFortunesOfTheLamp: {
        redirectUrl: "/casino/aggapplayngo-mystery-genie-fortunes-of-the-lamp",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MysteryGenieFortunesOfTheLamp.webp",
        alt: "Mystery Genie Fortunes of the Lamp",
        name: "Mystery Genie Fortunes of the Lamp",
      },
      EasterEggspedition: {
        redirectUrl: "/casino/aggapplayngo-easter-eggspedition",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/EasterEggspedition.webp",
        alt: "Easter Eggspedition",
        name: "Easter Eggspedition",
      },
      PiranhaPays: {
        redirectUrl: "/casino/aggapplayngo-piranha-pays",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PiranhaPays.webp",
        alt: "Piranha Pays",
        name: "Piranha Pays",
      },
      ChambersOfAncients: {
        redirectUrl: "/casino/aggapplayngo-chambers-of-ancients",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/ChambersOfAncients.webp",
        alt: "Chambers of Ancients",
        name: "Chambers of Ancients",
      },
      BanquetOfDead: {
        redirectUrl: "/casino/aggapplayngo-banquet-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BanquetOfDead.webp",
        alt: "Banquet of Dead",
        name: "Banquet of Dead",
      },
      LegionGoldUnleashed: {
        redirectUrl: "/casino/aggapplayngo-legion-gold-unleashed",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LegionGoldUnleashed.webp",
        alt: "Legion Gold Unleashed",
        name: "Legion Gold Unleashed",
      },
      UndefeatedXerxes: {
        redirectUrl: "/casino/aggapplayngo-undefeated-xerxes",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/UndefeatedXerxes.webp",
        alt: "Undefeated Xerxes",
        name: "Undefeated Xerxes",
      },
      LadyOfFortuneRemastered: {
        redirectUrl: "/casino/aggapplayngo-lady-of-fortune-remastered",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LadyOfFortuneRemastered.webp",
        alt: "Lady of Fortune Remastered",
        name: "Lady of Fortune Remastered",
      },
      SteppingDiamonds: {
        redirectUrl: "/casino/aggapplayngo-stepping-diamonds",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/SteppingDiamonds.webp",
        alt: "Stepping Diamonds",
        name: "Stepping Diamonds",
      },
      BaronLordOfSaturday: {
        redirectUrl: "/casino/aggapplayngo-baron-lord-of-saturday",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BaronLordOfSaturday.webp",
        alt: "Baron Lord of Saturday",
        name: "Baron Lord of Saturday",
      },
      BeastsOfFireMaximum: {
        redirectUrl: "/casino/aggapplayngo-beasts-of-fire-maximum",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BeastsOfFireMaximum.webp",
        alt: "Beasts of Fire Maximum",
        name: "Beasts of Fire Maximum",
      },
      LegionGoldAndTheSphinxOfDead: {
        redirectUrl: "/casino/aggapplayngo-legion-gold-and-the-sphinx-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LegionGoldAndTheSphinxOfDead.webp",
        alt: "Legion Gold and the Sphinx of Dead",
        name: "Legion Gold and the Sphinx of Dead",
      },
      PiggyBlitzDiscoGold: {
        redirectUrl: "/casino/aggapplayngo-piggy-blitz-disco-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PiggyBlitzDiscoGold.webp",
        alt: "Piggy Blitz Disco Gold",
        name: "Piggy Blitz Disco Gold",
      },
      RichWildeAndThePearlsOfVishnu: {
        redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-pearls-of-vishnu",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/RichWildeAndThePearlsOfVishnu.webp",
        alt: "Rich Wilde and the Pearls of Vishnu",
        name: "Rich Wilde and the Pearls of Vishnu",
      },
      BoatBonanzaChristmas: {
        redirectUrl: "/casino/aggapplayngo-boat-bonanza-christmas",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/BoatBonanzaChristmas.webp",
        alt: "Boat Bonanza Christmas",
        name: "Boat Bonanza Christmas",
      },
      WildestGambit: {
        redirectUrl: "/casino/aggapplayngo-wildest-gambit",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/WildestGambit.webp",
        alt: "Wildest Gambit",
        name: "Wildest Gambit",
      },
      LionSagaOdyssey: {
        redirectUrl: "/casino/aggapplayngo-lion-saga-odyssey",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LionSagaOdyssey.webp",
        alt: "Lion Saga Odyssey",
        name: "Lion Saga Odyssey",
      },
      HotDogHeist: {
        redirectUrl: "/casino/aggapplayngo-hot-dog-heist",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/HotDogHeist.webp",
        alt: "Hot Dog Heist",
        name: "Hot Dog Heist",
      },
      JollyRogerWildKraken: {
        redirectUrl: "/casino/aggapplayngo-jolly-roger-wild-kraken",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/JollyRogerWildKraken.webp",
        alt: "Jolly Roger Wild Kraken",
        name: "Jolly Roger Wild Kraken",
      },
      MidnightGold: {
        redirectUrl: "/casino/aggapplayngo-midnight-gold",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MidnightGold.webp",
        alt: "Midnight Gold",
        name: "Midnight Gold",
      },
      TreasuresOfKongar: {
        redirectUrl: "/casino/aggapplayngo-treasures-of-kongar",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TreasuresOfKongar.webp",
        alt: "Treasures of Kongar",
        name: "Treasures of Kongar",
      },
      TowerQuestLegacy: {
        redirectUrl: "/casino/aggapplayngo-tower-quest-legacy",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/TowerQuestLegacy.webp",
        alt: "Tower Quest Legacy",
        name: "Tower Quest Legacy",
      },
      LegacyOfGemsBlitzways: {
        redirectUrl: "/casino/aggapplayngo-legacy-of-gems-blitzways",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LegacyOfGemsBlitzways.webp",
        alt: "Legacy of Gems Blitzways",
        name: "Legacy of Gems Blitzways",
      },
      PotionOfMadness: {
        redirectUrl: "/casino/aggapplayngo-potion-of-madness",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/PotionOfMadness.webp",
        alt: "Potion of Madness",
        name: "Potion of Madness",
      },
      InvadingVegasRevengeOnMars: {
        redirectUrl: "/casino/aggapplayngo-invading-vegas-revenge-on-mars",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/InvadingVegasRevengeOnMars.webp",
        alt: "Invading Vegas Revenge on Mars",
        name: "Invading Vegas Revenge on Mars",
      },
      CrystalHall: {
        redirectUrl: "/casino/aggapplayngo-crystal-hall",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/CrystalHall.webp",
        alt: "Crystal Hall",
        name: "Crystal Hall",
      },
      MythOfDead: {
        redirectUrl: "/casino/aggapplayngo-myth-of-dead",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/MythOfDead.webp",
        alt: "Myth of Dead",
        name: "Myth of Dead",
      },
      LegionGoldVictory: {
        redirectUrl: "/casino/aggapplayngo-legion-gold-victory",
        code: "",
        casino: "Play'n GO",
        provider: "ALT_GAMING_GAP",
        category: "playNGo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/play-n-go/LegionGoldVictory.webp",
        alt: "Legion Gold Victory",
        name: "Legion Gold Victory",
      },
    },
    name: "play'n Go",
    key: "playNGoGames",
  },
  relaxGaming: {
    slide1: {
      BillAndCoin: {
        redirectUrl: "/casino/qt-bill-and-coin",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/BillAndCoin.webp",
        alt: "bill and coin",
        name: "Bill & Coin",
      },
      LureOfFortune: {
        redirectUrl: "/casino/qt-lure-of-fortune",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/LureOfFortune.webp",
        alt: "lure of fortune",
        name: "Lure Of Fortune",
      },
      TitanStrike: {
        redirectUrl: "/casino/qt-titan-strike",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/TitanStrike.webp",
        alt: "titan strike",
        name: "Titan Strike",
      },
      MoneyTrain4: {
        redirectUrl: "/casino/qt-money-train-4",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MoneyTrain4.webp",
        alt: "money train 4",
        name: "Money Train 4",
      },
      JokerSplit: {
        redirectUrl: "/casino/qt-joker-split",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/JokerSplit.webp",
        alt: "joker split",
        name: "Joker Split",
      },
      ToriiTumble: {
        redirectUrl: "/casino/qt-torii-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/ToriiTumble.webp",
        alt: "torii tumble",
        name: "Torii Tumble",
      },
      SlothTumble: {
        redirectUrl: "/casino/qt-sloth-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/SlothTumble.webp",
        alt: "sloth tumble",
        name: "Sloth Tumble",
      },
      SharkWash: {
        redirectUrl: "/casino/qt-shark-wash",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/SharkWash.webp",
        alt: "shark wash",
        name: "Shark Wash",
      },
      BananaTown: {
        redirectUrl: "/casino/qt-banana-town",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/BananaTown.webp",
        alt: "banana town",
        name: "Banana Town",
      },
      BeastMode: {
        redirectUrl: "/casino/qt-beast-mode",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/BeastMode.webp",
        alt: "beast mode",
        name: "Beast Mode",
      },
      BlenderBlitz: {
        redirectUrl: "/casino/qt-blender-blitz",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/BlenderBlitz.webp",
        alt: "blender blitz",
        name: "Blender Blitz",
      },
      BookOf99: {
        redirectUrl: "/casino/qt-book-of-99",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/Bookof99.webp",
        alt: "book of 99",
        name: "Book of 99",
      },
      BookOfPower: {
        redirectUrl: "/casino/qt-book-of-power",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/BookOfPower.webp",
        alt: "book of power",
        name: "Book Of Power",
      },
      CavemanBob: {
        redirectUrl: "/casino/qt-caveman-bob",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/CavemanBob.webp",
        alt: "caveman bob",
        name: "Caveman Bob",
      },
      ChipSpin: {
        redirectUrl: "/casino/qt-chip-spin",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/ChipSpin.webp",
        alt: "chip spin",
        name: "Chip Spin",
      },
      ClusterTumble: {
        redirectUrl: "/casino/qt-cluster-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/ClusterTumble.webp",
        alt: "cluster tumble",
        name: "Cluster Tumble",
      },
      DeadMansTrail: {
        redirectUrl: "/casino/qt-dead-mans-trail",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/DeadMansTrail.webp",
        alt: "dead mans trail",
        name: "Dead Man's Trail",
      },
      DeadRidersTrail: {
        redirectUrl: "/casino/qt-dead-riders-trail",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/DeadRidersTrail.webp",
        alt: "dead riders trail",
        name: "Dead Riders Trail",
      },
      DeepDescent: {
        redirectUrl: "/casino/qt-deep-descent",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/DeepDescent.webp",
        alt: "deep descent",
        name: "Deep Descent",
      },
      DragonsAwakening: {
        redirectUrl: "/casino/qt-dragons-awakening",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/DragonsAwakening.webp",
        alt: "dragons awakening",
        name: "Dragons Awakening",
      },
      EmeraldsInfinityReels: {
        redirectUrl: "/casino/qt-emeralds-infinity-reels",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/EmeraldsInfinityReels.webp",
        alt: "emeralds infinity reels",
        name: "Emerald's Infinity Reels",
      },
      ErikTheRed: {
        redirectUrl: "/casino/qt-erik-the-red",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/EriktheRed.webp",
        alt: "erik the red",
        name: "Erik the Red",
      },
      EpicJoker: {
        redirectUrl: "/casino/qt-epic-joker",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/EpicJoker.webp",
        alt: "epic joker",
        name: "Epic Joker",
      },
      FrequentFlyer: {
        redirectUrl: "/casino/qt-frequent-flyer",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/FrequentFlyer.webp",
        alt: "frequent flyer",
        name: "Frequent Flyer",
      },
      HazakuraWays: {
        redirectUrl: "/casino/qt-hazakura-ways",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/HazakuraWays.webp",
        alt: "hazakura ways",
        name: "Hazakura Ways",
      },
      HeliosFury: {
        redirectUrl: "/casino/qt-helios-fury",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/HeliosFury.webp",
        alt: "helios fury",
        name: "Helios' Fury",
      },
      Hellcatraz: {
        redirectUrl: "/casino/qt-hellcatraz",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/Hellcatraz.webp",
        alt: "hellcatraz",
        name: "Hellcatraz",
      },
      HeroesGathering: {
        redirectUrl: "/casino/qt-heroes-gathering",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/HeroesGathering.webp",
        alt: "heroes gathering",
        name: "Heroes Gathering",
      },
      Hex: {
        redirectUrl: "/casino/qt-hex",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/Hex.webp",
        alt: "hex",
        name: "Hex",
      },
      HorrorHotel: {
        redirectUrl: "/casino/qt-horror-hotel",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/HorrorHotel.webp",
        alt: "horror hotel",
        name: "Horror Hotel",
      },
      HotRodRacers: {
        redirectUrl: "/casino/qt-hot-rod-racers",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/HotRodRacers.webp",
        alt: "hot rod racers",
        name: "Hot Rod Racers",
      },
      IgniteTheNight: {
        redirectUrl: "/casino/qt-ignite-the-night",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/IgniteTheNight.webp",
        alt: "ignite the night",
        name: "Ignite The Night",
      },
      IronBank: {
        redirectUrl: "/casino/qt-iron-bank",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/IronBank.webp",
        alt: "iron bank",
        name: "Iron Bank",
      },
      ItsTime: {
        redirectUrl: "/casino/qt-its-time",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/ItsTime.webp",
        alt: "its time",
        name: "It's Time",
      },
      JurassicParty: {
        redirectUrl: "/casino/qt-jurassic-party",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/JurassicParty.webp",
        alt: "jurassic party",
        name: "Jurassic Party",
      },
      KingOfKings: {
        redirectUrl: "/casino/qt-king-of-kings",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/KingofKings.webp",
        alt: "king of kings",
        name: "King of Kings",
      },
      KlusterKrystalsMegaclusters: {
        redirectUrl: "/casino/qt-kluster-krystals-megaclusters",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/KlusterKrystalsMegaclusters.webp",
        alt: "kluster krystals megaclusters",
        name: "Kluster Krystals Megaclusters",
      },
      LaFiesta: {
        redirectUrl: "/casino/qt-la-fiesta",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/LaFiesta.webp",
        alt: "la fiesta",
        name: "La Fiesta",
      },
      LetsGetReadyToRumble: {
        redirectUrl: "/casino/qt-lets-get-ready-to-rumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/LetsgetreadytoRumble.webp",
        alt: "lets get ready to rumble",
        name: "Let's get ready to Rumble",
      },
      MarchingLegions: {
        redirectUrl: "/casino/qt-marching-legions",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MarchingLegions.webp",
        alt: "marching legions",
        name: "Marching Legions",
      },
      MegaFlip: {
        redirectUrl: "/casino/qt-mega-flip",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MegaFlip.webp",
        alt: "mega flip",
        name: "Mega Flip",
      },
      MegaHeist: {
        redirectUrl: "/casino/qt-mega-heist",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MegaHeist.webp",
        alt: "mega heist",
        name: "Mega Heist",
      },
      MegaMasks: {
        redirectUrl: "/casino/qt-mega-masks",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MegaMasks.webp",
        alt: "mega masks",
        name: "Mega Masks",
      },
      MegaMine: {
        redirectUrl: "/casino/qt-mega-mine",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MegaMine.webp",
        alt: "mega mine",
        name: "Mega Mine",
      },
      MidnightMarauder: {
        redirectUrl: "/casino/qt-midnight-marauder",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MidnightMarauder.webp",
        alt: "midnight marauder",
        name: "Midnight Marauder",
      },
      MoneyCart: {
        redirectUrl: "/casino/qt-money-cart",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MoneyCart.webp",
        alt: "money cart",
        name: "Money Cart",
      },
      MoneyCart2: {
        redirectUrl: "/casino/qt-money-cart-2",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MoneyCart2.webp",
        alt: "money cart 2",
        name: "Money Cart 2",
      },
      MoneyCart3: {
        redirectUrl: "/casino/qt-money-cart-3",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MoneyCart3.webp",
        alt: "money cart 3",
        name: "Money Cart 3",
      },
      MoneyTrain: {
        redirectUrl: "/casino/qt-money-train",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MoneyTrain.webp",
        alt: "money train",
        name: "Money Train",
      },
      MoneyTrain2: {
        redirectUrl: "/casino/qt-money-train-2",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MoneyTrain2.webp",
        alt: "money train 2",
        name: "Money Train 2",
      },
      MoneyTrain3: {
        redirectUrl: "/casino/qt-money-train-3",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MoneyTrain3.webp",
        alt: "money train 3",
        name: "Money Train 3",
      },
      MultiplierOdyssey: {
        redirectUrl: "/casino/qt-multiplier-odyssey",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MultiplierOdyssey.webp",
        alt: "multiplier odyssey",
        name: "Multiplier Odyssey",
      },
      NetGains: {
        redirectUrl: "/casino/qt-net-gains",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/NetGains.webp",
        alt: "net gains",
        name: "Net Gains",
      },
      Plunderland: {
        redirectUrl: "/casino/qt-plunderland",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/Plunderland.webp",
        alt: "plunderland",
        name: "Plunderland",
      },
      Powerspin: {
        redirectUrl: "/casino/qt-powerspin",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/Powerspin.webp",
        alt: "powerspin",
        name: "Powerspin",
      },
      RamsesRevenge: {
        redirectUrl: "/casino/qt-ramses-revenge",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/RamsesRevenge.webp",
        alt: "ramses revenge",
        name: "Ramses Revenge",
      },
      SailsOfFortune: {
        redirectUrl: "/casino/qt-sails-of-fortune",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/SailsOfFortune.webp",
        alt: "sails of fortune",
        name: "Sails Of Fortune",
      },
      // SnakeArena: {
      //   redirectUrl: "/casino/qt-snake-arena",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/SnakeArena.webp",
      //   alt: "snake arena",
      //   name: "Snake Arena",
      // },
      SantasStack: {
        redirectUrl: "/casino/qt-santas-stack",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/SantasStack.webp",
        alt: "santas stack",
        name: "Santa's Stack",
      },
      SpaceMiners: {
        redirectUrl: "/casino/qt-space-miners",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/SpaceMiners.webp",
        alt: "space miners",
        name: "Space Miners",
      },
      TemplarTumble: {
        redirectUrl: "/casino/qt-templar-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/TemplarTumble.webp",
        alt: "templar tumble",
        name: "Templar Tumble",
      },
      SpiritOfTheBeast: {
        redirectUrl: "/casino/qt-spirit-of-the-beast",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/SpiritoftheBeast.webp",
        alt: "spirit of the beast",
        name: "Spirit of the Beast",
      },
      TempleTumble: {
        redirectUrl: "/casino/qt-temple-tumble-megaways",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/TempleTumbleMegaways.webp",
        alt: "temple tumble",
        name: "Temple Tumble",
      },
      // TheGreatPigsbyMegaways: {
      //   redirectUrl: "/casino/qt-the-great-pigsby-megaways",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/TheGreatPigsbyMegaways.webp",
      //   alt: "the great pigsby megaways",
      //   name: "The Great Pigsby Megaways",
      // },
      TheGreatPigsby: {
        redirectUrl: "/casino/qt-the-great-pigsby",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/TheGreatPigsby.webp",
        alt: "the great pigsby",
        name: "The Great Pigsby",
      },
      TigerKingdomInfinityReels: {
        redirectUrl: "/casino/qt-tiger-kingdom-infinity-reels",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/TigerKingdomInfinityReels.webp",
        alt: "tiger kingdom infinity reels",
        name: "Tiger Kingdom Infinity Reels",
      },
      TNTTumble: {
        redirectUrl: "/casino/qt-tnt-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/TNTTumble.webp",
        alt: "tnt tumble",
        name: "TNT Tumble",
      },
      TopDawgs: {
        redirectUrl: "/casino/qt-top-dawgdollar",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/TopDawg.webp",
        alt: "top dawg$",
        name: "Top Dawg$",
      },
      TowerTumble: {
        redirectUrl: "/casino/qt-tower-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/TowerTumble.webp",
        alt: "tower tumble",
        name: "Tower Tumble",
      },
      TrollsGold: {
        redirectUrl: "/casino/qt-trolls-gold",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/TrollsGold.webp",
        alt: "trolls gold",
        name: "Troll's Gold",
      },
      VolatileVikings: {
        redirectUrl: "/casino/qt-volatile-vikings",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/VolatileVikings.webp",
        alt: "volatile vikings",
        name: "Volatile Vikings",
      },
      WildChapo: {
        redirectUrl: "/casino/qt-wild-chapo",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/WildChapo.webp",
        alt: "wild chapo",
        name: "Wild Chapo",
      },
      WildChapo2: {
        redirectUrl: "/casino/qt-wild-chapo-2",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/WildChapo2.webp",
        alt: "wild chapo-2",
        name: "Wild Chapo 2",
      },
      Wildchemy: {
        redirectUrl: "/casino/qt-wildchemy",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/Wildchemy.webp",
        alt: "wildchemy",
        name: "Wildchemy",
      },
      WildHike: {
        redirectUrl: "/casino/qt-wild-hike",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/WildHike.webp",
        alt: "wild hike",
        name: "Wild Hike",
      },
      WildYield: {
        redirectUrl: "/casino/qt-wild-yield",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/WildYield.webp",
        alt: "wild yield",
        name: "Wild Yield",
      },
      ZombieCircus: {
        redirectUrl: "/casino/qt-zombie-circus",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/ZombieCircus.webp",
        alt: "zombie circus",
        name: "Zombie Circus",
      },
      BlackjackNeo: {
        redirectUrl: "/casino/qt-blackjack-neo",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/BlackjackNeo.webp",
        alt: "blackjack neo",
        name: "Blackjack Neo",
      },
      RouletteNouveau: {
        redirectUrl: "/casino/qt-roulette-nouveau",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/RouletteNouveau.webp",
        alt: "roulette nouveau",
        name: "Roulette Nouveau",
      },
      MONEYCART4: {
        redirectUrl: "/casino/qt-money-cart-4",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/MONEYCART4.webp",
        alt: "money cart 4",
        name: "MONEY CART 4",
      },
      SWEETOPIAROYALE: {
        redirectUrl: "/casino/qt-sweetopia-royale",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/SWEETOPIAROYALE.webp",
        alt: "sweetopia royale",
        name: "SWEETOPIA ROYALE",
      },
      FIREWINSFACTORY: {
        redirectUrl: "/casino/qt-firewins-factory",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/FIREWINSFACTORY.webp",
        alt: "firewins factory",
        name: "Firewins Factory",
      },
      // HeroesHunt2MegawaysXmasVersion: {
      //   redirectUrl: "/casino/qt-heroes-hunt-2-megaways-xmas-version",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl:
      //     "./images/casino/relax-gaming/HeroesHunt2MegawaysXmasVersion.webp",
      //   alt: "heroes hunt 2 megaways - xmas version",
      //   name: "Heroes Hunt 2 Megaways - Xmas Version",
      // },
      TheGreatPigsbyMegapays: {
        redirectUrl: "/casino/qt-the-great-pigsby-megapays",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/TheGreatPigsbyMegapays.webp",
        alt: "the great pigsby megapays",
        name: "The Great Pigsby Megapays",
      },
      SnakeArenaDreamDrop: {
        redirectUrl: "/casino/qt-snake-arena-dream-drop",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/SnakeArenaDreamDrop.webp",
        alt: "snake arena dream drop",
        name: "Snake Arena Dream Drop",
      },
      // VolatileVikings2DreamDrop: {
      //   redirectUrl: "/casino/qt-volatile-vikings-2-dream-drop",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/VolatileVikings2DreamDrop.webp",
      //   alt: "volatile vikings 2 dream drop",
      //   name: "Volatile Vikings 2 Dream Drop",
      // },
      // TntTumbleDreamDrop: {
      //   redirectUrl: "/casino/qt-tnt-tumble-dream-drop",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/TntTumbleDreamDrop.webp",
      //   alt: "tnt tumble dream drop",
      //   name: "Tnt Tumble Dream Drop",
      // },
      // NekoNightDreamDrop: {
      //   redirectUrl: "/casino/qt-neko-night-dream-drop",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/NekoNightDreamDrop.webp",
      //   alt: "neko night dream drop",
      //   name: "Neko Night Dream Drop",
      // },
      // WildChapoDreamDrop: {
      //   redirectUrl: "/casino/qt-wild-chapo-dream-drop",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/WildChapoDreamDrop.webp",
      //   alt: "wild chapo dream drop",
      //   name: "Wild Chapo Dream Drop",
      // },
      // TheTumbles: {
      //   redirectUrl: "/casino/qtechrelaxgaming-the-tumbles",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/TheTumbles.webp",
      //   alt: "the tumbles",
      //   name: "The Tumbles",
      // },
      // BoneRaiders: {
      //   redirectUrl: "/casino/qtechrelaxgaming-bone-raiders",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/BoneRaiders.webp",
      //   alt: "bone raiders",
      //   name: "Bone Raiders",
      // },
      AtlantisCrush: {
        redirectUrl: "/casino/qt-atlantis-crush",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/AtlantisCrush.webp",
        alt: "atlantis crush",
        name: "Atlantis Crush",
      },
      AncientTumble: {
        redirectUrl: "/casino/qt-ancient-tumble",
        code: "",
        casino: "Relax Gaming",
        provider: "WorldCasino",
        category: "relaxGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/relax-gaming/AncientTumble.webp",
        alt: "ancient tumble",
        name: "Ancient Tumble",
      },
      // EpicDreams: {
      //   redirectUrl: "/casino/qtechrelaxgaming-epic-dreams",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/EpicDreams.webp",
      //   alt: "epic dreams",
      //   name: "Epic Dreams",
      // },
      // SultanSpins: {
      //   redirectUrl: "/casino/qtechrelaxgaming-sultan-spins",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/SultanSpins.webp",
      //   alt: "sultan spins",
      //   name: "Sultan Spins",
      // },
      // QuackinReels: {
      //   redirectUrl: "/casino/qtechrelaxgaming-quackin-reels",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/QuackinReels.webp",
      //   alt: "quackin reels",
      //   name: "Quackin' Reels",
      // },
      // FeatherFury: {
      //   redirectUrl: "/casino/qtechrelaxgaming-feather-fury",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/FeatherFury.webp",
      //   alt: "feather fury",
      //   name: "Feather Fury",
      // },
      // MoneySleigh: {
      //   redirectUrl: "/casino/qtechrelaxgaming-money-sleigh",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/MoneySleigh.webp",
      //   alt: "money sleigh",
      //   name: "Money Sleigh",
      // },
      // WinterChampions: {
      //   redirectUrl: "/casino/qtechrelaxgaming-winter-champions",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/WinterChampions.webp",
      //   alt: "winter champions",
      //   name: "Winter Champions",
      // },
      // Immortal5: {
      //   redirectUrl: "/casino/qtechrelaxgaming-immortal-5",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/Immortal5.webp",
      //   alt: "immortal 5",
      //   name: "Immortal 5",
      // },
      // KrakensCove: {
      //   redirectUrl: "/casino/qtechrelaxgaming-krakens-cove",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/KrakensCove.webp",
      //   alt: "krakens cove",
      //   name: "Kraken's Cove",
      // },
      // CamelotCash: {
      //   redirectUrl: "/casino/qtechrelaxgaming-camelot-cash",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "WorldCasino",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/CamelotCash.webp",
      //   alt: "camelot cash",
      //   name: "Camelot Cash",
      // },
      // GiantsAndSheep: {
      //   redirectUrl: "/casino/qtechrelaxgaming-giants-and-sheep",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "QTECH",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/GiantsAndSheep.webp",
      //   alt: "giants and sheep",
      //   name: "Giants & Sheep",
      // },
      // GlyphOfGods: {
      //   redirectUrl: "/casino/qtechrelaxgaming-glyph-of-gods",
      //   code: "",
      //   casino: "Relax Gaming",
      //   provider: "QTECH",
      //   category: "relaxGaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/relax-gaming/GlyphofGods.webp",
      //   alt: "glyph of gods",
      //   name: "Glyph of Gods",
      // },
    },
    name: "Relax Gaming",
    key: "relaxGamingGames",
  },
  habanero: {
    slide1: {
      FruityMayan: {
        redirectUrl: "/casino/qt-fruity-mayan",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/FruityMayan.webp",
        alt: "Fruity Mayan",
        name: "Fruity Mayan",
      },
      SantasInn: {
        redirectUrl: "/casino/qt-santas-inn",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/SantasInn.webp",
        alt: "Santa's Inn",
        name: "Santa's Inn",
      },
      // ZeusDeluxe: {
      //   redirectUrl: "/casino/qt-zeus-deluxe",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "habanero",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/habanero/ZeusDeluxe.webp",
      //   alt: "Zeus Deluxe",
      //   name: "Zeus Deluxe",
      // },
      FruityHalloween: {
        redirectUrl: "/casino/qt-fruity-halloween",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/FruityHalloween.webp",
        alt: "Fruity Halloween",
        name: "Fruity Halloween",
      },
      SlimeParty: {
        redirectUrl: "/casino/qt-slime-party",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/SlimeParty.webp",
        alt: "Slime Party",
        name: "Slime Party",
      },
      MeowJanken: {
        redirectUrl: "/casino/qt-meow-janken",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/MeowJanken.webp",
        alt: "Meow Janken",
        name: "Meow Janken",
      },
      BikiniIslandDeluxe: {
        redirectUrl: "/casino/qt-bikini-island-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/BikiniIslandDeluxe.webp",
        alt: "Bikini Island Deluxe",
        name: "Bikini Island Deluxe",
      },
      AtomicKittens: {
        redirectUrl: "/casino/qt-atomic-kittens",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/AtomicKittens.webp",
        alt: "Atomic Kittens",
        name: "Atomic Kittens",
      },
      WitchesTome: {
        redirectUrl: "/casino/qt-witches-tome",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/WitchesTome.webp",
        alt: "Witches Tome",
        name: "Witches Tome",
      },
      LegendOfNezha: {
        redirectUrl: "/casino/qt-legend-of-nezha",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/LegendOfNezha.webp",
        alt: "Legend Of Nezha",
        name: "Legend Of Nezha",
      },
      TootyFruityFruits: {
        redirectUrl: "/casino/qt-tooty-fruity-fruits",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/TootyFruityFruits.webp",
        alt: "Tooty Fruity Fruits",
        name: "Tooty Fruity Fruits",
      },
      SirensSpell: {
        redirectUrl: "/casino/qt-sirenaeurotms-spell",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/SirensSpell.webp",
        alt: "Siren’s Spell",
        name: "Siren’s Spell",
      },
      Crystopia: {
        redirectUrl: "/casino/qt-crystopia",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Crystopia.webp",
        alt: "Crystopia",
        name: "Crystopia",
      },
      Mariachis5: {
        redirectUrl: "/casino/qt-5-mariachis",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/5Mariachis.webp",
        alt: "5 Mariachis",
        name: "5 Mariachis",
      },
      Lucky5Lions: {
        redirectUrl: "/casino/qt-5-lucky-lions",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/5LuckyLions.webp",
        alt: "5 Lucky Lions",
        name: "5 Lucky Lions",
      },
      Zodiacs12: {
        redirectUrl: "/casino/qt-12-zodiacs",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/12Zodiacs.webp",
        alt: "12 Zodiacs",
        name: "12 Zodiacs",
      },
      ArcaneElements: {
        redirectUrl: "/casino/qt-arcane-elements",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/ArcaneElements.webp",
        alt: "Arcane Elements",
        name: "Arcane Elements",
      },
      BeforeTimeRunsOut: {
        redirectUrl: "/casino/qt-before-time-runs-out",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/BeforeTimeRunsOut.webp",
        alt: "Before Time Runs Out",
        name: "Before Time Runs Out",
      },
      BirdOfThunder: {
        redirectUrl: "/casino/qt-bird-of-thunder",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/BirdofThunder.webp",
        alt: "Bird of Thunder",
        name: "Bird of Thunder",
      },
      BombRunner: {
        redirectUrl: "/casino/qt-bomb-runner",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/BombRunner.webp",
        alt: "Bomb Runner",
        name: "Bomb Runner",
      },
      BombsAway: {
        redirectUrl: "/casino/qt-bombs-away",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/BombsAway.webp",
        alt: "Bombs Away",
        name: "Bombs Away",
      },
      CalaverasExplosivas: {
        redirectUrl: "/casino/qt-calaveras-explosivas",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/CalaverasExplosivas.webp",
        alt: "Calaveras Explosivas",
        name: "Calaveras Explosivas",
      },
      CakeValley: {
        redirectUrl: "/casino/qt-cake-valley",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/CakeValley.webp",
        alt: "Cake Valley",
        name: "Cake Valley",
      },
      CandyTower: {
        redirectUrl: "/casino/qt-candy-tower",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/CandyTower.webp",
        alt: "Candy Tower",
        name: "Candy Tower",
      },
      ChristmasGiftRush: {
        redirectUrl: "/casino/qt-christmas-gift-rush",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/ChristmasGiftRush.webp",
        alt: "Christmas Gift Rush",
        name: "Christmas Gift Rush",
      },
      ColossalGems: {
        redirectUrl: "/casino/qt-colossal-gems",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/ColossalGems.webp",
        alt: "Colossal Gems",
        name: "Colossal Gems",
      },
      CoyoteCrash: {
        redirectUrl: "/casino/qt-coyote-crash",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/CoyoteCrash.webp",
        alt: "Coyote Crash",
        name: "Coyote Crash",
      },
      DiscoBeats: {
        redirectUrl: "/casino/qt-disco-beats",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/DiscoBeats.webp",
        alt: "Disco Beats",
        name: "Disco Beats",
      },
      DragonCastle: {
        redirectUrl: "/casino/qt-dragon-castle",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/DragonCastle.webp",
        alt: "Dragon Castle",
        name: "Dragon Castle",
      },
      DragonsRealm: {
        redirectUrl: "/casino/qt-dragons-realm",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/DragonsRealm.webp",
        alt: "Dragon's Realm",
        name: "Dragon's Realm",
      },
      DragonsThrone: {
        redirectUrl: "/casino/qt-dragons-throne",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/DragonsThrone.webp",
        alt: "Dragon’s Throne",
        name: "Dragon’s Throne",
      },
      DragonTigerGate: {
        redirectUrl: "/casino/qt-dragon-tiger-gate",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/DragonTigerGate.webp",
        alt: "Dragon Tiger Gate",
        name: "Dragon Tiger Gate",
      },
      EgyptianDreamsDeluxe: {
        redirectUrl: "/casino/qt-egyptian-dreams-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/EgyptianDreamsDeluxe.webp",
        alt: "Egyptian Dreams Deluxe",
        name: "Egyptian Dreams Deluxe",
      },
      FaCaiShen: {
        redirectUrl: "/casino/qt-fa-cai-shen",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/FaCaiShen.webp",
        alt: "Fa Cai Shen",
        name: "Fa Cai Shen",
      },
      FaCaiShenDeluxe: {
        redirectUrl: "/casino/qt-fa-cai-shen-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/FaCaiShenDeluxe.webp",
        alt: "Fa Cai Shen Deluxe",
        name: "Fa Cai Shen Deluxe",
      },
      Fenghuang: {
        redirectUrl: "/casino/qt-fenghuang",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Fenghuang.webp",
        alt: "Fenghuang",
        name: "Fenghuang",
      },
      FireRooster: {
        redirectUrl: "/casino/qt-fire-rooster",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/FireRooster.webp",
        alt: "Fire Rooster",
        name: "Fire Rooster",
      },
      Fly: {
        redirectUrl: "/casino/qt-fly-jet",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Fly.webp",
        alt: "Fly",
        name: "Fly",
      },
      FortuneDogs: {
        redirectUrl: "/casino/qt-fortune-dogs",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/FortuneDogs.webp",
        alt: "Fortune Dogs",
        name: "Fortune Dogs",
      },
      FourDivineBeasts: {
        redirectUrl: "/casino/qt-four-divine-beasts",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/FourDivineBeasts.webp",
        alt: "Four Divine Beasts",
        name: "Four Divine Beasts",
      },
      Gangsters: {
        redirectUrl: "/casino/qt-gangsters",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Gangsters.webp",
        alt: "Gangsters",
        name: "Gangsters",
      },
      GoldenUnicornDeluxe: {
        redirectUrl: "/casino/qt-golden-unicorn-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/GoldenUnicornDeluxe.webp",
        alt: "Golden Unicorn Deluxe",
        name: "Golden Unicorn Deluxe",
      },
      GoldRush: {
        redirectUrl: "/casino/qt-gold-rush",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/GoldRush.webp",
        alt: "Gold Rush",
        name: "Gold Rush",
      },
      HappiestChristmasTree: {
        redirectUrl: "/casino/qt-happiest-christmas-tree",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/HappiestChristmasTree.webp",
        alt: "Happiest Christmas Tree",
        name: "Happiest Christmas Tree",
      },
      HappyApe: {
        redirectUrl: "/casino/qt-happy-ape",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/HappyApe.webp",
        alt: "Happy Ape",
        name: "Happy Ape",
      },
      HeySushi: {
        redirectUrl: "/casino/qt-hey-sushi",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/HeySushi.webp",
        alt: "Hey Sushi",
        name: "Hey Sushi",
      },
      HotHotFruit: {
        redirectUrl: "/casino/qt-hot-hot-fruit",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/HotHotFruit.webp",
        alt: "Hot Hot Fruit",
        name: "Hot Hot Fruit",
      },
      HotHotHalloween: {
        redirectUrl: "/casino/qt-hot-hot-halloween",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/HotHotHalloween.webp",
        alt: "Hot Hot Halloween",
        name: "Hot Hot Halloween",
      },
      IndianCashCatcher: {
        redirectUrl: "/casino/qt-indian-cash-catcher",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/IndianCashCatcher.webp",
        alt: "Indian Cash Catcher",
        name: "Indian Cash Catcher",
      },
      JellyfishFlow: {
        redirectUrl: "/casino/qt-jellyfish-flow",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/JellyfishFlow.webp",
        alt: "Jellyfish Flow",
        name: "Jellyfish Flow",
      },
      JellyFishFlowUltra: {
        redirectUrl: "/casino/qt-jellyfish-flow-ultra",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/JellyFishFlowUltra.webp",
        alt: "JellyFish Flow Ultra",
        name: "JellyFish Flow Ultra",
      },
      Jugglenaut: {
        redirectUrl: "/casino/qt-jugglenaut",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Jugglenaut.webp",
        alt: "Jugglenaut",
        name: "Jugglenaut",
      },
      Jump: {
        redirectUrl: "/casino/qt-jump",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Jump.webp",
        alt: "Jump",
        name: "Jump",
      },
      KnockoutFootball: {
        redirectUrl: "/casino/qt-knockout-football",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/KnockoutFootball.webp",
        alt: "Knockout Football",
        name: "Knockout Football",
      },
      KnockoutFootballRush: {
        redirectUrl: "/casino/qt-knockout-football-rush",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/KnockoutFootballRush.webp",
        alt: "Knockout Football Rush",
        name: "Knockout Football Rush",
      },
      KoiGate: {
        redirectUrl: "/casino/qt-koi-gate",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/KoiGate.webp",
        alt: "Koi Gate",
        name: "Koi Gate",
      },
      LanternLuck: {
        redirectUrl: "/casino/qt-lantern-luck",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/LanternLuck.webp",
        alt: "Lantern Luck",
        name: "Lantern Luck",
      },
      LaughingBuddha: {
        redirectUrl: "/casino/qt-laughing-buddha",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/LaughingBuddha.webp",
        alt: "Laughing Buddha",
        name: "Laughing Buddha",
      },
      LegendaryBeasts: {
        redirectUrl: "/casino/qt-legendary-beasts",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/LegendaryBeasts.webp",
        alt: "Legendary Beasts",
        name: "Legendary Beasts",
      },
      LondonHunter: {
        redirectUrl: "/casino/qt-london-hunter",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/LondonHunter.webp",
        alt: "London Hunter",
        name: "London Hunter",
      },
      LoonyBlox: {
        redirectUrl: "/casino/qt-loony-blox",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/LoonyBlox.webp",
        alt: "Loony Blox",
        name: "Loony Blox",
      },
      LuckyDurian: {
        redirectUrl: "/casino/qt-lucky-durian",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/LuckyDurian.webp",
        alt: "Lucky Durian",
        name: "Lucky Durian",
      },
      LuckyFortuneCat: {
        redirectUrl: "/casino/qt-lucky-fortune-cat",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/LuckyFortuneCat.webp",
        alt: "Lucky Fortune Cat",
        name: "Lucky Fortune Cat",
      },
      LuckyLucky: {
        redirectUrl: "/casino/qt-lucky-lucky",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/LuckyLucky.webp",
        alt: "Lucky Lucky",
        name: "Lucky Lucky",
      },
      MagicOak: {
        redirectUrl: "/casino/qt-magic-oak",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/MagicOak.webp",
        alt: "Magic Oak",
        name: "Magic Oak",
      },
      MarvelousFurlongs: {
        redirectUrl: "/casino/qt-marvelous-furlongs",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/MarvelousFurlongs.webp",
        alt: "Marvelous Furlongs",
        name: "Marvelous Furlongs",
      },
      MightyMedusa: {
        redirectUrl: "/casino/qt-mighty-medusa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/MightyMedusa.webp",
        alt: "Mighty Medusa",
        name: "Mighty Medusa",
      },
      MonsterMashCash: {
        redirectUrl: "/casino/qt-monster-mash-cash",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/MonsterMashCash.webp",
        alt: "Monster Mash Cash",
        name: "Monster Mash Cash",
      },
      MountMazuma: {
        redirectUrl: "/casino/qt-mount-mazuma",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/MountMazuma.webp",
        alt: "Mount Mazuma",
        name: "Mount Mazuma",
      },
      MysticFortune: {
        redirectUrl: "/casino/qt-mystic-fortune",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/MysticFortune.webp",
        alt: "Mystic Fortune",
        name: "Mystic Fortune",
      },
      MysticFortuneDeluxe: {
        redirectUrl: "/casino/qt-mystic-fortune-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/MysticFortuneDeluxe.webp",
        alt: "Mystic Fortune Deluxe",
        name: "Mystic Fortune Deluxe",
      },
      NaughtySanta: {
        redirectUrl: "/casino/qt-naughty-santa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/NaughtySanta.webp",
        alt: "Naughty Santa",
        name: "Naughty Santa",
      },
      NaughtyWukong: {
        redirectUrl: "/casino/qt-naughty-wukong",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/NaughtyWukong.webp",
        alt: "Naughty Wukong",
        name: "Naughty Wukong",
      },
      NewYearsBash: {
        redirectUrl: "/casino/qt-new-years-bash",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/NewYearsBash.webp",
        alt: "New Year's Bash",
        name: "New Year's Bash",
      },
      NineTails: {
        redirectUrl: "/casino/qt-nine-tails",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/NineTails.webp",
        alt: "Nine Tails",
        name: "Nine Tails",
      },
      Nuwa: {
        redirectUrl: "/casino/qt-nuwa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Nuwa.webp",
        alt: "Nuwa",
        name: "Nuwa",
      },
      OrbsOfAtlantis: {
        redirectUrl: "/casino/qt-orbs-of-atlantis",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/OrbsOfAtlantis.webp",
        alt: "Orbs Of Atlantis",
        name: "Orbs Of Atlantis",
      },
      OceansCall: {
        redirectUrl: "/casino/qt-oceans-call",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/OceansCall.webp",
        alt: "Ocean's Call",
        name: "Ocean's Call",
      },
      PandaPanda: {
        redirectUrl: "/casino/qt-panda-panda",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/PandaPanda.webp",
        alt: "Panda Panda",
        name: "Panda Panda",
      },
      PoolShark: {
        redirectUrl: "/casino/qt-pool-shark",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/PoolShark.webp",
        alt: "Pool Shark",
        name: "Pool Shark",
      },
      Presto: {
        redirectUrl: "/casino/qt-presto",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Presto.webp",
        alt: "Presto",
        name: "Presto",
      },
      Prost: {
        redirectUrl: "/casino/qt-prost",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Prost.webp",
        alt: "Prost",
        name: "Prost",
      },
      PuckerUpPrince: {
        redirectUrl: "/casino/qt-pucker-up-prince",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/PuckerUpPrince.webp",
        alt: "Pucker Up Prince",
        name: "Pucker Up Prince",
      },
      PumpkinPatch: {
        redirectUrl: "/casino/qt-pumpkin-patch",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/PumpkinPatch.webp",
        alt: "Pumpkin Patch",
        name: "Pumpkin Patch",
      },
      RainbowMania: {
        redirectUrl: "/casino/qt-rainbow-mania",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/RainbowMania.webp",
        alt: "Rainbow Mania",
        name: "Rainbow Mania",
      },
      ReturnToTheFeature: {
        redirectUrl: "/casino/qt-return-to-the-feature",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/ReturnToTheFeature.webp",
        alt: "Return To The Feature",
        name: "Return To The Feature",
      },
      RollingRoger: {
        redirectUrl: "/casino/qt-rolling-roger",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/RollingRoger.webp",
        alt: "Rolling Roger",
        name: "Rolling Roger",
      },
      RomanEmpire: {
        redirectUrl: "/casino/qt-roman-empire",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/RomanEmpire.webp",
        alt: "Roman Empire",
        name: "Roman Empire",
      },
      RuffledUp: {
        redirectUrl: "/casino/qt-ruffled-up",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/RuffledUp.webp",
        alt: "Ruffled Up",
        name: "Ruffled Up",
      },
      SantasVillage: {
        redirectUrl: "/casino/qt-santas-village",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/SantasVillage.webp",
        alt: "Santa’s Village",
        name: "Santa’s Village",
      },
      Scopa: {
        redirectUrl: "/casino/qt-scopa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Scopa.webp",
        alt: "Scopa",
        name: "Scopa",
      },
      ScruffyScallywags: {
        redirectUrl: "/casino/qt-scruffy-scallywags",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/ScruffyScallywags.webp",
        alt: "Scruffy Scallywags",
        name: "Scruffy Scallywags",
      },
      ShaolinFortunes: {
        redirectUrl: "/casino/qt-shaolin-fortunes",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/ShaolinFortunes.webp",
        alt: "Shaolin Fortunes",
        name: "Shaolin Fortunes",
      },
      SojuBomb: {
        redirectUrl: "/casino/qt-soju-bomb",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/SojuBomb.webp",
        alt: "Soju Bomb",
        name: "Soju Bomb",
      },
      SOS: {
        redirectUrl: "/casino/qt-sos",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/SOS.webp",
        alt: "S.O.S!",
        name: "S.O.S!",
      },
      SpaceGoonz: {
        redirectUrl: "/casino/qt-space-goonz",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/SpaceGoonz.webp",
        alt: "Space Goonz",
        name: "Space Goonz",
      },
      Sparta: {
        redirectUrl: "/casino/qt-sparta",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Sparta.webp",
        alt: "Sparta",
        name: "Sparta",
      },
      SuperStrike: {
        redirectUrl: "/casino/qt-super-strike",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/SuperStrike.webp",
        alt: "Super Strike",
        name: "Super Strike",
      },
      SuperTwister: {
        redirectUrl: "/casino/qt-super-twister",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/SuperTwister.webp",
        alt: "Super Twister",
        name: "Super Twister",
      },
      TabernaDeLosMuertos: {
        redirectUrl: "/casino/qt-taberna-de-los-muertos",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/TabernaDeLosMuertos.webp",
        alt: "Taberna De Los Muertos",
        name: "Taberna De Los Muertos",
      },
      TabernaDeLosMuertosUltra: {
        redirectUrl: "/casino/qt-taberna-de-los-muertos-ultra",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/TabernaDeLosMuertosUltra.webp",
        alt: "Taberna De Los Muertos Ultra",
        name: "Taberna De Los Muertos Ultra",
      },
      TaikoBeats: {
        redirectUrl: "/casino/qt-taiko-beats",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/TaikoBeats.webp",
        alt: "Taiko Beats",
        name: "Taiko Beats",
      },
      TechnoTumble: {
        redirectUrl: "/casino/qt-techno-tumble",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/TechnoTumble.webp",
        alt: "Techno Tumble",
        name: "Techno Tumble",
      },
      TheBigDealDeluxe: {
        redirectUrl: "/casino/qt-the-big-deal-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/TheBigDealDeluxe.webp",
        alt: "The Big Deal Deluxe",
        name: "The Big Deal Deluxe",
      },
      TheDeadEscape: {
        redirectUrl: "/casino/qt-the-dead-escape",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/TheDeadEscape.webp",
        alt: "The Dead Escape",
        name: "The Dead Escape",
      },
      TotemTowers: {
        redirectUrl: "/casino/qt-totem-towers",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/TotemTowers.webp",
        alt: "Totem Towers",
        name: "Totem Towers",
      },
      TukTukThailand: {
        redirectUrl: "/casino/qt-tuk-tuk-thailand",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/TukTukThailand.webp",
        alt: "Tuk Tuk Thailand",
        name: "Tuk Tuk Thailand",
      },
      WaysOfFortune: {
        redirectUrl: "/casino/qt-ways-of-fortune",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/WaysOfFortune.webp",
        alt: "Ways Of Fortune",
        name: "Ways Of Fortune",
      },
      WealthInn: {
        redirectUrl: "/casino/qt-wealth-inn",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/WealthInn.webp",
        alt: "Wealth Inn",
        name: "Wealth Inn",
      },
      WickedWitch: {
        redirectUrl: "/casino/qt-wicked-witch",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/WickedWitch.webp",
        alt: "Wicked Witch",
        name: "Wicked Witch",
      },
      WildTrucks: {
        redirectUrl: "/casino/qt-wild-trucks",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/WildTrucks.webp",
        alt: "Wild Trucks",
        name: "Wild Trucks",
      },
      WizardsWantWar: {
        redirectUrl: "/casino/qt-wizards-want-war",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/WizardsWantWar.webp",
        alt: "Wizards Want War",
        name: "Wizards Want War",
      },
      Zeus: {
        redirectUrl: "/casino/qt-zeus",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Zeus.webp",
        alt: "Zeus",
        name: "Zeus",
      },
      Hand3Blackjack: {
        redirectUrl: "/casino/qt-3-hand-blackjack",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/3HandBlackjack.webp",
        alt: "3 Hand Blackjack",
        name: "3 Hand Blackjack",
      },
      Hand3BlackjackDoubleExposure: {
        redirectUrl: "/casino/qt-3-hand-blackjack-double-exposure",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/3HandBlackjackDoubleExposure.webp",
        alt: "3 Hand Blackjack Double Exposure",
        name: "3 Hand Blackjack Double Exposure",
      },
      AmericanBlackjack: {
        redirectUrl: "/casino/qt-american-blackjack",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/AmericanBlackjack.webp",
        alt: "American Blackjack",
        name: "American Blackjack",
      },
      Baccarat: {
        redirectUrl: "/casino/qt-baccarat",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Baccarat.webp",
        alt: "Baccarat",
        name: "Baccarat",
      },
      BaccaratZeroCommission: {
        redirectUrl: "/casino/qt-baccarat-zero-commission",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/BaccaratZeroCommission.webp",
        alt: "Baccarat Zero Commission",
        name: "Baccarat Zero Commission",
      },
      CaribbeanHoldem: {
        redirectUrl: "/casino/qt-caribbean-holdem",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/CaribbeanHoldem.webp",
        alt: "Caribbean Holdem",
        name: "Caribbean Holdem",
      },
      CaribbeanStud: {
        redirectUrl: "/casino/qt-caribbean-stud",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/CaribbeanStud.webp",
        alt: "Caribbean Stud",
        name: "Caribbean Stud",
      },
      DragonTiger: {
        redirectUrl: "/casino/qt-dragon-tiger",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/DragonTiger.webp",
        alt: "Dragon Tiger",
        name: "Dragon Tiger",
      },
      EuropeanRoulette: {
        redirectUrl: "/casino/qt-european-roulette",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/EuropeanRoulette.webp",
        alt: "European Roulette",
        name: "European Roulette",
      },
      SicBo: {
        redirectUrl: "/casino/qt-sic-bo",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Sicbo.webp",
        alt: "Sic Bo",
        name: "Sic Bo",
      },
      ThreeCardPoker: {
        redirectUrl: "/casino/qt-three-card-poker",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/ThreeCardPoker.webp",
        alt: "Three Card Poker",
        name: "Three Card Poker",
      },
      ThreeCardPokerDeluxe: {
        redirectUrl: "/casino/qt-three-card-poker-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/ThreeCardPokerDeluxe.webp",
        alt: "Three Card Poker Deluxe",
        name: "Three Card Poker Deluxe",
      },
      War: {
        redirectUrl: "/casino/qt-war",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/War.webp",
        alt: "War",
        name: "War",
      },
      ValentineMonchy: {
        redirectUrl: "/casino/qt-valentine-monchy",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/ValentineMonchy.webp",
        alt: "Valentine Monchy",
        name: "Valentine Monchy",
      },
      HotHotSummer: {
        redirectUrl: "/casino/qt-hot-hot-summer",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/HotHotSummer.webp",
        alt: "Hot Hot Summer",
        name: "Hot Hot Summer",
      },
      // HauntedHarbor: {
      //   redirectUrl: "/casino/aggaphabanero-haunted-harbor",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "habanero",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/habanero/HauntedHarbor.webp",
      //   alt: "Haunted Harbor",
      //   name: "Haunted Harbor",
      // },
      // GloryOfRome: {
      //   redirectUrl: "/casino/aggaphabanero-glory-of-rome",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "habanero",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/habanero/GloryofRome.webp",
      //   alt: "Glory of Rome",
      //   name: "Glory of Rome",
      // },
      KoiKoiTreasure: {
        redirectUrl: "/casino/qt-koi-koi-treasure",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/KoiKoiTreasure.webp",
        alt: "Koi-Koi Treasure",
        name: "Koi-Koi Treasure",
      },
      WaltzBeauty: {
        redirectUrl: "/casino/qt-waltz-beauty",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/WaltzBeauty.webp",
        alt: "Waltz Beauty",
        name: "Waltz Beauty",
      },
      TotemWarrior: {
        redirectUrl: "/casino/qt-totem-warrior",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/TotemWarrior.webp",
        alt: "Totem Warrior",
        name: "Totem Warrior",
      },
      ArcticHunt: {
        redirectUrl: "/casino/qt-arctic-hunt",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/ArcticHunt.webp",
        alt: "Arctic Hunt",
        name: "Arctic Hunt",
      },
      MooMooCow: {
        redirectUrl: "/casino/qt-moo-moo-cow",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/MooMooCow.webp",
        alt: "Moo Moo Cow",
        name: "Moo Moo Cow",
      },
      GoldenTajMahal: {
        redirectUrl: "/casino/qt-golden-taj-mahal",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/GoldenTajMahal.webp",
        alt: "Golden Taj Mahal",
        name: "Golden Taj Mahal",
      },
      WildFlow: {
        redirectUrl: "/casino/qt-wild-flow",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/WildFlow.webp",
        alt: "Wild Flow",
        name: "Wild Flow",
      },
      VampiresFate: {
        redirectUrl: "/casino/qt-vampires-fate",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/VampiresFate.webp",
        alt: "Vampire's Fate",
        name: "Vampire's Fate",
      },
      Jump2: {
        redirectUrl: "/casino/qt-jump-high-2",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Jump2.webp",
        alt: "Jump! 2",
        name: "Jump! 2",
      },
      Poseidon: {
        redirectUrl: "/casino/qt-poseidon",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/habanero/Poseidon.webp",
        alt: "Poseidon",
        name: "Poseidon",
      },
      // BabaYaga: {
      //   redirectUrl: "/casino/aggaphabanero-baba-yaga",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/habanero/BabaYaga.webp",
      //   alt: "Baba Yaga",
      //   name: "Baba Yaga",
      // },
      // CarnivalCove: {
      //   redirectUrl: "/casino/aggaphabanero-carnival-cove",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/habanero/CarnivalCove.webp",
      //   alt: "Carnival Cove",
      //   name: "Carnival Cove",
      // },
      // HyperHues: {
      //   redirectUrl: "/casino/aggaphabanero-hyper-hues",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/habanero/HyperHues.webp",
      //   alt: "Hyper Hues",
      //   name: "Hyper Hues",
      // },
      // JapaneseMask: {
      //   redirectUrl: "/casino/aggaphabanero-japanese-mask",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/habanero/JapaneseMask.webp",
      //   alt: "Japanese Mask",
      //   name: "Japanese Mask",
      // },
      // ShamrockQuest: {
      //   redirectUrl: "/casino/aggaphabanero-shamrock-quest",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/habanero/ShamrockQuest.webp",
      //   alt: "Shamrock Quest",
      //   name: "Shamrock Quest",
      // },
    },
    name: "Habanero",
    key: "habaneroGames",
  },
  dragoonSoft: {
    slide1: {
      Phoenix: {
        redirectUrl: "/casino/aggapdrgs-phoenix",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/Phoenix1.webp",
        alt: "Phoenix",
        name: "Phoenix",
      },
      GetMoney: {
        redirectUrl: "/casino/aggapdrgs-get-money",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/GetMoney.webp",
        alt: "Get Money",
        name: "Get Money",
      },
      CoinCat: {
        redirectUrl: "/casino/aggapdrgs-coin-cat",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/CoinCat.webp",
        alt: "Coin Cat",
        name: "Coin Cat",
      },
      AceyDeucey: {
        redirectUrl: "/casino/aggapdrgs-acey-deucey",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/AceyDeucey.webp",
        alt: "Acey Deucey",
        name: "Acey Deucey",
      },
      DragonOrCrash: {
        redirectUrl: "/casino/aggapdrgs-dragon-or-crash",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/DragonOrCrash.webp",
        alt: "Dragon or Crash",
        name: "Dragon or Crash",
      },
      FlyingPhoenix: {
        redirectUrl: "/casino/aggapdrgs-flying-phoenix",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/FlyingPhoenix.webp",
        alt: "Flying Phoenix",
        name: "Flying Phoenix",
      },
      JumpAndJump: {
        redirectUrl: "/casino/aggapdrgs-jump-and-jump",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/JumpAndJump.webp",
        alt: "Jump & Jump",
        name: "Jump & Jump",
      },
      LadderGame: {
        redirectUrl: "/casino/aggapdrgs-ladder-game",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/LadderGame.webp",
        alt: "Ladder Game",
        name: "Ladder Game",
      },
      LetsEnhance: {
        redirectUrl: "/casino/aggapdrgs-lets-enhance",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/LetsEnhance.webp",
        alt: "Let's Enhance",
        name: "Let's Enhance",
      },
      // LionsOrb: {
      //   redirectUrl: "/casino/qtechdragoonsoft-lions-orb",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/LionsOrb.webp",
      //   alt: "Lion's Orb",
      //   name: "Lion's Orb",
      // },
      // NinjaFishing: {
      //   redirectUrl: "/casino/qtechdragoonsoft-ninja-fishing",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/NinjaFishing.webp",
      //   alt: "Ninja Fishing",
      //   name: "Ninja Fishing",
      // },
      // WonderfulChristmas: {
      //   redirectUrl: "/casino/qtechdragoonsoft-wonderful-christmas",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/WonderfulChristmas.webp",
      //   alt: "Wonderful Christmas",
      //   name: "Wonderful Christmas",
      // },
      // Golf2: {
      //   redirectUrl: "/casino/qtechdragoonsoft-golf-2",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/Golf2.webp",
      //   alt: "Golf 2",
      //   name: "Golf 2",
      // },
      // DessertParty: {
      //   redirectUrl: "/casino/qtechdragoonsoft-dessert-party",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/Dessertparty.webp",
      //   alt: "Dessert Party",
      //   name: "Dessert Party",
      // },
      // PartyNight: {
      //   redirectUrl: "/casino/qtechdragoonsoft-party-night",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/PartyNight.webp",
      //   alt: "Party Night",
      //   name: "Party Night",
      // },
      // KingsSword: {
      //   redirectUrl: "/casino/qtechdragoonsoft-kings-sword",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/KingsSword.webp",
      //   alt: "King's Sword",
      //   name: "King's Sword",
      // },
      CatFishing: {
        redirectUrl: "/casino/aggapdrgs-cat-fishing",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/CatFishing.webp",
        alt: "Cat Fishing",
        name: "Cat Fishing",
      },
      OverlordAndConcubine: {
        redirectUrl: "/casino/aggapdrgs-overlord-and-concubine",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/OverlordAndConcubine.webp",
        alt: "Overlord & Concubine",
        name: "Overlord & Concubine",
      },
      Gods3Fishing: {
        redirectUrl: "/casino/aggapdrgs-3-gods-fishing",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/3GodsFishing.webp",
        alt: "3 Gods Fishing",
        name: "3 Gods Fishing",
      },
      BigHammer: {
        redirectUrl: "/casino/aggapdrgs-big-hammer",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/BigHammer.webp",
        alt: "Big Hammer",
        name: "Big Hammer",
      },
      BingoFishing: {
        redirectUrl: "/casino/aggapdrgs-bingo-fishing",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/BingoFishing.webp",
        alt: "Bingo Fishing",
        name: "Bingo Fishing",
      },
      CrazyOrb: {
        redirectUrl: "/casino/aggapdrgs-crazy-orb",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/CrazyOrb.webp",
        alt: "Crazy Orb",
        name: "Crazy Orb",
      },
      DemonConquered: {
        redirectUrl: "/casino/aggapdrgs-demon-conquered",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/DemonConquered.webp",
        alt: "Demon Conquered",
        name: "Demon Conquered",
      },
      DinoHunter: {
        redirectUrl: "/casino/aggapdrgs-dino-hunter",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/DinoHunter.webp",
        alt: "Dino Hunter",
        name: "Dino Hunter",
      },
      GodsSlashFish: {
        redirectUrl: "/casino/aggapdrgs-gods-slash-fish",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/GodsSlashFish.webp",
        alt: "Gods Slash Fish",
        name: "Gods Slash Fish",
      },
      GoldenZuma: {
        redirectUrl: "/casino/aggapdrgs-golden-zuma",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/GoldenZuma.webp",
        alt: "Golden Zuma",
        name: "Golden Zuma",
      },
      LetsShoot: {
        redirectUrl: "/casino/aggapdrgs-lets-shoot",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/LetsShoot.webp",
        alt: "Let's Shoot",
        name: "Let's Shoot",
      },
      OceanLord: {
        redirectUrl: "/casino/aggapdrgs-ocean-lord",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/OceanLord.webp",
        alt: "Ocean Lord",
        name: "Ocean Lord",
      },
      PlantsVsDinos: {
        redirectUrl: "/casino/aggapdrgs-plants-vs-dinos",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/PlantsVsDinos.webp",
        alt: "Plants vs. Dinos",
        name: "Plants vs. Dinos",
      },
      God5Beast: {
        redirectUrl: "/casino/aggapdrgs-5-god-beast",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/5GodBeast.webp",
        alt: "5 God Beast",
        name: "5 God Beast",
      },
      777: {
        redirectUrl: "/casino/aggapdrgs-777",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/777.webp",
        alt: "777",
        name: "777",
      },
      Alice: {
        redirectUrl: "/casino/aggapdrgs-alice",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/Alice.webp",
        alt: "Alice",
        name: "Alice",
      },
      Arab: {
        redirectUrl: "/casino/aggapdrgs-arab",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/Arab.webp",
        alt: "Arab",
        name: "Arab",
      },
      BakufuShogun: {
        redirectUrl: "/casino/aggapdrgs-bakufu-shogun",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/BakufuShogun.webp",
        alt: "Bakufu Shogun",
        name: "Bakufu Shogun",
      },
      BengalTiger: {
        redirectUrl: "/casino/aggapdrgs-bengal-tiger",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/BengalTiger.webp",
        alt: "Bengal Tiger",
        name: "Bengal Tiger",
      },
      BigDiamond: {
        redirectUrl: "/casino/aggapdrgs-big-diamond",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/BigDiamond.webp",
        alt: "Big Diamond",
        name: "Big Diamond",
      },
      BonusCat: {
        redirectUrl: "/casino/aggapdrgs-bonus-cat",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/BonusCat.webp",
        alt: "Bonus Cat",
        name: "Bonus Cat",
      },
      BoomingGems: {
        redirectUrl: "/casino/aggapdrgs-booming-gems",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/BoomingGems.webp",
        alt: "Booming Gems",
        name: "Booming Gems",
      },
      BuffaloBurst: {
        redirectUrl: "/casino/aggapdrgs-buffalo-burst",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/BuffaloBurst.webp",
        alt: "Buffalo Burst",
        name: "Buffalo Burst",
      },
      BustTreasury: {
        redirectUrl: "/casino/aggapdrgs-bust-treasury",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/BustTreasury.webp",
        alt: "Bust Treasury",
        name: "Bust Treasury",
      },
      CaishenComing: {
        redirectUrl: "/casino/aggapdrgs-caishen-coming",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/CaishenComing.webp",
        alt: "Caishen Coming",
        name: "Caishen Coming",
      },
      CandyDynasty: {
        redirectUrl: "/casino/aggapdrgs-candy-dynasty",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/CandyDynasty.webp",
        alt: "Candy Dynasty",
        name: "Candy Dynasty",
      },
      ChefLady: {
        redirectUrl: "/casino/aggapdrgs-chef-lady",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/ChefLady.webp",
        alt: "Chef Lady",
        name: "Chef Lady",
      },
      CoinRat: {
        redirectUrl: "/casino/aggapdrgs-coin-rat",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/CoinRat.webp",
        alt: "Coin Rat",
        name: "Coin Rat",
      },
      CrystalFruits: {
        redirectUrl: "/casino/aggapdrgs-crystal-fruits",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/CrystalFruits.webp",
        alt: "Crystal Fruits",
        name: "Crystal Fruits",
      },
      Diamond7: {
        redirectUrl: "/casino/aggapdrgs-diamond-7",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/Diamond7.webp",
        alt: "Diamond 7",
        name: "Diamond 7",
      },
      DiamondMogul: {
        redirectUrl: "/casino/aggapdrgs-diamond-mogul",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/DiamondMogul.webp",
        alt: "Diamond Mogul",
        name: "Diamond Mogul",
      },
      DoggyWealth: {
        redirectUrl: "/casino/aggapdrgs-doggy-wealth",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/DoggyWealth.webp",
        alt: "Doggy Wealth",
        name: "Doggy Wealth",
      },
      Dracula: {
        redirectUrl: "/casino/aggapdrgs-dracula",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/Dracula.webp",
        alt: "Dracula",
        name: "Dracula",
      },
      Dragonburst: {
        redirectUrl: "/casino/aggapdrgs-dragonburst",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/Dragonburst.webp",
        alt: "Dragonburst",
        name: "Dragonburst",
      },
      DragonsTreasure: {
        redirectUrl: "/casino/aggapdrgs-dragons-treasure",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/DragonsTreasure.webp",
        alt: "Dragon's Treasure",
        name: "Dragon's Treasure",
      },
      EgyptDynasty: {
        redirectUrl: "/casino/aggapdrgs-egypt-dynasty",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/EgyptDynasty.webp",
        alt: "Egypt Dynasty",
        name: "Egypt Dynasty",
      },
      EgyptOracle: {
        redirectUrl: "/casino/aggapdrgs-egypt-oracle",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/EgyptOracle.webp",
        alt: "Egypt Oracle",
        name: "Egypt Oracle",
      },
      FruitsBar: {
        redirectUrl: "/casino/aggapdrgs-fruits-bar",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/FruitsBar.webp",
        alt: "Fruits Bar",
        name: "Fruits Bar",
      },
      FushenComing: {
        redirectUrl: "/casino/aggapdrgs-fushen-coming",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/FushenComing.webp",
        alt: "Fushen Coming",
        name: "Fushen Coming",
      },
      GetHigh: {
        redirectUrl: "/casino/aggapdrgs-get-high",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/GetHigh.webp",
        alt: "Get High",
        name: "Get High",
      },
      GiveYouMoney: {
        redirectUrl: "/casino/aggapdrgs-give-you-money",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/GiveYouMoney.webp",
        alt: "Give You Money",
        name: "Give You Money",
      },
      Golf: {
        redirectUrl: "/casino/aggapdrgs-golf",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/Golf.webp",
        alt: "Golf",
        name: "Golf",
      },
      GrandSheriff: {
        redirectUrl: "/casino/aggapdrgs-grand-sheriff",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/GrandSheriff.webp",
        alt: "Grand Sheriff",
        name: "Grand Sheriff",
      },
      GreatLion: {
        redirectUrl: "/casino/aggapdrgs-great-lion",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/GreatLion.webp",
        alt: "Great Lion",
        name: "Great Lion",
      },
      GreatestCircus: {
        redirectUrl: "/casino/aggapdrgs-greatest-circus",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/GreatestCircus.webp",
        alt: "Greatest Circus",
        name: "Greatest Circus",
      },
      IcyBar: {
        redirectUrl: "/casino/aggapdrgs-icy-bar",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/IcyBar.webp",
        alt: "Icy Bar",
        name: "Icy Bar",
      },
      ImmortalHeroes: {
        redirectUrl: "/casino/aggapdrgs-immortal-heroes",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/ImmortalHeroes.webp",
        alt: "Immortal Heroes",
        name: "Immortal Heroes",
      },
      JinHouYe: {
        redirectUrl: "/casino/aggapdrgs-jin-hou-ye",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/JinHouYe.webp",
        alt: "Jin Hou Ye",
        name: "Jin Hou Ye",
      },
      LuLingQi: {
        redirectUrl: "/casino/aggapdrgs-lu-ling-qi",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/LuLingQi.webp",
        alt: "Lu Ling Qi",
        name: "Lu Ling Qi",
      },
      ManyBeauties: {
        redirectUrl: "/casino/aggapdrgs-many-beauties",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/ManyBeauties.webp",
        alt: "Many Beauties",
        name: "Many Beauties",
      },
      MayaKing: {
        redirectUrl: "/casino/aggapdrgs-maya-king",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/MayaKing.webp",
        alt: "Maya King",
        name: "Maya King",
      },
      MidasTouch: {
        redirectUrl: "/casino/aggapdrgs-midas-touch",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/MidasTouch.webp",
        alt: "Midas Touch",
        name: "Midas Touch",
      },
      MonkeyKing: {
        redirectUrl: "/casino/aggapdrgs-monkey-king",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/MonkeyKing.webp",
        alt: "Monkey King",
        name: "Monkey King",
      },
      OrePower: {
        redirectUrl: "/casino/aggapdrgs-ore-power",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/OrePower.webp",
        alt: "Ore Power",
        name: "Ore Power",
      },
      OverDragonsGate: {
        redirectUrl: "/casino/aggapdrgs-over-dragons-gate",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/OverDragonsGate.webp",
        alt: "Over Dragon's Gate",
        name: "Over Dragon's Gate",
      },
      Pandaria: {
        redirectUrl: "/casino/aggapdrgs-pandaria",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/Pandaria.webp",
        alt: "Pandaria",
        name: "Pandaria",
      },
      PirateKing: {
        redirectUrl: "/casino/aggapdrgs-pirate-king",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/PirateKing.webp",
        alt: "Pirate King",
        name: "Pirate King",
      },
      RichDragon: {
        redirectUrl: "/casino/aggapdrgs-rich-dragon",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/RichDragon.webp",
        alt: "Rich Dragon",
        name: "Rich Dragon",
      },
      RichLion: {
        redirectUrl: "/casino/aggapdrgs-rich-lion",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/RichLion.webp",
        alt: "Rich Lion",
        name: "Rich Lion",
      },
      RichNow: {
        redirectUrl: "/casino/aggapdrgs-rich-now",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/RichNow.webp",
        alt: "Rich Now",
        name: "Rich Now",
      },
      RollInMoney: {
        redirectUrl: "/casino/aggapdrgs-roll-in-money",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/RollInMoney.webp",
        alt: "Roll in Money",
        name: "Roll in Money",
      },
      Roman: {
        redirectUrl: "/casino/aggapdrgs-roman",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/Roman.webp",
        alt: "Roman",
        name: "Roman",
      },
      StoneHominid: {
        redirectUrl: "/casino/aggapdrgs-stone-hominid",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/StoneHominid.webp",
        alt: "Stone Hominid",
        name: "Stone Hominid",
      },
      TigerLord: {
        redirectUrl: "/casino/aggapdrgs-tiger-lord",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/TigerLord.webp",
        alt: "Tiger Lord",
        name: "Tiger Lord",
      },
      TripleMonkey: {
        redirectUrl: "/casino/aggapdrgs-triple-monkey",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/TripleMonkey.webp",
        alt: "Triple Monkey",
        name: "Triple Monkey",
      },
      TRex: {
        redirectUrl: "/casino/aggapdrgs-t-rex",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/TRex.webp",
        alt: "T-Rex",
        name: "T-Rex",
      },
      UltraTreasure: {
        redirectUrl: "/casino/aggapdrgs-ultra-treasure",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/UltraTreasure.webp",
        alt: "Ultra Treasure",
        name: "Ultra Treasure",
      },
      WolfLegend: {
        redirectUrl: "/casino/aggapdrgs-wolf-legend",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/WolfLegend.webp",
        alt: "Wolf Legend",
        name: "Wolf Legend",
      },
      Worldie: {
        redirectUrl: "/casino/aggapdrgs-worldie",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/Worldie.webp",
        alt: "Worldie",
        name: "Worldie",
      },
      YouWillWin: {
        redirectUrl: "/casino/aggapdrgs-you-will-win",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/YouWillWin.webp",
        alt: "You Will Win",
        name: "You Will Win",
      },
      Zeus: {
        redirectUrl: "/casino/aggapdrgs-zeus",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/Zeus.webp",
        alt: "Zeus",
        name: "Zeus",
      },
      ZhaoYun: {
        redirectUrl: "/casino/aggapdrgs-zhao-yun",
        code: "",
        casino: "Slots",
        provider: "ALT_GAMING_GAP",
        category: "dragoonSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/dragoon-soft/ZhaoYun.webp",
        alt: "Zhao Yun",
        name: "Zhao Yun",
      },
      // GoldenEgg: {
      //   redirectUrl: "/casino/aggapdrgs-golden-egg",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/GoldenEgg.webp",
      //   alt: "Golden Egg",
      //   name: "Golden Egg",
      // },
      // MahjongWin: {
      //   redirectUrl: "/casino/qtechdragoonsoft-mahjong-win",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/MahjongWin.webp",
      //   alt: "Mahjong Win",
      //   name: "Mahjong Win",
      // },
      // SuperHooHeyHow: {
      //   redirectUrl: "/casino/qtechdragoonsoft-super-hoo-hey-how",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/SuperHooHeyHow.webp",
      //   alt: "Super Hoo Hey How",
      //   name: "Super Hoo Hey How",
      // },
      // MuchRicher: {
      //   redirectUrl: "/casino/qtechdragoonsoft-much-richer",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/MuchRicher.webp",
      //   alt: "Much Richer",
      //   name: "Much Richer",
      // },
      // GoddessOrCrash: {
      //   redirectUrl: "/casino/qtechdragoonsoft-goddess-or-crash",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/GoddessOrCrash.webp",
      //   alt: "Goddess or Crash",
      //   name: "Goddess or Crash",
      // },
      // FireBallBlazePhoenix: {
      //   redirectUrl: "/casino/qtechdragoonsoft-fire-ball-blaze-phoenix",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/FireBallBlazePhoenix.webp",
      //   alt: "Fire Ball Blaze Phoenix",
      //   name: "Fire Ball Blaze Phoenix",
      // },
      // MidasHand: {
      //   redirectUrl: "/casino/qtechdragoonsoft-midas-hand",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/MidasHand.webp",
      //   alt: "Midas Hand",
      //   name: "Midas Hand",
      // },
      // HappyFish: {
      //   redirectUrl: "/casino/qtechdragoonsoft-happy-fish",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/HappyFish.webp",
      //   alt: "Happy Fish",
      //   name: "Happy Fish",
      // },
      // DancingSamba: {
      //   redirectUrl: "/casino/qtechdragoonsoft-dancing-samba",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/DancingSamba.webp",
      //   alt: "Dancing Samba",
      //   name: "Dancing Samba",
      // },
      // FortuneTwins: {
      //   redirectUrl: "/casino/qtechdragoonsoft-fortune-twins",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/FortuneTwins.webp",
      //   alt: "Fortune Twins",
      //   name: "Fortune Twins",
      // },
      // AztecTreasure: {
      //   redirectUrl: "/casino/qtechdragoonsoft-aztec-treasure",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/AztecTreasure.webp",
      //   alt: "Aztec Treasure",
      //   name: "Aztec Treasure",
      // },
      // OdinTerritory: {
      //   redirectUrl: "/casino/qtechdragoonsoft-odin-territory",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/OdinTerritory.webp",
      //   alt: "Odin Territory",
      //   name: "Odin Territory",
      // },
      // CrazyBartender: {
      //   redirectUrl: "/casino/qtechdragoonsoft-crazy-bartender",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/dragoon-soft/CrazyBartender.webp",
      //   alt: "Crazy Bartender",
      //   name: "Crazy Bartender",
      // },
    },
    name: "Dragoon Soft",
    key: "dragoonSoftGames",
  },
  mac88: {
    slide1: {
      DragonTiger: {
        redirectUrl: "/casino/aggapmac88gaming-dragon-tiger",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "dragontiger",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/dragon-tiger.webp",
        alt: "Dragon Tiger",
        name: "Dragon Tiger",
      },
      DragonTiger2: {
        redirectUrl: "/casino/aggapmac88gaming-dragon-tiger-2",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "dragontiger",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/dragon-tiger-2.webp",
        alt: "Dragon Tiger 2",
        name: "Dragon Tiger 2",
      },
      DragonTigerLion: {
        redirectUrl: "/casino/aggapmac88gaming-dtl",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "dragontiger",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/dtl.webp",
        alt: "Dragon Tiger Lion",
        name: "Dragon Tiger Lion",
      },
      Day1DragonTiger: {
        redirectUrl: "/casino/aggapmac88gaming-1-day-dragon-tiger",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "dragontiger",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/1-day-dragon-tiger.webp",
        alt: "1 Day Dragon Tiger",
        name: "1 Day Dragon Tiger",
      },
      Baccarat29: {
        redirectUrl: "/casino/aggapmac88gaming-29-baccarat",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/29-baccarat.webp",
        alt: "29 Baccarat",
        name: "29 Baccarat",
      },
      BaccaratOneDay: {
        redirectUrl: "/casino/aggapmac88gaming-baccarat-one-day",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/baccarat-one-day.webp",
        alt: "Baccarat One Day",
        name: "Baccarat One Day",
      },
      SicBo: {
        redirectUrl: "/casino/aggapmac88gaming-sic-bo",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/sic-bo.webp",
        alt: "Sic Bo",
        name: "Sic Bo",
      },
      Roulette: {
        redirectUrl: "/casino/aggapmac88gaming-roulette",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/roulette.webp",
        alt: "Roulette",
        name: "Roulette",
      },
      Poker1Day: {
        redirectUrl: "/casino/aggapmac88gaming-poker-1-day",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/poker-1-day.webp",
        alt: "Poker 1-Day",
        name: "Poker 1-Day",
      },
      Poker2020: {
        redirectUrl: "/casino/aggapmac88gaming-poker-20-20",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/poker-20-20.webp",
        alt: "Poker 20-20",
        name: "Poker 20-20",
      },
      Player6Poker: {
        redirectUrl: "/casino/aggapmac88gaming-6-player-poker",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/6-player-poker.webp",
        alt: "6 Player Poker",
        name: "6 Player Poker",
      },
      MuflisTeenpatti: {
        redirectUrl: "/casino/aggapmac88gaming-muflis-teenpatti",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/muflis-teenpatti.webp",
        alt: "Muflis Teenpatti",
        name: "Muflis Teenpatti",
      },
      TwoCardTeenpatti: {
        redirectUrl: "/casino/aggapmac88gaming-two-card-teenpatti",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/2-card-teenpatti.webp",
        alt: "Two Card Teenpatti",
        name: "Two Card Teenpatti",
      },
      OpenTeenpatti: {
        redirectUrl: "/casino/aggapmac88gaming-open-teen-patti",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/open-teen-patti.webp",
        alt: "Open Teen patti",
        name: "Open Teen patti",
      },
      TeenpattiOneDay: {
        redirectUrl: "/casino/aggapmac88gaming-teenpatti-one-day",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/teenpatti-one-day.webp",
        alt: "Teenpatti One Day",
        name: "Teenpatti One Day",
      },
      TestTeenpatti: {
        redirectUrl: "/casino/aggapmac88gaming-test-teenpatti",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/test-teenpatti.webp",
        alt: "Test Teenpatti",
        name: "Test Teenpatti",
      },
      Teenpatti2020: {
        redirectUrl: "/casino/aggapmac88gaming-20-20-teenpatti",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/20-20-teenpatti.webp",
        alt: "20-20 Teenpatti",
        name: "20-20 Teenpatti",
      },
      Teenpatti20202: {
        redirectUrl: "/casino/aggapmac88gaming-20-20-teenpatti-2",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/20-20-teenpatti-2.webp",
        alt: "20 20 Teenpatti 2",
        name: "20 20 Teenpatti 2",
      },
      AK47Teenpatti: {
        redirectUrl: "/casino/aggapmac88gaming-ak47-teenpatti",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/ak47-teenpatti.webp",
        alt: "AK47 Teenpatti",
        name: "AK47 Teenpatti",
      },
      InstantTeenPatti: {
        redirectUrl: "/casino/aggapmac88gaming-instant-teen-patti",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/instant-teen-patti.webp",
        alt: "Instant Teen Patti",
        name: "Instant Teen Patti",
      },
      Highlow: {
        redirectUrl: "/casino/aggapmac88gaming-high-low",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "hiLo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/high-low.webp",
        alt: "High low",
        name: "High low",
      },
      HiLo: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "hiLo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/hi-lo.webp",
        alt: "Hi Lo",
        name: "Hi Lo",
      },
      // LotteryMac88: {
      //   redirectUrl: "/casino/aggapmac88gaming-lottery",
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   category: "lottery",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/lottery/Lottery-Mac88.webp",
      //   alt: "Lottery",
      //   name: "Lottery",
      //   providerName: "lottery",
      // },
      BollywoodCasinoB: {
        redirectUrl: "/casino/aggapmac88gaming-bollywood-casino-b",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/bollywood-casino-b.webp",
        alt: "Bollywood Casino B",
        name: "Bollywood Casino B",
      },
      CasinoWar: {
        redirectUrl: "/casino/aggapmac88gaming-casino-war",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/casino-war.webp",
        alt: "Casino War",
        name: "Casino War",
      },
      CenterCard: {
        redirectUrl: "/casino/aggapmac88gaming-center-card",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/center-card.webp",
        alt: "Center card",
        name: "Center card",
      },
      Instantworli: {
        redirectUrl: "/casino/aggapmac88gaming-instant-worli",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/instant-worli.webp",
        alt: "Instant worli",
        name: "Instant worli",
      },
      NoteNumber: {
        redirectUrl: "/casino/aggapmac88gaming-note-number",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/note-number.webp",
        alt: "Note Number",
        name: "Note Number",
      },
      OneCard2020: {
        redirectUrl: "/casino/aggapmac88gaming-one-card-20-20",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/one-card-20-20.webp",
        alt: "One Card 20 20",
        name: "One Card 20 20",
      },
      OneCardOneDay: {
        redirectUrl: "/casino/aggapmac88gaming-one-card-one-day",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/one-card-one-day.webp",
        alt: "One Card One Day",
        name: "One Card One Day",
      },
      QueenRace: {
        redirectUrl: "/casino/aggapmac88gaming-queen-race",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/queen-race.webp",
        alt: "Queen Race",
        name: "Queen Race",
      },
      Race20: {
        redirectUrl: "/casino/aggapmac88gaming-race-20",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/race-20.webp",
        alt: "Race 20",
        name: "Race 20",
      },
      Raceto17: {
        redirectUrl: "/casino/aggapmac88gaming-race-to-17",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/race-to-17.webp",
        alt: "Race to 17",
        name: "Race to 17",
      },
      Raceto2nd: {
        redirectUrl: "/casino/aggapmac88gaming-race-to-2nd",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/race-to-2nd.webp",
        alt: "Race to 2nd",
        name: "Race to 2nd",
      },
      // SideBetcity: {
      //   redirectUrl: "/casino/aggapmac88gaming-side-bet-city",
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   category: "others",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/mac88/side-bet-city.webp",
      //   alt: "Side Bet city",
      //   name: "Side Bet city",
      // },
      CenterCardOneDay: {
        redirectUrl: "/casino/aggapmac88gaming-center-card-one-day",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/center-card-one-day.webp",
        alt: "Center Card One Day",
        name: "Center Card One Day",
      },
      Trio: {
        redirectUrl: "/casino/aggapmac88gaming-trio",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/trio.webp",
        alt: "Trio",
        name: "Trio",
      },
      WorliMatka: {
        redirectUrl: "/casino/aggapmac88gaming-worli-matka",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/worli-matka.webp",
        alt: "Worli Matka",
        name: "Worli Matka",
      },
      Cards3Judgement: {
        redirectUrl: "/casino/aggapmac88gaming-3-cards-judgement",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/3-cards-judgement.webp",
        alt: "3 Cards Judgement",
        name: "3 Cards Judgement",
      },
      AmarAkbarAnthony: {
        redirectUrl: "/casino/aggapmac88gaming-amar-akbar-anthony",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/amar-akbar-anthony.webp",
        alt: "Amar Akbar Anthony",
        name: "Amar Akbar Anthony",
      },
      Lucky7: {
        redirectUrl: "/casino/aggapmac88gaming-lucky7",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "lucky7",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/lucky7.webp",
        alt: "Lucky 7",
        name: "Lucky 7",
      },
      Lucky5: {
        redirectUrl: "/casino/aggapmac88gaming-lucky-5",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "lucky7",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/lucky-5.webp",
        alt: "Lucky 5",
        name: "Lucky 5",
      },
      AndarBahar: {
        redirectUrl: "/casino/aggapmac88gaming-andar-bahar",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "andarbahar",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/andar-bahar.webp",
        alt: "Andar Bahar",
        name: "Andar Bahar",
      },
      AndarBahar50: {
        redirectUrl: "/casino/aggapmac88gaming-andar-bahar-50",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "andarbahar",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/andar-bahar-50.webp",
        alt: "Andar Bahar 50",
        name: "Andar Bahar 50",
      },
      Cards32: {
        redirectUrl: "/casino/aggapmac88gaming-32-cards",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/32-cards.webp",
        alt: "32 Cards",
        name: "32 Cards",
      },
      DreamWheel: {
        redirectUrl: "/casino/aggapmac88gaming-dream-wheel",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "liveGameShows",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/dream-wheel.webp",
        alt: "Dream Wheel",
        name: "Dream Wheel",
      },
      FootballStudIo: {
        redirectUrl: "/casino/aggapmac88gaming-football-studio",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "liveGameShows",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88/football-studio.webp",
        alt: "Football StudIo",
        name: "Football StudIo",
      },
    },
    name: "Mac88",
    key: "mac88Games",
  },
  mac88VR: {
    slide1: {
      VRLucky7: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-lucky-7",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "lucky7",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-lucky-7.webp",
        alt: "VR Lucky 7",
        name: "VR Lucky 7",
      },
      Lucky5: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-lucky-5",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "lucky7",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/lucky-5.webp",
        alt: "Lucky 5",
        name: "Lucky 5",
      },
      Lucky15: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-lucky-15",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "lucky7",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/lucky-15.webp",
        alt: "Lucky 15",
        name: "Lucky 15",
      },
      CenterCardVR: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-center-card-vr",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/center-card-vr.webp",
        alt: "Center Card VR",
        name: "Center Card VR",
      },
      // KaunBanegaCrorepatiVR: {
      //   redirectUrl: "/casino/aggapmac88gamingvirtual-kaun-banega-crorepati-vr",
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   category: "teenpatti",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/mac88-vr/kaun-banega-crorepati-vr.webp",
      //   alt: "Kaun Banega Crorepati VR",
      //   name: "Kaun Banega Crorepati VR",
      // },
      VRAmarAkbarAnthony: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-amar-akbar-anthony",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-amar-akbar-anthony.webp",
        alt: "VR Amar Akbar Anthony",
        name: "VR Amar Akbar Anthony",
      },
      VRBollywoodCasino: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-bollywood-casino",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-bollywood-casino.webp",
        alt: "VR Bollywood Casino",
        name: "VR Bollywood Casino",
      },
      VRCasinoMeter: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-casino-meter",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-casino-meter.webp",
        alt: "VR Casino Meter",
        name: "VR Casino Meter",
      },
      VRQueenRace: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-queen-race",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-queen-race.webp",
        alt: "VR Queen Race",
        name: "VR Queen Race",
      },
      VRRaceT20: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-race-t20",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-race-20.webp",
        alt: "VR Race T20",
        name: "VR Race T20",
      },
      VRTrio: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-trio",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-trio.webp",
        alt: "VR Trio",
        name: "VR Trio",
      },
      VRWorliMatka: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-worli-matka",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-worli-matka.webp",
        alt: "VR Worli Matka",
        name: "VR Worli Matka",
      },
      BallbyBallVR: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/ball-by-ball-vr.webp",
        alt: "Ball by Ball VR",
        name: "Ball by Ball VR",
      },

      RockPaperScissors: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/rock-paper-scissors.webp",
        alt: "Rock Paper Scissors",
        name: "Rock Paper Scissors",
      },
      Boys5: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-5-boys",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/5-boys.webp",
        alt: "5 Boys",
        name: "5 Boys",
      },
      Vortex: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vortex",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vortex.webp",
        alt: "Vortex",
        name: "Vortex",
      },
      BollyKiss: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-bolly-kiss",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/bollywood-kiss.webp",
        alt: "Bolly Kiss",
        name: "Bolly Kiss",
      },
      Plinko: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-plinko",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/plinko.webp",
        alt: "Plinko",
        name: "Plinko",
      },
      diamonds: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-diamonds",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/diamonds.webp",
        alt: "Diamond",
        name: "Diamond",
      },
      Limbo: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-limbo",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/limbo.webp",
        alt: "Limbo",
        name: "Limbo",
      },
      Dice: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-dice",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/dice.webp",
        alt: "Dice",
        name: "Dice",
      },

      // K3Lottery10: {
      //   redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   category: "others",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/mac88-vr/centrecard-vr.webp",
      //   alt: "K3 Lottery 10",
      //   name: "K3 Lottery 10",
      // },
      VRDragonTiger: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-dragon-tiger",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "dragontiger",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-dragon-tiger.webp",
        alt: "VR Dragon Tiger",
        name: "VR Dragon Tiger",
      },
      VR2020DTL: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-20-20-dtl",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-20-20-dtl.webp",
        alt: "VR 20-20 DTL",
        name: "VR 20-20 DTL",
      },
      AK47VR: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-ak47-vr",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/ak47-vr.webp",
        alt: "AK47 VR",
        name: "AK47 VR",
      },
      VR2020Teenpatti: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-20-20-teenpatti",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-20-20-teenpatti.webp",
        alt: "VR 20-20 Teenpatti",
        name: "VR 20-20 Teenpatti",
      },
      VR2CardTP: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-2-card-tp",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "teenpatti",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-2-card-tp.webp",
        alt: "VR 2 Card TP",
        name: "VR 2 Card TP",
      },
      VR32Cards: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-32-cards",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "cards32",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-32-cards.webp",
        alt: "VR 32 Cards",
        name: "VR 32 Cards",
      },
      VRAndarBahar: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-andar-bahar",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "andarbahar",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-andar-bahar.webp",
        alt: "VR Andar Bahar",
        name: "VR Andar Bahar",
      },
      VRHighlow: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-high-low",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "hiLo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/high-low-vr.webp",
        alt: "VR High low",
        name: "VR High low",
      },
      HiloVR: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo-vr",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "hiLo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/hi-lo.webp",
        alt: "Hi Lo VR",
        name: "Hi Lo VR",
      },
      VR29cardbacarrat: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-29-card-bacarrat",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/29-baccarat-vr.webp",
        alt: "VR 29 card bacarrat",
        name: "VR 29 card bacarrat",
      },
      VRPoker: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-poker",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-poker.webp",
        alt: "VR Poker",
        name: "VR Poker",
      },
      // XRoulette: {
      //   redirectUrl: "/casino/aggapmac88gamingvirtual-x-roulette",
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   category: "roulette",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/mac88-vr/x-roulette.webp",
      //   alt: "X Roulette",
      //   name: "X Roulette",
      // },
      VRAutoRoulette: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-vr-auto-roulette",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/vr-auto-roulette.webp",
        alt: "VR Auto Roulette",
        name: "VR Auto Roulette",
      },
      minesMac: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-mines",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "mines",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/mines.webp",
        alt: "Mines",
        name: "Mines",
      },
      JetXT: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-jet-xt",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "crashX",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/jet-xt.webp",
        alt: "Jet XT",
        name: "Jet XT",
      },
      Kitex: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-kitex",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "crashX",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/kitex.webp",
        alt: "Kitex",
        name: "Kitex",
      },
      CrashX: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-crash-x",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "crashX",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/crash-x.webp",
        alt: "Crash X",
        name: "Crash X",
      },
      // AviatorX2: {
      //   redirectUrl: "/casino/aggapmac88gamingvirtual-aviatorx2",
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   category: "crashX",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/mac88-vr/aviatorX2.webp",
      //   alt: "AviatorX2",
      //   name: "AviatorX2",
      // },
      PushpaRani: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-pushpa-rani",
        code: "",
        casino: "Mac88",
        provider: "ALT_GAMING_GAP",
        category: "crash",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/mac88-vr/pushpa-rani.webp",
        alt: "Pushpa Rani",
        name: "Pushpa Rani",
      },
    },
    name: "Mac88VR",
    key: "mac88VRGames",
  },
  smartSoft: {
    slide1: {
      JetX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-jetx",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "crashX",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/JetX.webp",
        alt: "JetX",
        name: "JetX",
        providerName: "SmartSoft",
      },
      // Cappadocia: {
      //   redirectUrl: "/casino/aggapsmartsoftgaming-cappadocia",
      //   code: "",
      //   casino: "SmartSoft",
      //   provider: "ALT_GAMING_GAP",
      //   category: "crashX",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/smartsoft/Cappadocia.webp",
      //   alt: "Cappadocia",
      //   name: "Cappadocia",
      //   providerName: "SmartSoft",
      // },
      JetX3: {
        redirectUrl: "/casino/aggapsmartsoftgaming-jetx3",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "crashX",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/JetX3.webp",
        alt: "JetX3",
        name: "JetX3",
        providerName: "SmartSoft",
      },
      CricketX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-cricketx",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "crashX",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/CricketX.webp",
        alt: "CricketX",
        name: "CricketX",
        providerName: "SmartSoft",
      },
      FootballX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-footballx",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "crashX",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/FootballX.webp",
        alt: "FootballX",
        name: "FootballX",
        providerName: "SmartSoft",
      },
      TowerX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-towerx",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "crashX",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/TowerX.webp",
        alt: "TowerX",
        name: "TowerX",
        providerName: "SmartSoft",
      },
      // SpinX: {
      //   redirectUrl: "/casino/aggapsmartsoftgaming-spinx",
      //   code: "",
      //   casino: "SmartSoft",
      //   provider: "ALT_GAMING_GAP",
      //   category: "others",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/smartsoft/SpinX.webp",
      //   alt: "SpinX",
      //   name: "SpinX",
      //   providerName: "SmartSoft",
      // },
      PlinkoX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-plinkox",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/PlinkoX.webp",
        alt: "PlinkoX",
        name: "PlinkoX",
        providerName: "SmartSoft",
      },
      HunterX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-hunter-x",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/CrazyHuntX.webp",
        alt: "Hunter X",
        name: "Hunter X",
        providerName: "SmartSoft",
      },
      Jokers4Bonuses: {
        redirectUrl: "/casino/aggapsmartsoftgaming-4-bonuses-bonanza",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/Jokers4Bonuses.webp",
        alt: "Joker's 4 Bonuses",
        name: "Joker's 4 Bonuses",
        providerName: "SmartSoft",
      },
      Samurai: {
        redirectUrl: "/casino/aggapsmartsoftgaming-samurai",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/Samurai.webp",
        alt: "Samurai",
        name: "Samurai",
        providerName: "SmartSoft",
      },
      BurningIce: {
        redirectUrl: "/casino/aggapsmartsoftgaming-burning-ice",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/BurningIce.webp",
        alt: "Burning Ice",
        name: "Burning Ice",
        providerName: "SmartSoft",
      },
      BurningIce10: {
        redirectUrl: "/casino/aggapsmartsoftgaming-burning-ice-10",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/BurningIce10.webp",
        alt: "Burning Ice 10",
        name: "Burning Ice 10",
        providerName: "SmartSoft",
      },
      BurningIce40: {
        redirectUrl: "/casino/aggapsmartsoftgaming-burning-ice-40",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/BurningIce40.webp",
        alt: "Burning Ice 40",
        name: "Burning Ice 40",
        providerName: "SmartSoft",
      },
      Vampires: {
        redirectUrl: "/casino/aggapsmartsoftgaming-vampires",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/Vampires.webp",
        alt: "Vampires",
        name: "Vampires",
        providerName: "SmartSoft",
      },
      MultiHot5: {
        redirectUrl: "/casino/aggapsmartsoftgaming-multi-hot-5",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/MultiHot5.webp",
        alt: "Multi Hot 5",
        name: "Multi Hot 5",
        providerName: "SmartSoft",
      },
      // WildJungle: {
      //   redirectUrl: "/casino/aggapsmartsoftgaming-wild-jungle",
      //   code: "",
      //   casino: "SmartSoft",
      //   provider: "ALT_GAMING_GAP",
      //   category: "others",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/smartsoft/WildJungle.webp",
      //   alt: "Wild Jungle",
      //   name: "Wild Jungle",
      //   providerName: "SmartSoft",
      // },
      GeniesBonanza: {
        redirectUrl: "/casino/aggapsmartsoftgaming-genies-bonanza",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/GeniesBonanza.webp",
        alt: "Genie's Bonanza",
        name: "Genie's Bonanza",
        providerName: "SmartSoft",
      },
      MultiHotWays: {
        redirectUrl: "/casino/aggapsmartsoftgaming-multi-hot-ways",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/MultiHotWays.webp",
        alt: "Multi Hot Ways",
        name: "Multi Hot Ways",
        providerName: "SmartSoft",
      },
      Balloon: {
        redirectUrl: "/casino/aggapsmartsoftgaming-baloon",
        code: "",
        casino: "SmartSoft",
        provider: "ALT_GAMING_GAP",
        category: "crash",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/smartsoft/Balloon.webp",
        alt: "Balloon",
        name: "Balloon",
        providerName: "SmartSoft",
      },
    },
    name: "SmartSoft",
    key: "smartSoftGames",
  },
  asiaGaming: {
    slide1: {
      Lobby: {
        redirectUrl: "/casino/aggapasiagaming-lobby",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/Lobby.webp",
        alt: "Lobby",
        name: "LobbytX",
        providerName: "AsiaGaming",
      },
      DragonTiger: {
        redirectUrl: "/casino/aggapasiagaming-dragon-tiger",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/DragonTiger.webp",
        alt: "Dragon Tiger",
        name: "Dragon Tiger",
        providerName: "AsiaGaming",
      },
      Sicbo: {
        redirectUrl: "/casino/aggapasiagaming-sicbo",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/Sicbo.webp",
        alt: "Sicbo",
        name: "SicbotX",
        providerName: "AsiaGaming",
      },
      BullBull: {
        redirectUrl: "/casino/aggapasiagaming-bull-bull",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BullBull.webp",
        alt: "Bull Bull",
        name: "Bull Bull",
        providerName: "AsiaGaming",
      },
      WinThreeCards: {
        redirectUrl: "/casino/aggapasiagaming-win-three-cards",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/WinThreeCards.webp",
        alt: "Win Three Cards",
        name: "Win Three Cards",
        providerName: "AsiaGaming",
      },
      RouletteD1: {
        redirectUrl: "/casino/aggapasiagaming-roulette-d1",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/RouletteD1.webp",
        alt: "Roulette D1",
        name: "Roulette D1",
        providerName: "AsiaGaming",
      },
      BaccaratN07: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-n07",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratN07.webp",
        alt: "Baccarat N07",
        name: "Baccarat N07",
        providerName: "AsiaGaming",
      },
      BaccaratN06: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-n06",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratN06.webp",
        alt: "Baccarat N06",
        name: "Baccarat N06",
        providerName: "AsiaGaming",
      },
      BaccaratN09: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-n09",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratN09.webp",
        alt: "Baccarat N09",
        name: "Baccarat N09",
        providerName: "AsiaGaming",
      },
      BaccaratD51: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-d51",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratD51.webp",
        alt: "Baccarat D51",
        name: "Baccarat D51",
        providerName: "AsiaGaming",
      },
      BaccaratN08: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-n08",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratN08.webp",
        alt: "Baccarat N08",
        name: "Baccarat N08",
        providerName: "AsiaGaming",
      },
      BaccaratD52: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-d52",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratD52.webp",
        alt: "Baccarat D52",
        name: "Baccarat D52",
        providerName: "AsiaGaming",
      },
      BaccaratD55: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-d55",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratD55.webp",
        alt: "Baccarat D55",
        name: "Baccarat D55",
        providerName: "AsiaGaming",
      },
      BaccaratD54: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-d54",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratD54.webp",
        alt: "Baccarat D54",
        name: "Baccarat D54",
        providerName: "AsiaGaming",
      },
      BaccaratD53: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-d53",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratD53.webp",
        alt: "Baccarat D53",
        name: "Baccarat D53",
        providerName: "AsiaGaming",
      },
      BaccaratD59: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-d59",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratD59.webp",
        alt: "Baccarat D59",
        name: "Baccarat D59",
        providerName: "AsiaGaming",
      },
      BaccaratD58: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-d58",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratD58.webp",
        alt: "Baccarat D58",
        name: "Baccarat D58",
        providerName: "AsiaGaming",
      },
      BaccaratD57: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-d57",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratD57.webp",
        alt: "Baccarat D57",
        name: "Baccarat D57",
        providerName: "AsiaGaming",
      },
      BaccaratD56: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-d56",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratD56.webp",
        alt: "Baccarat D56",
        name: "Baccarat D56",
        providerName: "AsiaGaming",
      },
      DragonTigerD60: {
        redirectUrl: "/casino/aggapasiagaming-dragon-tiger-d60",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/DragonTigerD60.webp",
        alt: "Dragon Tiger D60",
        name: "Dragon Tiger D60",
        providerName: "AsiaGaming",
      },
      ThreeFaceN24: {
        redirectUrl: "/casino/aggapasiagaming-three-face-n24",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/ThreeFaceN24.webp",
        alt: "Three Face N24",
        name: "Three Face N24",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratN71: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-n71",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratN71.webp",
        alt: "Speed Baccarat N71",
        name: "Speed Baccarat N71",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratN72: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-n72",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratN72.webp",
        alt: "Speed Baccarat N72",
        name: "Speed Baccarat N72",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratN73: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-n73",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratN73.webp",
        alt: "Speed Baccarat N73",
        name: "Speed Baccarat N73",
        providerName: "AsiaGaming",
      },
      BaccaratB1: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-b1",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratB1.webp",
        alt: "Baccarat B1",
        name: "Baccarat B1",
        providerName: "AsiaGaming",
      },
      BaccaratB2: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-b2",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratB2.webp",
        alt: "Baccarat B2",
        name: "Baccarat B2",
        providerName: "AsiaGaming",
      },
      BaccaratB3: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-b3",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratB3.webp",
        alt: "Baccarat B3",
        name: "Baccarat B3",
        providerName: "AsiaGaming",
      },
      BaccaratB4: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-b4",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratB4.webp",
        alt: "Baccarat B4",
        name: "Baccarat B4",
        providerName: "AsiaGaming",
      },
      BaccaratB5: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-b5",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratB5.webp",
        alt: "Baccarat B5",
        name: "Baccarat B5",
        providerName: "AsiaGaming",
      },
      BaccaratB6: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-b6",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratB6.webp",
        alt: "Baccarat B6",
        name: "Baccarat B6",
        providerName: "AsiaGaming",
      },
      BlackJackD21: {
        redirectUrl: "/casino/aggapasiagaming-blackjack-d21",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BlackJackD21.webp",
        alt: "BlackJack D21",
        name: "BlackJack D21",
        providerName: "AsiaGaming",
      },
      BlackJackD22: {
        redirectUrl: "/casino/aggapasiagaming-blackjack-d22",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BlackJackD22.webp",
        alt: "BlackJack D22",
        name: "BlackJack D22",
        providerName: "AsiaGaming",
      },
      BaccaratM51: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-m51",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratM51.webp",
        alt: "Baccarat M51",
        name: "Baccarat M51",
        providerName: "AsiaGaming",
      },
      BaccaratM52: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-m52",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratM52.webp",
        alt: "Baccarat M52",
        name: "Baccarat M52",
        providerName: "AsiaGaming",
      },
      BaccaratM53: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-m53",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratM53.webp",
        alt: "Baccarat M53",
        name: "Baccarat M53",
        providerName: "AsiaGaming",
      },
      BaccaratM54: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-m54",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratM54.webp",
        alt: "Baccarat M54",
        name: "Baccarat M54",
        providerName: "AsiaGaming",
      },
      BaccaratM55: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-m55",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratM55.webp",
        alt: "Baccarat M55",
        name: "Baccarat M55",
        providerName: "AsiaGaming",
      },
      BaccaratM56: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-m56",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratM56.webp",
        alt: "Baccarat M56",
        name: "Baccarat M56",
        providerName: "AsiaGaming",
      },
      BaccaratM57: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-m57",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratM57.webp",
        alt: "Baccarat M57",
        name: "Baccarat M57",
        providerName: "AsiaGaming",
      },
      BaccaratM58: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-m58",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratM58.webp",
        alt: "Baccarat M58",
        name: "Baccarat M58",
        providerName: "AsiaGaming",
      },
      BaccaratM59: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-m59",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratM59.webp",
        alt: "Baccarat M59",
        name: "Baccarat M59",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratN10: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-n10",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratN10.webp",
        alt: "Speed Baccarat N10",
        name: "Speed Baccarat N10",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratN11: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-n11",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratN11.webp",
        alt: "Speed Baccarat N11",
        name: "Speed Baccarat N11",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratN12: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-n12",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratN12.webp",
        alt: "Speed Baccarat N12",
        name: "Speed Baccarat N12",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratN13: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-n13",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratN13.webp",
        alt: "Speed Baccarat N13",
        name: "Speed Baccarat N13",
        providerName: "AsiaGaming",
      },
      BaccaratN15: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-n15",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratN15.webp",
        alt: "Baccarat N15",
        name: "Baccarat N15",
        providerName: "AsiaGaming",
      },
      BaccaratN16: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-n16",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratN16.webp",
        alt: "Baccarat N16",
        name: "Baccarat N16",
        providerName: "AsiaGaming",
      },
      BaccaratN17: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-n17",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratN17.webp",
        alt: "Baccarat N17",
        name: "Baccarat N17",
        providerName: "AsiaGaming",
      },
      BaccaratN18: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-n18",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratN18.webp",
        alt: "Baccarat N18",
        name: "Baccarat N18",
        providerName: "AsiaGaming",
      },
      BaccaratN19: {
        redirectUrl: "/casino/aggapasiagaming-baccarat-n19",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BaccaratN19.webp",
        alt: "Baccarat N19",
        name: "Baccarat N19",
        providerName: "AsiaGaming",
      },
      BullBullN23: {
        redirectUrl: "/casino/aggapasiagaming-bull-bull-n23",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BullBullN23.webp",
        alt: "Bull Bull N23",
        name: "Bull Bull N23",
        providerName: "AsiaGaming",
      },
      DragonTigerM60: {
        redirectUrl: "/casino/aggapasiagaming-dragon-tiger-m60",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/DragonTigerM60.webp",
        alt: "Dragon Tiger M60",
        name: "Dragon Tiger M60",
        providerName: "AsiaGaming",
      },
      BlackJackD23: {
        redirectUrl: "/casino/aggapasiagaming-blackjack-d23",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BlackJackD23.webp",
        alt: "BlackJack D23",
        name: "BlackJack D23",
        providerName: "AsiaGaming",
      },
      BlackJackD24: {
        redirectUrl: "/casino/aggapasiagaming-blackjack-d24",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BlackJackD24.webp",
        alt: "BlackJack D24",
        name: "BlackJack D24",
        providerName: "AsiaGaming",
      },
      BlackJackD25: {
        redirectUrl: "/casino/aggapasiagaming-blackjack-d25",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BlackJackD25.webp",
        alt: "BlackJack D25",
        name: "BlackJack D25",
        providerName: "AsiaGaming",
      },
      BlackJackD26: {
        redirectUrl: "/casino/aggapasiagaming-blackjack-d26",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BlackJackD26.webp",
        alt: "BlackJack D26",
        name: "BlackJack D26",
        providerName: "AsiaGaming",
      },
      BlackJackD27: {
        redirectUrl: "/casino/aggapasiagaming-blackjack-d27",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BlackJackD27.webp",
        alt: "BlackJack D27",
        name: "BlackJack D27",
        providerName: "AsiaGaming",
      },
      BlackJackD28: {
        redirectUrl: "/casino/aggapasiagaming-blackjack-d28",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BlackJackD28.webp",
        alt: "BlackJack D28",
        name: "BlackJack D28",
        providerName: "AsiaGaming",
      },
      BlackJackD29: {
        redirectUrl: "/casino/aggapasiagaming-blackjack-d29",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BlackJackD29.webp",
        alt: "BlackJack D29",
        name: "BlackJack D29",
        providerName: "AsiaGaming",
      },
      BlackJackD30: {
        redirectUrl: "/casino/aggapasiagaming-blackjack-d30",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/BlackJackD30.webp",
        alt: "BlackJack D30",
        name: "BlackJack D30",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratM69: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-m69",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratM69.webp",
        alt: "Speed Baccarat M69",
        name: "Speed Baccarat M69",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratM70: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-m70",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratM70.webp",
        alt: "Speed Baccarat M70",
        name: "Speed Baccarat M70",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratM71: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-m71",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratM71.webp",
        alt: "Speed Baccarat M71",
        name: "Speed Baccarat M71",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratM72: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-m72",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratM72.webp",
        alt: "Speed Baccarat M72",
        name: "Speed Baccarat M72",
        providerName: "AsiaGaming",
      },
      SpeedBaccaratM73: {
        redirectUrl: "/casino/aggapasiagaming-speed-baccarat-m73",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/SpeedBaccaratM73.webp",
        alt: "Speed Baccarat M73",
        name: "Speed Baccarat M73",
        providerName: "AsiaGaming",
      },
      MiCardBaccaratM90: {
        redirectUrl: "/casino/aggapasiagaming-micard-baccarat-m90",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/MiCardBaccaratM90.webp",
        alt: "MiCard Baccarat M90",
        name: "MiCard Baccarat M90",
        providerName: "AsiaGaming",
      },
      MiCardBaccaratM91: {
        redirectUrl: "/casino/aggapasiagaming-micard-baccarat-m91",
        code: "",
        casino: "Asia Gaming",
        provider: "ALT_GAMING_GAP",
        category: "asiaGaming",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/asia-games/MiCardBaccaratM91.webp",
        alt: "MiCard Baccarat M91",
        name: "MiCard Baccarat M91",
        providerName: "AsiaGaming",
      },
    },
    name: "Ssia Gaming",
    key: "asiaGamingGames",
  },
  betGames: {
    slide1: {
      poker6: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "6+ Poker",
        name: "6+ Poker",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/6+poker.webp",
        redirectUrl: "/casino/aggapbetgames-6-poker",
      },
      badbaboons: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Bad Baboons",
        name: "Bad Baboons",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/badbaboons.webp",
        redirectUrl: "/casino/aggapbetgames-bad-baboons",
      },
      betonbaccarat: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Bet On Baccarat",
        name: "Bet On Baccarat",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/betonbaccarat.webp",
        redirectUrl: "/casino/aggapbetgames-bet-on-baccarat",
      },
      betonpoker: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Bet On Poker",
        name: "Bet On Poker",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/betonpoker.webp",
        redirectUrl: "/casino/aggapbetgames-bet-on-poker",
      },
      candycoins: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Candy Coins",
        name: "Candy Coins",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/candycoins.webp",
        redirectUrl: "/casino/aggapbetgames-candy-coins",
      },
      citrussplash: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Citrus Splash",
        name: "Citrus Splash",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/citrussplash.webp",
        redirectUrl: "/casino/aggapbetgames-citrus-splash",
      },
      classicroulette: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Classic Roulette",
        name: "Classic Roulette",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/classicroulette.webp",
        redirectUrl: "/casino/aggapbetgames-classic-roulette",
      },
      classicwheel: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Classic Wheel",
        name: "Classic Wheel",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/classicwheel.webp",
        redirectUrl: "/casino/aggapbetgames-classic-wheel",
      },
      cryptofgizasecretsuneviled: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Crypt Of Giza - Secrets Unveiled",
        name: "Crypt Of Giza - Secrets Unveiled",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/cryptofgizasecretsuneviled.webp",
        redirectUrl: "/casino/aggapbetgames-crypt-of-giza-secrets-unveiled",
      },
      cryptofgiza: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Crypt of Giza",
        name: "Crypt of Giza",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/cryptofgiza.webp",
        redirectUrl: "/casino/aggapbetgames-crypt-of-giza",
      },
      diceduel: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Dice Duel",
        name: "Dice Duel",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/diceduel.webp",
        redirectUrl: "/casino/aggapbetgames-dice-duel",
      },
      dragonsfate: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Dragon's Fate",
        name: "Dragon's Fate",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/dragonsfate.webp",
        redirectUrl: "/casino/aggapbetgames-dragons-fate",
      },
      flashroulette: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Flash Roulette",
        name: "Flash Roulette",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/flashroulette.webp",
        redirectUrl: "/casino/aggapbetgames-flash-roulette",
      },
      footballgrid: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Football Grid",
        name: "Football Grid",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/footballgrid.webp",
        redirectUrl: "/casino/aggapbetgames-football-grid",
      },
      instantlucky7: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Instant Lucky 7",
        name: "Instant Lucky 7",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/instantlucky7.webp",
        redirectUrl: "/casino/aggapbetgames-instant-lucky-7",
      },
      lotuswealthwonders: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Lotus Wealth Wonders",
        name: "Lotus Wealth Wonders",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/lotuswealthwonders.webp",
        redirectUrl: "/casino/aggapbetgames-lotus-wealth-wonders",
      },
      lucky5: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Lucky 5",
        name: "Lucky 5",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/lucky5.webp",
        redirectUrl: "/casino/aggapbetgames-lucky-5",
      },
      lucky6: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Lucky 6",
        name: "Lucky 6",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/lucky6.webp",
        redirectUrl: "/casino/aggapbetgames-lucky-6",
      },
      lucky7: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Lucky7",
        name: "Lucky7",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/lucky7.webp",
        redirectUrl: "/casino/aggapbetgames-lucky-7",
      },
      penguinrush: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Penguin Rush",
        name: "Penguin Rush",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/penguinrush.webp",
        redirectUrl: "/casino/aggapbetgames-penguin-rush",
      },
      skyward: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Skyward",
        name: "Skyward",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/skyward.webp",
        redirectUrl: "/casino/aggapbetgames-skyward",
      },
      speedy7: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Speedy 7",
        name: "Speedy 7",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/speedy7.webp",
        redirectUrl: "/casino/aggapbetgames-speedy-7",
      },
      starzle: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Starzle",
        name: "Starzle",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/starzle.webp",
        redirectUrl: "/casino/aggapbetgames-starzle",
      },
      warofbets: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "War Of Bets",
        name: "War Of Bets",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/warofbets.webp",
        redirectUrl: "/casino/aggapbetgames-war-of-bets",
      },
      wheeloffortune: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Wheel Of Fortune",
        name: "Wheel Of Fortune",
        providerName: "BetGames",
        imgUrl: "./images/casino/bet-games/wheeloffortune.webp",
        redirectUrl: "/casino/aggapbetgames-wheel-of-fortune",
      },
    },
    name: "Bet Games",
    key: "betGames",
  },
  fishingGames: {
    slide1: {
      Gods3Fishing: {
        redirectUrl: "/casino/aggapdrgs-3-gods-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/3GodsFishing.webp",
        alt: "3 Gods Fishing",
        name: "3 Gods Fishing",
      },
      AlaskanFishing: {
        redirectUrl: "/casino/aggapgamesglobal-alaskan-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/AlaskanFishing.webp",
        alt: "Alaskan Fishing",
        name: "Alaskan Fishing",
      },
      BiggerCatchBassFishing: {
        redirectUrl: "/casino/aggapblueprintgaming-bigger-catch-bass-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/BiggerCatchBassFishing.webp",
        alt: "Bigger Catch Bass Fishing",
        name: "Bigger Catch Bass Fishing",
      },
      BigHammer: {
        redirectUrl: "/casino/aggapdrgs-big-hammer",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/BigHammer.webp",
        alt: "Big Hammer",
        name: "Big Hammer",
      },
      BingoFishing: {
        redirectUrl: "/casino/aggapdrgs-bingo-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/BingoFishing.webp",
        alt: "Bingo Fishing",
        name: "Bingo Fishing",
      },
      CaishenFishing: {
        redirectUrl: "/casino/aggapjdbgaming-caishen-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/CaiShenFishing.webp",
        alt: "Caishen Fishing",
        name: "Caishen Fishing",
      },
      CatFishing: {
        redirectUrl: "/casino/aggapdrgs-cat-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/CatFishing.webp",
        alt: "Cat Fishing",
        name: "Cat Fishing",
      },
      DemonConquered: {
        redirectUrl: "/casino/aggapdrgs-demon-conquered",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/DemonConquered.webp",
        alt: "Demon Conquered",
        name: "Demon Conquered",
      },
      DinoHunter: {
        redirectUrl: "/casino/aggapdrgs-dino-hunter",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/DinoHunter.webp",
        alt: "Dino Hunter",
        name: "Dino Hunter",
      },
      DragonFishing: {
        redirectUrl: "/casino/aggapjdbgaming-dragon-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/DragonFishing.webp",
        alt: "Dragon Fishing",
        name: "Dragon Fishing",
      },
      DragonFishing2: {
        redirectUrl: "/casino/aggapjdbgaming-dragon-fishing-2",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/DragonFishing2.webp",
        alt: "Dragon Fishing 2",
        name: "Dragon Fishing 2",
      },
      FintasticFishing: {
        redirectUrl: "/casino/aggapgamesglobal-fintastic-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/FintasticFishing.webp",
        alt: "Fintastic Fishing",
        name: "Fintastic Fishing",
      },
      FishingClub: {
        redirectUrl: "/casino/aggapbgaming-fishing-club",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/FishingClub.webp",
        alt: "Fishing Club",
        name: "Fishing Club",
      },
      FishingDisco: {
        redirectUrl: "/casino/aggapjdbgaming-fishing-disco",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/FishingDisco.webp",
        alt: "Fishing Disco",
        name: "Fishing Disco",
      },
      FishingFeverBassKing: {
        redirectUrl: "/casino/aggapgamesglobal-fishing-fever-bass-king",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/FishingFeverBassKing.webp",
        alt: "Fishing Fever Bass King",
        name: "Fishing Fever Bass King",
      },
      FishingFloatsConnectifyPays: {
        redirectUrl: "/casino/aggapgamesglobal-fishing-floats-connectify-pays",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "./images/casino/fishing-games/FishingFloatsConnectifyPays.webp",
        alt: "Fishing Floats Connectify Pays",
        name: "Fishing Floats Connectify Pays",
      },
      FishingSeason: {
        redirectUrl: "/casino/aggapcaletagaming-fishing-season",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/FishingSeason.webp",
        alt: "Fishing Season",
        name: "Fishing Season",
      },
      FishingYilufa: {
        redirectUrl: "/casino/aggapjdbgaming-fishing-yilufa",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/FishingYilufa.webp",
        alt: "Fishing Yilufa",
        name: "Fishing Yilufa",
      },
      GoFishingReelinFortunes: {
        redirectUrl: "/casino/aggapgamesglobal-go-fishing-reelin-fortunes",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/GoFishingReelinFortunes.webp",
        alt: "Go! Fishing: Reelin' Fortunes",
        name: "Go! Fishing: Reelin' Fortunes",
      },
      GodsSlashFish: {
        redirectUrl: "/casino/aggapdrgs-gods-slash-fish",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/GodsSlashFish.webp",
        alt: "Gods Slash Fish",
        name: "Gods Slash Fish",
      },
      HellChefGoesFishing: {
        redirectUrl: "/casino/aggapkalambagames-hell-chef-goes-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/HellChefGoesFishing.webp",
        alt: "Hell Chef Goes Fishing",
        name: "Hell Chef Goes Fishing",
      },
      LetsShoot: {
        redirectUrl: "/casino/aggapdrgs-lets-shoot",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/LetsShoot.webp",
        alt: "Let's Shoot",
        name: "Let's Shoot",
      },
      LuckyFishingMegaways: {
        redirectUrl: "/casino/aggappragmaticplay-lucky-fishing-megaways",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/LuckyFishingMegaways.webp",
        alt: "Lucky Fishing Megaways",
        name: "Lucky Fishing Megaways",
      },
      OceanLord: {
        redirectUrl: "/casino/aggapdrgs-ocean-lord",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/OceanLord.webp",
        alt: "Ocean Lord",
        name: "Ocean Lord",
      },
      PlantsvsDinos: {
        redirectUrl: "/casino/aggapdrgs-plants-vs-dinos",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/PlantsvsDinos.webp",
        alt: "Plants vs. Dinos",
        name: "Plants vs. Dinos",
      },
      RichFishing: {
        redirectUrl: "/casino/aggaprich88-rich-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/RichFishing.webp",
        alt: "Rich Fishing",
        name: "Rich Fishing",
      },
      RiptideFishing: {
        redirectUrl: "/casino/aggapgamesglobal-riptide-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/RiptideFishing.webp",
        alt: "Riptide Fishing",
        name: "Riptide Fishing",
      },
      ShadeDragonsFishing: {
        redirectUrl: "/casino/aggapjdbgaming-shade-dragons-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/ShadeDragonsFishing.webp",
        alt: "Shade Dragons Fishing",
        name: "Shade Dragons Fishing",
      },
      WildMarlinBigGameFishing: {
        redirectUrl: "/casino/aggapgamesglobal-wild-marlin-big-game-fishing",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/WildMarlinBigGameFishing.webp",
        alt: "Wild Marlin! - Big Game Fishing",
        name: "Wild Marlin! - Big Game Fishing",
      },
      WinterFishingClub: {
        redirectUrl: "/casino/aggapbgaming-winter-fishing-club",
        code: "",
        casino: "Fish Shooting",
        provider: "ALT_GAMING_GAP",
        category: "fishingGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/fishing-games/WinterFishingClub.webp",
        alt: "Winter Fishing Club",
        name: "Winter Fishing Club",
      },
    },
    name: "Fishing Games",
    key: "fishingGames",
  },
  PGSoft: {
    slide1: {
      CashMania: {
        redirectUrl: "/casino/aggappg-cash-mania-u1195",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/CashMania.webp",
        alt: "Cash Mania",
        name: "Cash Mania",
      },
      BaccaratDeluxe: {
        redirectUrl: "/casino/aggappg-baccarat-deluxe",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/BaccaratDeluxe.webp",
        alt: "Baccarat Deluxe",
        name: "Baccarat Deluxe",
      },
      FortuneSnake: {
        redirectUrl: "/casino/aggappg-fortune-snake",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/FortuneSnake.webp",
        alt: "Fortune Snake",
        name: "Fortune Snake",
      },
      GeishasRevenge: {
        redirectUrl: "/casino/aggappg-geishas-revenge",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/GeishasRevenge.webp",
        alt: "Geisha's Revenge",
        name: "Geisha's Revenge",
      },
      ChocolateDeluxe: {
        redirectUrl: "/casino/aggappg-chocolate-deluxe",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/ChocolateDeluxe.webp",
        alt: "Chocolate Deluxe",
        name: "Chocolate Deluxe",
      },
      RioFantasia: {
        redirectUrl: "/casino/aggappg-rio-fantasia",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/RioFantasia.webp",
        alt: "Rio Fantasia",
        name: "Rio Fantasia",
      },
      MuseumMystery: {
        redirectUrl: "/casino/aggappg-museum-mystery",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/MuseumMystery.webp",
        alt: "Museum Mystery",
        name: "Museum Mystery",
      },
      OishiDelights: {
        redirectUrl: "/casino/aggappg-oishi-delights",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/OishiDelights.webp",
        alt: "Oishi Delights",
        name: "Oishi Delights",
      },
      ThreeCrazyPiggies: {
        redirectUrl: "/casino/aggappg-three-crazy-piggies",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/ThreeCrazyPiggies.webp",
        alt: "Three Crazy Piggies",
        name: "Three Crazy Piggies",
      },
      WingsofIguazu: {
        redirectUrl: "/casino/aggappg-wings-of-iguazu",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/WingsofIguazu.webp",
        alt: "Wings of Iguazu",
        name: "Wings of Iguazu",
      },
      YakuzaHonor: {
        redirectUrl: "/casino/aggappg-yakuza-honor",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/YakuzaHonor.webp",
        alt: "Yakuza Honor",
        name: "Yakuza Honor",
      },
      SharkBounty: {
        redirectUrl: "/casino/aggappg-shark-bounty",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/SharkBounty.webp",
        alt: "Shark Bounty",
        name: "Shark Bounty",
      },
      FutebolFever: {
        redirectUrl: "/casino/aggappg-futebol-fever",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/FutebolFever.webp",
        alt: "Futebol Fever",
        name: "Futebol Fever",
      },
      ChickyRun: {
        redirectUrl: "/casino/aggappg-chicky-run",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/ChickyRun.webp",
        alt: "Chicky Run",
        name: "Chicky Run",
      },
      ZombieOutbreak: {
        redirectUrl: "/casino/aggappg-zombie-outbreak",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/ZombieOutbreak.webp",
        alt: "Zombie Outbreak",
        name: "Zombie Outbreak",
      },
      AnubisWrath: {
        redirectUrl: "/casino/aggappg-anubis-wrath",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/AnubisWrath.webp",
        alt: "Anubis Wrath",
        name: "Anubis Wrath",
      },
      MysticPotion: {
        redirectUrl: "/casino/aggappg-mystic-potion",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/MysticPotion.webp",
        alt: "Mystic Potion",
        name: "Mystic Potion",
      },
      PinataWins: {
        redirectUrl: "/casino/aggappg-pinata-wins",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/PinataWins.webp",
        alt: "Pinata Wins",
        name: "Pinata Wins",
      },
      WildApe3258: {
        redirectUrl: "/casino/aggappg-wild-ape-3258",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/WildApe3258.webp",
        alt: "Wild Ape #3258",
        name: "Wild Ape #3258",
      },
      GemstonesGold: {
        redirectUrl: "/casino/aggappg-gemstones-gold",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/GemstonesGold.webp",
        alt: "Gemstones Gold",
        name: "Gemstones Gold",
      },
      FortuneDragon: {
        redirectUrl: "/casino/aggappg-fortune-dragon",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/FortuneDragon.webp",
        alt: "Fortune Dragon",
        name: "Fortune Dragon",
      },
      DragonHatch2: {
        redirectUrl: "/casino/aggappg-dragon-hatch-2",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/DragonHatch2.webp",
        alt: "Dragon Hatch 2",
        name: "Dragon Hatch 2",
      },
      WerewolfsHunt: {
        redirectUrl: "/casino/aggappg-werewolfs-hunt",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/WerewolfsHunt.webp",
        alt: "Werewolf's Hunt",
        name: "Werewolf's Hunt",
      },
      TsarTreasures: {
        redirectUrl: "/casino/aggappg-tsar-treasures",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/TsarTreasures.webp",
        alt: "Tsar Treasures",
        name: "Tsar Treasures",
      },
      MafiaMayhem: {
        redirectUrl: "/casino/aggappg-mafia-mayhem",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/MafiaMayhem.webp",
        alt: "Mafia Mayhem",
        name: "Mafia Mayhem",
      },
      ForgeofWealth: {
        redirectUrl: "/casino/aggappg-forge-of-wealth",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/ForgeofWealth.webp",
        alt: "Forge of Wealth",
        name: "Forge of Wealth",
      },
      WildHeistCashout: {
        redirectUrl: "/casino/aggappg-wild-heist-cashout",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/WildHeistCashout.webp",
        alt: "Wild Heist Cashout",
        name: "Wild Heist Cashout",
      },
      UltimateStriker: {
        redirectUrl: "/casino/aggappg-ultimate-striker",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/UltimateStriker.webp",
        alt: "Ultimate Striker",
        name: "Ultimate Striker",
      },
      NinjaRaccoonFrenzy: {
        redirectUrl: "/casino/aggappg-ninja-raccoon-frenzy",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/NinjaRaccoonFrenzy.webp",
        alt: "Ninja Raccoon Frenzy",
        name: "Ninja Raccoon Frenzy",
      },
      GladiatorsGlory: {
        redirectUrl: "/casino/aggappg-gladiators-glory",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/GladiatorsGlory.webp",
        alt: "Gladiator's Glory",
        name: "Gladiator's Glory",
      },
      SafariWilds: {
        redirectUrl: "/casino/aggappg-safari-wilds",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/SafariWilds.webp",
        alt: "Safari Wilds",
        name: "Safari Wilds",
      },
      CruiseRoyale: {
        redirectUrl: "/casino/aggappg-cruise-royale",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/CruiseRoyale.webp",
        alt: "Cruise Royale",
        name: "Cruise Royale",
      },
      FruityCandy: {
        redirectUrl: "/casino/aggappg-fruity-candy",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/FruityCandy.webp",
        alt: "Fruity Candy",
        name: "Fruity Candy",
      },
      LuckyCloverLady: {
        redirectUrl: "/casino/aggappg-lucky-clover-lady",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/LuckyCloverLady.webp",
        alt: "Lucky Clover Lady",
        name: "Lucky Clover Lady",
      },
      SuperGolfDrive: {
        redirectUrl: "/casino/aggappg-super-golf-drive",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/SuperGolfDrive.webp",
        alt: "Super Golf Drive",
        name: "Super Golf Drive",
      },
      MysticalSpirits: {
        redirectUrl: "/casino/aggappg-mystical-spirits",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/MysticalSpirits.webp",
        alt: "Mystical Spirits",
        name: "Mystical Spirits",
      },
      SongkranSplash: {
        redirectUrl: "/casino/aggappg-songkran-splash",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/SongkranSplash.webp",
        alt: "Songkran Splash",
        name: "Songkran Splash",
      },
      BakeryBonanza: {
        redirectUrl: "/casino/aggappg-bakery-bonanza",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/BakeryBonanza.webp",
        alt: "Bakery Bonanza",
        name: "Bakery Bonanza",
      },
      HawaiianTiki: {
        redirectUrl: "/casino/aggappg-hawaiian-tiki",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/HawaiianTiki.webp",
        alt: "Hawaiian Tiki",
        name: "Hawaiian Tiki",
      },
      RavePartyFever: {
        redirectUrl: "/casino/aggappg-rave-party-fever",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/RavePartyFever.webp",
        alt: "Rave Party Fever",
        name: "Rave Party Fever",
      },
      FortuneRabbit: {
        redirectUrl: "/casino/aggappg-fortune-rabbit",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/FortuneRabbit.webp",
        alt: "Fortune Rabbit",
        name: "Fortune Rabbit",
      },
      MidasFortune: {
        redirectUrl: "/casino/aggappg-midas-fortune",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/MidasFortune.webp",
        alt: "Midas Fortune",
        name: "Midas Fortune",
      },
      AsgardianRising: {
        redirectUrl: "/casino/aggappg-asgardian-rising",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/AsgardianRising.webp",
        alt: "Asgardian Rising",
        name: "Asgardian Rising",
      },
      DinerDelights: {
        redirectUrl: "/casino/aggappg-diner-delights",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/DinerDelights.webp",
        alt: "Diner Delights",
        name: "Diner Delights",
      },
      AlchemyGold: {
        redirectUrl: "/casino/aggappg-alchemy-gold",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/AlchemyGold.webp",
        alt: "Alchemy Gold",
        name: "Alchemy Gold",
      },
      TotemWonders: {
        redirectUrl: "/casino/aggappg-totem-wonders",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/TotemWonders.webp",
        alt: "Totem Wonders",
        name: "Totem Wonders",
      },
      ProsperityFortuneTree: {
        redirectUrl: "/casino/aggappg-prosperity-fortune-tree",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/ProsperityFortuneTree.webp",
        alt: "Prosperity Fortune Tree",
        name: "Prosperity Fortune Tree",
      },
      WildBountyShowdown: {
        redirectUrl: "/casino/aggappg-wild-bounty-showdown",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/WildBountyShowdown.webp",
        alt: "Wild Bounty Showdown",
        name: "Wild Bounty Showdown",
      },
      WildCoaster: {
        redirectUrl: "/casino/aggappg-wild-coaster",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/WildCoaster.webp",
        alt: "Wild Coaster",
        name: "Wild Coaster",
      },
      LegendofPerseus: {
        redirectUrl: "/casino/aggappg-legend-of-perseus",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/pg-soft/LegendofPerseus.webp",
        alt: "Legend of Perseus",
        name: "Legend of Perseus",
      },
    },
    name: "Pocket Games Soft",
    key: "PGSoftGames",
  },

  playson: {
    slide1: {
      ThreeChilliesandJoker_HoldandWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "3 Chillies and Joker: Hold and Win",
        name: "3 Chillies and Joker: Hold and Win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/3chiliesandjokerholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-3-chillies-and-joker-hold-and-win",
      },
      DiamondsPowerXXLHoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Diamonds Power XXL: hold and win",
        name: "Diamonds Power XXL: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/DiamondsPowerXXLholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-diamonds-power-xxl-hold-and-win",
      },

      // MoreEneryCojnsHoldAndWin: {
      //   code: "",
      //   casino: "",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: pageUrlGenerator("/slots"),
      //   alt: "More Enery Cojns: hold and win",
      //   name: "More Enery Cojns: hold and win",
      //   providerName: "Playson",
      //   imgUrl: "./images/casino/playson/MoreneryCojnsholdandwin.webp",
      //   redirectUrl: "/casino/aggapplayson-more-enery-cojns-hold-and-win",
      // },

      PaddyStarSmashAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Paddy star: smash and win",
        name: "Paddy star: smash and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/Paddystarsmashandwin.webp",
        redirectUrl: "/casino/aggapplayson-paddy-star-smash-and-win",
      },

      FlamingBellsHoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "flaming bells: hold and win",
        name: "flaming bells: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/flamingbellsholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-flaming-bells-hold-and-win",
      },

      CrownStrikeHoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "crown strike: hold and win",
        name: "crown strike: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/crownstrikeholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-crown-strike-hold-and-win",
      },

      GoldenPennyX1000: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "golden penny x1000",
        name: "golden penny x1000",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/goldenpennyx1000.webp",
        redirectUrl: "/casino/aggapplayson-golden-penny-x1000",
      },

      ThreeRoyalCoinsHoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "3 royal coins: hold and win",
        name: "3 royal coins: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/3royalcoinsholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-3-royal-coins-hold-and-win",
      },

      // RockinJockerHoldAndWin: {
      //   code: "",
      //   casino: "",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: pageUrlGenerator("/slots"),
      //   alt: "rockin' jocker : hold and win",
      //   name: "rockin' jocker : hold and win",
      //   providerName: "Playson",
      //   imgUrl: "./images/casino/playson/rockinjocker-holdandwin.webp",
      //   redirectUrl: "/casino/aggapplayson-rockin-jocker-hold-and-win",
      // },

      FourPotsRichesHoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "4 pots riches: hold and win",
        name: "4 pots riches: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/4potsrichesholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-4-pots-riches-hold-and-win",
      },

      CoinStrike2HoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "coin strike 2: hold and win",
        name: "coin strike 2: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/coinstrike2holdandwin.webp",
        redirectUrl: "/casino/aggapplayson-coin-strike-2-hold-and-win",
      },

      SuperPinkJokerHoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "super pink joker: hold and win",
        name: "super pink joker: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/superpinkjokerholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-super-pink-joker-hold-and-win",
      },

      LionGems3PotsHoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "lion gems 3 pots: hold and win",
        name: "lion gems 3 pots: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/liongems3potsholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-lion-gems-3-pots-hold-and-win",
      },

      ThunderCoinsXXLHoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "thunder coins XXL: hold and win",
        name: "thunder coins XXL: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/thundercoinsXXLholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-thunder-coins-xxl-hold-and-win",
      },

      ThreeXCatch: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "3x catch",
        name: "3x catch",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/3xcatch.webp",
        redirectUrl: "/casino/aggapplayson-3x-catch",
      },

      KingOfTheSkyHitTheBonus: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "king of the sky: hit the bonus",
        name: "king of the sky: hit the bonus",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/kingoftheskyhitthebonus.webp",
        redirectUrl: "/casino/aggapplayson-king-of-the-sky-hit-the-bonus",
      },

      RoyalExpressHoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "royal express: hold and win",
        name: "royal express: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/royalexpressholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-royal-express-hold-and-win",
      },

      ChargeTheCloversHitTheBinus: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Charge the Clovers: Hit the Bonus",
        name: "Charge the Clovers: Hit the Bonus",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/chargetheclovershitthebinus.webp",
        redirectUrl: "/casino/aggapplayson-charge-the-clovers-hit-the-bonus",
      },

      ThreeLuxorPotsHoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "3 luxor pots: hold and win",
        name: "3 luxor pots: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/3luxorpotsholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-3-luxor-pots-hold-and-win",
      },

      TwentyFiveCookiesHitTheBonus: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "25 cookies: hit the bonus",
        name: "25 cookies: hit the bonus",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/25cookieshitthebonus.webp",
        redirectUrl: "/casino/aggapplayson-25-cookies-hit-the-bonus",
      },

      SunnyFruitsHoldAndWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "sunny fruits: hold and win",
        name: "sunny fruits: hold and win",
        providerName: "Playson",
        imgUrl: "./images/casino/playson/sunnyfruitsholdandwin.webp",
        redirectUrl: "/casino/aggapplayson-sunny-fruits-hold-and-win",
      },

      RiseOfEgypt: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "rise of egypt",
        name: "rise of egypt",   
        providerName: "Playson",
        imgUrl: "./images/casino/playson/riseofegypt.webp",
        redirectUrl: "/casino/aggapplayson-rise-of-egypt",
      },
    },
    name: "Playson",
    key: "playson",
  },

  playtechNew: {
    slide1: {
      allbetsblackjackbrasileira: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "All Bets Blackjack Brasileira",
        name: "All Bets Blackjack Brasileira",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/allbetsblackjackbrasileira.webp",
        redirectUrl: "/casino/aggapplaytechlive-all-bets-blackjack-brasileira",
      },
      autoroulette2: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Auto Roulette 2",
        name: "Auto Roulette 2",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/autoroulette2.webp",
        redirectUrl: "/casino/aggapplaytechlive-auto-roulette-2",
      },
      baccaratbrasileiranocommission: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Baccarat Brasileira No Comission",
        name: "Baccarat Brasileira No Comission",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/baccaratbrasileiranocommission.webp",
        redirectUrl: "/casino/aggapplaytechlive-baccarat-brasileira-no-comission",
      },
      baccaratbrasileira: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Baccarat Brasileira",
        name: "Baccarat Brasileira",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/baccaratbrasileira.webp",
        redirectUrl: "/casino/aggapplaytechlive-baccarat-brasileira",
      },
      baccaratnocommission: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Baccarat No Commission",
        name: "Baccarat No Commission",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/baccaratnocommission.webp",
        redirectUrl: "/casino/aggapplaytechlive-baccarat-no-comission",
      },
      blackjack2: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Blackjack 2",
        name: "Blackjack 2",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/blackjack2.webp",
        redirectUrl: "/casino/aggapplaytechlive-blackjack-2",
      },
      blackjack10: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Blackjack 10",
        name: "Blackjack 10",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/blackjack10.webp",
        redirectUrl: "/casino/aggapplaytechlive-blackjack-10",
      },
      blackjacksoiree4: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Blackjack SoirÃ©e 4",
        name: "Blackjack SoirÃ©e 4",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/blackjacksoiree4.webp",
        redirectUrl: "/casino/aggapplaytechlive-blackjack-soirace-4",
      },
      cashcollectroulettelive: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Cash Collect Roulette Live",
        name: "Cash Collect Roulette Live",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/cashcollectroulettelive.webp",
        redirectUrl: "/casino/aggapplaytechlive-cash-collect-roulette-live",
      },
      deutschesspeedroulette: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Deutsches Speed Roulette",
        name: "Deutsches Speed Roulette",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/deutschesspeedroulette.webp",
        redirectUrl: "/casino/aggapplaytechlive-deutsches-speed-roulette",
      },
      grandroyalecashback: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Grand Royale Cashback",
        name: "Grand Royale Cashback",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/grandroyalecashback.webp",
        redirectUrl: "/casino/aggapplaytechlive-grand-royale-cashback",
      },
      japanesesqueezebaccaratnocommisison: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Japanese Squeeze Baccarat No Comission",
        name: "Japanese Squeeze Baccarat No Comission",
        providerName: "Playtech",
        imgUrl:
          "./images/slots/playtech/japanesesqueezebaccaratnocommisison.webp",
        redirectUrl:
          "/casino/aggapplaytechlive-japanese-squeeze-baccarat-no-comission",
      },
      japanesesqueezebaccarat: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Japanese Squeeze Baccarat",
        name: "Japanese Squeeze Baccarat",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/japanesesqueezebaccarat.webp",
        redirectUrl: "/casino/aggapplaytechlive-japanese-squeeze-baccarat",
      },
      koreanspeedbaccarat1nocommission: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Korean Speed Baccarat 1 No Comission",
        name: "Korean Speed Baccarat 1 No Comission",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/koreanspeedbaccarat1nocommission.webp",
        redirectUrl:
          "/casino/aggapplaytechlive-korean-speed-baccarat-1-no-comission",
      },
      koreanspeedbaccarat1: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Korean Speed Baccarat 1",
        name: "Korean Speed Baccarat 1",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/koreanspeedbaccarat1.webp",
        redirectUrl: "/casino/aggapplaytechlive-korean-speed-baccarat-1",
      },
      luckyballroulette: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Lucky Ball Roulette",
        name: "Lucky Ball Roulette",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/luckyballroulette.webp",
        redirectUrl: "/casino/aggapplaytechlive-lucky-ball-roulette",
      },
      megafireblazeblackjacklive: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Mega Fire Blaze Blackjack Live",
        name: "Mega Fire Blaze Blackjack Live",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/megafireblazeblackjacklive.webp",
        redirectUrl: "/casino/aggapplaytechlive-mega-fire-blaze-blackjack-live",
      },
      megafireblazeluckyballbrasileiro: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Mega Fire Blaze Lucky Ball Brasileiro",
        name: "Mega Fire Blaze Lucky Ball Brasileiro",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/megafireblazeluckyballbrasileiro.webp",
        redirectUrl:
          "/casino/aggapplaytechlive-mega-fire-blaze-lucky-ball-brasileiro",
      },
      puntobancosoireegold: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Punto Banco Soirée Gold",
        name: "Punto Banco Soirée Gold",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/puntobancosoireegold.webp",
        redirectUrl: "/casino/aggapplaytechlive-punto-banco-soiree-gold",
      },
      royaleblackjack2: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Royale Blackjack 2",
        name: "Royale Blackjack 2",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/royaleblackjack2.webp",
        redirectUrl: "/casino/aggapplaytechlive-royale-blackjack-2",
      },
      RuYispeedbaccaratnocommission: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Ru Yi Speed Baccarat No Comission",
        name: "Ru Yi Speed Baccarat No Comission",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/RuYispeedbaccaratnocommission.webp",
        redirectUrl:
          "/casino/aggapplaytechlive-ru-yi-speed-baccarat-no-comission",
      },
      RuYispeedbaccarat: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Ru Yi Speed Baccarat",
        name: "Ru Yi Speed Baccarat",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/RuYispeedbaccarat.webp",
        redirectUrl: "/casino/aggapplaytechlive-ru-yi-speed-baccarat",
      },
      speedsicbo: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Speed SicBo",
        name: "Speed SicBo",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/speedsicbo.webp",
        redirectUrl: "/casino/aggapplaytechlive-speed-sicbo",
      },
      stickybanditsroulettelive: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "Sticky Bandits Roulette Live",
        name: "Sticky Bandits Roulette Live",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/stickybanditsroulettelive.webp",
        redirectUrl: "/casino/aggapplaytechlive-sticky-bandits-roulette-live",
      },
      thegreatestcardshow: {
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/Slots"),
        alt: "The Greatest Cards Show",
        name: "The Greatest Cards Show",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/thegreatestcardshow.webp",
        redirectUrl: "/casino/aggapplaytechlive-the-greatest-cards-show",
      },
    },
    name: "Playtech",
    key: "playtechNew",
  },

  playtech: {
    slide1: {
      RedWizardBankItUp: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Red Wizard: Bank It Up",
        name: "Red Wizard: Bank It Up",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_red_wizard_bank_it_up.webp",
        redirectUrl: "/casino/aggapplaytech-red-wizard-bank-it-up",
      },
      MegaFireBlazeTheKhan: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Mega Fire Blaze: The Khan",
        name: "Mega Fire Blaze: The Khan",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_mega_fire_blaze_the_khan.webp",
        redirectUrl: "/casino/aggapplaytech-mega-fire-blaze-the-khan",
      },

      MahjongMagic: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Mahjong Magic",
        name: "Mahjong Magic",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_mahjong_magic.webp",
        redirectUrl: "/casino/aggapplaytech-mahjong-magic",
      },

      CashRevealCredits: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Cash Reveal - Credits",
        name: "Cash Reveal - Credits",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_cash_reveal__credits.webp",
        redirectUrl: "/casino/aggapplaytech-cash-reveal-credits",
      },

      FlipRoyale: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Flip Royale",
        name: "Flip Royale",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_flip_royale.webp",
        redirectUrl: "/casino/aggapplaytech-flip-royale",
      },

      TenTonWaysStampede: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Ten Ton Ways Stampede",
        name: "Ten Ton Ways Stampede",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_ten_ton_ways_stampede.webp",
        redirectUrl: "/casino/aggapplaytech-ten-ton-ways-stampede",
      },

      CashTrickBegins: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Cash Truck Begins",
        name: "Cash Truck Begins",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_cash_truck_begins.webp",
        redirectUrl: "/casino/aggapplaytech-cash-truck-begins",
      },

      GigaMatchEgypt: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Giga Match Egypt",
        name: "Giga Match Egypt",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_giga_match_egypt.webp",
        redirectUrl: "/casino/aggapplaytech-giga-match-egypt",
      },

      ImmortalsWaysVolcano: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Immortals Ways Volcano",
        name: "Immortals Ways Volcano",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_immortal_ways_volcano.webp",
        redirectUrl: "/casino/aggapplaytech-immortals-ways-volcano",
      },
      JokerSpinAndRoll: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Joker Spin & Roll",
        name: "Joker Spin & Roll",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_joker_spin__roll.webp",
        redirectUrl: "/casino/aggapplaytech-joker-spin-and-roll",
      },

      FullMoonWhitePandaPowerPlayJackpot: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Full Moon: White Panda PowerPlay Jackpot",
        name: "Full Moon: White Panda PowerPlay Jackpot",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_full_moon_white_panda_powerplay_jackpot.webp",
        redirectUrl: "/casino/aggapplaytech-full-moon-white-panda-powerplay-jackpot",
      },

      GoldTrioLilDemon: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Gold Trio: Lil Demon",
        name: "Gold Trio: Lil Demon",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_full_moon_white_panda_powerplay_jackpot.webp",
        redirectUrl: "/casino/aggapplaytech-gold-trio-lil-demon",
      },

      ShieldsOfLambda: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Shields of Lambda",
        name: "Shields of Lambda",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_shields_of_lambda.webp",
        redirectUrl: "/casino/aggapplaytech-shields-of-lambda",
      },

      MegaFireBlaze3Wizards: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Mega Fire Blaze: 3 Wizards",
        name: "Mega Fire Blaze: 3 Wizards",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_mega_fire_blaze_3_wizards.webp",
        redirectUrl: "/casino/aggapplaytech-mega-fire-blaze-3-wizards",
      },

      MiniRoulette: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Mini Roulette",
        name: "Mini Roulette",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_mini_roulette.webp",
        redirectUrl: "/casino/aggapplaytech-mini-roulette",
      },

      SpinAWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Spin a Win",
        name: "Spin a Win",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_spin_a_win.webp",
        redirectUrl: "/casino/aggapplaytech-spin-a-win",
      },

      RouletteMini: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Roulette Mini",
        name: "Roulette Mini",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_roulette_mini.webp",
        redirectUrl: "/casino/aggapplaytech-roulette-mini",
      },

      AztecaBonusLinesPowerPlayJackpot: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Azteca: Bonus Lines PowerPlay Jackpot",
        name: "Azteca: Bonus Lines PowerPlay Jackpot",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_azteca_bonus_lines_powerplay_jackpot.webp",
        redirectUrl: "/casino/aggapplaytech-azteca-bonus-lines-powerplay-jackpot",
      },

      LunarLinkPhoenixMoons: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Lunar Link: Phoenix Moons",
        name: "Lunar Link: Phoenix Moons",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_lunar_link_phoenix_moons.webp",
        redirectUrl: "/casino/aggapplaytech-lunar-link-phoenix-moons",
      },

      AztecFruits: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Aztec Fruits",
        name: "Aztec Fruits",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_aztec_fruits.webp",
        redirectUrl: "/casino/aggapplaytech-aztec-fruits",
      },

      GoldTrioLeprechaunsLuckBF: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Gold Trio: Leprechaun's Luck BF",
        name: "Gold Trio: Leprechaun's Luck BF",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_gold_trio_leprechauns_luck_bf.webp",
        redirectUrl: "/casino/aggapplaytech-gold-trio-leprechauns-luck-bf",
      },

      ElRancheroCashCollectDiamondPath: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "El Ranchero Cash Collect: Diamond Path",
        name: "El Ranchero Cash Collect: Diamond Path",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_el_ranchero_cash_collect_diamond_path.webp",
        redirectUrl: "/casino/aggapplaytech-el-ranchero-cash-collect-diamond-path",
      },

      DropForTop: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Drop for Top",
        name: "Drop for Top",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_drop_for_top.webp",
        redirectUrl: "/casino/aggapplaytech-drop-for-top",
      },

      ReactionLink: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Reaction Link",
        name: "Reaction Link",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_reaction_link.webp",
        redirectUrl: "/casino/aggapplaytech-reaction-link",
      },

      WildRoll: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Wild Roll",
        name: "Wild Roll",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_wild_roll.webp",
        redirectUrl: "/casino/aggapplaytech-wild-roll",
      },

      PiggiesAndTheBankCashCollectAndLink: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Piggies and the Bank: Cash Collect & Link",
        name: "Piggies and the Bank: Cash Collect & Link",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_piggies_and_the_bank_cash_collect__link.webp",
        redirectUrl: "/casino/aggapplaytech-piggies-and-the-bank-cash-collect-and-link",
      },

      GooodHeavens: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Goood Heavens",
        name: "Goood Heavens",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_goood_heavens.webp",
        redirectUrl: "/casino/aggapplaytech-goood-heavens",
      },

      StreakOfLuckDoubleDice: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Streak of Luck: Double Dice",
        name: "Streak of Luck: Double Dice",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_streak_of_luck_double_dice.webp",
        redirectUrl: "/casino/aggapplaytech-streak-of-luck-double-dice",
      },

      PiggiesAndTheBankLuckyTap: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Piggies and the Bank: Lucky Tap",
        name: "Piggies and the Bank: Lucky Tap",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_piggies_and_the_bank_lucky_tap.webp",
        redirectUrl: "/casino/aggapplaytech-piggies-and-the-bank-lucky-tap",
      },
    },
    name: "Playtech",
    key: "playtech",
  },

  pragmaticPlayGames: {
    ...PragmaticplayGames,
    name: "Pragmatic Play",
    key: "pragmaticPlayGames",
  },

  spribe: {
    slide1: {
      aviator: {
        // redirectUrl: "/casino/spribe/aviator",
        redirectUrl: "/casino/aggapspribe-aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/Aviator-new.webp",
        alt: "",
        name: "Aviator",
        providerName: "Spribe",
      },
      goal: {
        // redirectUrl: "/casino/spribe/goal",
        redirectUrl : "/casino/aggapspribe-goal",
        code: "goal",
        casino: "spribe",
        provider: "goal",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/Goal-new.webp",
        alt: "",
        name: "Goal",
        providerName: "Spribe",
      },
      dice: {
        // redirectUrl: "/casino/spribe/dice",
        redirectUrl: "/casino/aggapspribe-dice",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/Dice-new.webp",
        alt: "",
        name: "Dice",
        providerName: "Spribe",
      },
      plinko: {
        // redirectUrl: "/casino/spribe/plinko",
        redirectUrl: "/casino/aggapspribe-plinko",
        code: "plinko",
        casino: "spribe",
        provider: "plinko",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/Plinko-new.webp",
        alt: "",
        name: "Plinko",
        providerName: "Spribe",
      },
      hilo: {
        // redirectUrl: "/casino/spribe/hilo",
        redirectUrl: "/casino/aggapspribe-hilo",
        code: "hi-lo",
        casino: "spribe",
        provider: "hi-lo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/Hilo-new.webp",
        alt: "",
        name: "Hilo",
        providerName: "Spribe",
      },
      keno: {
        // redirectUrl: "/casino/spribe/keno",
        redirectUrl: "/casino/aggapspribe-keno",
        code: "keno",
        casino: "spribe",
        provider: "keno",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/Keno-new.webp",
        alt: "keno",
        name: "Keno",
        providerName: "Spribe",
      },
      miniroulette: {
        // redirectUrl: "/casino/spribe/miniroulette",
        redirectUrl: "/casino/aggapspribe-mini-roulette",
        code: "mini-roulette",
        casino: "spribe",
        provider: "mini-roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/MiniRoulette-new.webp",
        alt: "",
        name: "Mini Roulette",
        providerName: "Spribe",
      },

      mines: {
        // redirectUrl: "/casino/spribe/mines",
        redirectUrl: "/casino/aggapspribe-mines",
        code: "mines",
        casino: "spribe",
        provider: "mines",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/Mines.webp",
        alt: "",
        name: "Mines",
        providerName: "Spribe",
      },
      hotline: {
        // redirectUrl: "/casino/spribe/hotline",
        redirectUrl: "/casino/aggapspribe-hotline",
        code: "hotline",
        casino: "spribe",
        provider: "hotline",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/HotlineNew.jpg",
        alt: "hotline",
        name: "Hotline",
        providerName: "Spribe",
      },
      PilotChicken: {
        redirectUrl: "/casino/aggapspribe-pilot-chicken",
        code: "",
        casino: "spribe",
        provider: "alt-gaming",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/spribe/pilotchicken.webp",
        alt: "Pilot Chicken",
        name: "Pilot Chicken",
      },
      GatesofEgypt: {
        redirectUrl: "/casino/aggapspribe-gates-of-egypt",
        code: "",
        casino: "spribe",
        provider: "alt-gaming",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/spribe/gatesofegypt.webp",
        alt: "Gates of Egypt",
        name: "Gates of Egypt",
      },
      NeoVegas: {
        redirectUrl: "/casino/aggapspribe-neo-vegas",
        code: "",
        casino: "spribe",
        provider: "alt-gaming",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/spribe/neovegas.webp",
        alt: "Neo Vegas",
        name: "Neo Vegas",
      },
      CrystalsFall: {
        redirectUrl: "/casino/aggapspribe-crystal-fall",
        code: "",
        casino: "spribe",
        provider: "alt-gaming",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/spribe/crystalfall.webp",
        alt: "Crystal Fall",
        name: "Crystal Fall",
      },
      Trader: {
        redirectUrl: "/casino/aggapspribe-trader",
        code: "",
        casino: "spribe",
        provider: "alt-gaming",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/spribe/trader.webp",
        alt: "Trader",
        name: "Trader",
      },
      Keno80: {
        redirectUrl: "/casino/aggapspribe-keno-80",
        code: "",
        casino: "spribe",
        provider: "alt-gaming",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/spribe/multikeno.webp",
        alt: "Keno 80",
        name: "Keno 80",
      },
      Balloon: {
        redirectUrl: "/casino/aggapspribe-balloon",
        code: "",
        casino: "spribe",
        provider: "alt-gaming",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/spribe/balloon.webp",
        alt: "Balloon",
        name: "Balloon",
      },
    },
    name: "Spribe",
    key: "spribe",
  },
  inout: {
    slide1: {
      Wheel: {
        redirectUrl: "/casino/io-wheel",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Wheel.png",
        alt: "",
        name: "Wheel",
      },
      Twist: {
        redirectUrl: "/casino/io-twist",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Twist.png",
        alt: "",
        name: "Twist",
      },
      Triple: {
        redirectUrl: "/casino/io-triple",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Triple.png",
        alt: "",
        name: "Triple",
      },

      Tower: {
        redirectUrl: "/casino/io-tower",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Tower.png",
        alt: "",
        name: "Tower",
      },
      Sweetkeno: {
        redirectUrl: "/casino/io-sweet-keno",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Sweet-keno.png",
        alt: "",
        name: "Sweet keno",
      },
      SugarDaddy: {
        redirectUrl: "/casino/io-sugar-daddy",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Sugar-daddy.png",
        alt: "",
        name: "Sugar Daddy",
      },
      stairs: {
        redirectUrl: "/casino/io-stairs",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/stairs.png",
        alt: "",
        name: "Stairs",
      },
      squidGamebler: {
        redirectUrl: "/casino/io-squid-gamebler",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Squid-game.png",
        alt: "",
        name: "Squid Gamebler",
      },
      squidGamebler: {
        redirectUrl: "/casino/io-squid-gamebler",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Squid-game.png",
        alt: "",
        name: "Squid Gamebler",
      },
      Roulette: {
        redirectUrl: "/casino/io-roulette",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Roulette.png",
        alt: "",
        name: "Roulette",
      },
      RockPaperScissors: {
        redirectUrl: "/casino/io-rock-paper-scissors",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Rock-paper-scissors.png",
        alt: "",
        name: "Rock Paper Scissors",
      },
      Robodice: {
        redirectUrl: "/casino/io-robo-dice",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Robo-dice.png",
        alt: "",
        name: "Robo dice",
      },
      RabbitRoad: {
        redirectUrl: "/casino/io-rabbit-road",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Rabbit-road.png",
        alt: "",
        name: "Rabbit Road",
      },
      PlinkoAZTEC: {
        redirectUrl: "/casino/io-plinko-aztec",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Aztec-plinko.png",
        alt: "",
        name: "Plinko AZTEC",
      },
      Plinko1000: {
        redirectUrl: "/casino/io-plinko-1000",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Plinko-1000.png",
        alt: "",
        name: "Plinko 1000",
      },
      PenaltyUnlimited: {
        redirectUrl: "/casino/io-penalty-unlimited",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Penalty-unlimited.png",
        alt: "",
        name: "Penalty Unlimited",
      },
      NewHilo: {
        redirectUrl: "/casino/io-new-hilo",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Hi-lo-joker.png",
        alt: "",
        name: "New Hilo",
      },
      NewDouble: {
        redirectUrl: "/casino/io-new-double",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Double-online.png",
        alt: "",
        name: "New Double",
      },
      Mines: {
        redirectUrl: "/casino/io-mines",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Mines.png",
        alt: "",
        name: "Mines",
      },
      Luckymines: {
        redirectUrl: "/casino/io-lucky-mines",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Lucky-Mines.png",
        alt: "",
        name: "Lucky mines",
      },
      Luckymines: {
        redirectUrl: "/casino/io-lucky-mines",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Lucky-Mines.png",
        alt: "",
        name: "Lucky mines",
      },
      Linbo: {
        redirectUrl: "/casino/io-limbo",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Linbo.png",
        alt: "",
        name: "Limbo",
      },
      JokerPoker: {
        redirectUrl: "/casino/io-joker-poker",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Joker-poker.png",
        alt: "",
        name: "Joker Poker",
      },
      JogoDoBicho: {
        redirectUrl: "/casino/io-jogo-do-bicho",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Jogo-do-Bicho.png",
        alt: "",
        name: "Jogo Do Bicho",
      },
      Hotmines: {
        redirectUrl: "/casino/io-hot-mines",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Hot-mines.png",
        alt: "",
        name: "Hot-mines",
      },
      Hamsterrun: {
        redirectUrl: "/casino/io-hamster-run",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Hamster-run.png",
        alt: "",
        name: "Hamster-run",
      },
      GoblinTower: {
        redirectUrl: "/casino/io-goblin-tower",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Goblin-Tower.png",
        alt: "",
        name: "Goblin-tower",
      },
      ForestArrow: {
        redirectUrl: "/casino/io-forest-arrow",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Forest-arrow.png",
        alt: "",
        name: "Forest Arrow",
      },
      Diver: {
        redirectUrl: "/casino/io-diver",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Diver.png",
        alt: "",
        name: "Diver",
      },
      Cryptos: {
        redirectUrl: "/casino/io-cryptos",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Cryptos.png",
        alt: "",
        name: "Cryptos",
      },
      Crash: {
        redirectUrl: "/casino/io-crash",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Crash.png",
        alt: "",
        name: "Crash",
      },
      Coinflip: {
        redirectUrl: "/casino/io-coinflip",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Coin-flip.png",
        alt: "",
        name: "Coin-flip",
      },
      ChickenRoyal: {
        redirectUrl: "/casino/io-chicken-royal",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Chicken-royal.png",
        alt: "",
        name: "Chicken Royal",
      },
      ChickenRoad2: {
        redirectUrl: "/casino/io-chicken-road-2",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Chicken-road-2.png",
        alt: "",
        name: "Chicken Road 2",
      },
      ChickenRoad: {
        redirectUrl: "/casino/io-chicken-road",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Chicken-road.png",
        alt: "",
        name: "Chicken Road",
      },
      Bubbles: {
        redirectUrl: "/casino/io-bubbles",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Bubbles.png",
        alt: "",
        name: "Bubbles",
      },
      BalloniX: {
        redirectUrl: "/casino/io-ballonix",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Ballonix.png",
        alt: "",
        name: "BalloniX",
      },
      Aviafly: {
        redirectUrl: "/casino/io-aviafly",
        code: "1000124",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/games-image/inout/Avia-Fly.png",
        alt: "",
        name: "Aviafly",
      },
    },
    name: "InOut Games",
    key: "inout",
  },

  bigTimeGaming: {
    slide1: {
      DangerHighVoltage2: {
        redirectUrl: "/casino/aggapbigtimegaming-danger-high-voltage-2",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_dangerhighvoltage2.jpg",
        alt: "Danger High Voltage 2",
        name: "Danger High Voltage 2",
      },
      WhiteRabbit2: {
        redirectUrl: "/casino/aggapbigtimegaming-white-rabbit-2",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_whiterabbit2.webp",
        alt: "White Rabbit 2",
        name: "White Rabbit 2",
      },

      CastleTerror2: {
        redirectUrl: "/casino/aggapbigtimegaming-castle-terror-2",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_castleofterror.jpg",
        alt: "Castle Terror 2",
        name: "Castle Terror 2",
      },

      SatrCluster2: {
        redirectUrl: "/casino/aggapbigtimegaming-satr-cluster-2",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_starclusters2.webp",
        alt: "Satr Cluster 2",
        name: "Satr Cluster 2",
      },

      BigBucksDeluxeTapcards: {
        redirectUrl: "/casino/aggapbigtimegaming-big-bucks-deluxe-tapcards",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_bigbucksdeluxetapcards.webp",
        alt: "Big Bucks Deluxe Tapcards",
        name: "Big Bucks Deluxe Tapcards",
      },

      MillionaireTapcards: {
        redirectUrl: "/casino/aggapbigtimegaming-millionaire-tapcards",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_millionairetapcards.webp",
        alt: "Millionaire Tapcards",
        name: "Millionaire Tapcards",
      },

      ExtraChiliTapcards: {
        redirectUrl: "/casino/aggapbigtimegaming-extra-chili-tapcards",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_extrachilitapcards.webp",
        alt: "Extra Chili Tapcards",
        name: "Extra Chili Tapcards",
      },

      BonanzaTapcards: {
        redirectUrl: "/casino/aggapbigtimegaming-bonanza-tapcards",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_bonanzatapcards.webp",
        alt: "Bonanza Tapcards",
        name: "Bonanza Tapcards",
      },

      CrystalTowers: {
        redirectUrl: "/casino/aggapbigtimegaming-crystal-towers",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_crystaltowers.webp",
        alt: "Crystal Towers",
        name: "Crystal Towers",
      },

      TempleQuestSpinfinity: {
        redirectUrl: "/casino/aggapbigtimegaming-temple-quest-spinfinity",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_templequestspinfinity.webp",
        alt: "Temple Quest Spinfinity",
        name: "Temple Quest Spinfinity",
      },

      BigBucksDeluxe: {
        redirectUrl: "/casino/aggapbigtimegaming-big-bucks-deluxe",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_bigbucksdeluxe.webp",
        alt: "Big Bucks Deluxe",
        name: "Big Bucks Deluxe",
      },

      MaxMegaways3: {
        redirectUrl: "/casino/aggapbigtimegaming-max-megaways-3",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_maxmegaways3.webp",
        alt: "Max Megaways 3",
        name: "Max Megaways 3",
      },

      Burgers: {
        redirectUrl: "/casino/aggapbigtimegaming-burgers",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_burgers.webp",
        alt: "Burgers",
        name: "Burgers",
      },

      GoldenGooseMegaways: {
        redirectUrl: "/casino/aggapbigtimegaming-golden-goose-megaways",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_goldengoosemegaways.webp",
        alt: "Golden Goose Megaways",
        name: "Golden Goose Megaways",
      },

      DragonBorm: {
        redirectUrl: "/casino/aggapbigtimegaming-dragon-born",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_dragonborn.webp",
        alt: "Dragon Born",
        name: "Dragon Born",
      },

      ExtraChilli: {
        redirectUrl: "/casino/aggapbigtimegaming-extra-chilli",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_extrachilli.webp",
        alt: "Extra Chilli",
        name: "Extra Chilli",
      },

      HolyDiverMegaways: {
        redirectUrl: "/casino/aggapbigtimegaming-holy-diver-megaways",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_holydivermegaways.jpg",
        alt: "Holy Diver Megaways",
        name: "Holy Diver Megaways",
      },

      Boo: {
        redirectUrl: "/casino/aggapbigtimegaming-boo",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_boo.jpg",
        alt: "Boo",
        name: "Boo",
      },

      FizzyPennyslot: {
        redirectUrl: "/casino/aggapbigtimegaming-fizzy-pennyslot",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_fizzypennyslot.jpg",
        alt: "Fizzy Pennyslot",
        name: "Fizzy Pennyslot",
      },

      RoyalMint: {
        redirectUrl: "/casino/aggapbigtimegaming-royal-mint",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_royalmint94rtp.jpg",
        alt: "Royal Mint",
        name: "Royal Mint",
      },

      TriggerHappy: {
        redirectUrl: "/casino/aggapbigtimegaming-trigger-happy",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_triggerhappy.jpg",
        alt: "Trigger Happy",
        name: "Trigger Happy",
      },

      FireworksMegaways: {
        redirectUrl: "/casino/aggapbigtimegaming-fireworks-megaways",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_fireworksmegaways.jpg",
        alt: "Fireworks Megaways",
        name: "Fireworks Megaways",
      },

      OverTheMoon: {
        redirectUrl: "/casino/aggapbigtimegaming-over-the-moon",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_overthemoon.webp",
        alt: "Over the Moon",
        name: "Over the Moon",
      },

      TheRace: {
        redirectUrl: "/casino/aggapbigtimegaming-the-race",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_therace.webp",
        alt: "The Race",
        name: "The Race",
      },

      GiftsOfFortune: {
        redirectUrl: "/casino/aggapbigtimegaming-gifts-of-fortune",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_giftsoffortune.jpg",
        alt: "Gifts of Fortune",
        name: "Gifts of Fortune",
      },

      RasputinMegaways: {
        redirectUrl: "/casino/aggapbigtimegaming-rasputin-megaways",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_rasputinmegaways.webp",
        alt: "Rasputin Megaways",
        name: "Rasputin Megaways",
      },

      ChristmasBonanza: {
        redirectUrl: "/casino/aggapbigtimegaming-christmas-bonanza",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_christmasbonanza.webp",
        alt: "Christmas Bonanza",
        name: "Christmas Bonanza",
      },

      Outlaw: {
        redirectUrl: "/casino/aggapbigtimegaming-outlaw",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_outlaw.jpg",
        alt: "Outlaw",
        name: "Outlaw",
      },

      CastleOfTerror: {
        redirectUrl: "/casino/aggapbigtimegaming-castle-of-terror",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_castleofterror.jpg",
        alt: "Castle of Terror",
        name: "Castle of Terror",
      },

      MaxMegaways: {
        redirectUrl: "/casino/aggapbigtimegaming-max-megaways",
        code: "",
        casino: "Big Time Gaming",
        provider: "ALT_GAMING_GAP",
        category: "Big Time Gaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/bigTimeGaming/big_maxmegaways.jpg",
        alt: "Max Megaways",
        name: "Max Megaways",
      },
    },
    name: "Big Time Gaming",
    key: "bigTimeGaming",
  },

  goldenrace: {
    slide1: {
      GoldenRace: {
        redirectUrl: "/casino/aggapgoldenrace-golden-race",
        code: "",
        casino: "Golden Race",
        provider: "ALT_GAMING_GAP",
        category: "goldenrace",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/goldenrace/golden-race-thumb.webp",
        alt: "Golden Race",
        name: "Golden Race",
      },
    },
    name: "Golden Race",
    key: "goldenrace",
  },

  betongames: {
    slide1: {
      BetonGames: {
        redirectUrl: "/casino/aggapbetongames-egypt-fortunes-bingo-bounty",
        code: "",
        casino: "BetOnGames",
        provider: "ALT_GAMING_GAP",
        category: "BetOnGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betongames/BetOnGameslobby.png",
        alt: "Bet On Games",
        name: "Bet On Games",
      },
      // OutlawsAdventure: {
      //   redirectUrl: "/casino/aggapbetongames-outlaws-adventure",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/outlawsadventure.webp",
      //   alt: "Outlaws Adventure",
      //   name: "Outlaws Adventure",
      // },
      // EgyptFortunesBingoBounty: {
      //   redirectUrl: "/casino/aggapbetongames-egypt-fortunes-bingo-bounty",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/egyptfortunesbingobounty.webp",
      //   alt: "Egypt Fortunes Bingo Bounty",
      //   name: "Egypt Fortunes Bingo Bounty",
      // },

      // BigCatch1000NudgeBonusBuy: {
      //   redirectUrl: "/casino/aggapbetongames-big-catch-1000-nudge-bonus-buy",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/bigcatch1000nudgebonusbuy.webp",
      //   alt: "Big Catch 1000 Nudge Bonus buy",
      //   name: "Big Catch 1000 Nudge Bonus buy",
      // },

      // TheBigLapRapidLink: {
      //   redirectUrl: "/casino/aggapbetongames-the-big-lap-rapid-link",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/thebiglaprapidlink.webp",
      //   alt: "The Big Lap Rapid Link",
      //   name: "The Big Lap Rapid Link",
      // },

      // AmazingDiamondsHoldNLink: {
      //   redirectUrl: "/casino/aggapbetongames-amazing-diamonds-hold-n-link",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/amazingdiamondsholdnlink.webp",
      //   alt: "Amazing Diamonds Hold N Link",
      //   name: "Amazing Diamonds Hold N Link",
      // },

      // LiveFruits: {
      //   redirectUrl: "/casino/aggapbetongames-live-fruits",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/livefruits.webp",
      //   alt: "Live Fruits",
      //   name: "Live Fruits",
      // },

      // PenaltyRush: {
      //   redirectUrl: "/casino/aggapbetongames-penalty-rush",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/penaltyrush.webp",
      //   alt: "Penalty Rush",
      //   name: "Penalty Rush",
      // },

      // HitInVegas: {
      //   redirectUrl: "/casino/aggapbetongames-hit-in-vegas",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/hitinvegas.webp",
      //   alt: "Hit in Vegas",
      //   name: "Hit in Vegas",
      // },

      // WildBuffalo: {
      //   redirectUrl: "/casino/aggapbetongames-wild-buffalo",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/wildbuffalo.webp",
      //   alt: "Wild Buffalo",
      //   name: "Wild Buffalo",
      // },

      // VolcanoFruits: {
      //   redirectUrl: "/casino/aggapbetongames-volcano-fruits",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/volcanofruits.webp",
      //   alt: "Volcano Fruits",
      //   name: "Volcano Fruits",
      // },

      // RoyalFruits20: {
      //   redirectUrl: "/casino/aggapbetongames-royal-fruits-20",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/royalfruits20.webp",
      //   alt: "Royal Fruits 20",
      //   name: "Royal Fruits 20",
      // },

      // DiamondShot: {
      //   redirectUrl: "/casino/aggapbetongames-diamond-shot",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/diamondshot.webp",
      //   alt: "Diamond Shot",
      //   name: "Diamond Shot",
      // },

      // FrostyFruits: {
      //   redirectUrl: "/casino/aggapbetongames-frosty-fruits",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/frostyfruits.webp",
      //   alt: "Frosty Fruits",
      //   name: "Frosty Fruits",
      // },

      // FortuneCash: {
      //   redirectUrl: "/casino/aggapbetongames-fortune-cash",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/fortunecash.webp",
      //   alt: "Fortune Cash",
      //   name: "Fortune Cash",
      // },

      // FruitBrust: {
      //   redirectUrl: "/casino/aggapbetongames-fruit-brust",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/fruitburst.webp",
      //   alt: "Fruit Brust",
      //   name: "Fruit Brust",
      // },

      // RoyalFruits40: {
      //   redirectUrl: "/casino/aggapbetongames-royal-fruits-40",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/royalfruits40.webp",
      //   alt: "Royal Fruits 40",
      //   name: "Royal Fruits 40",
      // },

      // DancingLanterns: {
      //   redirectUrl: "/casino/aggapbetongames-dancing-lanterns",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/dancinglanterns.webp",
      //   alt: "Dancing Lanterns",
      //   name: "Dancing Lanterns",
      // },

      // JackpotSevens: {
      //   redirectUrl: "/casino/aggapbetongames-jackpot-sevens",
      //   code: "",
      //   casino: "BetOnGames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BetOnGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/betongames/jackpotsevens.webp",
      //   alt: "Jackpot Sevens",
      //   name: "Jackpot Sevens",
      // },
    },
    name: "BetOnGames",
    key: "betongames",
  },

  HP100: {
    slide1: {
      PumpIt: {
        redirectUrl: "/casino/aggap100hp-pump-it",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/pumpit.webp",
        alt: "Pump It",
        name: "Pump It",
      },
      Plinko: {
        redirectUrl: "/casino/aggap100hp-plinko",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/plinko.webp",
        alt: "Plinko",
        name: "Plinko",
      },

      Penalty: {
        redirectUrl: "/casino/aggap100hp-penalty",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/penalty.webp",
        alt: "Penalty",
        name: "Penalty",
      },

      Keno: {
        redirectUrl: "/casino/aggap100hp-keno",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/keno.webp",
        alt: "Keno",
        name: "Keno",
      },

      Hilo: {
        redirectUrl: "/casino/aggap100hp-hilo",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/hilo.webp",
        alt: "Hilo",
        name: "Hilo",
      },

      GodsOfPlinko: {
        redirectUrl: "/casino/aggap100hp-gods-of-plinko",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/godsofplinko.webp",
        alt: "Gods of Plinko",
        name: "Gods of Plinko",
      },

      Double: {
        redirectUrl: "/casino/aggap100hp-double",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/double.webp",
        alt: "Double",
        name: "Double",
      },

      CoinFlip: {
        redirectUrl: "/casino/aggap100hp-coin-flip",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/coinflip.webp",
        alt: "Coin Flip",
        name: "Coin Flip",
      },

      ChickenTrain: {
        redirectUrl: "/casino/aggap100hp-chicken-train",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/chickentrain.webp",
        alt: "Chicken Train",
        name: "Chicken Train",
      },

      ChickenPirates: {
        redirectUrl: "/casino/aggap100hp-chicken-pirates",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/chickenpirate.webp",
        alt: "Chicken Pirates",
        name: "Chicken Pirates",
      },

      Tropicana: {
        redirectUrl: "/casino/aggap100hp-tropicana",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/tropicana.webp",
        alt: "Tropicana",
        name: "Tropicana",
      },

      StarX: {
        redirectUrl: "/casino/aggap100hp-star-x",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/starx.webp",
        alt: "Star X",
        name: "Star X",
      },

      Poker: {
        redirectUrl: "/casino/aggap100hp-poker",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/poker.webp",
        alt: "Poker",
        name: "Poker",
      },

      Mines: {
        redirectUrl: "/casino/aggap100hp-mines",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/mines.webp",
        alt: "Mines",
        name: "Mines",
      },

      MetaCrash: {
        redirectUrl: "/casino/aggap100hp-meta-crash",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/metacrash.webp",
        alt: "Meta Crash",
        name: "Meta Crash",
      },

      FortuneCrash: {
        redirectUrl: "/casino/aggap100hp-fortune-crash",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/fortunecrash.webp",
        alt: "Fortune Crash",
        name: "Fortune Crash",
      },

      Dize: {
        redirectUrl: "/casino/aggap100hp-dize",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/dice.webp",
        alt: "Dize",
        name: "Dize",
      },

      CrimeEmpire: {
        redirectUrl: "/casino/aggap100hp-crime-empire",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/crimeempire.webp",
        alt: "Crime Empire",
        name: "Crime Empire",
      },

      Crash: {
        redirectUrl: "/casino/aggap100hp-crash",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/crash.webp",
        alt: "Crash",
        name: "Crash",
      },

      Blackjack: {
        redirectUrl: "/casino/aggap100hp-blackjack",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/blackjack.webp",
        alt: "Blackjack",
        name: "Blackjack",
      },

      Astronaut: {
        redirectUrl: "/casino/aggap100hp-astronaut",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/astronaut.webp",
        alt: "Astronaut",
        name: "Astronaut",
      },

      AirJet: {
        redirectUrl: "/casino/aggap100hp-air-jet",
        code: "",
        casino: "100HP",
        provider: "ALT_GAMING_GAP",
        category: "100HP",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/hp100/airjet.webp",
        alt: "Air Jet",
        name: "Air Jet",
      },
    },
    name: "100 HP",
    key: "HP100",
  },

  betsoft: {
    slide1: {
      PlinkoCup: {
        redirectUrl: "/casino/aggapbetsoft-plinko-cup",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_plinkocup.webp",
        alt: "Plinko Cup",
        name: "Plinko Cup",
      },
      ThreeTechBros: {
        redirectUrl: "/casino/aggapbetsoft-3-tech-bros",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_3techbros.webp",
        alt: "3 Tech Bros",
        name: "3 Tech Bros",
      },

      ZombieMash: {
        redirectUrl: "/casino/aggapbetsoft-zombie-mash",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_zombiemash.webp",
        alt: "Zombie Mash",
        name: "Zombie Mash",
      },

      GreedyGoblinsThatStoleChristmasHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-greedy-goblins-that-stole-christmas-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_greedygoblinsthatstolechristmas-holdandwin.webp",
        alt: "Greedy Goblins that Stole Christmas - Hold and Win",
        name: "Greedy Goblins that Stole Christmas - Hold and Win",
      },

      TheTipsyTouristChristmasVacationHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-the-tipsy-tourist-christmas-vacation-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_thetipsytouristchristmasvacation-holdandwin.webp",
        alt: "The Tipsy Tourist Christmas Vacation - Hold and Win",
        name: "The Tipsy Tourist Christmas Vacation - Hold and Win",
      },

      CarnivalRush: {
        redirectUrl: "/casino/aggapbetsoft-carnival-rush",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_carnivalrush.webp",
        alt: "Carnival Rush",
        name: "Carnival Rush",
      },

      ReturnToTheCopaHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-return-to-the-copa-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_returntothecopa-holdandwin.webp",
        alt: "Return to the Copa - Hold and Win",
        name: "Return to the Copa - Hold and Win",
      },

      CoinsOfHalloweenHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-coins-of-halloween-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_coinsofhalloween-holdandwin.webp",
        alt: "Coins of Halloween - Hold and Win",
        name: "Coins of Halloween - Hold and Win",
      },

      GiridironFortune: {
        redirectUrl: "/casino/aggapbetsoft-giridiron-fortune",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_gridironfortune.webp",
        alt: "Giridiron Fortune",
        name: "Giridiron Fortune",
      },

      ThreePotsOfLunarWolfHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-3-pots-of-lunar-wolf-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_3potsoflunarwolfholdandwin.webp",
        alt: "3 Pots of Lunar Wolf: Hold and Win",
        name: "3 Pots of Lunar Wolf: Hold and Win",
      },

      TutankhamunsTombHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-tutankhamuns-tomb-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_tutankhamunstombholdandwin.webp",
        alt: "Tutankhamun's Tomb: Hold and Win",
        name: "Tutankhamun's Tomb: Hold and Win",
      },

      DiscoFarmHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-disco-farm-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_discofarm-holdandwin.webp",
        alt: "DISCO Farm - Hold and Win",
        name: "DISCO Farm - Hold and Win",
      },

      CoinsOfRADeluxeHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-coins-of-ra-deluxe-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_coinsofradeluxe-holdandwin.webp",
        alt: "Coins of RA Deluxe - Hold and Win",
        name: "Coins of RA Deluxe - Hold and Win",
      },

      CoinsOfBuffalo: {
        redirectUrl: "/casino/aggapbetsoft-coins-of-buffalo",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_coinsofbuffalo.webp",
        alt: "Coins of Buffalo",
        name: "Coins of Buffalo",
      },

      LizardLoot: {
        redirectUrl: "/casino/aggapbetsoft-lizard-loot",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_lizardloot.webp",
        alt: "Lizard Loot",
        name: "Lizard Loot",
      },

      PotsOfGreatFortuneHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-pots-of-great-fortune-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_potsofgreatfortuneholdandwin.webp",
        alt: "Pots of Great Fortune - Hold and Win",
        name: "Pots of Great Fortune - Hold and Win",
      },

      CoinsOfLeprechaunHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-coins-of-leprechaun-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_coinsofleprechaun-holdandwin.webp",
        alt: "Coins of Leprechaun -Hold and Win",
        name: "Coins of Leprechaun -Hold and Win",
      },

      CoinsOfFruitsHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-coins-of-fruits-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_coinsoffruitholdandwin.webp",
        alt: "Coins of Fruits: Hold and Win",
        name: "Coins of Fruits: Hold and Win",
      },

      CoinsOfAlkemorExtremeMagicHoldAndWin: {
        redirectUrl: "/casino/aggapbetsoft-coins-of-alkemor-extreme-magic-hold-and-win",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_coinsofalkemorextrememagicholdandwin.webp",
        alt: "Coins of Alkemor: Extreme Magic - Hold and Win",
        name: "Coins of Alkemor: Extreme Magic - Hold and Win",
      },

      DiamondMines: {
        redirectUrl: "/casino/aggapbetsoft-diamond-mines",
        code: "",
        casino: "betsoft",
        provider: "ALT_GAMING_GAP",
        category: "betsoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/betsoft/bst_diamondmines.webp",
        alt: "Diamond Mines",
        name: "Diamond Mines",
      },
    },
    name: "Betsoft",
    key: "betsoft",
  },
  macaw: {
    slide1: {
      HotBalloon: {
        redirectUrl: "/casino/aggapmacawgaming-hot-balloon",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/HotAirBallon.webp",
        alt: "Hot Balloon",
        name: "Hot Balloon",
      },
      MysteriousNight: {
        redirectUrl: "/casino/aggapmacawgaming-mysterious-night",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/mysteriousnight.webp",
        alt: "Mysterious Night",
        name: "Mysterious Night",
      },

      FortuneMelody: {
        redirectUrl: "/casino/aggapmacawgaming-fortune-melody",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/fortunemelody.webp",
        alt: "Fortune Melody",
        name: "Fortune Melody",
      },

      NeonCityWheel: {
        redirectUrl: "/casino/aggapmacawgaming-neon-city-wheel",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/neoncitywheel.webp",
        alt: "Neon City Wheel",
        name: "Neon City Wheel",
      },

      Lucky8: {
        redirectUrl: "/casino/aggapmacawgaming-lucky-8",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/luckyeight.webp",
        alt: "Lucky 8",
        name: "Lucky 8",
      },

      Rio40Graus: {
        redirectUrl: "/casino/aggapmacawgaming-rio-40-graus",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/rio40graus.webp",
        alt: "Rio 40 Graus",
        name: "Rio 40 Graus",
      },

      FruitCocktail: {
        redirectUrl: "/casino/aggapmacawgaming-fruit-cocktail",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/fruitcocktail.webp",
        alt: "Fruit Cocktail",
        name: "Fruit Cocktail",
      },

      WalkingDeath: {
        redirectUrl: "/casino/aggapmacawgaming-walking-death",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/walkingdeath.webp",
        alt: "Walking Death",
        name: "Walking Death",
      },

      Abrakadabra: {
        redirectUrl: "/casino/aggapmacawgaming-abrakadabra",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/Abrakadabra.webp",
        alt: "Abrakadabra",
        name: "Abrakadabra",
      },

      JokersSmile: {
        redirectUrl: "/casino/aggapmacawgaming-jokers-smile",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/jokerssmile.webp",
        alt: "Joker's Smile",
        name: "Joker's Smile",
      },

      SuleimanTheMagnificent: {
        redirectUrl: "/casino/aggapmacawgaming-suleiman-the-magnificent",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/suleimanthemagnificent.webp",
        alt: "Suleiman The Magnificent",
        name: "Suleiman The Magnificent",
      },

      HotBallonDeluxe: {
        redirectUrl: "/casino/aggapmacawgaming-hot-ballon-deluxe",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/hotballoondeluxe.webp",
        alt: "Hot Ballon Deluxe",
        name: "Hot Ballon Deluxe",
      },
      ZodiacAdventure: {
        redirectUrl: "/casino/aggapmacawgaming-zodiac-adventure",
        code: "",
        casino: "macaw",
        provider: "ALT_GAMING_GAP",
        category: "macaw",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/macaw/zodiacadventure.webp",
        alt: "Zodiac Adventure",
        name: "Zodiac Adventure",
      },
    },
    name: "Macaw Gaming",
    key: "macaw",
  },

  caletagaming: {
    slide1: {
      SugarBingo: {
        redirectUrl: "/casino/aggapcaletagaming-sugar-bingo",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_sugarbingo.webp",
        alt: "Sugar Bingo",
        name: "Sugar Bingo",
      },
      MoneyMazeBeto: {
        redirectUrl: "/casino/aggapcaletagaming-money-maze-beto",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_moneymazebeto.webp",
        alt: "Money Maze Beto",
        name: "Money Maze Beto",
      },

      // FashionTVFlashDiamond: {
      //   redirectUrl: "/casino/aggapcaletagaming-fashion-tv-flash-diamond",
      //   code: "",
      //   casino: "Caleta Gaming",
      //   provider: "ALT_GAMING_GAP",
      //   category: "caletagaming",
      //   homeUrl: "http://localhost:3000/slots",
      //   imgUrl: "./images/casino/caleta-gaming/clt_fashiontvflashdiamond.webp",
      //   alt: "Fashion TV Flash Diamond",
      //   name: "Fashion TV Flash Diamond",
      // },

      BingoBingo: {
        redirectUrl: "/casino/aggapcaletagaming-bingo-bingo",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_bingobingo.webp",
        alt: "Bingo Bingo",
        name: "Bingo Bingo",
      },

      HiLoaf: {
        redirectUrl: "/casino/aggapcaletagaming-hi-loaf",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_hi-loaf.webp",
        alt: "Hi-Loaf",
        name: "Hi-Loaf",
      },

      CrashCrash: {
        redirectUrl: "/casino/aggapcaletagaming-crash-crash",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_crashcrash.webp",
        alt: "Crash Crash",
        name: "Crash Crash",
      },

      BetManCrash: {
        redirectUrl: "/casino/aggapcaletagaming-betman-crash",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_betmancrash.webp",
        alt: "BetMan Crash",
        name: "BetMan Crash",
      },

      BlackjackBeto: {
        redirectUrl: "/casino/aggapcaletagaming-blackjack-beto",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_blackjackbeto.webp",
        alt: "Blackjack Beto",
        name: "Blackjack Beto",
      },

      CoinKingBeto: {
        redirectUrl: "/casino/aggapcaletagaming-coin-king-beto",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_coinkingbeto.webp",
        alt: "Coin King Beto",
        name: "Coin King Beto",
      },

      BaileFunkBingo: {
        redirectUrl: "/casino/aggapcaletagaming-baile-funk-bingo",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_bailefunkbingo.webp",
        alt: "Baile Funk Bingo",
        name: "Baile Funk Bingo",
      },

      SweetSaga: {
        redirectUrl: "/casino/aggapcaletagaming-sweet-saga",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_sweetsaga.webp",
        alt: "Sweet Saga",
        name: "Sweet Saga",
      },

      GrandmaBingo: {
        redirectUrl: "/casino/aggapcaletagaming-grandma-bingo",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_grandmabingo.webp",
        alt: "Grandma Bingo",
        name: "Grandma Bingo",
      },

      BichosDaAmazingBingo: {
        redirectUrl: "/casino/aggapcaletagaming-bichos-da-amazing-bingo",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_bichosdaamazniabingo.webp",
        alt: "Bichos da Amazing Bingo",
        name: "Bichos da Amazing Bingo",
      },

      FateOfOlympus: {
        redirectUrl: "/casino/aggapcaletagaming-fate-of-olympus",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_fateofolympus.webp",
        alt: "Fate of Olympus",
        name: "Fate of Olympus",
      },

      FashionTVAquaBoutiqueBingo: {
        redirectUrl: "/casino/aggapcaletagaming-fashion-tv-aqua-boutique-bingo",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_aquaboutiquebingo.webp",
        alt: "Fashion TV Aqua Boutique Bingo",
        name: "Fashion TV Aqua Boutique Bingo",
      },

      WingsOfLiberty: {
        redirectUrl: "/casino/aggapcaletagaming-wings-of-liberty",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_wingsofliberty.webp",
        alt: "Wings of Liberty",
        name: "Wings of Liberty",
      },

      BollywoodNights: {
        redirectUrl: "/casino/aggapcaletagaming-bollywood-nights",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/ids_bollywoodnights.webp",
        alt: "Bollywood Nights",
        name: "Bollywood Nights",
      },

      KabaddiRaiders: {
        redirectUrl: "/casino/aggapcaletagaming-kabaddi-raiders",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/ids_kabaddiraiders.webp",
        alt: "Kabaddi Raiders",
        name: "Kabaddi Raiders",
      },

      PremierLeagueCricket: {
        redirectUrl: "/casino/aggapcaletagaming-premier-league-cricket",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/ids_premierleaguecricket.webp",
        alt: "Premier League Cricket",
        name: "Premier League Cricket",
      },

      DiwaliLights: {
        redirectUrl: "/casino/aggapcaletagaming-diwali-lights",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/ids_diwalilights.webp",
        alt: "Diwali Lights",
        name: "Diwali Lights",
      },

      LordsBalcony: {
        redirectUrl: "/casino/aggapcaletagaming-lords-balcony",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/ids_lordsbalcony.webp",
        alt: "Lords Balcony",
        name: "Lords Balcony",
      },

      FortuneWolf: {
        redirectUrl: "/casino/aggapcaletagaming-fortune-wolf",
        code: "",
        casino: "Caleta Gaming",
        provider: "ALT_GAMING_GAP",
        category: "caletagaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/caleta-gaming/clt_fortunewolf.jpg",
        alt: "Fortune Wolf",
        name: "Fortune Wolf",
      },
    },
    name: "Caleta Gaming",
    key: "caletagaming",
  },

  truelab: {
    slide1: {
      HotMoneySlot: {
        code: "98567",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Hot Money Slot",
        name: "Hot Money Slot",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_hotmoneyslot95.webp",
        redirectUrl: "/casino/aggaptruelab-hot-money-slot-u7090",
      },
      DrRockAndFrozenMonkey: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Dr. Rock and Frozen Monkey",
        name: "Dr. Rock and Frozen Monkey",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_drrockandfrozenmonkey.webp",
        redirectUrl: "/casino/aggaptruelab-dr-rock-and-frozen-monkey-u8652",
      },

      Hot100Slot: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "100 hot Slot",
        name: "100 hot Slot",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_100hotslot95.webp",
        redirectUrl: "/casino/aggaptruelab-100-hot-slot-u4467",
      },

      AbyssOfGlory: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Abyss of Glory",
        name: "Abyss of Glory",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_abyssofglory92.webp",
        redirectUrl: "/casino/aggaptruelab-abyss-of-glory-u4915",
      },

      GreedyPiggy: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Greedy Piggy",
        name: "Greedy Piggy",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_greedypiggy92.webp",
        redirectUrl: "/casino/aggaptruelab-greedy-piggy-u8264",
      },

      VitussBritvaGodOfRandom: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Vituss Britva God of Random",
        name: "Vituss Britva God of Random",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_vitussbritvagodofrandom92.webp",
        redirectUrl: "/casino/aggaptruelab-vituss-britva-god-of-random-u3319",
      },

      Hellevator: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Hellevator",
        name: "Hellevator",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_hellevator95.webp",
        redirectUrl: "/casino/aggaptruelab-hellevator-u9118",
      },

      LofiTheYeti: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Lofi The Yeti",
        name: "Lofi The Yeti",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_lofitheyeti92.webp",
        redirectUrl: "/casino/aggaptruelab-lofi-the-yeti",
      },

      DrRockAndCreepyMonster: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Dr. Rock and Creepy Monster",
        name: "Dr. Rock and Creepy Monster",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_drrockandcreepymonster.webp",
        redirectUrl: "/casino/aggaptruelab-dr-rock-and-creepy-monster-u3764",
      },

      HoldMyBeer: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Hold My Beer",
        name: "Hold My Beer",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_holdmybeer92.webp",
        redirectUrl: "/casino/aggaptruelab-hold-my-beer-u2657",
      },

      Skyborn: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Skyborn",
        name: "Skyborn",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_skyborn92.webp",
        redirectUrl: "/casino/aggaptruelab-skyborn-u6866",
      },

      StormVsFire: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Storm vs Fire",
        name: "Storm vs Fire",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_stormvsfire92.webp",
        redirectUrl: "/casino/aggaptruelab-storm-vs-fire-u9082",
      },

      // BookOfOdin: {
      //   code: "",
      //   casino: "truelab",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: pageUrlGenerator("/slots"),
      //   alt: "Book of Odin",
      //   name: "Book of Odin",
      //   providerName: "TrueLab",
      //   imgUrl: "./images/casino/truelab/trf_bookofodin92.webp",
      //   redirectUrl: "/casino/aaggaptruelab-book-of-odin-u7845",
      // },

      ClusterFuck: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Cluster*uck",
        name: "Cluster*uck",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_clusteruck92.webp",
        redirectUrl: "/casino/aggaptruelab-clusteruck-u2655",
      },

      FishyBusiness: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Fishy Business",
        name: "Fishy Business",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_fishybusiness92.webp",
        redirectUrl: "/casino/aggaptruelab-fishy-business-u6826",
      },

      // FruitCircusParty: {
      //   code: "",
      //   casino: "truelab",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: pageUrlGenerator("/slots"),
      //   alt: "Fruit Circus Party",
      //   name: "Fruit Circus Party",
      //   providerName: "TrueLab",
      //   imgUrl: "./images/casino/truelab/trf_fruitcircusparty92.webp",
      //   redirectUrl: "/casino/aggaptruelab-fruit-circus-party-u1694",
      // },

      HotDevilSlot: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Hot Devil Slot",
        name: "Hot Devil Slot",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_hotdevilslot92.webp",
        redirectUrl: "/casino/aggaptruelab-hot-devil-slot-u4901",
      },

      MysticCharms: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Mystic Charms",
        name: "Mystic Charms",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_mysticcharms92.webp",
        redirectUrl: "/casino/aggaptruelab-mystic-charms-u1914",
      },

      MostWanted: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Most Wanted",
        name: "Most Wanted",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_mostwanted92.webp",
        redirectUrl: "/casino/aggaptruelab-most-wanted-u9474",
      },

      // AztecLegend: {
      //   code: "",
      //   casino: "truelab",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: pageUrlGenerator("/slots"),
      //   alt: "Aztec Legend",
      //   name: "Aztec Legend",
      //   providerName: "TrueLab",
      //   imgUrl: "./images/casino/truelab/trf_azteclegend92.webp",
      //   redirectUrl: "/casino/aggaptruelab-aztec-legend-u5113",
      // },

      BookOfHuli: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Book of Huli",
        name: "Book of Huli",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_bookofhuli92.webp",
        redirectUrl: "/casino/aggaptruelab-book-of-huli-u1118",
      },

      // AppleCrush: {
      //   code: "",
      //   casino: "truelab",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: pageUrlGenerator("/slots"),
      //   alt: "Apple crush",
      //   name: "Apple crush",
      //   providerName: "TrueLab",
      //   imgUrl: "./images/casino/truelab/trf_applecrush92.webp",
      //   redirectUrl: "/casino/aggaptruelab-apple-crush-u7181",
      // },

      DrRockAndTheRiffReactor: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Dr. Rock and the Riff Reactor",
        name: "Dr. Rock and the Riff Reactor",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_drrockandtheriffreactor92.webp",
        redirectUrl: "/casino/aggaptruelab-dr-rock-and-the-riff-reactor-u6879",
      },

      AlohaFruitBonanza: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Aloha Fruit Bonanza",
        name: "Aloha Fruit Bonanza",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_alohafruitbonanza92.webp",
        redirectUrl: "/casino/aggaptruelab-aloha-fruit-bonanza-u6526",
      },

      GunsLoveAndTherapy: {
        code: "",
        casino: "truelab",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Guns, Love and Therapy",
        name: "Guns, Love and Therapy",
        providerName: "TrueLab",
        imgUrl: "./images/casino/truelab/trf_gunsloveandtherapy92.webp",
        redirectUrl: "/casino/aggaptruelab-guns-love-and-therapy-u7609",
      },
    },
    name: "TrueLab",
    key: "truelab",
  },

  BGaming: {
    slide1: {
      Aviamasters2: {
        redirectUrl: "/casino/aggap100hp-pump-it",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_aviamasters_2.webp",
        alt: "Aviamasters 2",
        name: "Aviamasters 2",
      },
      GoldenAvalonHoldAndWin: {
        redirectUrl: "/casino/aggapbgaming-golden-avalon-hold-and-win",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_golden_avalon_hold_and_win.webp",
        alt: "Golden Avalon Hold and Win",
        name: "Golden Avalon Hold and Win",
      },

      RocketEruptionTripleBlast: {
        redirectUrl: "/casino/aggapbgaming-rocket-eruption-triple-blast",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_rocket_eruption_triple_blast.webp",
        alt: "Rocket Eruption: Triple Blast",
        name: "Rocket Eruption: Triple Blast",
      },

      HeartOfTiki: {
        redirectUrl: "/casino/aggapbgaming-heart-of-tiki",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_heart_of_tiki.webp",
        alt: "Heart of Tiki",
        name: "Heart of Tiki",
      },

      FortuneRedPackets: {
        redirectUrl: "/casino/aggapbgaming-fortune-red-packets",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_fortune_red_packets.webp",
        alt: "Fortune Red Packets",
        name: "Fortune Red Packets",
      },

      PandaFortuneRush: {
        redirectUrl: "/casino/aggapbgaming-panda-fortune-rush",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_panda_fortune_rush.webp",
        alt: "Panda Fortune Rush",
        name: "Panda Fortune Rush",
      },

      AlwaysUpX10000: {
        redirectUrl: "/casino/aggapbgaming-always-up-x10000",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_always_up_x10000.webp",
        alt: "Always Up x10000",
        name: "Always Up x10000",
      },

      WinterTrophyHoldAndWin: {
        redirectUrl: "/casino/aggapbgaming-winter-trophy-hold-and-win",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_winter_trophy_hold_and_win.webp",
        alt: "Winter Trophy Hold and Win",
        name: "Winter Trophy Hold and Win",
      },

      // BlazingFiresPotsHoldAndSpin: {
      //   redirectUrl: "/casino/aggapbgaming-blazing-fires-pots-hold-and-spin",
      //   code: "",
      //   casino: "BGaming",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BGaming",
      //   homeUrl: "http://localhost:3000/slots",
      //   imgUrl: "./images/casino/BGaming/bgm_blazing_fire_pots_hold__spin.webp",
      //   alt: "Blazing Fires Pots Hold & Spin",
      //   name: "Blazing Fires Pots Hold & Spin",
      // },

      JewelBoomSuperDrop: {
        redirectUrl: "/casino/aggapbgaming-jewel-boom-super-drop",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_jewel_boom_super_drop.webp",
        alt: "Jewel Boom Super Drop",
        name: "Jewel Boom Super Drop",
      },

      TreasureExplorer: {
        redirectUrl: "/casino/aggapbgaming-treasure-explorer",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_treasure_explorer.webp",
        alt: "Treasure Explorer",
        name: "Treasure Explorer",
      },

      MysteryHeist: {
        redirectUrl: "/casino/aggapbgaming-mystery-heist",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_mystery_heist.webp",
        alt: "Mystery Heist",
        name: "Mystery Heist",
      },

      SurrenderMultihandBlackjack: {
        redirectUrl: "/casino/aggapbgaming-surrender-multihand-blackjack",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_surrender_multihand_blackjack.webp",
        alt: "Surrender Multihand Blackjack",
        name: "Surrender Multihand Blackjack",
      },

      JokerXLove: {
        redirectUrl: "/casino/aggapbgaming-joker-x-love",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_joker_x_love.webp",
        alt: "joker X Love",
        name: "joker X Love",
      },

      TotallyHotXMasEdition: {
        redirectUrl: "/casino/aggapbgaming-totally-hot-x-mas-edition",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_totally_hot_xmas_edition.webp",
        alt: "Totally Hot X-mas Edition",
        name: "Totally Hot X-mas Edition",
      },

      AviamastersXMas: {
        redirectUrl: "/casino/aggapbgaming-aviamasters-x-mas",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_aviamasters_2.webp",
        alt: "Aviamasters X-mas",
        name: "Aviamasters X-mas",
      },

      // TrampDayTrueways: {
      //   redirectUrl: "/casino/aggapbgaming-tramp-day-trueways",
      //   code: "",
      //   casino: "BGaming",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BGaming",
      //   homeUrl: "http://localhost:3000/slots",
      //   imgUrl: "./images/casino/BGaming/bgm_tramp_day_trueways.webp",
      //   alt: "Tramp Day Trueways",
      //   name: "Tramp Day Trueways",
      // },

      // AztecClawWildDice: {
      //   redirectUrl: "/casino/aggapbgaming-aztec-claw-wild-dice",
      //   code: "",
      //   casino: "BGaming",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BGaming",
      //   homeUrl: "http://localhost:3000/slots",
      //   imgUrl: "./images/casino/BGaming/bgm_aztecs_claw_wild_dice.webp",
      //   alt: "Aztec Claw Wild Dice",
      //   name: "Aztec Claw Wild Dice",
      // },

      StarTrekTheNextGeneration: {
        redirectUrl: "/casino/aggapbgaming-star-trek-the-next-generation",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_star_trek_the_next_generation.webp",
        alt: "Star Trek: The Next Generation",
        name: "Star Trek: The Next Generation",
      },

      // HotChiliBells100XMas: {
      //   redirectUrl: "/casino/aggapbgaming-hot-chili-bells-100-x-mas",
      //   code: "",
      //   casino: "BGaming",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BGaming",
      //   homeUrl: "http://localhost:3000/slots",
      //   imgUrl: "./images/casino/BGaming/bgm_hot_chilli_bells_100.webp",
      //   alt: "Hot Chili Bells 100 X-MAs",
      //   name: "Hot Chili Bells 100 X-MAs",
      // },

      UFOPyramids: {
        redirectUrl: "/casino/aggapbgaming-ufo-pyramids",
        code: "",
        casino: "BGaming",
        provider: "ALT_GAMING_GAP",
        category: "BGaming",
        homeUrl: "http://localhost:3000/slots",
        imgUrl: "./images/casino/BGaming/bgm_ufo_pyramids.webp",
        alt: "UFO Pyramids",
        name: "UFO Pyramids",
      },

      // OpenIt: {
      //   redirectUrl: "/casino/aggapbgaming-open-it",
      //   code: "",
      //   casino: "BGaming",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BGaming",
      //   homeUrl: "http://localhost:3000/slots",
      //   imgUrl: "./images/casino/BGaming/bgm_open_it.webp",
      //   alt: "Open It!",
      //   name: "Open It!",
      // },

      // DivineQueenHeartOfIce: {
      //   redirectUrl: "/casino/aggapbgaming-divine-queen-heart-of-ice",
      //   code: "",
      //   casino: "BGaming",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BGaming",
      //   homeUrl: "http://localhost:3000/slots",
      //   imgUrl: "./images/casino/BGaming/bgm_divine_queen_heart_of_ice.webp",
      //   alt: "Divine Queen: Heart of Ice",
      //   name: "Divine Queen: Heart of Ice",
      // },

      // WildMilion: {
      //   redirectUrl: "/casino/aggapbgaming-wild-milion",
      //   code: "",
      //   casino: "BGaming",
      //   provider: "ALT_GAMING_GAP",
      //   category: "BGaming",
      //   homeUrl: "http://localhost:3000/slots",
      //   imgUrl: "./images/casino/BGaming/bgm_wild_million.webp",
      //   alt: "Wild Milion",
      //   name: "Wild Milion",
      // },
    },
    name: "BGaming",
    key: "BGaming",
  },

  kalambagames: {
    slide1: {
      RubyHeistHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-ruby-heist-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_rubyheistholdandwin.webp",
        alt: "Ruby Heist Hold and Win",
        name: "Ruby Heist Hold and Win",
      },
      MangoMulti7sHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-mango-multi-7s-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_mangomulti7sholdandwin.webp",
        alt: "Mango Multi 7s Hold and Win",
        name: "Mango Multi 7s Hold and Win",
      },

      // HorusFirePrizeTower: {
      //   redirectUrl: "/casino/aggapkalambagames-horus-fire-prize-tower",
      //   code: "",
      //   casino: "kalambagames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "kalambagames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/kalambagames/klb_horusfireprizetower.webp",
      //   alt: "Horus Fire Prize Tower",
      //   name: "Horus Fire Prize Tower",
      // },

      PiggyBankPlunderHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-piggy-bank-plunder-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_piggybankplunderholdandwin.webp",
        alt: "Piggy Bank Plunder Hold and Win",
        name: "Piggy Bank Plunder Hold and Win",
      },

      // BisonMadnessPrizeTower: {
      //   redirectUrl: "/casino/aggapkalambagames-bison-madness-prize-tower",
      //   code: "",
      //   casino: "kalambagames",
      //   provider: "ALT_GAMING_GAP",
      //   category: "kalambagames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/kalambagames/klb_bisonmadnessprizetower.webp",
      //   alt: "Bison Madness Prize Tower",
      //   name: "Bison Madness Prize Tower",
      // },

      JokerFright7s: {
        redirectUrl: "/casino/aggapkalambagames-joker-fright-7s",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_jokerfright7s.webp",
        alt: "Joker Fright 7s",
        name: "Joker Fright 7s",
      },

      EmeraldGlory7s: {
        redirectUrl: "/casino/aggapkalambagames-emerald-glory-7s",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_emeraldglory7s.webp",
        alt: "Emerald Glory 7s",
        name: "Emerald Glory 7s",
      },

      BlazingScarabsHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-3-blazing-scarabs-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_3blazingscarabsholdandwin.webp",
        alt: "3 Blazing Scarabs Hold and Win",
        name: "3 Blazing Scarabs Hold and Win",
      },

      JokerCatcher7s: {
        redirectUrl: "/casino/aggapkalambagames-joker-catcher-7s",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_jokercatcher7s.webp",
        alt: "Joker Catcher 7s",
        name: "Joker Catcher 7s",
      },

      DragonsGlowHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-dragons-glow-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_dragonsglowholdandwin.webp",
        alt: "Dragons Glow Hold and Win",
        name: "Dragons Glow Hold and Win",
      },

      MooncakeDragonsHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-mooncake-dragons-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_mooncakedragonsholdandwin.webp",
        alt: "Mooncake Dragons Hold and Win",
        name: "Mooncake Dragons Hold and Win",
      },

      NinjazVsNarcos2: {
        redirectUrl: "/casino/aggapkalambagames-ninjaz-vs-narcos-2",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_ninjazvsnarcos2.webp",
        alt: "Ninjaz vs Narcos 2",
        name: "Ninjaz vs Narcos 2",
      },
      BisondaPrizeMatch: {
        redirectUrl: "/casino/aggapkalambagames-bisonda-prize-match",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_bisonadoprizematch.webp",
        alt: "Bisonda PrizeMatch",
        name: "Bisonda PrizeMatch",
      },

      SoloReelBlitz: {
        redirectUrl: "/casino/aggapkalambagames-soloreel-blitz",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_soloreeltmblitz.webp",
        alt: "SoloReel Blitz",
        name: "SoloReel Blitz",
      },

      JewelsOfJupiterHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-jewels-of-jupiter-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_jewelsofjupiterholdandwin.webp",
        alt: "Jewels of Jupiter Hold and Win",
        name: "Jewels of Jupiter Hold and Win",
      },

      MultiBlitz7s: {
        redirectUrl: "/casino/aggapkalambagames-multi-blitz-7s",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_multiblitz7s.webp",
        alt: "Multi Blitz 7s",
        name: "Multi Blitz 7s",
      },

      CloverSupremeHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-clover-supreme-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_cloversupremeholdandwin.webp",
        alt: "Clover Supreme Hold and Win",
        name: "Clover Supreme Hold and Win",
      },

      Firedream7sHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-firedream-7s-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_firedream7sholdandwin.webp",
        alt: "Firedream 7s Hold and Win",
        name: "Firedream 7s Hold and Win",
      },

      EagleHonor7s: {
        redirectUrl: "/casino/aggapkalambagames-eagle-honor-7s",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_eaglehonor7s.webp",
        alt: "Eagle Honor 7s",
        name: "Eagle Honor 7s",
      },

      SoccerStormHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-soccer-storm-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_soccerstormholdandwin.webp",
        alt: "Soccer Storm Hold and Win",
        name: "Soccer Storm Hold and Win",
      },

      GlowBurst7s: {
        redirectUrl: "/casino/aggapkalambagames-glow-burst-7s",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_glowburst7s.webp",
        alt: "Glow Burst 7s",
        name: "Glow Burst 7s",
      },

      MangoExpress7s: {
        redirectUrl: "/casino/aggapkalambagames-mango-express-7s",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_mangoexpress7s.webp",
        alt: "Mango Express 7s",
        name: "Mango Express 7s",
      },
      ChiliMax7sHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-chili-max-7s-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_chilimax7sholdandwin.webp",
        alt: "Chili Max 7s Hold and Win",
        name: "Chili Max 7s Hold and Win",
      },

      DynastySpark7s: {
        redirectUrl: "/casino/aggapkalambagames-dynasty-spark-7s",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_dynastyspark7s.webp",
        alt: "Dynasty Spark 7s",
        name: "Dynasty Spark 7s",
      },

      AztecApocalypsePrizeMatch: {
        redirectUrl: "/casino/aggapkalambagames-aztec-apocalypse-prize-match",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_aztecapocalypseprizematch.webp",
        alt: "Aztec Apocalypse PrizeMatch",
        name: "Aztec Apocalypse PrizeMatch",
      },

      CaribbeanAnneHoldandWin: {
        redirectUrl: "/casino/aggapkalambagames-caribbean-anne-hold-and-win",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_caribbeananneholdandwin.webp",
        alt: "Caribbean Anne Hold and Win",
        name: "Caribbean Anne Hold and Win",
      },

      AlohaJuicy7s: {
        redirectUrl: "/casino/aggapkalambagames-aloha-juicy-7s",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_alohajuicy7s.webp",
        alt: "Aloha Juicy 7s",
        name: "Aloha Juicy 7s",
      },

      AlienEggstractors: {
        redirectUrl: "/casino/aggapkalambagames-alien-eggstractors",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_alieneggstractors.webp",
        alt: "Alien Eggstractors",
        name: "Alien Eggstractors",
      },

      CherryRush7s: {
        redirectUrl: "/casino/aggapkalambagames-cherry-rush-7s",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_cherryrush7s.webp",
        alt: "Cherry Rush 7s",
        name: "Cherry Rush 7s",
      },

      BunnyHunt7s: {
        redirectUrl: "/casino/aggapkalambagames-bunny-hunt-7s",
        code: "",
        casino: "kalambagames",
        provider: "ALT_GAMING_GAP",
        category: "kalambagames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/casino/kalambagames/klb_bunnyhunt7s.webp",
        alt: "Bunny Hunt 7s",
        name: "Bunny Hunt 7s",
      },
    },
    name: "Kalamba Games",
    key: "kalambagames",
  },


  playtech: {
    slide1: {
      RedWizardBankItUp: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Red Wizard: Bank It Up",
        name: "Red Wizard: Bank It Up",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_red_wizard_bank_it_up.webp",
        redirectUrl: "/casino/aggapplaytech-red-wizard-bank-it-up",
      },
      MegaFireBlazeTheKhan: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Mega Fire Blaze: The Khan",
        name: "Mega Fire Blaze: The Khan",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_mega_fire_blaze_the_khan.webp",
        redirectUrl: "/casino/aggapplaytech-mega-fire-blaze-the-khan",
      },

      MahjongMagic: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Mahjong Magic",
        name: "Mahjong Magic",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_mahjong_magic.webp",
        redirectUrl: "/casino/aggapplaytech-mahjong-magic",
      },

      CashRevealCredits: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Cash Reveal - Credits",
        name: "Cash Reveal - Credits",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_cash_reveal__credits.webp",
        redirectUrl: "/casino/aggapplaytech-cash-reveal-credits",
      },

      FlipRoyale: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Flip Royale",
        name: "Flip Royale",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_flip_royale.webp",
        redirectUrl: "/casino/aggapplaytech-flip-royale",
      },

      TenTonWaysStampede: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Ten Ton Ways Stampede",
        name: "Ten Ton Ways Stampede",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_ten_ton_ways_stampede.webp",
        redirectUrl: "/casino/aggapplaytech-ten-ton-ways-stampede",
      },

      CashTrickBegins: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Cash Truck Begins",
        name: "Cash Truck Begins",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_cash_truck_begins.webp",
        redirectUrl: "/casino/aggapplaytech-cash-truck-begins",
      },

      GigaMatchEgypt: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Giga Match Egypt",
        name: "Giga Match Egypt",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_giga_match_egypt.webp",
        redirectUrl: "/casino/aggapplaytech-giga-match-egypt",
      },

      ImmortalsWaysVolcano: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Immortals Ways Volcano",
        name: "Immortals Ways Volcano",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_immortal_ways_volcano.webp",
        redirectUrl: "/casino/aggapplaytech-immortals-ways-volcano",
      },
      JokerSpinAndRoll: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Joker Spin & Roll",
        name: "Joker Spin & Roll",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_joker_spin__roll.webp",
        redirectUrl: "/casino/aggapplaytech-joker-spin-and-roll",
      },

      FullMoonWhitePandaPowerPlayJackpot: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Full Moon: White Panda PowerPlay Jackpot",
        name: "Full Moon: White Panda PowerPlay Jackpot",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_full_moon_white_panda_powerplay_jackpot.webp",
        redirectUrl: "/casino/aggapplaytech-full-moon-white-panda-powerplay-jackpot",
      },

      GoldTrioLilDemon: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Gold Trio: Lil Demon",
        name: "Gold Trio: Lil Demon",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_full_moon_white_panda_powerplay_jackpot.webp",
        redirectUrl: "/casino/aggapplaytech-gold-trio-lil-demon",
      },

      ShieldsOfLambda: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Shields of Lambda",
        name: "Shields of Lambda",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_shields_of_lambda.webp",
        redirectUrl: "/casino/aggapplaytech-shields-of-lambda",
      },

      MegaFireBlaze3Wizards: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Mega Fire Blaze: 3 Wizards",
        name: "Mega Fire Blaze: 3 Wizards",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_mega_fire_blaze_3_wizards.webp",
        redirectUrl: "/casino/aggapplaytech-mega-fire-blaze-3-wizards",
      },

      MiniRoulette: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Mini Roulette",
        name: "Mini Roulette",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_mini_roulette.webp",
        redirectUrl: "/casino/aggapplaytech-mini-roulette",
      },

      SpinAWin: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Spin a Win",
        name: "Spin a Win",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_spin_a_win.webp",
        redirectUrl: "/casino/aggapplaytech-spin-a-win",
      },

      RouletteMini: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Roulette Mini",
        name: "Roulette Mini",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_roulette_mini.webp",
        redirectUrl: "/casino/aggapplaytech-roulette-mini",
      },

      AztecaBonusLinesPowerPlayJackpot: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Azteca: Bonus Lines PowerPlay Jackpot",
        name: "Azteca: Bonus Lines PowerPlay Jackpot",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_azteca_bonus_lines_powerplay_jackpot.webp",
        redirectUrl: "/casino/aggapplaytech-azteca-bonus-lines-powerplay-jackpot",
      },

      LunarLinkPhoenixMoons: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Lunar Link: Phoenix Moons",
        name: "Lunar Link: Phoenix Moons",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_lunar_link_phoenix_moons.webp",
        redirectUrl: "/casino/aggapplaytech-lunar-link-phoenix-moons",
      },

      AztecFruits: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Aztec Fruits",
        name: "Aztec Fruits",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_aztec_fruits.webp",
        redirectUrl: "/casino/aggapplaytech-aztec-fruits",
      },

      GoldTrioLeprechaunsLuckBF: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Gold Trio: Leprechaun's Luck BF",
        name: "Gold Trio: Leprechaun's Luck BF",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_gold_trio_leprechauns_luck_bf.webp",
        redirectUrl: "/casino/aggapplaytech-gold-trio-leprechauns-luck-bf",
      },

      ElRancheroCashCollectDiamondPath: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "El Ranchero Cash Collect: Diamond Path",
        name: "El Ranchero Cash Collect: Diamond Path",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_el_ranchero_cash_collect_diamond_path.webp",
        redirectUrl: "/casino/aggapplaytech-el-ranchero-cash-collect-diamond-path",
      },

      DropForTop: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Drop for Top",
        name: "Drop for Top",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_drop_for_top.webp",
        redirectUrl: "/casino/aggapplaytech-drop-for-top",
      },

      ReactionLink: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Reaction Link",
        name: "Reaction Link",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_reaction_link.webp",
        redirectUrl: "/casino/aggapplaytech-reaction-link",
      },

      WildRoll: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Wild Roll",
        name: "Wild Roll",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_wild_roll.webp",
        redirectUrl: "/casino/aggapplaytech-wild-roll",
      },

      PiggiesAndTheBankCashCollectAndLink: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Piggies and the Bank: Cash Collect & Link",
        name: "Piggies and the Bank: Cash Collect & Link",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_piggies_and_the_bank_cash_collect__link.webp",
        redirectUrl: "/casino/aggapplaytech-piggies-and-the-bank-cash-collect-and-link",
      },

      GooodHeavens: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Goood Heavens",
        name: "Goood Heavens",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_goood_heavens.webp",
        redirectUrl: "/casino/aggapplaytech-goood-heavens",
      },

      StreakOfLuckDoubleDice: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Streak of Luck: Double Dice",
        name: "Streak of Luck: Double Dice",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_streak_of_luck_double_dice.webp",
        redirectUrl: "/casino/aggapplaytech-streak-of-luck-double-dice",
      },

      PiggiesAndTheBankLuckyTap: {
        code: "",
        casino: "",
        provider: "ALT_GAMING_GAP",
        homeUrl: pageUrlGenerator("/slots"),
        alt: "Piggies and the Bank: Lucky Tap",
        name: "Piggies and the Bank: Lucky Tap",
        providerName: "Playtech",
        imgUrl: "./images/slots/playtech/plt_piggies_and_the_bank_lucky_tap.webp",
        redirectUrl: "/casino/aggapplaytech-piggies-and-the-bank-lucky-tap",
      },
    },
    name: "Playtech",
    key: "playtech",
  },
  

};
